module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00b9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"option":"UiRadiogroupOption_option_2kq4U","option__head":"UiRadiogroupOption_option__head_I2jQ0","disabled":"UiRadiogroupOption_disabled_3AO23","size-sm":"UiRadiogroupOption_size-sm_G8p7S","size-md":"UiRadiogroupOption_size-md_2nytu","size-lg":"UiRadiogroupOption_size-lg_3Jvod","option_section":"UiRadiogroupOption_option_section_12NhM","active":"UiRadiogroupOption_active_FkOi1","option_default":"UiRadiogroupOption_option_default_33dcY","icon":"UiRadiogroupOption_icon_pyAO-","label":"UiRadiogroupOption_label_2JDWL","description":"UiRadiogroupOption_description_2kljP","done":"UiRadiogroupOption_done_1st7p"};

/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "00fd":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ "022e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"drop":"UiUploaderFileInDropArea_drop_3ZjSo","drop_big":"UiUploaderFileInDropArea_drop_big_21za5","drop__progress-bar":"UiUploaderFileInDropArea_drop__progress-bar_3xx8Z","drop__progress-bar-container":"UiUploaderFileInDropArea_drop__progress-bar-container_1wQZl","drop__icon":"UiUploaderFileInDropArea_drop__icon_1pRff","drop__preview-link":"UiUploaderFileInDropArea_drop__preview-link_22pAx","drop__title":"UiUploaderFileInDropArea_drop__title_2AvgA","drop__title_lite":"UiUploaderFileInDropArea_drop__title_lite_1IYYP","drop__title_error":"UiUploaderFileInDropArea_drop__title_error_2KCxd","drop__title-accent":"UiUploaderFileInDropArea_drop__title-accent_1zSpx","drop__title-link":"UiUploaderFileInDropArea_drop__title-link_3IQ5Q","drop__extra":"UiUploaderFileInDropArea_drop__extra_FL77i","drop__extra_error":"UiUploaderFileInDropArea_drop__extra_error_1-uU2","drop_wait":"UiUploaderFileInDropArea_drop_wait_3bdS3","drop__extra-icon":"UiUploaderFileInDropArea_drop__extra-icon_32C-o","type":"UiUploaderFileInDropArea_type_2_B4k","type__item":"UiUploaderFileInDropArea_type__item_1wFnC","type_over":"UiUploaderFileInDropArea_type_over_2tU3y","type__item_left":"UiUploaderFileInDropArea_type__item_left_bHWa1","type__item_right":"UiUploaderFileInDropArea_type__item_right_1yQ66","icon":"UiUploaderFileInDropArea_icon_3DJDv","icon_ready":"UiUploaderFileInDropArea_icon_ready_1JZd2","icon_loading":"UiUploaderFileInDropArea_icon_loading_3pRiF","icon_done":"UiUploaderFileInDropArea_icon_done_2Jc7l","icon_big":"UiUploaderFileInDropArea_icon_big_1j3Kq","icon_error":"UiUploaderFileInDropArea_icon_error_3lLOk"};

/***/ }),

/***/ "0317":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"UiInfoBox_box_1KUPR","box_simple":"UiInfoBox_box_simple_3kw5x","box__icon-box":"UiInfoBox_box__icon-box_17LTZ","box__title":"UiInfoBox_box__title_8lAdo","box__toggle":"UiInfoBox_box__toggle_2Dndr","box_warning":"UiInfoBox_box_warning_1sVbK","box__icon-box_default":"UiInfoBox_box__icon-box_default_3RDXo","box__icon":"UiInfoBox_box__icon_1f4k6","box__icon_default":"UiInfoBox_box__icon_default_16wJV","box__header":"UiInfoBox_box__header_rszcE","box__toggle-icon":"UiInfoBox_box__toggle-icon_2QvNc","box__content":"UiInfoBox_box__content_3wBgV","box__desc":"UiInfoBox_box__desc_dvYxN"};

/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "03dd":
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__("eac5"),
    nativeKeys = __webpack_require__("57a5");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07c7":
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ "087d":
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ "0933":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdownMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("89f5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdownMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdownMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropdownMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "0a07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiErrors_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4440");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiErrors_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiErrors_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiErrors_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "0b07":
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__("34ac"),
    getValue = __webpack_require__("3698");

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d24":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e"),
    stubFalse = __webpack_require__("07c7");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "0d3b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "0dc9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4b79");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLink_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "0eab":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAddButton_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("909a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAddButton_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAddButton_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAddButton_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "100e":
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__("cd9d"),
    overRest = __webpack_require__("2286"),
    setToString = __webpack_require__("c1c9");

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),

/***/ "1290":
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ "1310":
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ "1368":
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__("da03");

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ "13fa":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs-item":"UiTabsItem_tabs-item_lNPOp"};

/***/ }),

/***/ "1680":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9812");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "17c9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"cell":"UiCalendarCell_cell_ump2-","cell_selected":"UiCalendarCell_cell_selected_10_D4","cell_disabled":"UiCalendarCell_cell_disabled_nU86R","cell__backdrop":"UiCalendarCell_cell__backdrop_3KA_W","cell_in-range":"UiCalendarCell_cell_in-range_K5XHW","cell_is-range-first":"UiCalendarCell_cell_is-range-first_t7OeT","cell_is-range-last":"UiCalendarCell_cell_is-range-last_15Di_","cell__content":"UiCalendarCell_cell__content_1TpzX","cell_current":"UiCalendarCell_cell_current_3mr2w"};

/***/ }),

/***/ "182b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"datepicker":"UiDatepicker_datepicker_3_uxS","datepicker__content":"UiDatepicker_datepicker__content_1w3z3","datepicker__content-inner":"UiDatepicker_datepicker__content-inner_1QNmD","open":"UiDatepicker_open_2SLyf","datepicker__footer":"UiDatepicker_datepicker__footer_3kOR2","datepicker__button":"UiDatepicker_datepicker__button_gCT87","greenIcon":"UiDatepicker_greenIcon_3IxV0","datepicker-trigger":"UiDatepicker_datepicker-trigger_1qq9e","timepicker":"UiDatepicker_timepicker_3yUyd","timepicker__label":"UiDatepicker_timepicker__label_2LCQJ","timepicker__tooltip":"UiDatepicker_timepicker__tooltip_3HK2W","timepicker__tooltip-content":"UiDatepicker_timepicker__tooltip-content_2YTps","timepicker__field":"UiDatepicker_timepicker__field_3dTjb","timepicker__icon":"UiDatepicker_timepicker__icon_g1Ewz","ui-kit-datepicker":"UiDatepicker_ui-kit-datepicker_1GnIl"};

/***/ }),

/***/ "18a2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTooltip_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ca56");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTooltip_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTooltip_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTooltip_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "19aa":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),

/***/ "1a4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiText_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("27bb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiText_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiText_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiText_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "1a8c":
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c07":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"tabs":"UiTabs_tabs_3VpC_","tabs_full-width":"UiTabs_tabs_full-width_3d5NK","tabs__icon":"UiTabs_tabs__icon_3IVTc","tabs_size-sm":"UiTabs_tabs_size-sm_1heHy","tabs_size-md":"UiTabs_tabs_size-md_1UQij","tabs_radiogroup":"UiTabs_tabs_radiogroup_1PiSD","tabs__icon_text":"UiTabs_tabs__icon_text_4lVU8","tabs_size-lg":"UiTabs_tabs_size-lg_2rBHW","tabs__control_active":"UiTabs_tabs__control_active_2kxMo","tabs__controls":"UiTabs_tabs__controls_2RzE1","tabs_expanded":"UiTabs_tabs_expanded_3Slmg","tabs_top-line":"UiTabs_tabs_top-line_1L1p8","tabs_rubber":"UiTabs_tabs_rubber_4I4Mp","tabs__control":"UiTabs_tabs__control_1-mUP","tabs_default":"UiTabs_tabs_default_2-3Ls","tabs__control_disabled":"UiTabs_tabs__control_disabled_1bgg-","tabs__control_rubber":"UiTabs_tabs__control_rubber_Aa7J4","tabs__counter":"UiTabs_tabs__counter_2Suy-","tabs__content":"UiTabs_tabs__content_3iY4E","tabs__content_no-ctr":"UiTabs_tabs__content_no-ctr_2lngl","tabs_global":"UiTabs_tabs_global_3dG4v","tabs__control_icon-without-text":"UiTabs_tabs__control_icon-without-text_3eeG_","extra":"UiTabs_extra_3PG5N","extra__btn":"UiTabs_extra__btn_IY08b","extra__wrap":"UiTabs_extra__wrap_2z4Nc","extra_open":"UiTabs_extra_open_2lH4c","extra__icon":"UiTabs_extra__icon_3Yg7X","extra__counter":"UiTabs_extra__counter_35oTi","ticker":"UiTabs_ticker_2taP-"};

/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c3c":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    Uint8Array = __webpack_require__("2474"),
    eq = __webpack_require__("9638"),
    equalArrays = __webpack_require__("a2be"),
    mapToArray = __webpack_require__("edfa"),
    setToArray = __webpack_require__("ac41");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ "1cec":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1db9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"modal-overlay":"UiModalSidebar_modal-overlay_3xabU","modal-overlay_fixed":"UiModalSidebar_modal-overlay_fixed_Kd84m","modal-overlay_left":"UiModalSidebar_modal-overlay_left_2LXRG","modal-overlay_right":"UiModalSidebar_modal-overlay_right_1pHIc","modal-sidebar":"UiModalSidebar_modal-sidebar_2LJvT","modal-sidebar__inner":"UiModalSidebar_modal-sidebar__inner_1zDd0","modal-sidebar__head":"UiModalSidebar_modal-sidebar__head_3NHVB","modal-sidebar__head-inner":"UiModalSidebar_modal-sidebar__head-inner_3CO69","modal-sidebar__title":"UiModalSidebar_modal-sidebar__title_CVJnk","modal-sidebar__title_ellipsis":"UiModalSidebar_modal-sidebar__title_ellipsis_2fjSW","modal-sidebar__body":"UiModalSidebar_modal-sidebar__body_slttd","modal-sidebar__body-fixed":"UiModalSidebar_modal-sidebar__body-fixed_i2oTD","modal-sidebar__footer":"UiModalSidebar_modal-sidebar__footer_24RYh","btn":"UiModalSidebar_btn_1hLCB","modal-sidebar__close":"UiModalSidebar_modal-sidebar__close_3nEMF","modal-sidebar_left":"UiModalSidebar_modal-sidebar_left_2YHa_","modal-sidebar_sm":"UiModalSidebar_modal-sidebar_sm_3I6mI","modal-sidebar_lg":"UiModalSidebar_modal-sidebar_lg_2PK0p"};

/***/ }),

/***/ "1e58":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"UiCheckbox_checkbox_CP9FX","checkbox__ch":"UiCheckbox_checkbox__ch_39tNe","checkbox__ch-icon":"UiCheckbox_checkbox__ch-icon_rZagB","checkbox__ch-input":"UiCheckbox_checkbox__ch-input_1NMJt","checkbox__ch-image":"UiCheckbox_checkbox__ch-image_272GX","checkbox__text":"UiCheckbox_checkbox__text_2cEGS","checkbox__label":"UiCheckbox_checkbox__label_1EGuC","checkbox__label_muted":"UiCheckbox_checkbox__label_muted_o403C","checkbox__desc":"UiCheckbox_checkbox__desc_3qQh3","checkbox_checked":"UiCheckbox_checkbox_checked_2kSmy","checkbox_disabled":"UiCheckbox_checkbox_disabled_3vDuP","checkbox_active":"UiCheckbox_checkbox_active_XaJs5","checkbox_indeterminate":"UiCheckbox_checkbox_indeterminate_TC0NL","checkbox_min":"UiCheckbox_checkbox_min_39vL4","checkbox-wrap":"UiCheckbox_checkbox-wrap_2aDoq"};

/***/ }),

/***/ "1e74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTitle_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3f02");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTitle_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTitle_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTitle_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "1efc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ "1fc8":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ "207d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiContentBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d178");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiContentBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiContentBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiContentBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "20c6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"preview":"UiAttachment_preview_Oqgqh","preview_size_sm":"UiAttachment_preview_size_sm_jG_-c","preview_size_md":"UiAttachment_preview_size_md_R5BzP","preview_type_image":"UiAttachment_preview_type_image_2CGGx","preview_type_video":"UiAttachment_preview_type_video_i3PtK","preview_type_document":"UiAttachment_preview_type_document_28uUR","preview_type_spreadsheet":"UiAttachment_preview_type_spreadsheet_3Fnmq","preview_state_error":"UiAttachment_preview_state_error_cVC1e","preview_overlay":"UiAttachment_preview_overlay_3z-iP","thumb":"UiAttachment_thumb_1n-wx","ext":"UiAttachment_ext_25HCm","ext_size_sm":"UiAttachment_ext_size_sm_3OMaU","img":"UiAttachment_img_1H6HR","icon":"UiAttachment_icon_2VmfS"};

/***/ }),

/***/ "2217":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSkeleton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fae0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSkeleton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSkeleton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSkeleton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2286":
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__("85e3");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "23e8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSubmenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("668e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSubmenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSubmenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSubmenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2474":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ "2478":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ "248b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b3df");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2524":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ "252c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __vue_component__; });
/* unused harmony export install */
function getInternetExplorerVersion() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return -1;
}

//
var isIE;

function initCompat() {
  if (!initCompat.init) {
    initCompat.init = true;
    isIE = getInternetExplorerVersion() !== -1;
  }
}

var script = {
  name: 'ResizeObserver',
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    initCompat();
    this.$nextTick(function () {
      _this._w = _this.$el.offsetWidth;
      _this._h = _this.$el.offsetHeight;

      if (_this.emitOnMount) {
        _this.emitSize();
      }
    });
    var object = document.createElement('object');
    this._resizeObject = object;
    object.setAttribute('aria-hidden', 'true');
    object.setAttribute('tabindex', -1);
    object.onload = this.addResizeHandlers;
    object.type = 'text/html';

    if (isIE) {
      this.$el.appendChild(object);
    }

    object.data = 'about:blank';

    if (!isIE) {
      this.$el.appendChild(object);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify: function compareAndNotify() {
      if (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) {
        this._w = this.$el.offsetWidth;
        this._h = this.$el.offsetHeight;
        this.emitSize();
      }
    },
    emitSize: function emitSize() {
      this.$emit('notify', {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers: function addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener('resize', this.compareAndNotify);

      this.compareAndNotify();
    },
    removeResizeHandlers: function removeResizeHandlers() {
      if (this._resizeObject && this._resizeObject.onload) {
        if (!isIE && this._resizeObject.contentDocument) {
          this._resizeObject.contentDocument.defaultView.removeEventListener('resize', this.compareAndNotify);
        }

        this.$el.removeChild(this._resizeObject);
        this._resizeObject.onload = null;
        this._resizeObject = null;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "resize-observer",
    attrs: {
      tabindex: "-1"
    }
  });
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = "data-v-8859cc6c";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function install(Vue) {
  // eslint-disable-next-line vue/component-definition-name-casing
  Vue.component('resize-observer', __vue_component__);
  Vue.component('ResizeObserver', __vue_component__);
}

var plugin = {
  // eslint-disable-next-line no-undef
  version: "1.0.1",
  install: install
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);

//# sourceMappingURL=vue-resize.esm.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "253c":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ "262c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadio_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3b53");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadio_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadio_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadio_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "27bb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"text":"UiText_text_2_z8L","text_gray":"UiText_text_gray_3-JEz","text_primary":"UiText_text_primary_29t0r","text_success":"UiText_text_success_1tu3N","text_action":"UiText_text_action_26OZr","text_black":"UiText_text_black_1BwQd","text_hero":"UiText_text_hero_2XVk3","text_title-01":"UiText_text_title-01_1uEdD","text_title-02":"UiText_text_title-02_3DREW","text_article":"UiText_text_article_2l13o","text_paragraph":"UiText_text_paragraph_1ij_7","text_md":"UiText_text_md_3Oq4i","text_body":"UiText_text_body_Psnvi","text_small":"UiText_text_small_QTWpg","text_tiny":"UiText_text_tiny_1_wcg","text_accent":"UiText_text_accent_nhXJH","text_title":"UiText_text_title_1c9wp","text_ellipsis":"UiText_text_ellipsis_3WWJn","text_link":"UiText_text_link_cYNuY","text_uppercase":"UiText_text_uppercase_jshFD"};

/***/ }),

/***/ "2881":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"UiInputGiant_input_2fb9g","input__error":"UiInputGiant_input__error_3eIeC","input__error_ellipsis":"UiInputGiant_input__error_ellipsis_uCm4E","input_placeholder":"UiInputGiant_input_placeholder_mL6l8","input__icon":"UiInputGiant_input__icon_DTvYH","input_focus":"UiInputGiant_input_focus_1SBn8","input_disabled":"UiInputGiant_input_disabled_33RXx","area":"UiInputGiant_area_1l1uw","suffix":"UiInputGiant_suffix_tosrP","prefix":"UiInputGiant_prefix_29wio","input_error":"UiInputGiant_input_error_stQae","input__icon_state-fill":"UiInputGiant_input__icon_state-fill_3qviM","placeholder":"UiInputGiant_placeholder_cjxM1","input_line-style":"UiInputGiant_input_line-style_HB-AR","content-inner":"UiInputGiant_content-inner_1dZpJ","input__tooltip-area":"UiInputGiant_input__tooltip-area_PypgK","input__error-tooltip":"UiInputGiant_input__error-tooltip_1gvt0","input__error-wrap":"UiInputGiant_input__error-wrap_guy_P","label":"UiInputGiant_label_2BbPI","content":"UiInputGiant_content_1JuUs","suffix__icon":"UiInputGiant_suffix__icon_PgwX1","prefix__icon":"UiInputGiant_prefix__icon_cWGC2","prefix__inner":"UiInputGiant_prefix__inner_3viRs","postfix":"UiInputGiant_postfix_M-i1C"};

/***/ }),

/***/ "28c9":
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ "296f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"UiCalendar_container_O_8Mm","calendar":"UiCalendar_calendar_2cKr0","table":"UiCalendar_table_Jw5A-","row":"UiCalendar_row_1_ST3","row_justify-end":"UiCalendar_row_justify-end_14Mxi","cell-weekday":"UiCalendar_cell-weekday_2dPoY","cell-day":"UiCalendar_cell-day_1xjM1","cell-day_muted":"UiCalendar_cell-day_muted_1j7i_","cell-month":"UiCalendar_cell-month_1t0Hu","cell-year":"UiCalendar_cell-year_EAAWi"};

/***/ }),

/***/ "29f3":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ "2a45":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("86df");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiMenuBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

module.exports = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};


/***/ }),

/***/ "2ae7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDatepicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("182b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDatepicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDatepicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDatepicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2b16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e24b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2b3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("3ca3");
var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var global = __webpack_require__("da84");
var defineProperties = __webpack_require__("37e8");
var redefine = __webpack_require__("6eeb");
var anInstance = __webpack_require__("19aa");
var has = __webpack_require__("5135");
var assign = __webpack_require__("60da");
var arrayFrom = __webpack_require__("4df4");
var codeAt = __webpack_require__("6547").codeAt;
var toASCII = __webpack_require__("5fb2");
var setToStringTag = __webpack_require__("d44e");
var URLSearchParamsModule = __webpack_require__("9861");
var InternalStateModule = __webpack_require__("69f3");

var NativeURL = global.URL;
var URLSearchParams = URLSearchParamsModule.URLSearchParams;
var getInternalSearchParamsState = URLSearchParamsModule.getState;
var setInternalState = InternalStateModule.set;
var getInternalURLState = InternalStateModule.getterFor('URL');
var floor = Math.floor;
var pow = Math.pow;

var INVALID_AUTHORITY = 'Invalid authority';
var INVALID_SCHEME = 'Invalid scheme';
var INVALID_HOST = 'Invalid host';
var INVALID_PORT = 'Invalid port';

var ALPHA = /[A-Za-z]/;
var ALPHANUMERIC = /[\d+-.A-Za-z]/;
var DIGIT = /\d/;
var HEX_START = /^(0x|0X)/;
var OCT = /^[0-7]+$/;
var DEC = /^\d+$/;
var HEX = /^[\dA-Fa-f]+$/;
/* eslint-disable no-control-regex -- safe */
var FORBIDDEN_HOST_CODE_POINT = /[\u0000\t\u000A\u000D #%/:?@[\\]]/;
var FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\u0000\t\u000A\u000D #/:?@[\\]]/;
var LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u001F ]+|[\u0000-\u001F ]+$/g;
var TAB_AND_NEW_LINE = /[\t\u000A\u000D]/g;
/* eslint-enable no-control-regex -- safe */
var EOF;

var parseHost = function (url, input) {
  var result, codePoints, index;
  if (input.charAt(0) == '[') {
    if (input.charAt(input.length - 1) != ']') return INVALID_HOST;
    result = parseIPv6(input.slice(1, -1));
    if (!result) return INVALID_HOST;
    url.host = result;
  // opaque host
  } else if (!isSpecial(url)) {
    if (FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT.test(input)) return INVALID_HOST;
    result = '';
    codePoints = arrayFrom(input);
    for (index = 0; index < codePoints.length; index++) {
      result += percentEncode(codePoints[index], C0ControlPercentEncodeSet);
    }
    url.host = result;
  } else {
    input = toASCII(input);
    if (FORBIDDEN_HOST_CODE_POINT.test(input)) return INVALID_HOST;
    result = parseIPv4(input);
    if (result === null) return INVALID_HOST;
    url.host = result;
  }
};

var parseIPv4 = function (input) {
  var parts = input.split('.');
  var partsLength, numbers, index, part, radix, number, ipv4;
  if (parts.length && parts[parts.length - 1] == '') {
    parts.pop();
  }
  partsLength = parts.length;
  if (partsLength > 4) return input;
  numbers = [];
  for (index = 0; index < partsLength; index++) {
    part = parts[index];
    if (part == '') return input;
    radix = 10;
    if (part.length > 1 && part.charAt(0) == '0') {
      radix = HEX_START.test(part) ? 16 : 8;
      part = part.slice(radix == 8 ? 1 : 2);
    }
    if (part === '') {
      number = 0;
    } else {
      if (!(radix == 10 ? DEC : radix == 8 ? OCT : HEX).test(part)) return input;
      number = parseInt(part, radix);
    }
    numbers.push(number);
  }
  for (index = 0; index < partsLength; index++) {
    number = numbers[index];
    if (index == partsLength - 1) {
      if (number >= pow(256, 5 - partsLength)) return null;
    } else if (number > 255) return null;
  }
  ipv4 = numbers.pop();
  for (index = 0; index < numbers.length; index++) {
    ipv4 += numbers[index] * pow(256, 3 - index);
  }
  return ipv4;
};

// eslint-disable-next-line max-statements -- TODO
var parseIPv6 = function (input) {
  var address = [0, 0, 0, 0, 0, 0, 0, 0];
  var pieceIndex = 0;
  var compress = null;
  var pointer = 0;
  var value, length, numbersSeen, ipv4Piece, number, swaps, swap;

  var char = function () {
    return input.charAt(pointer);
  };

  if (char() == ':') {
    if (input.charAt(1) != ':') return;
    pointer += 2;
    pieceIndex++;
    compress = pieceIndex;
  }
  while (char()) {
    if (pieceIndex == 8) return;
    if (char() == ':') {
      if (compress !== null) return;
      pointer++;
      pieceIndex++;
      compress = pieceIndex;
      continue;
    }
    value = length = 0;
    while (length < 4 && HEX.test(char())) {
      value = value * 16 + parseInt(char(), 16);
      pointer++;
      length++;
    }
    if (char() == '.') {
      if (length == 0) return;
      pointer -= length;
      if (pieceIndex > 6) return;
      numbersSeen = 0;
      while (char()) {
        ipv4Piece = null;
        if (numbersSeen > 0) {
          if (char() == '.' && numbersSeen < 4) pointer++;
          else return;
        }
        if (!DIGIT.test(char())) return;
        while (DIGIT.test(char())) {
          number = parseInt(char(), 10);
          if (ipv4Piece === null) ipv4Piece = number;
          else if (ipv4Piece == 0) return;
          else ipv4Piece = ipv4Piece * 10 + number;
          if (ipv4Piece > 255) return;
          pointer++;
        }
        address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
        numbersSeen++;
        if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
      }
      if (numbersSeen != 4) return;
      break;
    } else if (char() == ':') {
      pointer++;
      if (!char()) return;
    } else if (char()) return;
    address[pieceIndex++] = value;
  }
  if (compress !== null) {
    swaps = pieceIndex - compress;
    pieceIndex = 7;
    while (pieceIndex != 0 && swaps > 0) {
      swap = address[pieceIndex];
      address[pieceIndex--] = address[compress + swaps - 1];
      address[compress + --swaps] = swap;
    }
  } else if (pieceIndex != 8) return;
  return address;
};

var findLongestZeroSequence = function (ipv6) {
  var maxIndex = null;
  var maxLength = 1;
  var currStart = null;
  var currLength = 0;
  var index = 0;
  for (; index < 8; index++) {
    if (ipv6[index] !== 0) {
      if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
      }
      currStart = null;
      currLength = 0;
    } else {
      if (currStart === null) currStart = index;
      ++currLength;
    }
  }
  if (currLength > maxLength) {
    maxIndex = currStart;
    maxLength = currLength;
  }
  return maxIndex;
};

var serializeHost = function (host) {
  var result, index, compress, ignore0;
  // ipv4
  if (typeof host == 'number') {
    result = [];
    for (index = 0; index < 4; index++) {
      result.unshift(host % 256);
      host = floor(host / 256);
    } return result.join('.');
  // ipv6
  } else if (typeof host == 'object') {
    result = '';
    compress = findLongestZeroSequence(host);
    for (index = 0; index < 8; index++) {
      if (ignore0 && host[index] === 0) continue;
      if (ignore0) ignore0 = false;
      if (compress === index) {
        result += index ? ':' : '::';
        ignore0 = true;
      } else {
        result += host[index].toString(16);
        if (index < 7) result += ':';
      }
    }
    return '[' + result + ']';
  } return host;
};

var C0ControlPercentEncodeSet = {};
var fragmentPercentEncodeSet = assign({}, C0ControlPercentEncodeSet, {
  ' ': 1, '"': 1, '<': 1, '>': 1, '`': 1
});
var pathPercentEncodeSet = assign({}, fragmentPercentEncodeSet, {
  '#': 1, '?': 1, '{': 1, '}': 1
});
var userinfoPercentEncodeSet = assign({}, pathPercentEncodeSet, {
  '/': 1, ':': 1, ';': 1, '=': 1, '@': 1, '[': 1, '\\': 1, ']': 1, '^': 1, '|': 1
});

var percentEncode = function (char, set) {
  var code = codeAt(char, 0);
  return code > 0x20 && code < 0x7F && !has(set, char) ? char : encodeURIComponent(char);
};

var specialSchemes = {
  ftp: 21,
  file: null,
  http: 80,
  https: 443,
  ws: 80,
  wss: 443
};

var isSpecial = function (url) {
  return has(specialSchemes, url.scheme);
};

var includesCredentials = function (url) {
  return url.username != '' || url.password != '';
};

var cannotHaveUsernamePasswordPort = function (url) {
  return !url.host || url.cannotBeABaseURL || url.scheme == 'file';
};

var isWindowsDriveLetter = function (string, normalized) {
  var second;
  return string.length == 2 && ALPHA.test(string.charAt(0))
    && ((second = string.charAt(1)) == ':' || (!normalized && second == '|'));
};

var startsWithWindowsDriveLetter = function (string) {
  var third;
  return string.length > 1 && isWindowsDriveLetter(string.slice(0, 2)) && (
    string.length == 2 ||
    ((third = string.charAt(2)) === '/' || third === '\\' || third === '?' || third === '#')
  );
};

var shortenURLsPath = function (url) {
  var path = url.path;
  var pathSize = path.length;
  if (pathSize && (url.scheme != 'file' || pathSize != 1 || !isWindowsDriveLetter(path[0], true))) {
    path.pop();
  }
};

var isSingleDot = function (segment) {
  return segment === '.' || segment.toLowerCase() === '%2e';
};

var isDoubleDot = function (segment) {
  segment = segment.toLowerCase();
  return segment === '..' || segment === '%2e.' || segment === '.%2e' || segment === '%2e%2e';
};

// States:
var SCHEME_START = {};
var SCHEME = {};
var NO_SCHEME = {};
var SPECIAL_RELATIVE_OR_AUTHORITY = {};
var PATH_OR_AUTHORITY = {};
var RELATIVE = {};
var RELATIVE_SLASH = {};
var SPECIAL_AUTHORITY_SLASHES = {};
var SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var AUTHORITY = {};
var HOST = {};
var HOSTNAME = {};
var PORT = {};
var FILE = {};
var FILE_SLASH = {};
var FILE_HOST = {};
var PATH_START = {};
var PATH = {};
var CANNOT_BE_A_BASE_URL_PATH = {};
var QUERY = {};
var FRAGMENT = {};

// eslint-disable-next-line max-statements -- TODO
var parseURL = function (url, input, stateOverride, base) {
  var state = stateOverride || SCHEME_START;
  var pointer = 0;
  var buffer = '';
  var seenAt = false;
  var seenBracket = false;
  var seenPasswordToken = false;
  var codePoints, char, bufferCodePoints, failure;

  if (!stateOverride) {
    url.scheme = '';
    url.username = '';
    url.password = '';
    url.host = null;
    url.port = null;
    url.path = [];
    url.query = null;
    url.fragment = null;
    url.cannotBeABaseURL = false;
    input = input.replace(LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, '');
  }

  input = input.replace(TAB_AND_NEW_LINE, '');

  codePoints = arrayFrom(input);

  while (pointer <= codePoints.length) {
    char = codePoints[pointer];
    switch (state) {
      case SCHEME_START:
        if (char && ALPHA.test(char)) {
          buffer += char.toLowerCase();
          state = SCHEME;
        } else if (!stateOverride) {
          state = NO_SCHEME;
          continue;
        } else return INVALID_SCHEME;
        break;

      case SCHEME:
        if (char && (ALPHANUMERIC.test(char) || char == '+' || char == '-' || char == '.')) {
          buffer += char.toLowerCase();
        } else if (char == ':') {
          if (stateOverride && (
            (isSpecial(url) != has(specialSchemes, buffer)) ||
            (buffer == 'file' && (includesCredentials(url) || url.port !== null)) ||
            (url.scheme == 'file' && !url.host)
          )) return;
          url.scheme = buffer;
          if (stateOverride) {
            if (isSpecial(url) && specialSchemes[url.scheme] == url.port) url.port = null;
            return;
          }
          buffer = '';
          if (url.scheme == 'file') {
            state = FILE;
          } else if (isSpecial(url) && base && base.scheme == url.scheme) {
            state = SPECIAL_RELATIVE_OR_AUTHORITY;
          } else if (isSpecial(url)) {
            state = SPECIAL_AUTHORITY_SLASHES;
          } else if (codePoints[pointer + 1] == '/') {
            state = PATH_OR_AUTHORITY;
            pointer++;
          } else {
            url.cannotBeABaseURL = true;
            url.path.push('');
            state = CANNOT_BE_A_BASE_URL_PATH;
          }
        } else if (!stateOverride) {
          buffer = '';
          state = NO_SCHEME;
          pointer = 0;
          continue;
        } else return INVALID_SCHEME;
        break;

      case NO_SCHEME:
        if (!base || (base.cannotBeABaseURL && char != '#')) return INVALID_SCHEME;
        if (base.cannotBeABaseURL && char == '#') {
          url.scheme = base.scheme;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          url.cannotBeABaseURL = true;
          state = FRAGMENT;
          break;
        }
        state = base.scheme == 'file' ? FILE : RELATIVE;
        continue;

      case SPECIAL_RELATIVE_OR_AUTHORITY:
        if (char == '/' && codePoints[pointer + 1] == '/') {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
          pointer++;
        } else {
          state = RELATIVE;
          continue;
        } break;

      case PATH_OR_AUTHORITY:
        if (char == '/') {
          state = AUTHORITY;
          break;
        } else {
          state = PATH;
          continue;
        }

      case RELATIVE:
        url.scheme = base.scheme;
        if (char == EOF) {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
        } else if (char == '/' || (char == '\\' && isSpecial(url))) {
          state = RELATIVE_SLASH;
        } else if (char == '?') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.query = base.query;
          url.fragment = '';
          state = FRAGMENT;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          url.path = base.path.slice();
          url.path.pop();
          state = PATH;
          continue;
        } break;

      case RELATIVE_SLASH:
        if (isSpecial(url) && (char == '/' || char == '\\')) {
          state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        } else if (char == '/') {
          state = AUTHORITY;
        } else {
          url.username = base.username;
          url.password = base.password;
          url.host = base.host;
          url.port = base.port;
          state = PATH;
          continue;
        } break;

      case SPECIAL_AUTHORITY_SLASHES:
        state = SPECIAL_AUTHORITY_IGNORE_SLASHES;
        if (char != '/' || buffer.charAt(pointer + 1) != '/') continue;
        pointer++;
        break;

      case SPECIAL_AUTHORITY_IGNORE_SLASHES:
        if (char != '/' && char != '\\') {
          state = AUTHORITY;
          continue;
        } break;

      case AUTHORITY:
        if (char == '@') {
          if (seenAt) buffer = '%40' + buffer;
          seenAt = true;
          bufferCodePoints = arrayFrom(buffer);
          for (var i = 0; i < bufferCodePoints.length; i++) {
            var codePoint = bufferCodePoints[i];
            if (codePoint == ':' && !seenPasswordToken) {
              seenPasswordToken = true;
              continue;
            }
            var encodedCodePoints = percentEncode(codePoint, userinfoPercentEncodeSet);
            if (seenPasswordToken) url.password += encodedCodePoints;
            else url.username += encodedCodePoints;
          }
          buffer = '';
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (seenAt && buffer == '') return INVALID_AUTHORITY;
          pointer -= arrayFrom(buffer).length + 1;
          buffer = '';
          state = HOST;
        } else buffer += char;
        break;

      case HOST:
      case HOSTNAME:
        if (stateOverride && url.scheme == 'file') {
          state = FILE_HOST;
          continue;
        } else if (char == ':' && !seenBracket) {
          if (buffer == '') return INVALID_HOST;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PORT;
          if (stateOverride == HOSTNAME) return;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url))
        ) {
          if (isSpecial(url) && buffer == '') return INVALID_HOST;
          if (stateOverride && buffer == '' && (includesCredentials(url) || url.port !== null)) return;
          failure = parseHost(url, buffer);
          if (failure) return failure;
          buffer = '';
          state = PATH_START;
          if (stateOverride) return;
          continue;
        } else {
          if (char == '[') seenBracket = true;
          else if (char == ']') seenBracket = false;
          buffer += char;
        } break;

      case PORT:
        if (DIGIT.test(char)) {
          buffer += char;
        } else if (
          char == EOF || char == '/' || char == '?' || char == '#' ||
          (char == '\\' && isSpecial(url)) ||
          stateOverride
        ) {
          if (buffer != '') {
            var port = parseInt(buffer, 10);
            if (port > 0xFFFF) return INVALID_PORT;
            url.port = (isSpecial(url) && port === specialSchemes[url.scheme]) ? null : port;
            buffer = '';
          }
          if (stateOverride) return;
          state = PATH_START;
          continue;
        } else return INVALID_PORT;
        break;

      case FILE:
        url.scheme = 'file';
        if (char == '/' || char == '\\') state = FILE_SLASH;
        else if (base && base.scheme == 'file') {
          if (char == EOF) {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
          } else if (char == '?') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.host = base.host;
            url.path = base.path.slice();
            url.query = base.query;
            url.fragment = '';
            state = FRAGMENT;
          } else {
            if (!startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
              url.host = base.host;
              url.path = base.path.slice();
              shortenURLsPath(url);
            }
            state = PATH;
            continue;
          }
        } else {
          state = PATH;
          continue;
        } break;

      case FILE_SLASH:
        if (char == '/' || char == '\\') {
          state = FILE_HOST;
          break;
        }
        if (base && base.scheme == 'file' && !startsWithWindowsDriveLetter(codePoints.slice(pointer).join(''))) {
          if (isWindowsDriveLetter(base.path[0], true)) url.path.push(base.path[0]);
          else url.host = base.host;
        }
        state = PATH;
        continue;

      case FILE_HOST:
        if (char == EOF || char == '/' || char == '\\' || char == '?' || char == '#') {
          if (!stateOverride && isWindowsDriveLetter(buffer)) {
            state = PATH;
          } else if (buffer == '') {
            url.host = '';
            if (stateOverride) return;
            state = PATH_START;
          } else {
            failure = parseHost(url, buffer);
            if (failure) return failure;
            if (url.host == 'localhost') url.host = '';
            if (stateOverride) return;
            buffer = '';
            state = PATH_START;
          } continue;
        } else buffer += char;
        break;

      case PATH_START:
        if (isSpecial(url)) {
          state = PATH;
          if (char != '/' && char != '\\') continue;
        } else if (!stateOverride && char == '?') {
          url.query = '';
          state = QUERY;
        } else if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          state = PATH;
          if (char != '/') continue;
        } break;

      case PATH:
        if (
          char == EOF || char == '/' ||
          (char == '\\' && isSpecial(url)) ||
          (!stateOverride && (char == '?' || char == '#'))
        ) {
          if (isDoubleDot(buffer)) {
            shortenURLsPath(url);
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else if (isSingleDot(buffer)) {
            if (char != '/' && !(char == '\\' && isSpecial(url))) {
              url.path.push('');
            }
          } else {
            if (url.scheme == 'file' && !url.path.length && isWindowsDriveLetter(buffer)) {
              if (url.host) url.host = '';
              buffer = buffer.charAt(0) + ':'; // normalize windows drive letter
            }
            url.path.push(buffer);
          }
          buffer = '';
          if (url.scheme == 'file' && (char == EOF || char == '?' || char == '#')) {
            while (url.path.length > 1 && url.path[0] === '') {
              url.path.shift();
            }
          }
          if (char == '?') {
            url.query = '';
            state = QUERY;
          } else if (char == '#') {
            url.fragment = '';
            state = FRAGMENT;
          }
        } else {
          buffer += percentEncode(char, pathPercentEncodeSet);
        } break;

      case CANNOT_BE_A_BASE_URL_PATH:
        if (char == '?') {
          url.query = '';
          state = QUERY;
        } else if (char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          url.path[0] += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case QUERY:
        if (!stateOverride && char == '#') {
          url.fragment = '';
          state = FRAGMENT;
        } else if (char != EOF) {
          if (char == "'" && isSpecial(url)) url.query += '%27';
          else if (char == '#') url.query += '%23';
          else url.query += percentEncode(char, C0ControlPercentEncodeSet);
        } break;

      case FRAGMENT:
        if (char != EOF) url.fragment += percentEncode(char, fragmentPercentEncodeSet);
        break;
    }

    pointer++;
  }
};

// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var URLConstructor = function URL(url /* , base */) {
  var that = anInstance(this, URLConstructor, 'URL');
  var base = arguments.length > 1 ? arguments[1] : undefined;
  var urlString = String(url);
  var state = setInternalState(that, { type: 'URL' });
  var baseState, failure;
  if (base !== undefined) {
    if (base instanceof URLConstructor) baseState = getInternalURLState(base);
    else {
      failure = parseURL(baseState = {}, String(base));
      if (failure) throw TypeError(failure);
    }
  }
  failure = parseURL(state, urlString, null, baseState);
  if (failure) throw TypeError(failure);
  var searchParams = state.searchParams = new URLSearchParams();
  var searchParamsState = getInternalSearchParamsState(searchParams);
  searchParamsState.updateSearchParams(state.query);
  searchParamsState.updateURL = function () {
    state.query = String(searchParams) || null;
  };
  if (!DESCRIPTORS) {
    that.href = serializeURL.call(that);
    that.origin = getOrigin.call(that);
    that.protocol = getProtocol.call(that);
    that.username = getUsername.call(that);
    that.password = getPassword.call(that);
    that.host = getHost.call(that);
    that.hostname = getHostname.call(that);
    that.port = getPort.call(that);
    that.pathname = getPathname.call(that);
    that.search = getSearch.call(that);
    that.searchParams = getSearchParams.call(that);
    that.hash = getHash.call(that);
  }
};

var URLPrototype = URLConstructor.prototype;

var serializeURL = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var username = url.username;
  var password = url.password;
  var host = url.host;
  var port = url.port;
  var path = url.path;
  var query = url.query;
  var fragment = url.fragment;
  var output = scheme + ':';
  if (host !== null) {
    output += '//';
    if (includesCredentials(url)) {
      output += username + (password ? ':' + password : '') + '@';
    }
    output += serializeHost(host);
    if (port !== null) output += ':' + port;
  } else if (scheme == 'file') output += '//';
  output += url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
  if (query !== null) output += '?' + query;
  if (fragment !== null) output += '#' + fragment;
  return output;
};

var getOrigin = function () {
  var url = getInternalURLState(this);
  var scheme = url.scheme;
  var port = url.port;
  if (scheme == 'blob') try {
    return new URL(scheme.path[0]).origin;
  } catch (error) {
    return 'null';
  }
  if (scheme == 'file' || !isSpecial(url)) return 'null';
  return scheme + '://' + serializeHost(url.host) + (port !== null ? ':' + port : '');
};

var getProtocol = function () {
  return getInternalURLState(this).scheme + ':';
};

var getUsername = function () {
  return getInternalURLState(this).username;
};

var getPassword = function () {
  return getInternalURLState(this).password;
};

var getHost = function () {
  var url = getInternalURLState(this);
  var host = url.host;
  var port = url.port;
  return host === null ? ''
    : port === null ? serializeHost(host)
    : serializeHost(host) + ':' + port;
};

var getHostname = function () {
  var host = getInternalURLState(this).host;
  return host === null ? '' : serializeHost(host);
};

var getPort = function () {
  var port = getInternalURLState(this).port;
  return port === null ? '' : String(port);
};

var getPathname = function () {
  var url = getInternalURLState(this);
  var path = url.path;
  return url.cannotBeABaseURL ? path[0] : path.length ? '/' + path.join('/') : '';
};

var getSearch = function () {
  var query = getInternalURLState(this).query;
  return query ? '?' + query : '';
};

var getSearchParams = function () {
  return getInternalURLState(this).searchParams;
};

var getHash = function () {
  var fragment = getInternalURLState(this).fragment;
  return fragment ? '#' + fragment : '';
};

var accessorDescriptor = function (getter, setter) {
  return { get: getter, set: setter, configurable: true, enumerable: true };
};

if (DESCRIPTORS) {
  defineProperties(URLPrototype, {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    href: accessorDescriptor(serializeURL, function (href) {
      var url = getInternalURLState(this);
      var urlString = String(href);
      var failure = parseURL(url, urlString);
      if (failure) throw TypeError(failure);
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    origin: accessorDescriptor(getOrigin),
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    protocol: accessorDescriptor(getProtocol, function (protocol) {
      var url = getInternalURLState(this);
      parseURL(url, String(protocol) + ':', SCHEME_START);
    }),
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    username: accessorDescriptor(getUsername, function (username) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(username));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.username = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.username += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    password: accessorDescriptor(getPassword, function (password) {
      var url = getInternalURLState(this);
      var codePoints = arrayFrom(String(password));
      if (cannotHaveUsernamePasswordPort(url)) return;
      url.password = '';
      for (var i = 0; i < codePoints.length; i++) {
        url.password += percentEncode(codePoints[i], userinfoPercentEncodeSet);
      }
    }),
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    host: accessorDescriptor(getHost, function (host) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(host), HOST);
    }),
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    hostname: accessorDescriptor(getHostname, function (hostname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      parseURL(url, String(hostname), HOSTNAME);
    }),
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    port: accessorDescriptor(getPort, function (port) {
      var url = getInternalURLState(this);
      if (cannotHaveUsernamePasswordPort(url)) return;
      port = String(port);
      if (port == '') url.port = null;
      else parseURL(url, port, PORT);
    }),
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    pathname: accessorDescriptor(getPathname, function (pathname) {
      var url = getInternalURLState(this);
      if (url.cannotBeABaseURL) return;
      url.path = [];
      parseURL(url, pathname + '', PATH_START);
    }),
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    search: accessorDescriptor(getSearch, function (search) {
      var url = getInternalURLState(this);
      search = String(search);
      if (search == '') {
        url.query = null;
      } else {
        if ('?' == search.charAt(0)) search = search.slice(1);
        url.query = '';
        parseURL(url, search, QUERY);
      }
      getInternalSearchParamsState(url.searchParams).updateSearchParams(url.query);
    }),
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    searchParams: accessorDescriptor(getSearchParams),
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    hash: accessorDescriptor(getHash, function (hash) {
      var url = getInternalURLState(this);
      hash = String(hash);
      if (hash == '') {
        url.fragment = null;
        return;
      }
      if ('#' == hash.charAt(0)) hash = hash.slice(1);
      url.fragment = '';
      parseURL(url, hash, FRAGMENT);
    })
  });
}

// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
redefine(URLPrototype, 'toJSON', function toJSON() {
  return serializeURL.call(this);
}, { enumerable: true });

// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
redefine(URLPrototype, 'toString', function toString() {
  return serializeURL.call(this);
}, { enumerable: true });

if (NativeURL) {
  var nativeCreateObjectURL = NativeURL.createObjectURL;
  var nativeRevokeObjectURL = NativeURL.revokeObjectURL;
  // `URL.createObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeCreateObjectURL) redefine(URLConstructor, 'createObjectURL', function createObjectURL(blob) {
    return nativeCreateObjectURL.apply(NativeURL, arguments);
  });
  // `URL.revokeObjectURL` method
  // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  if (nativeRevokeObjectURL) redefine(URLConstructor, 'revokeObjectURL', function revokeObjectURL(url) {
    return nativeRevokeObjectURL.apply(NativeURL, arguments);
  });
}

setToStringTag(URLConstructor, 'URL');

$({ global: true, forced: !USE_NATIVE_URL, sham: !DESCRIPTORS }, {
  URL: URLConstructor
});


/***/ }),

/***/ "2b3e":
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__("585a");

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ "2b58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdownGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c578");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdownGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdownGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdownGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "2d7c":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ "2dc8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopconfirm_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c4e2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopconfirm_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopconfirm_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopconfirm_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2dcb":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ "2ec1":
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__("100e"),
    isIterateeCall = __webpack_require__("9aff");

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),

/***/ "2f74":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputGiant_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2881");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputGiant_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputGiant_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputGiant_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "2fcc":
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ "30c9":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isLength = __webpack_require__("b218");

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ "316d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"UiCollapseMenu_menu_f-wrJ","menu__collapse":"UiCollapseMenu_menu__collapse_QPWVK","menu_opened":"UiCollapseMenu_menu_opened_38fTu","menu_active":"UiCollapseMenu_menu_active_tkZgF"};

/***/ }),

/***/ "3229":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiField_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("73e8");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiField_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiField_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiField_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "32b3":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ "32f4":
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__("2d7c"),
    stubArray = __webpack_require__("d327");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ "33a8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTransition_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7475");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTransition_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTransition_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "341b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFile_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ac0b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFile_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFile_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFile_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "34ac":
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__("9520"),
    isMasked = __webpack_require__("1368"),
    isObject = __webpack_require__("1a8c"),
    toSource = __webpack_require__("dc57");

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "35ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAlert_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d579");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAlert_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAlert_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAlert_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "3698":
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ "3729":
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__("9e69"),
    getRawTag = __webpack_require__("00fd"),
    objectToString = __webpack_require__("29f3");

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "39c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fdb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "39ff":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ "3b4a":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ "3b53":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"radio":"UiRadio_radio_P4fdK","radio__btn":"UiRadio_radio__btn_1YjS7","radio__btn-icon":"UiRadio_radio__btn-icon_3BrHz","radio__btn-input":"UiRadio_radio__btn-input_1rcZ9","radio__text":"UiRadio_radio__text_1YXa9","radio__label":"UiRadio_radio__label_2CGH1","radio__desc":"UiRadio_radio__desc_33Shr","radio_disabled":"UiRadio_radio_disabled_2PVDX","radio_checked":"UiRadio_radio_checked_3lboj","radio_active":"UiRadio_radio_active_3Nb_4","radio_focused":"UiRadio_radio_focused_2EDpl","radio-wrap":"UiRadio_radio-wrap_2lQuc"};

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3c5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAttachment_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("20c6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAttachment_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAttachment_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAttachment_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "3c97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiOptionGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cee1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiOptionGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiOptionGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiOptionGroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3e95":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c6ff");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "3f02":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"UiTitle_title_3FT8S"};

/***/ }),

/***/ "3f06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTag_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3fdc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTag_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTag_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTag_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "3fdc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"tag-wrap":"UiTag_tag-wrap_2Z33w","tag":"UiTag_tag_1Gnu2","tag__close":"UiTag_tag__close_12f6X","tag__content":"UiTag_tag__content_7ZOG1","tag__left-icon":"UiTag_tag__left-icon_1mGE6","tag_light":"UiTag_tag_light_1obJS","tag_dark":"UiTag_tag_dark_10RwR","tag_large":"UiTag_tag_large_36Vdu","tag_big":"UiTag_tag_big_3zXit","tag_small":"UiTag_tag_small_5BAxj","tag_caps":"UiTag_tag_caps_3IfeJ","tag_pointer":"UiTag_tag_pointer_mRwfl"};

/***/ }),

/***/ "40ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"UiRow_row_tDv3Q","row_top-xxs":"UiRow_row_top-xxs_2z8xB","row_top-xs":"UiRow_row_top-xs_P3M8S","row_top-s":"UiRow_row_top-s_1ZyHD","row_top-m":"UiRow_row_top-m_3Uegk","row_top-l":"UiRow_row_top-l_1WVP6","row_top-xl":"UiRow_row_top-xl_WF4ii","row_bottom-xxs":"UiRow_row_bottom-xxs_1jmZy","row_bottom-xs":"UiRow_row_bottom-xs_3SaCj","row_bottom-s":"UiRow_row_bottom-s_2tSHR","row_bottom-m":"UiRow_row_bottom-m_1I9u7","row_bottom-l":"UiRow_row_bottom-l_12G1W","row_bottom-xl":"UiRow_row_bottom-xl_3OaT9","row_inner-top-xxs":"UiRow_row_inner-top-xxs_3Sa7O","row_inner-top-xs":"UiRow_row_inner-top-xs_2YAf6","row_inner-top-s":"UiRow_row_inner-top-s_1sj7E","row_inner-top-m":"UiRow_row_inner-top-m_2AFLh","row_inner-top-l":"UiRow_row_inner-top-l_64juP","row_inner-top-xl":"UiRow_row_inner-top-xl_2EgIf","row_inner-bottom-xxs":"UiRow_row_inner-bottom-xxs_1Qgi5","row_inner-bottom-xs":"UiRow_row_inner-bottom-xs_2CGz2","row_inner-bottom-s":"UiRow_row_inner-bottom-s_1NkOT","row_inner-bottom-m":"UiRow_row_inner-bottom-m_Ps2mj","row_inner-bottom-l":"UiRow_row_inner-bottom-l_1eApq","row_inner-bottom-xl":"UiRow_row_inner-bottom-xl_3NNNp"};

/***/ }),

/***/ "41c3":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c"),
    isPrototype = __webpack_require__("eac5"),
    nativeKeysIn = __webpack_require__("ec8c");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ "4245":
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__("1290");

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ "42454":
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__("f909"),
    createAssigner = __webpack_require__("2ec1");

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ "4284":
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42a2":
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__("b5a7"),
    Map = __webpack_require__("79bc"),
    Promise = __webpack_require__("1cec"),
    Set = __webpack_require__("c869"),
    WeakMap = __webpack_require__("39ff"),
    baseGetTag = __webpack_require__("3729"),
    toSource = __webpack_require__("dc57");

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ "4359":
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ "4413":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputNumber_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f24a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputNumber_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputNumber_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputNumber_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "4440":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"error-wrap":"UiErrors_error-wrap_KXWqN","error":"UiErrors_error_1D_Tp","error_ellipsis":"UiErrors_error_ellipsis_3amZJ","error_right":"UiErrors_error_right_3nGYE"};

/***/ }),

/***/ "4498":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"color-box":"ColorBox_color-box_1bJlm","color-box__row":"ColorBox_color-box__row_1lGEJ","color-box__sliders":"ColorBox_color-box__sliders_Vep2N","color-box__sliders-body":"ColorBox_color-box__sliders-body_j4TA1","color-box__btn":"ColorBox_color-box__btn_1zmkG","panel":"ColorBox_panel_1uZ6R","panel__alpha":"ColorBox_panel__alpha_2_v98","panel__color-value":"ColorBox_panel__color-value_2eBFy"};

/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "465b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiScrollbar_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa25");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiScrollbar_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiScrollbar_vue_vue_type_style_index_0_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "48d4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"action-btn":"UiActionBtn_action-btn_3ZMpY","action-btn_success":"UiActionBtn_action-btn_success_d4nKk","action-btn_cancel":"UiActionBtn_action-btn_cancel_1bzEp","action-btn__icon":"UiActionBtn_action-btn__icon_2_mAA","action-btn_loading":"UiActionBtn_action-btn_loading_S9jTf","action-btn__icon_success":"UiActionBtn_action-btn__icon_success_30Saj","action-btn__icon_cancel":"UiActionBtn_action-btn__icon_cancel_118iC"};

/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var IS_NODE = __webpack_require__("605d");
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // eslint-disable-next-line es/no-symbol -- required for testing
  return !Symbol.sham &&
    // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    (IS_NODE ? V8_VERSION === 38 : V8_VERSION > 37 && V8_VERSION < 41);
});


/***/ }),

/***/ "49c4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("316d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenu_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "49f4":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ "4b79":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"UiLink_link_184Im","link__icon":"UiLink_link__icon_r5CwL","link__inner":"UiLink_link__inner_7wXh-","link_light":"UiLink_link_light_2Nvoa","link_default":"UiLink_link_default_2-Ne0","link_dark":"UiLink_link_dark_3D9ma","link_breadcrumbs":"UiLink_link_breadcrumbs_YCF2c","link_navigation":"UiLink_link_navigation_1xP0R","link_navigation-anchor":"UiLink_link_navigation-anchor_2zZdD","link_title":"UiLink_link_title_8yegN","link_tiny":"UiLink_link_tiny_OrrGs","link_small":"UiLink_link_small_kqHCB","link_body":"UiLink_link_body_2iuAH","link_paragraph":"UiLink_link_paragraph_3pYpD","link_article":"UiLink_link_article_1idIq","link_title-02":"UiLink_link_title-02_1erAj","link_title-01":"UiLink_link_title-01_2_UfX","link_accent":"UiLink_link_accent_coox8","link_dot-border":"UiLink_link_dot-border_2M2S4","link_ellipsis":"UiLink_link_ellipsis_ZNp-t"};

/***/ }),

/***/ "4bbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatarList_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a41c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatarList_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatarList_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatarList_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "4c96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ac3f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4f50":
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__("b760"),
    cloneBuffer = __webpack_require__("e538"),
    cloneTypedArray = __webpack_require__("c8fe"),
    copyArray = __webpack_require__("4359"),
    initCloneObject = __webpack_require__("fa21"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isArrayLikeObject = __webpack_require__("dcbe"),
    isBuffer = __webpack_require__("0d24"),
    isFunction = __webpack_require__("9520"),
    isObject = __webpack_require__("1a8c"),
    isPlainObject = __webpack_require__("60ed"),
    isTypedArray = __webpack_require__("73ac"),
    safeGet = __webpack_require__("8adb"),
    toPlainObject = __webpack_require__("8de2");

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ "4fb2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"UiAccordionItem_item_18kad","head":"UiAccordionItem_head_36AjC","head__title":"UiAccordionItem_head__title_13WHx","head__btn-box":"UiAccordionItem_head__btn-box_3C6xT","head__button_active":"UiAccordionItem_head__button_active_aHrNF","head__icon":"UiAccordionItem_head__icon_17RqE","head__icon_open":"UiAccordionItem_head__icon_open_1C5jm","content":"UiAccordionItem_content_1f_Gj"};

/***/ }),

/***/ "4fdb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"UiDropSelect_select_HWDW_","select__content":"UiDropSelect_select__content_1qWdp","select__content-inner":"UiDropSelect_select__content-inner_10TqM","open":"UiDropSelect_open_1QFLb","select__content-ch-wrap":"UiDropSelect_select__content-ch-wrap_2yo8T","select__content-ch":"UiDropSelect_select__content-ch_1SL34","select__footer":"UiDropSelect_select__footer_1N7cw","select__error":"UiDropSelect_select__error_3BII5","greenIcon":"UiDropSelect_greenIcon_2Mnj_","select-trigger":"UiDropSelect_select-trigger_3iTDb"};

/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "50d8":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5239":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCopyBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("80d7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCopyBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCopyBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCopyBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "531a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenuGroup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b9d7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenuGroup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenuGroup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseMenuGroup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "556c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPagination_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("97c1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPagination_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPagination_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPagination_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "55a3":
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ "5612":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"ui-input":"UiInput_ui-input_3K9rK","ui-input__fake-placeholder":"UiInput_ui-input__fake-placeholder_1AsIE","ui-input_variable-width":"UiInput_ui-input_variable-width_1s08-","ui-input_default":"UiInput_ui-input_default_2XTSW","input":"UiInput_input_3imQE","input__area":"UiInput_input__area_2i6h-","input_placeholder-style":"UiInput_input_placeholder-style_wDc75","input__prefix":"UiInput_input__prefix_2_E8S","input__icon":"UiInput_input__icon_3OvsI","input__icon_state-fill":"UiInput_input__icon_state-fill_1wBLL","input__icon_loading":"UiInput_input__icon_loading_3jwDM","input__error":"UiInput_input__error_1jBJf","input_focus":"UiInput_input_focus_398gr","input_error":"UiInput_input_error_6lyBB","input__btn-clear":"UiInput_input__btn-clear_LQrAJ","input_disabled":"UiInput_input_disabled_14igw","input_readonly":"UiInput_input_readonly_1cj8_","input_with-left-icon":"UiInput_input_with-left-icon_sfw1P","input_with-right-icon":"UiInput_input_with-right-icon_2R06a","input_no-empty":"UiInput_input_no-empty_3zTOx","input__icon_left":"UiInput_input__icon_left_2jUiU","ui-input_inline-edit":"UiInput_ui-input_inline-edit_1h7X0","input_accent":"UiInput_input_accent_2fw2T","input__icon_right":"UiInput_input__icon_right_1BqVo","input_inversion":"UiInput_input_inversion_hzwQW","input_xs":"UiInput_input_xs_3dDw_","input_sm":"UiInput_input_sm_3iUL0","input_md":"UiInput_input_md_3bIGh","input_lg":"UiInput_input_lg_2ZIMU","input_xl":"UiInput_input_xl_2z8TY","input_min":"UiInput_input_min_2Jfm8","input__error_ellipsis":"UiInput_input__error_ellipsis_9w2aJ","input__error_right":"UiInput_input__error_right_3eNZV","input__btn-clear_disabled":"UiInput_input__btn-clear_disabled_PIvQl","input_readonly_grey":"UiInput_input_readonly_grey_3L711","input__tooltip-area":"UiInput_input__tooltip-area_3JKCR","input__error-tooltip":"UiInput_input__error-tooltip_219og","input__error-wrap":"UiInput_input__error-wrap_10m_Y","input_stepper-horizontal":"UiInput_input_stepper-horizontal_3cf7Q","input_stepper-vertical":"UiInput_input_stepper-vertical_3e0mJ","input_stepper-inline":"UiInput_input_stepper-inline_19pdW"};

/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.10.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "57a5":
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__("91e9");

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ "585a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "5a4c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"box":"UiCollapseBox_box_XPylv","box_bordered":"UiCollapseBox_box_bordered_1M3dt","box__inner-wrap":"UiCollapseBox_box__inner-wrap_1VedQ","box_active":"UiCollapseBox_box_active_3eKB2","box_disabled":"UiCollapseBox_box_disabled_3qUML","box_shadows":"UiCollapseBox_box_shadows_3NVfA","box__arrow":"UiCollapseBox_box__arrow_nRRof","box__head":"UiCollapseBox_box__head_1aV0s","box__title-wrap":"UiCollapseBox_box__title-wrap_39VYf","box__title":"UiCollapseBox_box__title_1flrE","box__title_ellipsis":"UiCollapseBox_box__title_ellipsis_3RHBa","box__description":"UiCollapseBox_box__description_3XdOv","box__action":"UiCollapseBox_box__action_2AvHs","box__icon":"UiCollapseBox_box__icon_d3BDR","box__icon-inner":"UiCollapseBox_box__icon-inner_2XzWh","box__icon_sm":"UiCollapseBox_box__icon_sm_2A81N","box__icon_md":"UiCollapseBox_box__icon_md_2JsoW","box__collapse":"UiCollapseBox_box__collapse_2_E6l","box__row":"UiCollapseBox_box__row_2U_2D","box__inner":"UiCollapseBox_box__inner_15Car","box__inner_md":"UiCollapseBox_box__inner_md_jLi2V","box__row_head":"UiCollapseBox_box__row_head_2ZWiJ","box__row_body":"UiCollapseBox_box__row_body_3IRaY","box__col":"UiCollapseBox_box__col_XOadK","box__footer":"UiCollapseBox_box__footer_2iHeh","box_with-icon-sm":"UiCollapseBox_box_with-icon-sm_1Pi6E","box_with-icon-md":"UiCollapseBox_box_with-icon-md_1fiTS","pointer":"UiCollapseBox_pointer_1g2yb","box_color_red":"UiCollapseBox_box_color_red_1AfxD","box_color_blue":"UiCollapseBox_box_color_blue_2pS6A","box_color_yellow":"UiCollapseBox_box_color_yellow_33CqR","box_color_green":"UiCollapseBox_box_color_green_b6xmj","box_color_purple":"UiCollapseBox_box_color_purple_1YUhE","box_color_black":"UiCollapseBox_box_color_black_3GfxO","box_color_grey":"UiCollapseBox_box_color_grey_2KNN9","disabled-tooltip":"UiCollapseBox_disabled-tooltip_7-nbe","disabled-tooltip__trigger":"UiCollapseBox_disabled-tooltip__trigger_38UWn","disabled-tooltip__popover":"UiCollapseBox_disabled-tooltip__popover_2Crd8","error-msg":"UiCollapseBox_error-msg_2iX_a","error-msg__icon":"UiCollapseBox_error-msg__icon_2SO8V"};

/***/ }),

/***/ "5b0a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabsItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("13fa");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabsItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabsItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabsItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "5bc3":
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5a4c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapseBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "5d6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4498");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ColorBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "5e2e":
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__("28c9"),
    listCacheDelete = __webpack_require__("69d5"),
    listCacheGet = __webpack_require__("b4c0"),
    listCacheHas = __webpack_require__("fba5"),
    listCacheSet = __webpack_require__("67ca");

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ "5fb2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var base = 36;
var tMin = 1;
var tMax = 26;
var skew = 38;
var damp = 700;
var initialBias = 72;
var initialN = 128; // 0x80
var delimiter = '-'; // '\x2D'
var regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var OVERFLOW_ERROR = 'Overflow: input needs wider integers to process';
var baseMinusTMin = base - tMin;
var floor = Math.floor;
var stringFromCharCode = String.fromCharCode;

/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */
var ucs2decode = function (string) {
  var output = [];
  var counter = 0;
  var length = string.length;
  while (counter < length) {
    var value = string.charCodeAt(counter++);
    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
      // It's a high surrogate, and there is a next character.
      var extra = string.charCodeAt(counter++);
      if ((extra & 0xFC00) == 0xDC00) { // Low surrogate.
        output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
      } else {
        // It's an unmatched surrogate; only append this code unit, in case the
        // next code unit is the high surrogate of a surrogate pair.
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
};

/**
 * Converts a digit/integer into a basic code point.
 */
var digitToBasic = function (digit) {
  //  0..25 map to ASCII a..z or A..Z
  // 26..35 map to ASCII 0..9
  return digit + 22 + 75 * (digit < 26);
};

/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */
var adapt = function (delta, numPoints, firstTime) {
  var k = 0;
  delta = firstTime ? floor(delta / damp) : delta >> 1;
  delta += floor(delta / numPoints);
  for (; delta > baseMinusTMin * tMax >> 1; k += base) {
    delta = floor(delta / baseMinusTMin);
  }
  return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};

/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */
// eslint-disable-next-line max-statements -- TODO
var encode = function (input) {
  var output = [];

  // Convert the input in UCS-2 to an array of Unicode code points.
  input = ucs2decode(input);

  // Cache the length.
  var inputLength = input.length;

  // Initialize the state.
  var n = initialN;
  var delta = 0;
  var bias = initialBias;
  var i, currentValue;

  // Handle the basic code points.
  for (i = 0; i < input.length; i++) {
    currentValue = input[i];
    if (currentValue < 0x80) {
      output.push(stringFromCharCode(currentValue));
    }
  }

  var basicLength = output.length; // number of basic code points.
  var handledCPCount = basicLength; // number of code points that have been handled;

  // Finish the basic string with a delimiter unless it's empty.
  if (basicLength) {
    output.push(delimiter);
  }

  // Main encoding loop:
  while (handledCPCount < inputLength) {
    // All non-basic code points < n have been handled already. Find the next larger one:
    var m = maxInt;
    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue >= n && currentValue < m) {
        m = currentValue;
      }
    }

    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
    var handledCPCountPlusOne = handledCPCount + 1;
    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
      throw RangeError(OVERFLOW_ERROR);
    }

    delta += (m - n) * handledCPCountPlusOne;
    n = m;

    for (i = 0; i < input.length; i++) {
      currentValue = input[i];
      if (currentValue < n && ++delta > maxInt) {
        throw RangeError(OVERFLOW_ERROR);
      }
      if (currentValue == n) {
        // Represent delta as a generalized variable-length integer.
        var q = delta;
        for (var k = base; /* no condition */; k += base) {
          var t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
          if (q < t) break;
          var qMinusT = q - t;
          var baseMinusT = base - t;
          output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT)));
          q = floor(qMinusT / baseMinusT);
        }

        output.push(stringFromCharCode(digitToBasic(q)));
        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
        delta = 0;
        ++handledCPCount;
      }
    }

    ++delta;
    ++n;
  }
  return output.join('');
};

module.exports = function (input) {
  var encoded = [];
  var labels = input.toLowerCase().replace(regexSeparators, '\u002E').split('.');
  var i, label;
  for (i = 0; i < labels.length; i++) {
    label = labels[i];
    encoded.push(regexNonASCII.test(label) ? 'xn--' + encode(label) : label);
  }
  return encoded.join('.');
};


/***/ }),

/***/ "6044":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07");

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6097":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6a52");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiPopup_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "60ed":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    getPrototype = __webpack_require__("2dcb"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "6323":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTimeBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aeb1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTimeBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTimeBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTimeBox_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "63ea":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__("c05f");

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "668e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"submenu-btn":"UiSubmenuBtn_submenu-btn_-NQ2Y","submenu-btn_active":"UiSubmenuBtn_submenu-btn_active_1OIX_"};

/***/ }),

/***/ "66cb":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if ( true && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {return tinycolor;}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {}

})(Math);


/***/ }),

/***/ "6747":
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ "67ca":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ "686b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a30f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIcon_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "69d5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6a52":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"popup-wrapp":"UiPopup_popup-wrapp_1gVtr","popup-overlay":"UiPopup_popup-overlay_1gN8k","popup":"UiPopup_popup_3ESMf","popup__close":"UiPopup_popup__close_f5IoB","popup__content":"UiPopup_popup__content_1E6zX","popup__head":"UiPopup_popup__head_3BYin","popup__head-icon":"UiPopup_popup__head-icon_nACCG","popup__head-title":"UiPopup_popup__head-title_3aIAg","popup__footer":"UiPopup_popup__footer_1GepO","popup__tooltip":"UiPopup_popup__tooltip_1Vzxt","popup__title":"UiPopup_popup__title_HFht2","popup_popup":"UiPopup_popup_popup_1MnAf","popup_with-fixed-title":"UiPopup_popup_with-fixed-title_Z8e6Y","popup_responsive":"UiPopup_popup_responsive_xutSJ","popup__title-wrap":"UiPopup_popup__title-wrap_2yn8g","popup_confirm":"UiPopup_popup_confirm_3bqsW","popup_alert":"UiPopup_popup_alert_AYOlB","popup_hint":"UiPopup_popup_hint_1ytkM","popup__footer-description":"UiPopup_popup__footer-description_1G8Xb","popup-body-wrapp":"UiPopup_popup-body-wrapp_bxqNU","shortcut-tooltip":"UiPopup_shortcut-tooltip_AtbfE","popup_fullscreen":"UiPopup_popup_fullscreen_2Bmh1"};

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f86":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"popover":"UiBreadcrumbsMore_popover_1Ccje","target":"UiBreadcrumbsMore_target_3IYM5","target_light":"UiBreadcrumbsMore_target_light_34wu7","open":"UiBreadcrumbsMore_open_1rlL0","target_dark":"UiBreadcrumbsMore_target_dark_2XP-X","target_rules":"UiBreadcrumbsMore_target_rules_1wLkQ","target__icon":"UiBreadcrumbsMore_target__icon_2Cj_8","more-dropdown":"UiBreadcrumbsMore_more-dropdown_1BgHz","more-dropdown__item":"UiBreadcrumbsMore_more-dropdown__item_1v5eM"};

/***/ }),

/***/ "6fcd":
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__("50d8"),
    isArguments = __webpack_require__("d370"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isIndex = __webpack_require__("c098"),
    isTypedArray = __webpack_require__("73ac");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ "7037":
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "72af":
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__("99cd");

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ "72e0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ed0e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAvatar_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "72f0":
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ "734a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "73ac":
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__("743f"),
    baseUnary = __webpack_require__("b047"),
    nodeUtil = __webpack_require__("99d3");

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ "73e8":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"field-row":"UiField_field-row_2D3qI","field-row__label-box":"UiField_field-row__label-box_2NTyd","field-row__label":"UiField_field-row__label_16xqa","field-row__icon":"UiField_field-row__icon_21rvJ","field-row__subtitle":"UiField_field-row__subtitle_3V0k-"};

/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "743f":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isLength = __webpack_require__("b218"),
    isObjectLike = __webpack_require__("1310");

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ "7475":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "747c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"saturation":"SaturationSlider_saturation_3t2c5","saturation__grad":"SaturationSlider_saturation__grad_ObyWC","saturation__grad_black":"SaturationSlider_saturation__grad_black_3m3WK","saturation__grad_white":"SaturationSlider_saturation__grad_white_2Wlvh","saturation-pointer":"SaturationSlider_saturation-pointer_1ro9B","saturation-pointer__inner":"SaturationSlider_saturation-pointer__inner_2gkkK"};

/***/ }),

/***/ "7530":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("1a8c");

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ "7611":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"UiButton_btn_3ejnD","btn_block":"UiButton_btn_block_2s7jf","btn__inner":"UiButton_btn__inner_1rctX","btn__icon":"UiButton_btn__icon_3qm4B","btn__icon-success":"UiButton_btn__icon-success_1bD0X","btn_primary":"UiButton_btn_primary_2n0L-","btn_active":"UiButton_btn_active_2N6D0","btn_primary-success":"UiButton_btn_primary-success_3CPeN","btn_primary-error":"UiButton_btn_primary-error_3Wmu6","btn_primary-loading":"UiButton_btn_primary-loading_bARTd","btn_disabled":"UiButton_btn_disabled_3YEpN","btn_secondary":"UiButton_btn_secondary_35rAN","btn_secondary-success":"UiButton_btn_secondary-success_1THaG","btn_secondary-error":"UiButton_btn_secondary-error_eOnCU","btn_secondary-loading":"UiButton_btn_secondary-loading_3xxrh","btn_tertiary":"UiButton_btn_tertiary_33eRf","btn_delete":"UiButton_btn_delete_3JvGq","btn_tertiary-success":"UiButton_btn_tertiary-success_2j8_T","btn_tertiary-error":"UiButton_btn_tertiary-error_3y2mU","btn_tertiary-loading":"UiButton_btn_tertiary-loading_eAhCP","btn_outlined":"UiButton_btn_outlined_3KfK7","btn_blue":"UiButton_btn_blue_2u7rs","btn_black":"UiButton_btn_black_N6u3D","btn_lg":"UiButton_btn_lg_23Ixt","btn__txt":"UiButton_btn__txt_lBLyT","btn_left-icon":"UiButton_btn_left-icon_1YdIB","btn_right-icon":"UiButton_btn_right-icon_9kWUY","btn_md":"UiButton_btn_md_2eedl","btn_sm":"UiButton_btn_sm_MukZt","btn_xs":"UiButton_btn_xs_1hbVo","btn_circle":"UiButton_btn_circle_23K6M","btn_square":"UiButton_btn_square_I9yuL","btn_ellipsis":"UiButton_btn_ellipsis_14NYF","btn-tooltip":"UiButton_btn-tooltip_3zHXn"};

/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7867":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7d49");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "7951":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"navigation":"UiCalendarNavigation_navigation_ua63c","navigation__placeholder":"UiCalendarNavigation_navigation__placeholder_1NoVN","navigation__icon":"UiCalendarNavigation_navigation__icon_QMGpu","navigation__text":"UiCalendarNavigation_navigation__text_2AKK6"};

/***/ }),

/***/ "7999":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabs_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1c07");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabs_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabs_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTabs_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "79bb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"inline-edit":"UiInlineEdit_inline-edit_3DGwX","inline-edit__input":"UiInlineEdit_inline-edit__input_10RpS","inline-edit__input_focused":"UiInlineEdit_inline-edit__input_focused_1-ycX","inline-edit__input_error":"UiInlineEdit_inline-edit__input_error_cmtXG","inline-edit__input_accent":"UiInlineEdit_inline-edit__input_accent_3EnJM","inline-edit__icon":"UiInlineEdit_inline-edit__icon_2vlqG","inline-edit__icon_inversion":"UiInlineEdit_inline-edit__icon_inversion_vqVyM","inline-edit__icon-left":"UiInlineEdit_inline-edit__icon-left_2f2mt","inline-edit__icon-right":"UiInlineEdit_inline-edit__icon-right_3k4Gp","inline-edit_inversion":"UiInlineEdit_inline-edit_inversion_3puRk","inline-edit_focused":"UiInlineEdit_inline-edit_focused_3cBEP","inline-edit_error":"UiInlineEdit_inline-edit_error_VjHuV","inline-edit_disabled":"UiInlineEdit_inline-edit_disabled_2qsDi","inline-edit_xs":"UiInlineEdit_inline-edit_xs_2lBYz","inline-edit__resposive-helper":"UiInlineEdit_inline-edit__resposive-helper_1dioF","inline-edit_sm":"UiInlineEdit_inline-edit_sm_5YQbJ","inline-edit_md":"UiInlineEdit_inline-edit_md_1nFuO","inline-edit_lg":"UiInlineEdit_inline-edit_lg_hC6iE","inline-edit_xl":"UiInlineEdit_inline-edit_xl_34FsZ"};

/***/ }),

/***/ "79bc":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ "7a48":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7b83":
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__("7c64"),
    mapCacheDelete = __webpack_require__("93ed"),
    mapCacheGet = __webpack_require__("2478"),
    mapCacheHas = __webpack_require__("a524"),
    mapCacheSet = __webpack_require__("1fc8");

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ "7b97":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    equalArrays = __webpack_require__("a2be"),
    equalByTag = __webpack_require__("1c3c"),
    equalObjects = __webpack_require__("b1e5"),
    getTag = __webpack_require__("42a2"),
    isArray = __webpack_require__("6747"),
    isBuffer = __webpack_require__("0d24"),
    isTypedArray = __webpack_require__("73ac");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ "7bf6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("296f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "7c03":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarNavigation_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7951");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarNavigation_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarNavigation_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarNavigation_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "7c64":
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__("e24ba"),
    ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc");

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7cb4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7d1f":
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__("087d"),
    isArray = __webpack_require__("6747");

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ "7d49":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"layout":"UiIntegrationLayout_layout_3yg4b","header":"UiIntegrationLayout_header_3n3EO","header__nav":"UiIntegrationLayout_header__nav_2tiIc","header__nav-logo":"UiIntegrationLayout_header__nav-logo_3udGQ","header__nav-arrow":"UiIntegrationLayout_header__nav-arrow_2bo0w","header__nav-item":"UiIntegrationLayout_header__nav-item_3CZOJ","header__nav-item_primary":"UiIntegrationLayout_header__nav-item_primary_3_STO","header__link":"UiIntegrationLayout_header__link_310Us","header__inner":"UiIntegrationLayout_header__inner_2nC_F","aside":"UiIntegrationLayout_aside_36gE9","content":"UiIntegrationLayout_content_hYJoj","main":"UiIntegrationLayout_main_1y-7e"};

/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7e64":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    stackClear = __webpack_require__("efb6"),
    stackDelete = __webpack_require__("2fcc"),
    stackGet = __webpack_require__("802a"),
    stackHas = __webpack_require__("55a3"),
    stackSet = __webpack_require__("d02c");

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ "7ed2":
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "802a":
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ "80d7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"btn-wrap":"UiCopyBtn_btn-wrap_3q022","copy-area":"UiCopyBtn_copy-area_2CGmx","tooltip__inline":"UiCopyBtn_tooltip__inline_1b0ZQ","tooltip__icon":"UiCopyBtn_tooltip__icon_2DaGx","tooltip__txt":"UiCopyBtn_tooltip__txt_rhp2N"};

/***/ }),

/***/ "8205":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAccordionItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4fb2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAccordionItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAccordionItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiAccordionItem_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "85e3":
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "86df":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"menu-btn":"UiMenuBtn_menu-btn_2mWVp","menu-btn_opened":"UiMenuBtn_menu-btn_opened_wlznG","menu-btn_active":"UiMenuBtn_menu-btn_active_1vJnz","menu-btn__inner":"UiMenuBtn_menu-btn__inner_w3w26","menu-btn__icon":"UiMenuBtn_menu-btn__icon_1UB7f","menu-btn__image":"UiMenuBtn_menu-btn__image_SswJJ","menu-btn__icon-collapse":"UiMenuBtn_menu-btn__icon-collapse_1FSSa","menu-btn__label":"UiMenuBtn_menu-btn__label_1DUsJ"};

/***/ }),

/***/ "872a":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("3b4a");

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ "8756":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"UiInputDropdown_input_3uKMA","input__inner":"UiInputDropdown_input__inner_3o9ZS","input__inner_disabled":"UiInputDropdown_input__inner_disabled_25lMr","input__image-hover":"UiInputDropdown_input__image-hover_1vbyP","input__icon_prefix":"UiInputDropdown_input__icon_prefix_12iDr","input__text":"UiInputDropdown_input__text_1P9He","ticker":"UiInputDropdown_ticker_2qhst","input__inner_center":"UiInputDropdown_input__inner_center_1dcTI","input__content":"UiInputDropdown_input__content_3T9LH","input__descript":"UiInputDropdown_input__descript_1bPOT","input__icon":"UiInputDropdown_input__icon_2SfZN","input__icon_suffix":"UiInputDropdown_input__icon_suffix__-QJ1","input__avatar":"UiInputDropdown_input__avatar_1gR_U","input__image":"UiInputDropdown_input__image_2AC8r","input__additional-txt":"UiInputDropdown_input__additional-txt_aRQ6R","input_start-icon":"UiInputDropdown_input_start-icon_ItU2b","input_black-icon":"UiInputDropdown_input_black-icon_2UAZf","input_simple":"UiInputDropdown_input_simple_3wwVs","input_disabled":"UiInputDropdown_input_disabled_3GOuh","input_md":"UiInputDropdown_input_md_31N3t","input_sm":"UiInputDropdown_input_sm_-1gW4","input_accent":"UiInputDropdown_input_accent_2aNlk","input_delete":"UiInputDropdown_input_delete_1Q981"};

/***/ }),

/***/ "8824":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b21c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiListBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "89f5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UiDropdownMenu_dropdown_oxSy0","dropdown-content":"UiDropdownMenu_dropdown-content_lGjJv","dropdown-content__inner":"UiDropdownMenu_dropdown-content__inner_zGVf7","dropdown-content__inner_menu":"UiDropdownMenu_dropdown-content__inner_menu_3U3DJ","open":"UiDropdownMenu_open_VH9yE","dropdown-btn":"UiDropdownMenu_dropdown-btn_2Kk_-","dropdown-btn_disabled":"UiDropdownMenu_dropdown-btn_disabled_3O5d8","dropdown-btn_active":"UiDropdownMenu_dropdown-btn_active_rruWI","dropdown-btn__icon":"UiDropdownMenu_dropdown-btn__icon_3aLxs","dropdown-btn__title":"UiDropdownMenu_dropdown-btn__title_b2tCv","dropdown-btn__image":"UiDropdownMenu_dropdown-btn__image_1lr0U","dropdown-btn_white":"UiDropdownMenu_dropdown-btn_white_1YZbM","dropdown-btn_grey":"UiDropdownMenu_dropdown-btn_grey_ESI_H","dropdown-btn_tertiary":"UiDropdownMenu_dropdown-btn_tertiary_2px8I","dropdown-menu-item":"UiDropdownMenu_dropdown-menu-item_24Jn3"};

/***/ }),

/***/ "8adb":
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ "8b68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c724");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroup_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ "8d16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0317");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "8de2":
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__("8eeb"),
    keysIn = __webpack_require__("9934");

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ "8df4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d113");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiDropSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "8eeb":
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__("32b3"),
    baseAssignValue = __webpack_require__("872a");

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ "8f8f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"cp__trigger":"UiColorPicker_cp__trigger_1iG9C","cp__content":"UiColorPicker_cp__content_307N5","open":"UiColorPicker_open_zVqRg","cp__content-inner":"UiColorPicker_cp__content-inner_3Pn05","cp":"UiColorPicker_cp_3gt5R"};

/***/ }),

/***/ "8fa9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInput_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5612");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInput_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInput_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInput_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "909a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"add-btn":"UiAddButton_add-btn_Cp4kw","add-btn__content":"UiAddButton_add-btn__content_3kMef","add-btn_sm":"UiAddButton_add-btn_sm_12krs","add-btn_lg":"UiAddButton_add-btn_lg_2r3JK","add-btn_green":"UiAddButton_add-btn_green_2TomO","add-btn_blue":"UiAddButton_add-btn_blue_265kb","add-btn_red":"UiAddButton_add-btn_red_bH-n1","add-btn_yellow":"UiAddButton_add-btn_yellow_2R7eh","add-btn_purple":"UiAddButton_add-btn_purple_2eTuC"};

/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "91e9":
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ "9203":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d864");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiProgress_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "9367":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"uploader__errors":"UiUploader_uploader__errors_33Wyu","uploader_button":"UiUploader_uploader_button_-o2pu","uploader__restrictions":"UiUploader_uploader__restrictions_YcU-7","uploader__files":"UiUploader_uploader__files_2RuQ4","drop-area":"UiUploader_drop-area_RfnLZ","drop-area_big":"UiUploader_drop-area_big_2-bCI","drop-area_button":"UiUploader_drop-area_button_1_vrX","drop-area_waiting-for-drop":"UiUploader_drop-area_waiting-for-drop_10OJN","drop-area_error":"UiUploader_drop-area_error_2X9C1","drop-area__input":"UiUploader_drop-area__input_nIzb4","drop-area__trigger":"UiUploader_drop-area__trigger_iHTDv","drop-area_ready":"UiUploader_drop-area_ready_3s120","label":"UiUploader_label_25Sdu","label__content":"UiUploader_label__content_17Jvu","label__restrictions":"UiUploader_label__restrictions_3OuMP","label__trigger":"UiUploader_label__trigger_Fnh0R","btn":"UiUploader_btn_2csGI","btn__file":"UiUploader_btn__file_3-Tsq","btn_inline-restriction":"UiUploader_btn_inline-restriction_3Lexg"};

/***/ }),

/***/ "93da":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarCell_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("17c9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarCell_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarCell_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCalendarCell_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "93ed":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "9520":
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__("3729"),
    isObject = __webpack_require__("1a8c");

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ "9523":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "9638":
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ "970b":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ "97c1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination":"UiPagination_pagination_3L6vo","pagination__arrow":"UiPagination_pagination__arrow_hno-T","pagination__arrow-icon":"UiPagination_pagination__arrow-icon_2GTp7","pagination__arrow_prev":"UiPagination_pagination__arrow_prev_p287o","pagination__arrow_next":"UiPagination_pagination__arrow_next_2L43h","pagination__pages-wrap":"UiPagination_pagination__pages-wrap_2rIQn","pagination__square":"UiPagination_pagination__square_RM1YT","pagination__hover-style":"UiPagination_pagination__hover-style_3dehx","pagination__page":"UiPagination_pagination__page_As_Jy","pagination__page_active":"UiPagination_pagination__page_active_26ew2","pagination__dots":"UiPagination_pagination__dots_2dAs3","pagination__dots-icon":"UiPagination_pagination__dots-icon_1KPt5","pagination__arrows-wrap":"UiPagination_pagination__arrows-wrap_3Eq-Y","pagination__arrows-wrap_start":"UiPagination_pagination__arrows-wrap_start_2ty_m","pagination__arrows-wrap_end":"UiPagination_pagination__arrows-wrap_end_27t_T"};

/***/ }),

/***/ "9812":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"color-slider":"ColorSlider_color-slider_1uX4V","color-slider__track":"ColorSlider_color-slider__track_3EyTX","slider-pointer":"ColorSlider_slider-pointer_1C7iB","slider-pointer__inner":"ColorSlider_slider-pointer__inner_3PMZH"};

/***/ }),

/***/ "983b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1e58");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCheckbox_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "9861":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("e260");
var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var redefine = __webpack_require__("6eeb");
var redefineAll = __webpack_require__("e2cc");
var setToStringTag = __webpack_require__("d44e");
var createIteratorConstructor = __webpack_require__("9ed3");
var InternalStateModule = __webpack_require__("69f3");
var anInstance = __webpack_require__("19aa");
var hasOwn = __webpack_require__("5135");
var bind = __webpack_require__("0366");
var classof = __webpack_require__("f5df");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var wellKnownSymbol = __webpack_require__("b622");

var $fetch = getBuiltIn('fetch');
var Headers = getBuiltIn('Headers');
var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = it.replace(plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = result.replace(percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replace = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replace[match];
};

var serialize = function (it) {
  return encodeURIComponent(it).replace(find, replacer);
};

var parseSearchParams = function (result, query) {
  if (query) {
    var attributes = query.split('&');
    var index = 0;
    var attribute, entry;
    while (index < attributes.length) {
      attribute = attributes[index++];
      if (attribute.length) {
        entry = attribute.split('=');
        result.push({
          key: deserialize(entry.shift()),
          value: deserialize(entry.join('='))
        });
      }
    }
  }
};

var updateSearchParams = function (query) {
  this.entries.length = 0;
  parseSearchParams(this.entries, query);
};

var validateArgumentsLength = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
});

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsConstructor, URL_SEARCH_PARAMS);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  var that = this;
  var entries = [];
  var iteratorMethod, iterator, next, step, entryIterator, entryNext, first, second, key;

  setInternalState(that, {
    type: URL_SEARCH_PARAMS,
    entries: entries,
    updateURL: function () { /* empty */ },
    updateSearchParams: updateSearchParams
  });

  if (init !== undefined) {
    if (isObject(init)) {
      iteratorMethod = getIteratorMethod(init);
      if (typeof iteratorMethod === 'function') {
        iterator = iteratorMethod.call(init);
        next = iterator.next;
        while (!(step = next.call(iterator)).done) {
          entryIterator = getIterator(anObject(step.value));
          entryNext = entryIterator.next;
          if (
            (first = entryNext.call(entryIterator)).done ||
            (second = entryNext.call(entryIterator)).done ||
            !entryNext.call(entryIterator).done
          ) throw TypeError('Expected sequence with length 2');
          entries.push({ key: first.value + '', value: second.value + '' });
        }
      } else for (key in init) if (hasOwn(init, key)) entries.push({ key: key, value: init[key] + '' });
    } else {
      parseSearchParams(entries, typeof init === 'string' ? init.charAt(0) === '?' ? init.slice(1) : init : init + '');
    }
  }
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

redefineAll(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    state.entries.push({ key: name + '', value: value + '' });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) entries.splice(index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) result.push(entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = name + '';
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = name + '';
    var val = value + '';
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) entries.splice(index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) entries.push({ key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    var entries = state.entries;
    // Array#sort is not stable in some engines
    var slice = entries.slice();
    var entry, entriesIndex, sliceIndex;
    entries.length = 0;
    for (sliceIndex = 0; sliceIndex < slice.length; sliceIndex++) {
      entry = slice[sliceIndex];
      for (entriesIndex = 0; entriesIndex < sliceIndex; entriesIndex++) {
        if (entries[entriesIndex].key > entry.key) {
          entries.splice(entriesIndex, 0, entry);
          break;
        }
      }
      if (entriesIndex === sliceIndex) entries.push(entry);
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined, 3);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries);

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
redefine(URLSearchParamsPrototype, 'toString', function toString() {
  var entries = getInternalParamsState(this).entries;
  var result = [];
  var index = 0;
  var entry;
  while (index < entries.length) {
    entry = entries[index++];
    result.push(serialize(entry.key) + '=' + serialize(entry.value));
  } return result.join('&');
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` for correct work with polyfilled `URLSearchParams`
// https://github.com/zloirock/core-js/issues/674
if (!USE_NATIVE_URL && typeof $fetch == 'function' && typeof Headers == 'function') {
  $({ global: true, enumerable: true, forced: true }, {
    fetch: function fetch(input /* , init */) {
      var args = [input];
      var init, body, headers;
      if (arguments.length > 1) {
        init = arguments[1];
        if (isObject(init)) {
          body = init.body;
          if (classof(body) === URL_SEARCH_PARAMS) {
            headers = init.headers ? new Headers(init.headers) : new Headers();
            if (!headers.has('content-type')) {
              headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
            }
            init = create(init, {
              body: createPropertyDescriptor(0, String(body)),
              headers: createPropertyDescriptor(0, headers)
            });
          }
        }
        args.push(init);
      } return $fetch.apply(this, args);
    }
  });
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "9934":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeysIn = __webpack_require__("41c3"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ "9981":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e5b1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInfoBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "99cd":
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ "99d3":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__("585a");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var getIteratorMethod = __webpack_require__("35a1");

module.exports = function (it) {
  var iteratorMethod = getIteratorMethod(it);
  if (typeof iteratorMethod != 'function') {
    throw TypeError(String(it) + ' is not iterable');
  } return anObject(iteratorMethod.call(it));
};


/***/ }),

/***/ "9aff":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638"),
    isArrayLike = __webpack_require__("30c9"),
    isIndex = __webpack_require__("c098"),
    isObject = __webpack_require__("1a8c");

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9e69":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "a042":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"UiUploaderProgressBar_progress-bar_149gq","progress-bar__filler":"UiUploaderProgressBar_progress-bar__filler_25jPb"};

/***/ }),

/***/ "a0b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModalSidebar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1db9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModalSidebar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModalSidebar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiModalSidebar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "a2be":
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__("d612"),
    arraySome = __webpack_require__("4284"),
    cacheHas = __webpack_require__("c584");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ "a30f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"UiIcon_icon_2pR-8","icon_btn":"UiIcon_icon_btn_-HRxf"};

/***/ }),

/***/ "a41c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar-list":"UiAvatarList_avatar-list_3VeAj","inner":"UiAvatarList_inner_wWB2L","item":"UiAvatarList_item_3TPZF","avatar-list_size_sm":"UiAvatarList_avatar-list_size_sm_2m_Jh","avatar-list_size_lg":"UiAvatarList_avatar-list_size_lg_OIYfj"};

/***/ }),

/***/ "a454":
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__("72f0"),
    defineProperty = __webpack_require__("3b4a"),
    identity = __webpack_require__("cd9d");

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ "a4a1":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, (function (exports) { 'use strict';

  /*!
   * perfect-scrollbar v1.5.2
   * Copyright 2021 Hyunje Jun, MDBootstrap and Contributors
   * Licensed under MIT
   */

  function get(element) {
    return getComputedStyle(element);
  }

  function set(element, obj) {
    for (var key in obj) {
      var val = obj[key];
      if (typeof val === 'number') {
        val = val + "px";
      }
      element.style[key] = val;
    }
    return element;
  }

  function div(className) {
    var div = document.createElement('div');
    div.className = className;
    return div;
  }

  var elMatches =
    typeof Element !== 'undefined' &&
    (Element.prototype.matches ||
      Element.prototype.webkitMatchesSelector ||
      Element.prototype.mozMatchesSelector ||
      Element.prototype.msMatchesSelector);

  function matches(element, query) {
    if (!elMatches) {
      throw new Error('No element matching method supported');
    }

    return elMatches.call(element, query);
  }

  function remove(element) {
    if (element.remove) {
      element.remove();
    } else {
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
    }
  }

  function queryChildren(element, selector) {
    return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
    );
  }

  var cls = {
    main: 'ps',
    rtl: 'ps__rtl',
    element: {
      thumb: function (x) { return ("ps__thumb-" + x); },
      rail: function (x) { return ("ps__rail-" + x); },
      consuming: 'ps__child--consume',
    },
    state: {
      focus: 'ps--focus',
      clicking: 'ps--clicking',
      active: function (x) { return ("ps--active-" + x); },
      scrolling: function (x) { return ("ps--scrolling-" + x); },
    },
  };

  /*
   * Helper methods
   */
  var scrollingClassTimeout = { x: null, y: null };

  function addScrollingClass(i, x) {
    var classList = i.element.classList;
    var className = cls.state.scrolling(x);

    if (classList.contains(className)) {
      clearTimeout(scrollingClassTimeout[x]);
    } else {
      classList.add(className);
    }
  }

  function removeScrollingClass(i, x) {
    scrollingClassTimeout[x] = setTimeout(
      function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
      i.settings.scrollingThreshold
    );
  }

  function setScrollingClassInstantly(i, x) {
    addScrollingClass(i, x);
    removeScrollingClass(i, x);
  }

  var EventElement = function EventElement(element) {
    this.element = element;
    this.handlers = {};
  };

  var prototypeAccessors = { isEmpty: { configurable: true } };

  EventElement.prototype.bind = function bind (eventName, handler) {
    if (typeof this.handlers[eventName] === 'undefined') {
      this.handlers[eventName] = [];
    }
    this.handlers[eventName].push(handler);
    this.element.addEventListener(eventName, handler, false);
  };

  EventElement.prototype.unbind = function unbind (eventName, target) {
      var this$1 = this;

    this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
      if (target && handler !== target) {
        return true;
      }
      this$1.element.removeEventListener(eventName, handler, false);
      return false;
    });
  };

  EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

    for (var name in this$1.handlers) {
      this$1.unbind(name);
    }
  };

  prototypeAccessors.isEmpty.get = function () {
      var this$1 = this;

    return Object.keys(this.handlers).every(
      function (key) { return this$1.handlers[key].length === 0; }
    );
  };

  Object.defineProperties( EventElement.prototype, prototypeAccessors );

  var EventManager = function EventManager() {
    this.eventElements = [];
  };

  EventManager.prototype.eventElement = function eventElement (element) {
    var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
    if (!ee) {
      ee = new EventElement(element);
      this.eventElements.push(ee);
    }
    return ee;
  };

  EventManager.prototype.bind = function bind (element, eventName, handler) {
    this.eventElement(element).bind(eventName, handler);
  };

  EventManager.prototype.unbind = function unbind (element, eventName, handler) {
    var ee = this.eventElement(element);
    ee.unbind(eventName, handler);

    if (ee.isEmpty) {
      // remove
      this.eventElements.splice(this.eventElements.indexOf(ee), 1);
    }
  };

  EventManager.prototype.unbindAll = function unbindAll () {
    this.eventElements.forEach(function (e) { return e.unbindAll(); });
    this.eventElements = [];
  };

  EventManager.prototype.once = function once (element, eventName, handler) {
    var ee = this.eventElement(element);
    var onceHandler = function (evt) {
      ee.unbind(eventName, onceHandler);
      handler(evt);
    };
    ee.bind(eventName, onceHandler);
  };

  function createEvent(name) {
    if (typeof window.CustomEvent === 'function') {
      return new CustomEvent(name);
    } else {
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(name, false, false, undefined);
      return evt;
    }
  }

  function processScrollDiff(
    i,
    axis,
    diff,
    useScrollingClass,
    forceFireReachEvent
  ) {
    if ( useScrollingClass === void 0 ) { useScrollingClass = true; }
    if ( forceFireReachEvent === void 0 ) { forceFireReachEvent = false; }

    var fields;
    if (axis === 'top') {
      fields = [
        'contentHeight',
        'containerHeight',
        'scrollTop',
        'y',
        'up',
        'down' ];
    } else if (axis === 'left') {
      fields = [
        'contentWidth',
        'containerWidth',
        'scrollLeft',
        'x',
        'left',
        'right' ];
    } else {
      throw new Error('A proper axis should be provided');
    }

    processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
  }

  function processScrollDiff$1(
    i,
    diff,
    ref,
    useScrollingClass,
    forceFireReachEvent
  ) {
    var contentHeight = ref[0];
    var containerHeight = ref[1];
    var scrollTop = ref[2];
    var y = ref[3];
    var up = ref[4];
    var down = ref[5];
    if ( useScrollingClass === void 0 ) { useScrollingClass = true; }
    if ( forceFireReachEvent === void 0 ) { forceFireReachEvent = false; }

    var element = i.element;

    // reset reach
    i.reach[y] = null;

    // 1 for subpixel rounding
    if (element[scrollTop] < 1) {
      i.reach[y] = 'start';
    }

    // 1 for subpixel rounding
    if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
      i.reach[y] = 'end';
    }

    if (diff) {
      element.dispatchEvent(createEvent(("ps-scroll-" + y)));

      if (diff < 0) {
        element.dispatchEvent(createEvent(("ps-scroll-" + up)));
      } else if (diff > 0) {
        element.dispatchEvent(createEvent(("ps-scroll-" + down)));
      }

      if (useScrollingClass) {
        setScrollingClassInstantly(i, y);
      }
    }

    if (i.reach[y] && (diff || forceFireReachEvent)) {
      element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
    }
  }

  function toInt(x) {
    return parseInt(x, 10) || 0;
  }

  function isEditable(el) {
    return (
      matches(el, 'input,[contenteditable]') ||
      matches(el, 'select,[contenteditable]') ||
      matches(el, 'textarea,[contenteditable]') ||
      matches(el, 'button,[contenteditable]')
    );
  }

  function outerWidth(element) {
    var styles = get(element);
    return (
      toInt(styles.width) +
      toInt(styles.paddingLeft) +
      toInt(styles.paddingRight) +
      toInt(styles.borderLeftWidth) +
      toInt(styles.borderRightWidth)
    );
  }

  var env = {
    isWebKit:
      typeof document !== 'undefined' &&
      'WebkitAppearance' in document.documentElement.style,
    supportsTouch:
      typeof window !== 'undefined' &&
      ('ontouchstart' in window ||
        ('maxTouchPoints' in window.navigator &&
          window.navigator.maxTouchPoints > 0) ||
        (window.DocumentTouch && document instanceof window.DocumentTouch)),
    supportsIePointer:
      typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
    isChrome:
      typeof navigator !== 'undefined' &&
      /Chrome/i.test(navigator && navigator.userAgent),
  };

  function updateGeometry(i) {
    var element = i.element;
    var roundedScrollTop = Math.floor(element.scrollTop);
    var rect = element.getBoundingClientRect();

    i.containerWidth = Math.round(rect.width);
    i.containerHeight = Math.round(rect.height);

    i.contentWidth = element.scrollWidth;
    i.contentHeight = element.scrollHeight;

    if (!element.contains(i.scrollbarXRail)) {
      // clean up and append
      queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
      );
      element.appendChild(i.scrollbarXRail);
    }
    if (!element.contains(i.scrollbarYRail)) {
      // clean up and append
      queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
      );
      element.appendChild(i.scrollbarYRail);
    }

    if (
      !i.settings.suppressScrollX &&
      i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
    ) {
      i.scrollbarXActive = true;
      i.railXWidth = i.containerWidth - i.railXMarginWidth;
      i.railXRatio = i.containerWidth / i.railXWidth;
      i.scrollbarXWidth = getThumbSize(
        i,
        toInt((i.railXWidth * i.containerWidth) / i.contentWidth)
      );
      i.scrollbarXLeft = toInt(
        ((i.negativeScrollAdjustment + element.scrollLeft) *
          (i.railXWidth - i.scrollbarXWidth)) /
          (i.contentWidth - i.containerWidth)
      );
    } else {
      i.scrollbarXActive = false;
    }

    if (
      !i.settings.suppressScrollY &&
      i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
    ) {
      i.scrollbarYActive = true;
      i.railYHeight = i.containerHeight - i.railYMarginHeight;
      i.railYRatio = i.containerHeight / i.railYHeight;
      i.scrollbarYHeight = getThumbSize(
        i,
        toInt((i.railYHeight * i.containerHeight) / i.contentHeight)
      );
      i.scrollbarYTop = toInt(
        (roundedScrollTop * (i.railYHeight - i.scrollbarYHeight)) /
          (i.contentHeight - i.containerHeight)
      );
    } else {
      i.scrollbarYActive = false;
    }

    if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
      i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
    }
    if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
      i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
    }

    updateCss(element, i);

    if (i.scrollbarXActive) {
      element.classList.add(cls.state.active('x'));
    } else {
      element.classList.remove(cls.state.active('x'));
      i.scrollbarXWidth = 0;
      i.scrollbarXLeft = 0;
      element.scrollLeft = i.isRtl === true ? i.contentWidth : 0;
    }
    if (i.scrollbarYActive) {
      element.classList.add(cls.state.active('y'));
    } else {
      element.classList.remove(cls.state.active('y'));
      i.scrollbarYHeight = 0;
      i.scrollbarYTop = 0;
      element.scrollTop = 0;
    }
  }

  function getThumbSize(i, thumbSize) {
    if (i.settings.minScrollbarLength) {
      thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
    }
    if (i.settings.maxScrollbarLength) {
      thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
    }
    return thumbSize;
  }

  function updateCss(element, i) {
    var xRailOffset = { width: i.railXWidth };
    var roundedScrollTop = Math.floor(element.scrollTop);

    if (i.isRtl) {
      xRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth -
        i.contentWidth;
    } else {
      xRailOffset.left = element.scrollLeft;
    }
    if (i.isScrollbarXUsingBottom) {
      xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
    } else {
      xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
    }
    set(i.scrollbarXRail, xRailOffset);

    var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
    if (i.isScrollbarYUsingRight) {
      if (i.isRtl) {
        yRailOffset.right =
          i.contentWidth -
          (i.negativeScrollAdjustment + element.scrollLeft) -
          i.scrollbarYRight -
          i.scrollbarYOuterWidth -
          9;
      } else {
        yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
      }
    } else {
      if (i.isRtl) {
        yRailOffset.left =
          i.negativeScrollAdjustment +
          element.scrollLeft +
          i.containerWidth * 2 -
          i.contentWidth -
          i.scrollbarYLeft -
          i.scrollbarYOuterWidth;
      } else {
        yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
      }
    }
    set(i.scrollbarYRail, yRailOffset);

    set(i.scrollbarX, {
      left: i.scrollbarXLeft,
      width: i.scrollbarXWidth - i.railBorderXWidth,
    });
    set(i.scrollbarY, {
      top: i.scrollbarYTop,
      height: i.scrollbarYHeight - i.railBorderYWidth,
    });
  }

  function clickRail(i) {
    var element = i.element;

    i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
    i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
      var positionTop =
        e.pageY -
        window.pageYOffset -
        i.scrollbarYRail.getBoundingClientRect().top;
      var direction = positionTop > i.scrollbarYTop ? 1 : -1;

      i.element.scrollTop += direction * i.containerHeight;
      updateGeometry(i);

      e.stopPropagation();
    });

    i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
    i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
      var positionLeft =
        e.pageX -
        window.pageXOffset -
        i.scrollbarXRail.getBoundingClientRect().left;
      var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

      i.element.scrollLeft += direction * i.containerWidth;
      updateGeometry(i);

      e.stopPropagation();
    });
  }

  function dragThumb(i) {
    bindMouseScrollHandler(i, [
      'containerWidth',
      'contentWidth',
      'pageX',
      'railXWidth',
      'scrollbarX',
      'scrollbarXWidth',
      'scrollLeft',
      'x',
      'scrollbarXRail' ]);
    bindMouseScrollHandler(i, [
      'containerHeight',
      'contentHeight',
      'pageY',
      'railYHeight',
      'scrollbarY',
      'scrollbarYHeight',
      'scrollTop',
      'y',
      'scrollbarYRail' ]);
  }

  function bindMouseScrollHandler(
    i,
    ref
  ) {
    var containerHeight = ref[0];
    var contentHeight = ref[1];
    var pageY = ref[2];
    var railYHeight = ref[3];
    var scrollbarY = ref[4];
    var scrollbarYHeight = ref[5];
    var scrollTop = ref[6];
    var y = ref[7];
    var scrollbarYRail = ref[8];

    var element = i.element;

    var startingScrollTop = null;
    var startingMousePageY = null;
    var scrollBy = null;

    function mouseMoveHandler(e) {
      if (e.touches && e.touches[0]) {
        e[pageY] = e.touches[0].pageY;
      }
      element[scrollTop] =
        startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
      addScrollingClass(i, y);
      updateGeometry(i);

      e.stopPropagation();
      e.preventDefault();
    }

    function mouseUpHandler() {
      removeScrollingClass(i, y);
      i[scrollbarYRail].classList.remove(cls.state.clicking);
      i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    }

    function bindMoves(e, touchMode) {
      startingScrollTop = element[scrollTop];
      if (touchMode && e.touches) {
        e[pageY] = e.touches[0].pageY;
      }
      startingMousePageY = e[pageY];
      scrollBy =
        (i[contentHeight] - i[containerHeight]) /
        (i[railYHeight] - i[scrollbarYHeight]);
      if (!touchMode) {
        i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
        i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);
        e.preventDefault();
      } else {
        i.event.bind(i.ownerDocument, 'touchmove', mouseMoveHandler);
      }

      i[scrollbarYRail].classList.add(cls.state.clicking);

      e.stopPropagation();
    }

    i.event.bind(i[scrollbarY], 'mousedown', function (e) {
      bindMoves(e);
    });
    i.event.bind(i[scrollbarY], 'touchstart', function (e) {
      bindMoves(e, true);
    });
  }

  function keyboard(i) {
    var element = i.element;

    var elementHovered = function () { return matches(element, ':hover'); };
    var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

    function shouldPreventDefault(deltaX, deltaY) {
      var scrollTop = Math.floor(element.scrollTop);
      if (deltaX === 0) {
        if (!i.scrollbarYActive) {
          return false;
        }
        if (
          (scrollTop === 0 && deltaY > 0) ||
          (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
        ) {
          return !i.settings.wheelPropagation;
        }
      }

      var scrollLeft = element.scrollLeft;
      if (deltaY === 0) {
        if (!i.scrollbarXActive) {
          return false;
        }
        if (
          (scrollLeft === 0 && deltaX < 0) ||
          (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
        ) {
          return !i.settings.wheelPropagation;
        }
      }
      return true;
    }

    i.event.bind(i.ownerDocument, 'keydown', function (e) {
      if (
        (e.isDefaultPrevented && e.isDefaultPrevented()) ||
        e.defaultPrevented
      ) {
        return;
      }

      if (!elementHovered() && !scrollbarFocused()) {
        return;
      }

      var activeElement = document.activeElement
        ? document.activeElement
        : i.ownerDocument.activeElement;
      if (activeElement) {
        if (activeElement.tagName === 'IFRAME') {
          activeElement = activeElement.contentDocument.activeElement;
        } else {
          // go deeper if element is a webcomponent
          while (activeElement.shadowRoot) {
            activeElement = activeElement.shadowRoot.activeElement;
          }
        }
        if (isEditable(activeElement)) {
          return;
        }
      }

      var deltaX = 0;
      var deltaY = 0;

      switch (e.which) {
        case 37: // left
          if (e.metaKey) {
            deltaX = -i.contentWidth;
          } else if (e.altKey) {
            deltaX = -i.containerWidth;
          } else {
            deltaX = -30;
          }
          break;
        case 38: // up
          if (e.metaKey) {
            deltaY = i.contentHeight;
          } else if (e.altKey) {
            deltaY = i.containerHeight;
          } else {
            deltaY = 30;
          }
          break;
        case 39: // right
          if (e.metaKey) {
            deltaX = i.contentWidth;
          } else if (e.altKey) {
            deltaX = i.containerWidth;
          } else {
            deltaX = 30;
          }
          break;
        case 40: // down
          if (e.metaKey) {
            deltaY = -i.contentHeight;
          } else if (e.altKey) {
            deltaY = -i.containerHeight;
          } else {
            deltaY = -30;
          }
          break;
        case 32: // space bar
          if (e.shiftKey) {
            deltaY = i.containerHeight;
          } else {
            deltaY = -i.containerHeight;
          }
          break;
        case 33: // page up
          deltaY = i.containerHeight;
          break;
        case 34: // page down
          deltaY = -i.containerHeight;
          break;
        case 36: // home
          deltaY = i.contentHeight;
          break;
        case 35: // end
          deltaY = -i.contentHeight;
          break;
        default:
          return;
      }

      if (i.settings.suppressScrollX && deltaX !== 0) {
        return;
      }
      if (i.settings.suppressScrollY && deltaY !== 0) {
        return;
      }

      element.scrollTop -= deltaY;
      element.scrollLeft += deltaX;
      updateGeometry(i);

      if (shouldPreventDefault(deltaX, deltaY)) {
        e.preventDefault();
      }
    });
  }

  function wheel(i) {
    var element = i.element;

    function shouldPreventDefault(deltaX, deltaY) {
      var roundedScrollTop = Math.floor(element.scrollTop);
      var isTop = element.scrollTop === 0;
      var isBottom =
        roundedScrollTop + element.offsetHeight === element.scrollHeight;
      var isLeft = element.scrollLeft === 0;
      var isRight =
        element.scrollLeft + element.offsetWidth === element.scrollWidth;

      var hitsBound;

      // pick axis with primary direction
      if (Math.abs(deltaY) > Math.abs(deltaX)) {
        hitsBound = isTop || isBottom;
      } else {
        hitsBound = isLeft || isRight;
      }

      return hitsBound ? !i.settings.wheelPropagation : true;
    }

    function getDeltaFromEvent(e) {
      var deltaX = e.deltaX;
      var deltaY = -1 * e.deltaY;

      if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
        // OS X Safari
        deltaX = (-1 * e.wheelDeltaX) / 6;
        deltaY = e.wheelDeltaY / 6;
      }

      if (e.deltaMode && e.deltaMode === 1) {
        // Firefox in deltaMode 1: Line scrolling
        deltaX *= 10;
        deltaY *= 10;
      }

      if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
        // IE in some mouse drivers
        deltaX = 0;
        deltaY = e.wheelDelta;
      }

      if (e.shiftKey) {
        // reverse axis with shift key
        return [-deltaY, -deltaX];
      }
      return [deltaX, deltaY];
    }

    function shouldBeConsumedByChild(target, deltaX, deltaY) {
      // FIXME: this is a workaround for <select> issue in FF and IE #571
      if (!env.isWebKit && element.querySelector('select:focus')) {
        return true;
      }

      if (!element.contains(target)) {
        return false;
      }

      var cursor = target;

      while (cursor && cursor !== element) {
        if (cursor.classList.contains(cls.element.consuming)) {
          return true;
        }

        var style = get(cursor);

        // if deltaY && vertical scrollable
        if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
          var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
          if (maxScrollTop > 0) {
            if (
              (cursor.scrollTop > 0 && deltaY < 0) ||
              (cursor.scrollTop < maxScrollTop && deltaY > 0)
            ) {
              return true;
            }
          }
        }
        // if deltaX && horizontal scrollable
        if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
          var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
          if (maxScrollLeft > 0) {
            if (
              (cursor.scrollLeft > 0 && deltaX < 0) ||
              (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
            ) {
              return true;
            }
          }
        }

        cursor = cursor.parentNode;
      }

      return false;
    }

    function mousewheelHandler(e) {
      var ref = getDeltaFromEvent(e);
      var deltaX = ref[0];
      var deltaY = ref[1];

      if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
        return;
      }

      var shouldPrevent = false;
      if (!i.settings.useBothWheelAxes) {
        // deltaX will only be used for horizontal scrolling and deltaY will
        // only be used for vertical scrolling - this is the default
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else if (i.scrollbarYActive && !i.scrollbarXActive) {
        // only vertical scrollbar is active and useBothWheelAxes option is
        // active, so let's scroll vertical bar using both mouse wheel axes
        if (deltaY) {
          element.scrollTop -= deltaY * i.settings.wheelSpeed;
        } else {
          element.scrollTop += deltaX * i.settings.wheelSpeed;
        }
        shouldPrevent = true;
      } else if (i.scrollbarXActive && !i.scrollbarYActive) {
        // useBothWheelAxes and only horizontal bar is active, so use both
        // wheel axes for horizontal bar
        if (deltaX) {
          element.scrollLeft += deltaX * i.settings.wheelSpeed;
        } else {
          element.scrollLeft -= deltaY * i.settings.wheelSpeed;
        }
        shouldPrevent = true;
      }

      updateGeometry(i);

      shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
      if (shouldPrevent && !e.ctrlKey) {
        e.stopPropagation();
        e.preventDefault();
      }
    }

    if (typeof window.onwheel !== 'undefined') {
      i.event.bind(element, 'wheel', mousewheelHandler);
    } else if (typeof window.onmousewheel !== 'undefined') {
      i.event.bind(element, 'mousewheel', mousewheelHandler);
    }
  }

  function touch(i) {
    if (!env.supportsTouch && !env.supportsIePointer) {
      return;
    }

    var element = i.element;

    function shouldPrevent(deltaX, deltaY) {
      var scrollTop = Math.floor(element.scrollTop);
      var scrollLeft = element.scrollLeft;
      var magnitudeX = Math.abs(deltaX);
      var magnitudeY = Math.abs(deltaY);

      if (magnitudeY > magnitudeX) {
        // user is perhaps trying to swipe up/down the page

        if (
          (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
          (deltaY > 0 && scrollTop === 0)
        ) {
          // set prevent for mobile Chrome refresh
          return window.scrollY === 0 && deltaY > 0 && env.isChrome;
        }
      } else if (magnitudeX > magnitudeY) {
        // user is perhaps trying to swipe left/right across the page

        if (
          (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
          (deltaX > 0 && scrollLeft === 0)
        ) {
          return true;
        }
      }

      return true;
    }

    function applyTouchMove(differenceX, differenceY) {
      element.scrollTop -= differenceY;
      element.scrollLeft -= differenceX;

      updateGeometry(i);
    }

    var startOffset = {};
    var startTime = 0;
    var speed = {};
    var easingLoop = null;

    function getTouch(e) {
      if (e.targetTouches) {
        return e.targetTouches[0];
      } else {
        // Maybe IE pointer
        return e;
      }
    }

    function shouldHandle(e) {
      if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
        return false;
      }
      if (e.targetTouches && e.targetTouches.length === 1) {
        return true;
      }
      if (
        e.pointerType &&
        e.pointerType !== 'mouse' &&
        e.pointerType !== e.MSPOINTER_TYPE_MOUSE
      ) {
        return true;
      }
      return false;
    }

    function touchStart(e) {
      if (!shouldHandle(e)) {
        return;
      }

      var touch = getTouch(e);

      startOffset.pageX = touch.pageX;
      startOffset.pageY = touch.pageY;

      startTime = new Date().getTime();

      if (easingLoop !== null) {
        clearInterval(easingLoop);
      }
    }

    function shouldBeConsumedByChild(target, deltaX, deltaY) {
      if (!element.contains(target)) {
        return false;
      }

      var cursor = target;

      while (cursor && cursor !== element) {
        if (cursor.classList.contains(cls.element.consuming)) {
          return true;
        }

        var style = get(cursor);

        // if deltaY && vertical scrollable
        if (deltaY && style.overflowY.match(/(scroll|auto)/)) {
          var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
          if (maxScrollTop > 0) {
            if (
              (cursor.scrollTop > 0 && deltaY < 0) ||
              (cursor.scrollTop < maxScrollTop && deltaY > 0)
            ) {
              return true;
            }
          }
        }
        // if deltaX && horizontal scrollable
        if (deltaX && style.overflowX.match(/(scroll|auto)/)) {
          var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
          if (maxScrollLeft > 0) {
            if (
              (cursor.scrollLeft > 0 && deltaX < 0) ||
              (cursor.scrollLeft < maxScrollLeft && deltaX > 0)
            ) {
              return true;
            }
          }
        }

        cursor = cursor.parentNode;
      }

      return false;
    }

    function touchMove(e) {
      if (shouldHandle(e)) {
        var touch = getTouch(e);

        var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

        var differenceX = currentOffset.pageX - startOffset.pageX;
        var differenceY = currentOffset.pageY - startOffset.pageY;

        if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
          return;
        }

        applyTouchMove(differenceX, differenceY);
        startOffset = currentOffset;

        var currentTime = new Date().getTime();

        var timeGap = currentTime - startTime;
        if (timeGap > 0) {
          speed.x = differenceX / timeGap;
          speed.y = differenceY / timeGap;
          startTime = currentTime;
        }

        if (shouldPrevent(differenceX, differenceY)) {
          e.preventDefault();
        }
      }
    }
    function touchEnd() {
      if (i.settings.swipeEasing) {
        clearInterval(easingLoop);
        easingLoop = setInterval(function() {
          if (i.isInitialized) {
            clearInterval(easingLoop);
            return;
          }

          if (!speed.x && !speed.y) {
            clearInterval(easingLoop);
            return;
          }

          if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
            clearInterval(easingLoop);
            return;
          }

          if (!i.element) {
            clearInterval(easingLoop);
            return;
          }

          applyTouchMove(speed.x * 30, speed.y * 30);

          speed.x *= 0.8;
          speed.y *= 0.8;
        }, 10);
      }
    }

    if (env.supportsTouch) {
      i.event.bind(element, 'touchstart', touchStart);
      i.event.bind(element, 'touchmove', touchMove);
      i.event.bind(element, 'touchend', touchEnd);
    } else if (env.supportsIePointer) {
      if (window.PointerEvent) {
        i.event.bind(element, 'pointerdown', touchStart);
        i.event.bind(element, 'pointermove', touchMove);
        i.event.bind(element, 'pointerup', touchEnd);
      } else if (window.MSPointerEvent) {
        i.event.bind(element, 'MSPointerDown', touchStart);
        i.event.bind(element, 'MSPointerMove', touchMove);
        i.event.bind(element, 'MSPointerUp', touchEnd);
      }
    }
  }

  var defaultSettings = function () { return ({
    handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
    maxScrollbarLength: null,
    minScrollbarLength: null,
    scrollingThreshold: 1000,
    scrollXMarginOffset: 0,
    scrollYMarginOffset: 0,
    suppressScrollX: false,
    suppressScrollY: false,
    swipeEasing: true,
    useBothWheelAxes: false,
    wheelPropagation: true,
    wheelSpeed: 1,
  }); };

  var handlers = {
    'click-rail': clickRail,
    'drag-thumb': dragThumb,
    keyboard: keyboard,
    wheel: wheel,
    touch: touch,
  };

  var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
    var this$2 = this;

    var this$1 = this;
    if ( userSettings === void 0 ) { userSettings = {}; }

    if (typeof element === 'string') {
      element = document.querySelector(element);
    }

    if (!element || !element.nodeName) {
      throw new Error('no element is specified to initialize PerfectScrollbar');
    }

    this.element = element;

    element.classList.add(cls.main);

    this.settings = defaultSettings();
    for (var key in userSettings) {
      this$2.settings[key] = userSettings[key];
    }

    this.containerWidth = null;
    this.containerHeight = null;
    this.contentWidth = null;
    this.contentHeight = null;

    var focus = function () { return element.classList.add(cls.state.focus); };
    var blur = function () { return element.classList.remove(cls.state.focus); };

    this.isRtl = get(element).direction === 'rtl';
    if (this.isRtl === true) {
      element.classList.add(cls.rtl);
    }
    this.isNegativeScroll = (function () {
      var originalScrollLeft = element.scrollLeft;
      var result = null;
      element.scrollLeft = -1;
      result = element.scrollLeft < 0;
      element.scrollLeft = originalScrollLeft;
      return result;
    })();
    this.negativeScrollAdjustment = this.isNegativeScroll
      ? element.scrollWidth - element.clientWidth
      : 0;
    this.event = new EventManager();
    this.ownerDocument = element.ownerDocument || document;

    this.scrollbarXRail = div(cls.element.rail('x'));
    element.appendChild(this.scrollbarXRail);
    this.scrollbarX = div(cls.element.thumb('x'));
    this.scrollbarXRail.appendChild(this.scrollbarX);
    this.scrollbarX.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarX, 'focus', focus);
    this.event.bind(this.scrollbarX, 'blur', blur);
    this.scrollbarXActive = null;
    this.scrollbarXWidth = null;
    this.scrollbarXLeft = null;
    var railXStyle = get(this.scrollbarXRail);
    this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
    if (isNaN(this.scrollbarXBottom)) {
      this.isScrollbarXUsingBottom = false;
      this.scrollbarXTop = toInt(railXStyle.top);
    } else {
      this.isScrollbarXUsingBottom = true;
    }
    this.railBorderXWidth =
      toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
    // Set rail to display:block to calculate margins
    set(this.scrollbarXRail, { display: 'block' });
    this.railXMarginWidth =
      toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
    set(this.scrollbarXRail, { display: '' });
    this.railXWidth = null;
    this.railXRatio = null;

    this.scrollbarYRail = div(cls.element.rail('y'));
    element.appendChild(this.scrollbarYRail);
    this.scrollbarY = div(cls.element.thumb('y'));
    this.scrollbarYRail.appendChild(this.scrollbarY);
    this.scrollbarY.setAttribute('tabindex', 0);
    this.event.bind(this.scrollbarY, 'focus', focus);
    this.event.bind(this.scrollbarY, 'blur', blur);
    this.scrollbarYActive = null;
    this.scrollbarYHeight = null;
    this.scrollbarYTop = null;
    var railYStyle = get(this.scrollbarYRail);
    this.scrollbarYRight = parseInt(railYStyle.right, 10);
    if (isNaN(this.scrollbarYRight)) {
      this.isScrollbarYUsingRight = false;
      this.scrollbarYLeft = toInt(railYStyle.left);
    } else {
      this.isScrollbarYUsingRight = true;
    }
    this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
    this.railBorderYWidth =
      toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
    set(this.scrollbarYRail, { display: 'block' });
    this.railYMarginHeight =
      toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
    set(this.scrollbarYRail, { display: '' });
    this.railYHeight = null;
    this.railYRatio = null;

    this.reach = {
      x:
        element.scrollLeft <= 0
          ? 'start'
          : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
      y:
        element.scrollTop <= 0
          ? 'start'
          : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
    };

    this.isAlive = true;

    this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

    this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
    this.lastScrollLeft = element.scrollLeft; // for onScroll only
    this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
    updateGeometry(this);
  };

  PerfectScrollbar.prototype.update = function update () {
    if (!this.isAlive) {
      return;
    }

    // Recalcuate negative scrollLeft adjustment
    this.negativeScrollAdjustment = this.isNegativeScroll
      ? this.element.scrollWidth - this.element.clientWidth
      : 0;

    // Recalculate rail margins
    set(this.scrollbarXRail, { display: 'block' });
    set(this.scrollbarYRail, { display: 'block' });
    this.railXMarginWidth =
      toInt(get(this.scrollbarXRail).marginLeft) +
      toInt(get(this.scrollbarXRail).marginRight);
    this.railYMarginHeight =
      toInt(get(this.scrollbarYRail).marginTop) +
      toInt(get(this.scrollbarYRail).marginBottom);

    // Hide scrollbars not to affect scrollWidth and scrollHeight
    set(this.scrollbarXRail, { display: 'none' });
    set(this.scrollbarYRail, { display: 'none' });

    updateGeometry(this);

    processScrollDiff(this, 'top', 0, false, true);
    processScrollDiff(this, 'left', 0, false, true);

    set(this.scrollbarXRail, { display: '' });
    set(this.scrollbarYRail, { display: '' });
  };

  PerfectScrollbar.prototype.onScroll = function onScroll (e) {
    if (!this.isAlive) {
      return;
    }

    updateGeometry(this);
    processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
    processScrollDiff(
      this,
      'left',
      this.element.scrollLeft - this.lastScrollLeft
    );

    this.lastScrollTop = Math.floor(this.element.scrollTop);
    this.lastScrollLeft = this.element.scrollLeft;
  };

  PerfectScrollbar.prototype.destroy = function destroy () {
    if (!this.isAlive) {
      return;
    }

    this.event.unbindAll();
    remove(this.scrollbarX);
    remove(this.scrollbarY);
    remove(this.scrollbarXRail);
    remove(this.scrollbarYRail);
    this.removePsClasses();

    // unset elements
    this.element = null;
    this.scrollbarX = null;
    this.scrollbarY = null;
    this.scrollbarXRail = null;
    this.scrollbarYRail = null;

    this.isAlive = false;
  };

  PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
    this.element.className = this.element.className
      .split(' ')
      .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
      .join(' ');
  };

  var PerfectScrollbar$1 = {
    name: 'PerfectScrollbar',
    props: {
      options: {
        type: Object,
        required: false,
        default: function () {}
      },
      tag: {
        type: String,
        required: false,
        default: 'div'
      },
      watchOptions: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: function data () {
      return {
        ps: null
      }
    },
    watch: {
      watchOptions: function watchOptions (shouldWatch) {
        if (!shouldWatch && this.watcher) {
          this.watcher();
        } else {
          this.createWatcher();
        }
      }
    },
    mounted: function mounted () {
      this.create();

      if (this.watchOptions) {
        this.createWatcher();
      }
    },
    updated: function updated () {
      var this$1 = this;

      this.$nextTick(function () {
        this$1.update();
      });
    },
    beforeDestroy: function beforeDestroy () {
      this.destroy();
    },
    methods: {
      create: function create () {
        if (!(this.ps && this.$isServer)) {
          this.ps = new PerfectScrollbar(this.$refs.container, this.options);
        }
      },
      createWatcher: function createWatcher () {
        var this$1 = this;

        this.watcher = this.$watch('options', function () {
          this$1.destroy();
          this$1.create();
        }, {
          deep: true
        });
      },
      update: function update () {
        if (this.ps) {
          this.ps.update();
        }
      },
      destroy: function destroy () {
        if (this.ps) {
          this.ps.destroy();
          this.ps = null;
        }
      }
    },
    render: function render (h) {
      return h(this.tag,
        {
          ref: 'container',
          class: 'ps',
          on: this.$listeners
        },
        this.$slots.default)
    }
  };

  function install (Vue, settings) {
    if (settings) {
      if (settings.name && typeof settings.name === 'string') {
        PerfectScrollbar$1.name = settings.name;
      }

      if (settings.options && typeof settings.options === 'object') {
        PerfectScrollbar$1.props.options.default = function () {
          return settings.options
        };
      }

      if (settings.tag && typeof settings.tag === 'string') {
        PerfectScrollbar$1.props.tag.default = settings.tag;
      }

      if (settings.watchOptions && typeof settings.watchOptions === 'boolean') {
        PerfectScrollbar$1.props.watchOptions = settings.watchOptions;
      }
    }

    Vue.component(
      PerfectScrollbar$1.name,
      PerfectScrollbar$1
    );
  }

  exports.install = install;
  exports.PerfectScrollbar = PerfectScrollbar$1;
  exports.default = install;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "a4c5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiActionBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("48d4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiActionBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiActionBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiActionBtn_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "a523":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SaturationSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("747c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SaturationSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SaturationSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SaturationSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "a524":
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__("4245");

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ "a648":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRow_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("40ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRow_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRow_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRow_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a6dc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9367");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploader_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "a736":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"switch":"UiSwitch_switch_2hvMr","switch__inner":"UiSwitch_switch__inner_UNbje","switch_square":"UiSwitch_switch_square_2hGuP","switch__thumb-wrap":"UiSwitch_switch__thumb-wrap_HI58Y","switch_disabled":"UiSwitch_switch_disabled_1XyF5","switch__thumb":"UiSwitch_switch__thumb_3CKTY","switch__icon":"UiSwitch_switch__icon_2hDVc","switch__text":"UiSwitch_switch__text_21bAo","switch__label":"UiSwitch_switch__label_nvuGW","switch__label_normal":"UiSwitch_switch__label_normal_3cu8j","switch__input":"UiSwitch_switch__input_36pm9","switch__desc":"UiSwitch_switch__desc_32aUB","switch__description-inner":"UiSwitch_switch__description-inner_q0_ki","switch__error":"UiSwitch_switch__error_1moA9","switch_checked":"UiSwitch_switch_checked_1sx2k","label":"UiSwitch_label_1TVdi","switch_focused":"UiSwitch_switch_focused_bDMH9","switch_active":"UiSwitch_switch_active_3tBL7"};

/***/ }),

/***/ "a994":
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__("7d1f"),
    getSymbols = __webpack_require__("32f4"),
    keys = __webpack_require__("ec69");

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ "aa25":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "abde":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmoji_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f01b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmoji_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmoji_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiEmoji_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "ac0b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"file":"UiUploaderFile_file_B8_Xx","file__progress-bar":"UiUploaderFile_file__progress-bar_14AeK","file__preview":"UiUploaderFile_file__preview_2W2FW","file__preview-link":"UiUploaderFile_file__preview-link_21Py5","file__img":"UiUploaderFile_file__img_Ad3L0","file__name":"UiUploaderFile_file__name_3SRAE","file_error":"UiUploaderFile_file_error_8wKEK","file_done":"UiUploaderFile_file_done_370fI","file_wait":"UiUploaderFile_file_wait_2WMdn","file_upload-btn":"UiUploaderFile_file_upload-btn_1v7pD","file__name-wrap":"UiUploaderFile_file__name-wrap_2kZRk","file__name-link":"UiUploaderFile_file__name-link_h2_oL","file__icon":"UiUploaderFile_file__icon_UCg4L","file__icon-upload":"UiUploaderFile_file__icon-upload_X1xZe","file__icon-done":"UiUploaderFile_file__icon-done_1WR11","file__icon-loading":"UiUploaderFile_file__icon-loading_3Y_Ja","file__icon-error":"UiUploaderFile_file__icon-error_3I9HH"};

/***/ }),

/***/ "ac3f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"UiTable_table_1BPHv","table-wrap":"UiTable_table-wrap_2RoY4"};

/***/ }),

/***/ "ac41":
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if ((!IS_PURE || NEW_ITERATOR_PROTOTYPE) && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aeb1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"time-box":"UiTimeBox_time-box_2MIgC"};

/***/ }),

/***/ "b047":
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ "b1e5":
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__("a994");

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ "b1ec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapse_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f45d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapse_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapse_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiCollapse_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "b218":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ "b21c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"list-btn":"UiListBtn_list-btn_2aag5","list-btn__remove":"UiListBtn_list-btn__remove_58mcE","list-btn__icon":"UiListBtn_list-btn__icon_2y4y_","list-btn__content":"UiListBtn_list-btn__content_2TQBE"};

/***/ }),

/***/ "b3df":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"drop-btn":"UiDropBtn_drop-btn_kXgko","drop-btn__target":"UiDropBtn_drop-btn__target_WxNVW","drop-btn__target_active":"UiDropBtn_drop-btn__target_active_j5ge8","drop-btn__icon":"UiDropBtn_drop-btn__icon_A4Yol","drop-btn__content":"UiDropBtn_drop-btn__content_1_l37","drop-btn__content-inner":"UiDropBtn_drop-btn__content-inner_55rLr","open":"UiDropBtn_open_3XZhr"};

/***/ }),

/***/ "b4c0":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ "b5a7":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (NATIVE_SYMBOL && has(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b6f7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"UiBreadcrumbs_breadcrumbs_1Gi3F","breadcrumbs__item":"UiBreadcrumbs_breadcrumbs__item_2i3rU","breadcrumbs__item_active":"UiBreadcrumbs_breadcrumbs__item_active_2UrW-","item":"UiBreadcrumbs_item_3HBmf","item_rules":"UiBreadcrumbs_item_rules_3TPZr","item_light":"UiBreadcrumbs_item_light_3y6hX","item_dark":"UiBreadcrumbs_item_dark_2WPF4","item_controls":"UiBreadcrumbs_item_controls_1T8rD","divider":"UiBreadcrumbs_divider_HxtM-","divider-icon":"UiBreadcrumbs_divider-icon_2ZgVc","more":"UiBreadcrumbs_more_2yYKI","control":"UiBreadcrumbs_control_3NIse","control__icon":"UiBreadcrumbs_control__icon_ROPz8"};

/***/ }),

/***/ "b760":
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__("872a"),
    eq = __webpack_require__("9638");

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ "b84b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7611");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiButton_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "b889":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorPicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8f8f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorPicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorPicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiColorPicker_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "b9d7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"menu":"UiCollapseMenuGroup_menu_2dkVt"};

/***/ }),

/***/ "baf2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bbc0":
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__("6044");

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ "be9f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7cb4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiIntegrationLayout_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bff8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbs_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b6f7");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbs_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbs_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbs_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c05f":
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__("7b97"),
    isObjectLike = __webpack_require__("1310");

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ "c098":
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ "c1c9":
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__("a454"),
    shortOut = __webpack_require__("f3c1");

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c4d9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f167");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSelect_vue_vue_type_style_index_1_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c4e2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"UiPopconfirm_title_2bD9_","footer":"UiPopconfirm_footer_3TFui","control":"UiPopconfirm_control_2mqlH"};

/***/ }),

/***/ "c578":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"optgroup":"UiInputDropdownGroup_optgroup_1dnQK","optgroup__head":"UiInputDropdownGroup_optgroup__head_3iSCs","optgroup__head-inner":"UiInputDropdownGroup_optgroup__head-inner_3BX0I","optgroup__head-option":"UiInputDropdownGroup_optgroup__head-option_1qC6R","optgroup__title":"UiInputDropdownGroup_optgroup__title_24MGV","optgroup__title_upper":"UiInputDropdownGroup_optgroup__title_upper_uHJUs","optgroup__cnt":"UiInputDropdownGroup_optgroup__cnt_1cvQ5"};

/***/ }),

/***/ "c584":
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c6d1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderProgressBar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a042");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderProgressBar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderProgressBar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderProgressBar_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "c6ff":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"UiSelect_select_2qa8C","select__content":"UiSelect_select__content_2TOPo","select__content-wrap":"UiSelect_select__content-wrap_3T6u_","select__content-inner":"UiSelect_select__content-inner_3IQQ6","select__content-inner_long":"UiSelect_select__content-inner_long_HJ8yi","open":"UiSelect_open_3mbp3","select__footer":"UiSelect_select__footer_2_mL9","greenIcon":"UiSelect_greenIcon_2uyTk","select-target":"UiSelect_select-target_1hyB7","fake-area":"UiSelect_fake-area_35n_K","tag-list":"UiSelect_tag-list_2Y5d2","tag-item":"UiSelect_tag-item_1HFM5","tag":"UiSelect_tag_dOjpa","emty-filter":"UiSelect_emty-filter_Uupjk","overflowing":"UiSelect_overflowing_2ghAX","tooltip":"UiSelect_tooltip_1y44W","hide":"UiSelect_hide_29HbF","overflowing-trigger":"UiSelect_overflowing-trigger_3qFeh"};

/***/ }),

/***/ "c724":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"radiogroup":"UiRadiogroup_radiogroup_2Ah5t","rubber":"UiRadiogroup_rubber_XMQbN","size-sm":"UiRadiogroup_size-sm_S-41-","size-md":"UiRadiogroup_size-md_1yrjB","size-lg":"UiRadiogroup_size-lg_UtMRD","radiogroup_section":"UiRadiogroup_radiogroup_section_31OlQ"};

/***/ }),

/***/ "c789":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroupOption_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("00b9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroupOption_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroupOption_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiRadiogroupOption_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "c864":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"hue-slider-track":"HueSlider_hue-slider-track_GSvdG"};

/***/ }),

/***/ "c869":
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__("0b07"),
    root = __webpack_require__("2b3e");

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8fe":
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__("f8af");

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ "ca56":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"UiTooltip_tooltip_2VL2m","tooltip__popover":"UiTooltip_tooltip__popover_2FCm0","tooltip__trigger":"UiTooltip_tooltip__trigger_CUKZn","tooltip__trigger_icon":"UiTooltip_tooltip__trigger_icon_90zol","open":"UiTooltip_open_2_TP8","tooltip__trigger_icon-sm":"UiTooltip_tooltip__trigger_icon-sm_3zIzf","tooltip__trigger_icon-md":"UiTooltip_tooltip__trigger_icon-md_3OtEL","tooltip__trigger_icon-lg":"UiTooltip_tooltip__trigger_icon-lg_fTmsY","tooltip__content":"UiTooltip_tooltip__content_2dgdv","tooltip__content-inner":"UiTooltip_tooltip__content-inner_4gskY","tooltip__content-body":"UiTooltip_tooltip__content-body_LH7AJ","tooltip__content_dark":"UiTooltip_tooltip__content_dark_1S_HW","tooltip__content_closable":"UiTooltip_tooltip__content_closable_dl_w_","tooltip__content_inline":"UiTooltip_tooltip__content_inline_3JvYe","tooltip__content_lg":"UiTooltip_tooltip__content_lg_Gollf","tooltip__content_pointer":"UiTooltip_tooltip__content_pointer_1neWD","tooltip__content_center-text":"UiTooltip_tooltip__content_center-text_1ZagX","tooltip__content_with-steps":"UiTooltip_tooltip__content_with-steps_fLOUy","tooltip__footer":"UiTooltip_tooltip__footer_1Fc8H","tooltip__close":"UiTooltip_tooltip__close_7h68V","tooltip__close_dark":"UiTooltip_tooltip__close_dark_3cAKn","tooltip__title":"UiTooltip_tooltip__title_1MTNH","tooltip__title_dark":"UiTooltip_tooltip__title_dark_3MHsw","tooltip__title_lg":"UiTooltip_tooltip__title_lg_1gqwi","tooltip__title_with-steps":"UiTooltip_tooltip__title_with-steps_247aP","tooltip__steps":"UiTooltip_tooltip__steps_4BNip"};

/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cb5a":
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__("9638");

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc5b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cd64":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("baf2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTable_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "cd9d":
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "ce5f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInlineEdit_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("79bb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInlineEdit_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInlineEdit_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInlineEdit_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "cec7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFileInDropArea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("022e");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFileInDropArea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFileInDropArea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiUploaderFileInDropArea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "cee1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"optgroup-wrap":"UiOptionGroup_optgroup-wrap_296nc"};

/***/ }),

/***/ "cfa9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"controls":"UiTextarea_controls_a4VtD","controls__container":"UiTextarea_controls__container_1QKpj","rows":"UiTextarea_rows_AUB8X","rows__item":"UiTextarea_rows__item_3hPDU","highlight":"UiTextarea_highlight_2LaDs","textarea":"UiTextarea_textarea_2DURW","textarea__area":"UiTextarea_textarea__area_1IwXL","textarea__area_resize":"UiTextarea_textarea__area_resize_3RYEn","textarea__area_resize_vertical":"UiTextarea_textarea__area_resize_vertical_4j4uE","textarea__area_resize_horizontal":"UiTextarea_textarea__area_resize_horizontal_3uTBW","textarea_default":"UiTextarea_textarea_default_26FY7","textarea__error":"UiTextarea_textarea__error_dl-dO","textarea__error_left":"UiTextarea_textarea__error_left_3V5lM","textarea_focus":"UiTextarea_textarea_focus__B_vq","textarea_disabled":"UiTextarea_textarea_disabled_2-_Gt","textarea_error":"UiTextarea_textarea_error_5iaVW","textarea__error-tooltip":"UiTextarea_textarea__error-tooltip_3_nAx","textarea_inline-edit":"UiTextarea_textarea_inline-edit_x8tJw","textarea_accent":"UiTextarea_textarea_accent_3vlAG","textarea_inversion":"UiTextarea_textarea_inversion_20goj","textarea__icon":"UiTextarea_textarea__icon_iszi8","textarea_xs":"UiTextarea_textarea_xs_3JALX","textarea_sm":"UiTextarea_textarea_sm_1hHkL","textarea_md":"UiTextarea_textarea_md_1XktB","textarea_lg":"UiTextarea_textarea_lg_3S46y","textarea_xl":"UiTextarea_textarea_xl_1ByIr","textarea_code":"UiTextarea_textarea_code_12HRa"};

/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d02c":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e"),
    Map = __webpack_require__("79bc"),
    MapCache = __webpack_require__("7b83");

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d113":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d178":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"content-box":"UiContentBox_content-box_25FGm"};

/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d1f7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("734a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_1_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_1_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiLoader_vue_vue_type_style_index_1_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d327":
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ "d370":
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__("253c"),
    isObjectLike = __webpack_require__("1310");

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d579":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"alert":"UiAlert_alert_2q81c","alert__icon":"UiAlert_alert__icon_3VitC","alert__icon-box":"UiAlert_alert__icon-box_lLtfq","alert__title":"UiAlert_alert__title_Ji63d","alert__title_ellipsis":"UiAlert_alert__title_ellipsis_29-fr","alert__close":"UiAlert_alert__close_yrRsW","alert__close-icon":"UiAlert_alert__close-icon_1OgrJ","alert_notice":"UiAlert_alert_notice_2k3Hh","alert_success":"UiAlert_alert_success_2i1Lv","alert_error":"UiAlert_alert_error_1hk3t","title-small":"UiAlert_title-small_eKcgd","slide-fade-enter-active":"UiAlert_slide-fade-enter-active_L8I8x","slide-fade-leave-active":"UiAlert_slide-fade-leave-active_1nis9","slide-fade-enter":"UiAlert_slide-fade-enter_2NG5Y","slide-fade-leave-to":"UiAlert_slide-fade-leave-to_2smuI"};

/***/ }),

/***/ "d612":
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__("7b83"),
    setCacheAdd = __webpack_require__("7ed2"),
    setCacheHas = __webpack_require__("dc0f");

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ "d864":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"progress":"UiProgress_progress_HdB_j","progress_box":"UiProgress_progress_box_2IUWE","progress__line":"UiProgress_progress__line_6ow4b","progress__current-value":"UiProgress_progress__current-value_1RnZS","progress__text":"UiProgress_progress__text_1DM2B","progress__percent":"UiProgress_progress__percent_3B2T8","progress__percent_zero":"UiProgress_progress__percent_zero_23gOt","progress__percent_full":"UiProgress_progress__percent_full_3eAIS"};

/***/ }),

/***/ "da03":
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__("2b3e");

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "db43":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"notification":"UiNotification_notification_11r74","notification__content":"UiNotification_notification__content_3Sls6","notification__collapse":"UiNotification_notification__collapse_1Xjep","notification__header":"UiNotification_notification__header_1oLwc","notification__header-left":"UiNotification_notification__header-left_1hCxP","notification__time":"UiNotification_notification__time_2j2O5","notification__badges":"UiNotification_notification__badges_2vU1q","notification__title_sm":"UiNotification_notification__title_sm_3vJaU","notification__title_md":"UiNotification_notification__title_md_1eRbP","notification__desc":"UiNotification_notification__desc_3X5vK","notification__controls":"UiNotification_notification__controls_2RwCc","notification__control":"UiNotification_notification__control_2FXt5","notification__close-wrap":"UiNotification_notification__close-wrap_1ilYZ","notification__close":"UiNotification_notification__close_xPW04","notification__btn-collapse":"UiNotification_notification__btn-collapse_3VkEM","notification__footer":"UiNotification_notification__footer_16J50","notification_info":"UiNotification_notification_info_1FvGm","notification_notice":"UiNotification_notification_notice_1DfOq","notification_success":"UiNotification_notification_success_3JHYa","notification_error":"UiNotification_notification_error_3FUiD","notification__title":"UiNotification_notification__title_1Q7hJ"};

/***/ }),

/***/ "dc0f":
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ "dc57":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ "dcbe":
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__("30c9"),
    isObjectLike = __webpack_require__("1310");

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ "de55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiNotification_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("db43");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiNotification_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiNotification_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiNotification_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e24b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"loader":"UiLoader_loader_1HhZY","loader__icon":"UiLoader_loader__icon_2l9VI","spin":"UiLoader_spin_2ZoVL","loader_fixed":"UiLoader_loader_fixed_1VgHl","loader_without-overlay":"UiLoader_loader_without-overlay_2MAmf"};

/***/ }),

/***/ "e24ba":
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__("49f4"),
    hashDelete = __webpack_require__("1efc"),
    hashGet = __webpack_require__("bbc0"),
    hashHas = __webpack_require__("7a48"),
    hashSet = __webpack_require__("2524");

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e2cc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("6eeb");

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "e37d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export VClosePopover */
/* unused harmony export VPopover */
/* unused harmony export VTooltip */
/* unused harmony export createTooltip */
/* unused harmony export destroyTooltip */
/* unused harmony export install */
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7037");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9523");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("970b");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("5bc3");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var popper_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("f0bd");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("63ea");
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var vue_resize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("252c");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("42454");
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_7__);









var SVGAnimatedString = function SVGAnimatedString() {};

if (typeof window !== 'undefined') {
  SVGAnimatedString = window.SVGAnimatedString;
}

function convertToArray(value) {
  if (typeof value === 'string') {
    value = value.split(' ');
  }

  return value;
}
/**
 * Add classes to an element.
 * This method checks to ensure that the classes don't already exist before adding them.
 * It uses el.className rather than classList in order to be IE friendly.
 * @param {object} el - The element to add the classes to.
 * @param {classes} string - List of space separated classes to be added to the element.
 */

function addClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    if (classList.indexOf(newClass) === -1) {
      classList.push(newClass);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
/**
 * Remove classes from an element.
 * It uses el.className rather than classList in order to be IE friendly.
 * @export
 * @param {any} el The element to remove the classes from.
 * @param {any} classes List of space separated classes to be removed from the element.
 */

function removeClasses(el, classes) {
  var newClasses = convertToArray(classes);
  var classList;

  if (el.className instanceof SVGAnimatedString) {
    classList = convertToArray(el.className.baseVal);
  } else {
    classList = convertToArray(el.className);
  }

  newClasses.forEach(function (newClass) {
    var index = classList.indexOf(newClass);

    if (index !== -1) {
      classList.splice(index, 1);
    }
  });

  if (el instanceof SVGElement) {
    el.setAttribute('class', classList.join(' '));
  } else {
    el.className = classList.join(' ');
  }
}
var supportsPassive = false;

if (typeof window !== 'undefined') {
  supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });
    window.addEventListener('test', null, opts);
  } catch (e) {}
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var DEFAULT_OPTIONS = {
  container: false,
  delay: 0,
  html: false,
  placement: 'top',
  title: '',
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  trigger: 'hover focus',
  offset: 0
};
var openTooltips = [];

var Tooltip = /*#__PURE__*/function () {
  /**
   * Create a new Tooltip.js instance
   * @class Tooltip
   * @param {HTMLElement} reference - The DOM node used as reference of the tooltip (it can be a jQuery element).
   * @param {Object} options
   * @param {String} options.placement=bottom
   *      Placement of the popper accepted values: `top(-start, -end), right(-start, -end), bottom(-start, -end),
   *      left(-start, -end)`
   * @param {HTMLElement|String|false} options.container=false - Append the tooltip to a specific element.
   * @param {Number|Object} options.delay=0
   *      Delay showing and hiding the tooltip (ms) - does not apply to manual trigger type.
   *      If a number is supplied, delay is applied to both hide/show.
   *      Object structure is: `{ show: 500, hide: 100 }`
   * @param {Boolean} options.html=false - Insert HTML into the tooltip. If false, the content will inserted with `innerText`.
   * @param {String|PlacementFunction} options.placement='top' - One of the allowed placements, or a function returning one of them.
   * @param {String} [options.template='<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>']
   *      Base HTML to used when creating the tooltip.
   *      The tooltip's `title` will be injected into the `.tooltip-inner` or `.tooltip__inner`.
   *      `.tooltip-arrow` or `.tooltip__arrow` will become the tooltip's arrow.
   *      The outermost wrapper element should have the `.tooltip` class.
   * @param {String|HTMLElement|TitleFunction} options.title='' - Default title value if `title` attribute isn't present.
   * @param {String} [options.trigger='hover focus']
   *      How tooltip is triggered - click, hover, focus, manual.
   *      You may pass multiple triggers; separate them with a space. `manual` cannot be combined with any other trigger.
   * @param {HTMLElement} options.boundariesElement
   *      The element used as boundaries for the tooltip. For more information refer to Popper.js'
   *      [boundariesElement docs](https://popper.js.org/popper-documentation.html)
   * @param {Number|String} options.offset=0 - Offset of the tooltip relative to its reference. For more information refer to Popper.js'
   *      [offset docs](https://popper.js.org/popper-documentation.html)
   * @param {Object} options.popperOptions={} - Popper options, will be passed directly to popper instance. For more information refer to Popper.js'
   *      [options docs](https://popper.js.org/popper-documentation.html)
   * @param {string} [options.ariaId] Id used for accessibility
   * @return {Object} instance - The generated tooltip instance
   */
  function Tooltip(_reference, _options) {
    var _this = this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Tooltip);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "_events", []);

    _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(this, "_setTooltipNodeEvent", function (evt, reference, delay, options) {
      var relatedreference = evt.relatedreference || evt.toElement || evt.relatedTarget;

      var callback = function callback(evt2) {
        var relatedreference2 = evt2.relatedreference || evt2.toElement || evt2.relatedTarget; // Remove event listener after call

        _this._tooltipNode.removeEventListener(evt.type, callback); // If the new reference is not the reference element


        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this._scheduleHide(reference, options.delay, options, evt2);
        }
      };

      if (_this._tooltipNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        _this._tooltipNode.addEventListener(evt.type, callback);

        return true;
      }

      return false;
    });

    // apply user options over default ones
    _options = _objectSpread$2(_objectSpread$2({}, DEFAULT_OPTIONS), _options);
    _reference.jquery && (_reference = _reference[0]);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this); // cache reference and options

    this.reference = _reference;
    this.options = _options; // set initial state

    this._isOpen = false;

    this._init();
  } //
  // Public methods
  //

  /**
   * Reveals an element's tooltip. This is considered a "manual" triggering of the tooltip.
   * Tooltips with zero-length titles are never displayed.
   * @method Tooltip#show
   * @memberof Tooltip
   */


  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Tooltip, [{
    key: "show",
    value: function show() {
      this._show(this.reference, this.options);
    }
    /**
     * Hides an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#hide
     * @memberof Tooltip
     */

  }, {
    key: "hide",
    value: function hide() {
      this._hide();
    }
    /**
     * Hides and destroys an element’s tooltip.
     * @method Tooltip#dispose
     * @memberof Tooltip
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();
    }
    /**
     * Toggles an element’s tooltip. This is considered a “manual” triggering of the tooltip.
     * @method Tooltip#toggle
     * @memberof Tooltip
     */

  }, {
    key: "toggle",
    value: function toggle() {
      if (this._isOpen) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }, {
    key: "setClasses",
    value: function setClasses(classes) {
      this._classes = classes;
    }
  }, {
    key: "setContent",
    value: function setContent(content) {
      this.options.title = content;

      if (this._tooltipNode) {
        this._setContent(content, this.options);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var classesUpdated = false;
      var classes = options && options.classes || directive.options.defaultClass;

      if (!lodash_isEqual__WEBPACK_IMPORTED_MODULE_5___default()(this._classes, classes)) {
        this.setClasses(classes);
        classesUpdated = true;
      }

      options = getOptions(options);
      var needPopperUpdate = false;
      var needRestart = false;

      if (this.options.offset !== options.offset || this.options.placement !== options.placement) {
        needPopperUpdate = true;
      }

      if (this.options.template !== options.template || this.options.trigger !== options.trigger || this.options.container !== options.container || classesUpdated) {
        needRestart = true;
      }

      for (var key in options) {
        this.options[key] = options[key];
      }

      if (this._tooltipNode) {
        if (needRestart) {
          var isOpen = this._isOpen;
          this.dispose();

          this._init();

          if (isOpen) {
            this.show();
          }
        } else if (needPopperUpdate) {
          this.popperInstance.update();
        }
      }
    } //
    // Private methods
    //

  }, {
    key: "_init",
    value: function _init() {
      // get events list
      var events = typeof this.options.trigger === 'string' ? this.options.trigger.split(' ') : [];
      this._isDisposed = false;
      this._enableDocumentTouch = events.indexOf('manual') === -1;
      events = events.filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }); // set event listeners

      this._setEventListeners(this.reference, events, this.options); // title attribute


      this.$_originalTitle = this.reference.getAttribute('title');
      this.reference.removeAttribute('title');
      this.reference.setAttribute('data-original-title', this.$_originalTitle);
    }
    /**
     * Creates a new tooltip node
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} reference
     * @param {String} template
     * @param {String|HTMLElement|TitleFunction} title
     * @param {Boolean} allowHtml
     * @return {HTMLelement} tooltipNode
     */

  }, {
    key: "_create",
    value: function _create(reference, template) {
      var _this2 = this;

      // create tooltip element
      var tooltipGenerator = window.document.createElement('div');
      tooltipGenerator.innerHTML = template.trim();
      var tooltipNode = tooltipGenerator.childNodes[0]; // add unique ID to our tooltip (needed for accessibility reasons)

      tooltipNode.id = this.options.ariaId || "tooltip_".concat(Math.random().toString(36).substr(2, 10)); // Initially hide the tooltip
      // The attribute will be switched in a next frame so
      // CSS transitions can play

      tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.options.autoHide && this.options.trigger.indexOf('hover') !== -1) {
        tooltipNode.addEventListener('mouseenter', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
        tooltipNode.addEventListener('click', function (evt) {
          return _this2._scheduleHide(reference, _this2.options.delay, _this2.options, evt);
        });
      } // return the generated tooltip node


      return tooltipNode;
    }
  }, {
    key: "_setContent",
    value: function _setContent(content, options) {
      var _this3 = this;

      this.asyncContent = false;

      this._applyContent(content, options).then(function () {
        if (!_this3.popperInstance) return;

        _this3.popperInstance.update();
      });
    }
  }, {
    key: "_applyContent",
    value: function _applyContent(title, options) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var allowHtml = options.html;
        var rootNode = _this4._tooltipNode;
        if (!rootNode) return;
        var titleNode = rootNode.querySelector(_this4.options.innerSelector);

        if (title.nodeType === 1) {
          // if title is a node, append it only if allowHtml is true
          if (allowHtml) {
            while (titleNode.firstChild) {
              titleNode.removeChild(titleNode.firstChild);
            }

            titleNode.appendChild(title);
          }
        } else if (typeof title === 'function') {
          // if title is a function, call it and set innerText or innerHtml depending by `allowHtml` value
          var result = title();

          if (result && typeof result.then === 'function') {
            _this4.asyncContent = true;
            options.loadingClass && addClasses(rootNode, options.loadingClass);

            if (options.loadingContent) {
              _this4._applyContent(options.loadingContent, options);
            }

            result.then(function (asyncResult) {
              options.loadingClass && removeClasses(rootNode, options.loadingClass);
              return _this4._applyContent(asyncResult, options);
            }).then(resolve).catch(reject);
          } else {
            _this4._applyContent(result, options).then(resolve).catch(reject);
          }

          return;
        } else {
          // if it's just a simple text, set innerText or innerHtml depending by `allowHtml` value
          allowHtml ? titleNode.innerHTML = title : titleNode.innerText = title;
        }

        resolve();
      });
    }
  }, {
    key: "_show",
    value: function _show(reference, options) {
      if (options && typeof options.container === 'string') {
        var container = document.querySelector(options.container);
        if (!container) return;
      }

      clearTimeout(this._disposeTimer);
      options = Object.assign({}, options);
      delete options.offset;
      var updateClasses = true;

      if (this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
        updateClasses = false;
      }

      var result = this._ensureShown(reference, options);

      if (updateClasses && this._tooltipNode) {
        addClasses(this._tooltipNode, this._classes);
      }

      addClasses(reference, ['v-tooltip-open']);
      return result;
    }
  }, {
    key: "_ensureShown",
    value: function _ensureShown(reference, options) {
      var _this5 = this;

      // don't show if it's already visible
      if (this._isOpen) {
        return this;
      }

      this._isOpen = true;
      openTooltips.push(this); // if the tooltipNode already exists, just show it

      if (this._tooltipNode) {
        this._tooltipNode.style.display = '';

        this._tooltipNode.setAttribute('aria-hidden', 'false');

        this.popperInstance.enableEventListeners();
        this.popperInstance.update();

        if (this.asyncContent) {
          this._setContent(options.title, options);
        }

        return this;
      } // get title


      var title = reference.getAttribute('title') || options.title; // don't show tooltip if no title is defined

      if (!title) {
        return this;
      } // create tooltip node


      var tooltipNode = this._create(reference, options.template);

      this._tooltipNode = tooltipNode; // Add `aria-describedby` to our reference element for accessibility reasons

      reference.setAttribute('aria-describedby', tooltipNode.id); // append tooltip to container

      var container = this._findContainer(options.container, reference);

      this._append(tooltipNode, container);

      var popperOptions = _objectSpread$2(_objectSpread$2({}, options.popperOptions), {}, {
        placement: options.placement
      });

      popperOptions.modifiers = _objectSpread$2(_objectSpread$2({}, popperOptions.modifiers), {}, {
        arrow: {
          element: this.options.arrowSelector
        }
      });

      if (options.boundariesElement) {
        popperOptions.modifiers.preventOverflow = {
          boundariesElement: options.boundariesElement
        };
      }

      this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](reference, tooltipNode, popperOptions);

      this._setContent(title, options); // Fix position


      requestAnimationFrame(function () {
        if (!_this5._isDisposed && _this5.popperInstance) {
          _this5.popperInstance.update(); // Show the tooltip


          requestAnimationFrame(function () {
            if (!_this5._isDisposed) {
              _this5._isOpen && tooltipNode.setAttribute('aria-hidden', 'false');
            } else {
              _this5.dispose();
            }
          });
        } else {
          _this5.dispose();
        }
      });
      return this;
    }
  }, {
    key: "_noLongerOpen",
    value: function _noLongerOpen() {
      var index = openTooltips.indexOf(this);

      if (index !== -1) {
        openTooltips.splice(index, 1);
      }
    }
  }, {
    key: "_hide",
    value: function _hide()
    /* reference, options */
    {
      var _this6 = this;

      // don't hide if it's already hidden
      if (!this._isOpen) {
        return this;
      }

      this._isOpen = false;

      this._noLongerOpen(); // hide tooltipNode


      this._tooltipNode.style.display = 'none';

      this._tooltipNode.setAttribute('aria-hidden', 'true');

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this._disposeTimer);
      var disposeTime = directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this._disposeTimer = setTimeout(function () {
          if (_this6._tooltipNode) {
            _this6._tooltipNode.removeEventListener('mouseenter', _this6.hide);

            _this6._tooltipNode.removeEventListener('click', _this6.hide); // Don't remove popper instance, just the HTML element


            _this6._removeTooltipNode();
          }
        }, disposeTime);
      }

      removeClasses(this.reference, ['v-tooltip-open']);
      return this;
    }
  }, {
    key: "_removeTooltipNode",
    value: function _removeTooltipNode() {
      if (!this._tooltipNode) return;
      var parentNode = this._tooltipNode.parentNode;

      if (parentNode) {
        parentNode.removeChild(this._tooltipNode);
        this.reference.removeAttribute('aria-describedby');
      }

      this._tooltipNode = null;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      var _this7 = this;

      this._isDisposed = true;
      this.reference.removeAttribute('data-original-title');

      if (this.$_originalTitle) {
        this.reference.setAttribute('title', this.$_originalTitle);
      } // remove event listeners first to prevent any unexpected behaviour


      this._events.forEach(function (_ref) {
        var func = _ref.func,
            event = _ref.event;

        _this7.reference.removeEventListener(event, func);
      });

      this._events = [];

      if (this._tooltipNode) {
        this._hide();

        this._tooltipNode.removeEventListener('mouseenter', this.hide);

        this._tooltipNode.removeEventListener('click', this.hide); // destroy instance


        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          this._removeTooltipNode();
        }
      } else {
        this._noLongerOpen();
      }

      return this;
    }
  }, {
    key: "_findContainer",
    value: function _findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    }
    /**
     * Append tooltip to container
     * @memberof Tooltip
     * @private
     * @param {HTMLElement} tooltip
     * @param {HTMLElement|String|false} container
     */

  }, {
    key: "_append",
    value: function _append(tooltipNode, container) {
      container.appendChild(tooltipNode);
    }
  }, {
    key: "_setEventListeners",
    value: function _setEventListeners(reference, events, options) {
      var _this8 = this;

      var directEvents = [];
      var oppositeEvents = [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            if (_this8.options.hideOnTargetClick) oppositeEvents.push('click');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(evt) {
          if (_this8._isOpen === true) {
            return;
          }

          evt.usedByTooltip = true;

          _this8._scheduleShow(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(evt) {
          if (evt.usedByTooltip === true) {
            return;
          }

          _this8._scheduleHide(reference, options.delay, options, evt);
        };

        _this8._events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    }
  }, {
    key: "_onDocumentTouch",
    value: function _onDocumentTouch(event) {
      if (this._enableDocumentTouch) {
        this._scheduleHide(this.reference, this.options.delay, this.options, event);
      }
    }
  }, {
    key: "_scheduleShow",
    value: function _scheduleShow(reference, delay, options
    /*, evt */
    ) {
      var _this9 = this;

      // defaults to 0
      var computedDelay = delay && delay.show || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        return _this9._show(reference, options);
      }, computedDelay);
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide(reference, delay, options, evt) {
      var _this10 = this;

      // defaults to 0
      var computedDelay = delay && delay.hide || delay || 0;
      clearTimeout(this._scheduleTimer);
      this._scheduleTimer = window.setTimeout(function () {
        if (_this10._isOpen === false) {
          return;
        }

        if (!_this10._tooltipNode.ownerDocument.body.contains(_this10._tooltipNode)) {
          return;
        } // if we are hiding because of a mouseleave, we must check that the new
        // reference isn't the tooltip, because in this case we don't want to hide it


        if (evt.type === 'mouseleave') {
          var isSet = _this10._setTooltipNodeEvent(evt, reference, delay, options); // if we set the new event, don't hide the tooltip yet
          // the new event will take care to hide it if necessary


          if (isSet) {
            return;
          }
        }

        _this10._hide(reference, options);
      }, computedDelay);
    }
  }]);

  return Tooltip;
}(); // Hide tooltips on touch devices

if (typeof document !== 'undefined') {
  document.addEventListener('touchstart', function (event) {
    for (var i = 0; i < openTooltips.length; i++) {
      openTooltips[i]._onDocumentTouch(event);
    }
  }, supportsPassive ? {
    passive: true,
    capture: true
  } : true);
}
/**
 * Placement function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback PlacementFunction
 * @param {HTMLElement} tooltip - tooltip DOM node.
 * @param {HTMLElement} reference - reference DOM node.
 * @return {String} placement - One of the allowed placement options.
 */

/**
 * Title function, its context is the Tooltip instance.
 * @memberof Tooltip
 * @callback TitleFunction
 * @return {String} placement - The desired title.
 */

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var state = {
  enabled: true
};
var positions = ['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end'];
var defaultOptions = {
  // Default tooltip placement relative to target element
  defaultPlacement: 'top',
  // Default CSS classes applied to the tooltip element
  defaultClass: 'vue-tooltip-theme',
  // Default CSS classes applied to the target element of the tooltip
  defaultTargetClass: 'has-tooltip',
  // Is the content HTML by default?
  defaultHtml: true,
  // Default HTML template of the tooltip element
  // It must include `tooltip-arrow` & `tooltip-inner` CSS classes (can be configured, see below)
  // Change if the classes conflict with other libraries (for example bootstrap)
  defaultTemplate: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  // Selector used to get the arrow element in the tooltip template
  defaultArrowSelector: '.tooltip-arrow, .tooltip__arrow',
  // Selector used to get the inner content element in the tooltip template
  defaultInnerSelector: '.tooltip-inner, .tooltip__inner',
  // Delay (ms)
  defaultDelay: 0,
  // Default events that trigger the tooltip
  defaultTrigger: 'hover focus',
  // Default position offset (px)
  defaultOffset: 0,
  // Default container where the tooltip will be appended
  defaultContainer: 'body',
  defaultBoundariesElement: undefined,
  defaultPopperOptions: {},
  // Class added when content is loading
  defaultLoadingClass: 'tooltip-loading',
  // Displayed when tooltip content is loading
  defaultLoadingContent: '...',
  // Hide on mouseover tooltip
  autoHide: true,
  // Close tooltip on click on tooltip target?
  defaultHideOnTargetClick: true,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 5000,
  // Options for popover
  popover: {
    defaultPlacement: 'bottom',
    // Use the `popoverClass` prop for theming
    defaultClass: 'vue-popover-theme',
    // Base class (change if conflicts with other libraries)
    defaultBaseClass: 'tooltip popover',
    // Wrapper class (contains arrow and inner)
    defaultWrapperClass: 'wrapper',
    // Inner content class
    defaultInnerClass: 'tooltip-inner popover-inner',
    // Arrow class
    defaultArrowClass: 'tooltip-arrow popover-arrow',
    // Class added when popover is open
    defaultOpenClass: 'open',
    defaultDelay: 0,
    defaultTrigger: 'click',
    defaultOffset: 0,
    defaultContainer: 'body',
    defaultBoundariesElement: undefined,
    defaultPopperOptions: {},
    // Hides if clicked outside of popover
    defaultAutoHide: true,
    // Update popper on content resize
    defaultHandleResize: true
  }
};
function getOptions(options) {
  var result = {
    placement: typeof options.placement !== 'undefined' ? options.placement : directive.options.defaultPlacement,
    delay: typeof options.delay !== 'undefined' ? options.delay : directive.options.defaultDelay,
    html: typeof options.html !== 'undefined' ? options.html : directive.options.defaultHtml,
    template: typeof options.template !== 'undefined' ? options.template : directive.options.defaultTemplate,
    arrowSelector: typeof options.arrowSelector !== 'undefined' ? options.arrowSelector : directive.options.defaultArrowSelector,
    innerSelector: typeof options.innerSelector !== 'undefined' ? options.innerSelector : directive.options.defaultInnerSelector,
    trigger: typeof options.trigger !== 'undefined' ? options.trigger : directive.options.defaultTrigger,
    offset: typeof options.offset !== 'undefined' ? options.offset : directive.options.defaultOffset,
    container: typeof options.container !== 'undefined' ? options.container : directive.options.defaultContainer,
    boundariesElement: typeof options.boundariesElement !== 'undefined' ? options.boundariesElement : directive.options.defaultBoundariesElement,
    autoHide: typeof options.autoHide !== 'undefined' ? options.autoHide : directive.options.autoHide,
    hideOnTargetClick: typeof options.hideOnTargetClick !== 'undefined' ? options.hideOnTargetClick : directive.options.defaultHideOnTargetClick,
    loadingClass: typeof options.loadingClass !== 'undefined' ? options.loadingClass : directive.options.defaultLoadingClass,
    loadingContent: typeof options.loadingContent !== 'undefined' ? options.loadingContent : directive.options.defaultLoadingContent,
    popperOptions: _objectSpread$1({}, typeof options.popperOptions !== 'undefined' ? options.popperOptions : directive.options.defaultPopperOptions)
  };

  if (result.offset) {
    var typeofOffset = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(result.offset);

    var offset = result.offset; // One value -> switch

    if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
      offset = "0, ".concat(offset);
    }

    if (!result.popperOptions.modifiers) {
      result.popperOptions.modifiers = {};
    }

    result.popperOptions.modifiers.offset = {
      offset: offset
    };
  }

  if (result.trigger && result.trigger.indexOf('click') !== -1) {
    result.hideOnTargetClick = false;
  }

  return result;
}
function getPlacement(value, modifiers) {
  var placement = value.placement;

  for (var i = 0; i < positions.length; i++) {
    var pos = positions[i];

    if (modifiers[pos]) {
      placement = pos;
    }
  }

  return placement;
}
function getContent(value) {
  var type = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value);

  if (type === 'string') {
    return value;
  } else if (value && type === 'object') {
    return value.content;
  } else {
    return false;
  }
}
function createTooltip(el, value) {
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var content = getContent(value);
  var classes = typeof value.classes !== 'undefined' ? value.classes : directive.options.defaultClass;

  var opts = _objectSpread$1({
    title: content
  }, getOptions(_objectSpread$1(_objectSpread$1({}, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) === 'object' ? value : {}), {}, {
    placement: getPlacement(value, modifiers)
  })));

  var tooltip = el._tooltip = new Tooltip(el, opts);
  tooltip.setClasses(classes);
  tooltip._vueEl = el; // Class on target

  var targetClasses = typeof value.targetClasses !== 'undefined' ? value.targetClasses : directive.options.defaultTargetClass;
  el._tooltipTargetClasses = targetClasses;
  addClasses(el, targetClasses);
  return tooltip;
}
function destroyTooltip(el) {
  if (el._tooltip) {
    el._tooltip.dispose();

    delete el._tooltip;
    delete el._tooltipOldShow;
  }

  if (el._tooltipTargetClasses) {
    removeClasses(el, el._tooltipTargetClasses);
    delete el._tooltipTargetClasses;
  }
}
function bind(el, _ref) {
  var value = _ref.value;
      _ref.oldValue;
      var modifiers = _ref.modifiers;
  var content = getContent(value);

  if (!content || !state.enabled) {
    destroyTooltip(el);
  } else {
    var tooltip;

    if (el._tooltip) {
      tooltip = el._tooltip; // Content

      tooltip.setContent(content); // Options

      tooltip.setOptions(_objectSpread$1(_objectSpread$1({}, value), {}, {
        placement: getPlacement(value, modifiers)
      }));
    } else {
      tooltip = createTooltip(el, value, modifiers);
    } // Manual show


    if (typeof value.show !== 'undefined' && value.show !== el._tooltipOldShow) {
      el._tooltipOldShow = value.show;
      value.show ? tooltip.show() : tooltip.hide();
    }
  }
}
var directive = {
  options: defaultOptions,
  bind: bind,
  update: bind,
  unbind: function unbind(el) {
    destroyTooltip(el);
  }
};

function addListeners(el) {
  el.addEventListener('click', onClick);
  el.addEventListener('touchstart', onTouchStart, supportsPassive ? {
    passive: true
  } : false);
}

function removeListeners(el) {
  el.removeEventListener('click', onClick);
  el.removeEventListener('touchstart', onTouchStart);
  el.removeEventListener('touchend', onTouchEnd);
  el.removeEventListener('touchcancel', onTouchCancel);
}

function onClick(event) {
  var el = event.currentTarget;
  event.closePopover = !el.$_vclosepopover_touch;
  event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
}

function onTouchStart(event) {
  if (event.changedTouches.length === 1) {
    var el = event.currentTarget;
    el.$_vclosepopover_touch = true;
    var touch = event.changedTouches[0];
    el.$_vclosepopover_touchPoint = touch;
    el.addEventListener('touchend', onTouchEnd);
    el.addEventListener('touchcancel', onTouchCancel);
  }
}

function onTouchEnd(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;

  if (event.changedTouches.length === 1) {
    var touch = event.changedTouches[0];
    var firstTouch = el.$_vclosepopover_touchPoint;
    event.closePopover = Math.abs(touch.screenY - firstTouch.screenY) < 20 && Math.abs(touch.screenX - firstTouch.screenX) < 20;
    event.closeAllPopover = el.$_closePopoverModifiers && !!el.$_closePopoverModifiers.all;
  }
}

function onTouchCancel(event) {
  var el = event.currentTarget;
  el.$_vclosepopover_touch = false;
}

var vclosepopover = {
  bind: function bind(el, _ref) {
    var value = _ref.value,
        modifiers = _ref.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (typeof value === 'undefined' || value) {
      addListeners(el);
    }
  },
  update: function update(el, _ref2) {
    var value = _ref2.value,
        oldValue = _ref2.oldValue,
        modifiers = _ref2.modifiers;
    el.$_closePopoverModifiers = modifiers;

    if (value !== oldValue) {
      if (typeof value === 'undefined' || value) {
        addListeners(el);
      } else {
        removeListeners(el);
      }
    }
  },
  unbind: function unbind(el) {
    removeListeners(el);
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function getDefault(key) {
  var value = directive.options.popover[key];

  if (typeof value === 'undefined') {
    return directive.options[key];
  }

  return value;
}

var isIOS = false;

if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
  isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

var openPopovers = [];

var Element = function Element() {};

if (typeof window !== 'undefined') {
  Element = window.Element;
}

var script = {
  name: 'VPopover',
  components: {
    ResizeObserver: vue_resize__WEBPACK_IMPORTED_MODULE_6__[/* ResizeObserver */ "a"]
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: function _default() {
        return getDefault('defaultPlacement');
      }
    },
    delay: {
      type: [String, Number, Object],
      default: function _default() {
        return getDefault('defaultDelay');
      }
    },
    offset: {
      type: [String, Number],
      default: function _default() {
        return getDefault('defaultOffset');
      }
    },
    trigger: {
      type: String,
      default: function _default() {
        return getDefault('defaultTrigger');
      }
    },
    container: {
      type: [String, Object, Element, Boolean],
      default: function _default() {
        return getDefault('defaultContainer');
      }
    },
    boundariesElement: {
      type: [String, Element],
      default: function _default() {
        return getDefault('defaultBoundariesElement');
      }
    },
    popperOptions: {
      type: Object,
      default: function _default() {
        return getDefault('defaultPopperOptions');
      }
    },
    popoverClass: {
      type: [String, Array],
      default: function _default() {
        return getDefault('defaultClass');
      }
    },
    popoverBaseClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultBaseClass;
      }
    },
    popoverInnerClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultInnerClass;
      }
    },
    popoverWrapperClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultWrapperClass;
      }
    },
    popoverArrowClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultArrowClass;
      }
    },
    autoHide: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultAutoHide;
      }
    },
    handleResize: {
      type: Boolean,
      default: function _default() {
        return directive.options.popover.defaultHandleResize;
      }
    },
    openGroup: {
      type: String,
      default: null
    },
    openClass: {
      type: [String, Array],
      default: function _default() {
        return directive.options.popover.defaultOpenClass;
      }
    },
    ariaId: {
      default: null
    }
  },
  data: function data() {
    return {
      isOpen: false,
      id: Math.random().toString(36).substr(2, 10)
    };
  },
  computed: {
    cssClass: function cssClass() {
      return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({}, this.openClass, this.isOpen);
    },
    popoverId: function popoverId() {
      return "popover_".concat(this.ariaId != null ? this.ariaId : this.id);
    }
  },
  watch: {
    open: function open(val) {
      if (val) {
        this.show();
      } else {
        this.hide();
      }
    },
    disabled: function disabled(val, oldVal) {
      if (val !== oldVal) {
        if (val) {
          this.hide();
        } else if (this.open) {
          this.show();
        }
      }
    },
    container: function container(val) {
      if (this.isOpen && this.popperInstance) {
        var popoverNode = this.$refs.popover;
        var reference = this.$refs.trigger;
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.popperInstance.scheduleUpdate();
      }
    },
    trigger: function trigger(val) {
      this.$_removeEventListeners();
      this.$_addEventListeners();
    },
    placement: function placement(val) {
      var _this = this;

      this.$_updatePopper(function () {
        _this.popperInstance.options.placement = val;
      });
    },
    offset: '$_restartPopper',
    boundariesElement: '$_restartPopper',
    popperOptions: {
      handler: '$_restartPopper',
      deep: true
    }
  },
  created: function created() {
    this.$_isDisposed = false;
    this.$_mounted = false;
    this.$_events = [];
    this.$_preventOpen = false;
  },
  mounted: function mounted() {
    var popoverNode = this.$refs.popover;
    popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
    this.$_init();

    if (this.open) {
      this.show();
    }
  },
  deactivated: function deactivated() {
    this.hide();
  },
  beforeDestroy: function beforeDestroy() {
    this.dispose();
  },
  methods: {
    show: function show() {
      var _this2 = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref2.event;
          _ref2.skipDelay;
          var _ref2$force = _ref2.force,
          force = _ref2$force === void 0 ? false : _ref2$force;

      if (force || !this.disabled) {
        this.$_scheduleShow(event);
        this.$emit('show');
      }

      this.$emit('update:open', true);
      this.$_beingShowed = true;
      requestAnimationFrame(function () {
        _this2.$_beingShowed = false;
      });
    },
    hide: function hide() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          event = _ref3.event;
          _ref3.skipDelay;

      this.$_scheduleHide(event);
      this.$emit('hide');
      this.$emit('update:open', false);
    },
    dispose: function dispose() {
      this.$_isDisposed = true;
      this.$_removeEventListeners();
      this.hide({
        skipDelay: true
      });

      if (this.popperInstance) {
        this.popperInstance.destroy(); // destroy tooltipNode if removeOnDestroy is not set, as popperInstance.destroy() already removes the element

        if (!this.popperInstance.options.removeOnDestroy) {
          var popoverNode = this.$refs.popover;
          popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
        }
      }

      this.$_mounted = false;
      this.popperInstance = null;
      this.isOpen = false;
      this.$emit('dispose');
    },
    $_init: function $_init() {
      if (this.trigger.indexOf('manual') === -1) {
        this.$_addEventListeners();
      }
    },
    $_show: function $_show() {
      var _this3 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      clearTimeout(this.$_disposeTimer); // Already open

      if (this.isOpen) {
        return;
      } // Popper is already initialized


      if (this.popperInstance) {
        this.isOpen = true;
        this.popperInstance.enableEventListeners();
        this.popperInstance.scheduleUpdate();
      }

      if (!this.$_mounted) {
        var container = this.$_findContainer(this.container, reference);

        if (!container) {
          console.warn('No container for popover', this);
          return;
        }

        container.appendChild(popoverNode);
        this.$_mounted = true;
        this.isOpen = false;

        if (this.popperInstance) {
          requestAnimationFrame(function () {
            if (!_this3.hidden) {
              _this3.isOpen = true;
            }
          });
        }
      }

      if (!this.popperInstance) {
        var popperOptions = _objectSpread(_objectSpread({}, this.popperOptions), {}, {
          placement: this.placement
        });

        popperOptions.modifiers = _objectSpread(_objectSpread({}, popperOptions.modifiers), {}, {
          arrow: _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.arrow), {}, {
            element: this.$refs.arrow
          })
        });

        if (this.offset) {
          var offset = this.$_getOffset();
          popperOptions.modifiers.offset = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.offset), {}, {
            offset: offset
          });
        }

        if (this.boundariesElement) {
          popperOptions.modifiers.preventOverflow = _objectSpread(_objectSpread({}, popperOptions.modifiers && popperOptions.modifiers.preventOverflow), {}, {
            boundariesElement: this.boundariesElement
          });
        }

        this.popperInstance = new popper_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"](reference, popoverNode, popperOptions); // Fix position

        requestAnimationFrame(function () {
          if (_this3.hidden) {
            _this3.hidden = false;

            _this3.$_hide();

            return;
          }

          if (!_this3.$_isDisposed && _this3.popperInstance) {
            _this3.popperInstance.scheduleUpdate(); // Show the tooltip


            requestAnimationFrame(function () {
              if (_this3.hidden) {
                _this3.hidden = false;

                _this3.$_hide();

                return;
              }

              if (!_this3.$_isDisposed) {
                _this3.isOpen = true;
              } else {
                _this3.dispose();
              }
            });
          } else {
            _this3.dispose();
          }
        });
      }

      var openGroup = this.openGroup;

      if (openGroup) {
        var popover;

        for (var i = 0; i < openPopovers.length; i++) {
          popover = openPopovers[i];

          if (popover.openGroup !== openGroup) {
            popover.hide();
            popover.$emit('close-group');
          }
        }
      }

      openPopovers.push(this);
      this.$emit('apply-show');
    },
    $_hide: function $_hide() {
      var _this4 = this;

      // Already hidden
      if (!this.isOpen) {
        return;
      }

      var index = openPopovers.indexOf(this);

      if (index !== -1) {
        openPopovers.splice(index, 1);
      }

      this.isOpen = false;

      if (this.popperInstance) {
        this.popperInstance.disableEventListeners();
      }

      clearTimeout(this.$_disposeTimer);
      var disposeTime = directive.options.popover.disposeTimeout || directive.options.disposeTimeout;

      if (disposeTime !== null) {
        this.$_disposeTimer = setTimeout(function () {
          var popoverNode = _this4.$refs.popover;

          if (popoverNode) {
            // Don't remove popper instance, just the HTML element
            popoverNode.parentNode && popoverNode.parentNode.removeChild(popoverNode);
            _this4.$_mounted = false;
          }
        }, disposeTime);
      }

      this.$emit('apply-hide');
    },
    $_findContainer: function $_findContainer(container, reference) {
      // if container is a query, get the relative element
      if (typeof container === 'string') {
        container = window.document.querySelector(container);
      } else if (container === false) {
        // if container is `false`, set it to reference parent
        container = reference.parentNode;
      }

      return container;
    },
    $_getOffset: function $_getOffset() {
      var typeofOffset = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(this.offset);

      var offset = this.offset; // One value -> switch

      if (typeofOffset === 'number' || typeofOffset === 'string' && offset.indexOf(',') === -1) {
        offset = "0, ".concat(offset);
      }

      return offset;
    },
    $_addEventListeners: function $_addEventListeners() {
      var _this5 = this;

      var reference = this.$refs.trigger;
      var directEvents = [];
      var oppositeEvents = [];
      var events = typeof this.trigger === 'string' ? this.trigger.split(' ').filter(function (trigger) {
        return ['click', 'hover', 'focus'].indexOf(trigger) !== -1;
      }) : [];
      events.forEach(function (event) {
        switch (event) {
          case 'hover':
            directEvents.push('mouseenter');
            oppositeEvents.push('mouseleave');
            break;

          case 'focus':
            directEvents.push('focus');
            oppositeEvents.push('blur');
            break;

          case 'click':
            directEvents.push('click');
            oppositeEvents.push('click');
            break;
        }
      }); // schedule show tooltip

      directEvents.forEach(function (event) {
        var func = function func(event) {
          if (_this5.isOpen) {
            return;
          }

          event.usedByTooltip = true;
          !_this5.$_preventOpen && _this5.show({
            event: event
          });
          _this5.hidden = false;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      }); // schedule hide tooltip

      oppositeEvents.forEach(function (event) {
        var func = function func(event) {
          if (event.usedByTooltip) {
            return;
          }

          _this5.hide({
            event: event
          });

          _this5.hidden = true;
        };

        _this5.$_events.push({
          event: event,
          func: func
        });

        reference.addEventListener(event, func);
      });
    },
    $_scheduleShow: function $_scheduleShow() {
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_show();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.show || this.delay || 0);
        this.$_scheduleTimer = setTimeout(this.$_show.bind(this), computedDelay);
      }
    },
    $_scheduleHide: function $_scheduleHide() {
      var _this6 = this;

      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var skipDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      clearTimeout(this.$_scheduleTimer);

      if (skipDelay) {
        this.$_hide();
      } else {
        // defaults to 0
        var computedDelay = parseInt(this.delay && this.delay.hide || this.delay || 0);
        this.$_scheduleTimer = setTimeout(function () {
          if (!_this6.isOpen) {
            return;
          } // if we are hiding because of a mouseleave, we must check that the new
          // reference isn't the tooltip, because in this case we don't want to hide it


          if (event && event.type === 'mouseleave') {
            var isSet = _this6.$_setTooltipNodeEvent(event); // if we set the new event, don't hide the tooltip yet
            // the new event will take care to hide it if necessary


            if (isSet) {
              return;
            }
          }

          _this6.$_hide();
        }, computedDelay);
      }
    },
    $_setTooltipNodeEvent: function $_setTooltipNodeEvent(event) {
      var _this7 = this;

      var reference = this.$refs.trigger;
      var popoverNode = this.$refs.popover;
      var relatedreference = event.relatedreference || event.toElement || event.relatedTarget;

      var callback = function callback(event2) {
        var relatedreference2 = event2.relatedreference || event2.toElement || event2.relatedTarget; // Remove event listener after call

        popoverNode.removeEventListener(event.type, callback); // If the new reference is not the reference element

        if (!reference.contains(relatedreference2)) {
          // Schedule to hide tooltip
          _this7.hide({
            event: event2
          });
        }
      };

      if (popoverNode.contains(relatedreference)) {
        // listen to mouseleave on the tooltip element to be able to hide the tooltip
        popoverNode.addEventListener(event.type, callback);
        return true;
      }

      return false;
    },
    $_removeEventListeners: function $_removeEventListeners() {
      var reference = this.$refs.trigger;
      this.$_events.forEach(function (_ref4) {
        var func = _ref4.func,
            event = _ref4.event;
        reference.removeEventListener(event, func);
      });
      this.$_events = [];
    },
    $_updatePopper: function $_updatePopper(cb) {
      if (this.popperInstance) {
        cb();
        if (this.isOpen) this.popperInstance.scheduleUpdate();
      }
    },
    $_restartPopper: function $_restartPopper() {
      if (this.popperInstance) {
        var isOpen = this.isOpen;
        this.dispose();
        this.$_isDisposed = false;
        this.$_init();

        if (isOpen) {
          this.show({
            skipDelay: true,
            force: true
          });
        }
      }
    },
    $_handleGlobalClose: function $_handleGlobalClose(event) {
      var _this8 = this;

      var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.$_beingShowed) return;
      this.hide({
        event: event
      });

      if (event.closePopover) {
        this.$emit('close-directive');
      } else {
        this.$emit('auto-hide');
      }

      if (touch) {
        this.$_preventOpen = true;
        setTimeout(function () {
          _this8.$_preventOpen = false;
        }, 300);
      }
    },
    $_handleResize: function $_handleResize() {
      if (this.isOpen && this.popperInstance) {
        this.popperInstance.scheduleUpdate();
        this.$emit('resize');
      }
    }
  }
};

if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  if (isIOS) {
    document.addEventListener('touchend', handleGlobalTouchend, supportsPassive ? {
      passive: true,
      capture: true
    } : true);
  } else {
    window.addEventListener('click', handleGlobalClick, true);
  }
}

function handleGlobalClick(event) {
  handleGlobalClose(event);
}

function handleGlobalTouchend(event) {
  handleGlobalClose(event, true);
}

function handleGlobalClose(event) {
  var touch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _loop = function _loop(i) {
    var popover = openPopovers[i];

    if (popover.$refs.popover) {
      var contains = popover.$refs.popover.contains(event.target);
      requestAnimationFrame(function () {
        if (event.closeAllPopover || event.closePopover && contains || popover.autoHide && !contains) {
          popover.$_handleGlobalClose(event, touch);
        }
      });
    }
  };

  // Delay so that close directive has time to set values
  for (var i = 0; i < openPopovers.length; i++) {
    _loop(i);
  }
}

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    staticClass: "v-popover",
    class: _vm.cssClass
  }, [_c("div", {
    ref: "trigger",
    staticClass: "trigger",
    staticStyle: {
      display: "inline-block"
    },
    attrs: {
      "aria-describedby": _vm.isOpen ? _vm.popoverId : undefined,
      tabindex: _vm.trigger.indexOf("focus") !== -1 ? 0 : undefined
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c("div", {
    ref: "popover",
    class: [_vm.popoverBaseClass, _vm.popoverClass, _vm.cssClass],
    style: {
      visibility: _vm.isOpen ? "visible" : "hidden"
    },
    attrs: {
      id: _vm.popoverId,
      "aria-hidden": _vm.isOpen ? "false" : "true",
      tabindex: _vm.autoHide ? 0 : undefined
    },
    on: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }

        _vm.autoHide && _vm.hide();
      }
    }
  }, [_c("div", {
    class: _vm.popoverWrapperClass
  }, [_c("div", {
    ref: "inner",
    class: _vm.popoverInnerClass,
    staticStyle: {
      position: "relative"
    }
  }, [_c("div", [_vm._t("popover", null, {
    isOpen: _vm.isOpen
  })], 2), _vm._v(" "), _vm.handleResize ? _c("ResizeObserver", {
    on: {
      notify: _vm.$_handleResize
    }
  }) : _vm._e()], 1), _vm._v(" "), _c("div", {
    ref: "arrow",
    class: _vm.popoverArrowClass
  })])])]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".resize-observer[data-v-8859cc6c]{position:absolute;top:0;left:0;z-index:-1;width:100%;height:100%;border:none;background-color:transparent;pointer-events:none;display:block;overflow:hidden;opacity:0}.resize-observer[data-v-8859cc6c] object{display:block;position:absolute;top:0;left:0;height:100%;width:100%;overflow:hidden;pointer-events:none;z-index:-1}";
styleInject(css_248z);

function install(Vue) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (install.installed) return;
  install.installed = true;
  var finalOptions = {};
  lodash_merge__WEBPACK_IMPORTED_MODULE_7___default()(finalOptions, defaultOptions, options);
  plugin.options = finalOptions;
  directive.options = finalOptions;
  Vue.directive('tooltip', directive);
  Vue.directive('close-popover', vclosepopover);
  Vue.component('VPopover', __vue_component__);
}
var VTooltip = directive;
var VClosePopover = vclosepopover;
var VPopover = __vue_component__;
var plugin = {
  install: install,

  get enabled() {
    return state.enabled;
  },

  set enabled(value) {
    state.enabled = value;
  }

}; // Auto-install

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__("2b3e");

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("62e4")(module)))

/***/ }),

/***/ "e5b1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"btn":"UiInfoBtn_btn_3kyx8","btn__trigger":"UiInfoBtn_btn__trigger_1HPBN","btn__trigger_disabled":"UiInfoBtn_btn__trigger_disabled_1PICV","btn__content-inner":"UiInfoBtn_btn__content-inner_1ITnR","btn__content":"UiInfoBtn_btn__content_1lubH","open":"UiInfoBtn_open_i7HWc"};

/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "eac5":
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ "ec69":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__("6fcd"),
    baseKeys = __webpack_require__("03dd"),
    isArrayLike = __webpack_require__("30c9");

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ "ec8c":
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ "ed0e":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UiAvatar_avatar_1TibP","avatar_size_sm":"UiAvatar_avatar_size_sm_jh7Jb","user-pic":"UiAvatar_user-pic_1XfuJ","status":"UiAvatar_status_3vXux","label":"UiAvatar_label_2NJ59","vip-icon":"UiAvatar_vip-icon_dXbVJ","bad-icon":"UiAvatar_bad-icon_XYfcO","content":"UiAvatar_content_1Y0Om","avatar_size_lg":"UiAvatar_avatar_size_lg_27WBL","avatar_vip":"UiAvatar_avatar_vip_QfxsN","avatar_bad":"UiAvatar_avatar_bad_Wp2ML","avatar_multiple":"UiAvatar_avatar_multiple_3I0vV","label_vip":"UiAvatar_label_vip_2u8jZ","label_bad":"UiAvatar_label_bad_3aFnC","img":"UiAvatar_img_1dEJa","status_free":"UiAvatar_status_free_3nqIm","status_busy":"UiAvatar_status_busy_2DJXo","status_dinner":"UiAvatar_status_dinner_cz6lZ","status_break":"UiAvatar_status_break_2UicD","labels":"UiAvatar_labels_HYF6N","popover":"UiAvatar_popover_12x9h","popup":"UiAvatar_popup_bbM7r","open":"UiAvatar_open_9mbV3","popup__text":"UiAvatar_popup__text_1S9d0","popup__img":"UiAvatar_popup__img_1YdQF"};

/***/ }),

/***/ "ed70":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextarea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cfa9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextarea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextarea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiTextarea_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "eda1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HueSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c864");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HueSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HueSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_HueSlider_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "edc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a736");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiSwitch_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "edfa":
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ "efb6":
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__("5e2e");

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ "f01b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"emojis__popover":"UiEmoji_emojis__popover_2PdNj","emojis__group":"UiEmoji_emojis__group_1sBoc","emojis__title":"UiEmoji_emojis__title_3RIVe","emojis__button":"UiEmoji_emojis__button_2aKi-","emojis__button-wrapper":"UiEmoji_emojis__button-wrapper_2OvCa","emojis__button_active":"UiEmoji_emojis__button_active_1B-09","emojis-list":"UiEmoji_emojis-list_1mV91","emojis-list__item":"UiEmoji_emojis-list__item_rW2Ea","emojis-popover-wrapper":"UiEmoji_emojis-popover-wrapper_xfYFd","open":"UiEmoji_open_3BN3l"};

/***/ }),

/***/ "f0bd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "f167":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f24a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"UiInputNumber_input_pH-2h","input_disabled":"UiInputNumber_input_disabled_13Oam","control__input":"UiInputNumber_control__input_3Z9Rx","input_type_inline-edit":"UiInputNumber_input_type_inline-edit_3QPKO","input__inner":"UiInputNumber_input__inner_1K-LK","input_type_vertical":"UiInputNumber_input_type_vertical_3odi_","input_type_horizontal":"UiInputNumber_input_type_horizontal_1lXRf","input__label":"UiInputNumber_input__label_10AoU","field-vertical":"UiInputNumber_field-vertical_3C3UY","input_clearable":"UiInputNumber_input_clearable_1kCem","input_responsive":"UiInputNumber_input_responsive_8fX3g","field-horizontal":"UiInputNumber_field-horizontal_24kFk","field-inline-edit":"UiInputNumber_field-inline-edit_3KjYN","control":"UiInputNumber_control_1y0n1","icon":"UiInputNumber_icon_3UZKD"};

/***/ }),

/***/ "f37d":
/***/ (function(module) {

module.exports = JSON.parse("[{\"name\":\"smileys\",\"emojis\":[\"😀\",\"😃\",\"😄\",\"😁\",\"😆\",\"😅\",\"🤣\",\"😂\",\"🙂\",\"🙃\",\"😉\",\"😊\",\"😇\",\"😍\",\"🤩\",\"😘\",\"😗\",\"😚\",\"😙\",\"😋\",\"😛\",\"😜\",\"🤪\",\"😝\",\"🤑\",\"🤗\",\"🤭\",\"🤫\",\"🤔\",\"🤐\",\"🤨\",\"😐\",\"😑\",\"😶\",\"😏\",\"😒\",\"🙄\",\"😬\",\"🤥\",\"😌\",\"😔\",\"😪\",\"🤤\",\"😴\",\"😷\",\"🤒\",\"🤕\",\"🤢\",\"🤮\",\"🤧\",\"😵\",\"🤯\",\"🤠\",\"😎\",\"🤓\",\"🧐\",\"😕\",\"😟\",\"🙁\",\"😮\",\"😯\",\"😲\",\"😳\",\"😦\",\"😧\",\"😨\",\"😰\",\"😥\",\"😢\",\"😭\",\"😱\",\"😖\",\"😣\",\"😞\",\"😓\",\"😩\",\"😫\",\"😤\",\"😡\",\"😠\",\"🤬\",\"😈\",\"👿\",\"💀\",\"💩\",\"🤡\",\"👹\",\"👺\",\"👻\",\"👽\",\"👾\",\"🤖\",\"😺\",\"😸\",\"😹\",\"😻\",\"😼\",\"😽\",\"🙀\",\"😿\",\"😾\",\"💋\",\"👋\",\"🤚\",\"🖐\",\"✋\",\"🖖\",\"👌\",\"✌\",\"🤞\",\"🤟\",\"🤘\",\"🤙\",\"👈\",\"👉\",\"👆\",\"🖕\",\"👇\",\"☝\",\"👍\",\"👎\",\"✊\",\"👊\",\"🤛\",\"🤜\",\"👏\",\"🙌\",\"👐\",\"🤲\",\"🤝\",\"🙏\",\"✍\",\"💅\",\"🤳\",\"💪\",\"👂\",\"👃\",\"🧠\",\"👀\",\"👅\",\"👄\",\"👶\",\"🧒\",\"👦\",\"👧\",\"🧑\",\"👱\",\"👨\",\"🧔\",\"👱‍♂\",\"👩\",\"👱‍♀\",\"🧓\",\"👴\",\"👵\",\"🙍\",\"🙍‍♂\",\"🙍‍♀\",\"🙎\",\"🙎‍♂\",\"🙎‍♀\",\"🙅\",\"🙅‍♂\",\"🙅‍♀\",\"🙆\",\"🙆‍♂\",\"🙆‍♀\",\"💁\",\"💁‍♂\",\"💁‍♀\",\"🙋\",\"🙋‍♂\",\"🙋‍♀\",\"🙇\",\"🙇‍♂\",\"🙇‍♀\",\"🤦\",\"🤦‍♂\",\"🤦‍♀\",\"🤷\",\"🤷‍♂\",\"🤷‍♀\",\"👨‍⚕\",\"👩‍⚕\",\"👨‍🎓\",\"👩‍🎓\",\"👨‍🏫\",\"👩‍🏫\",\"👨‍⚖\",\"👩‍⚖\",\"👨‍🌾\",\"👩‍🌾\",\"👨‍🍳\",\"👩‍🍳\",\"👨‍🔧\",\"👩‍🔧\",\"👨‍🏭\",\"👩‍🏭\",\"👨‍💼\",\"👩‍💼\",\"👨‍🔬\",\"👩‍🔬\",\"👨‍💻\",\"👩‍💻\",\"👨‍🎤\",\"👩‍🎤\",\"👨‍🎨\",\"👩‍🎨\",\"👨‍✈\",\"👩‍✈\",\"👨‍🚀\",\"👩‍🚀\",\"👨‍🚒\",\"👩‍🚒\",\"👮\",\"👮‍♂\",\"👮‍♀\",\"🕵\",\"🕵️‍♂️\",\"🕵️‍♀️\",\"💂\",\"💂‍♂️\",\"💂‍♀️\",\"👷\",\"👷‍♂️\",\"👷‍♀️\",\"🤴\",\"👸\",\"👳\",\"👳‍♂️\",\"👳‍♀️\",\"👲\",\"🧕\",\"🤵\",\"👰\",\"🤰\",\"🤱\",\"👼\",\"🎅\",\"🤶\",\"🧙\",\"🧙‍♂️\",\"🧙‍♀️\",\"🧚\",\"🧚‍♂️\",\"🧚‍♀️\",\"🧛\",\"🧛‍♂️\",\"🧛‍♀️\",\"🧜\",\"🧜‍♂️\",\"🧜‍♀️\",\"🧝\",\"🧝‍♂️\",\"🧝‍♀️\",\"🧞\",\"🧞‍♂️\",\"🧞‍♀️\",\"🧟\",\"🧟‍♂️\",\"🧟‍♀️\",\"💆\",\"💆‍♂️\",\"💆‍♀️\",\"💇\",\"💇‍♂️\",\"💇‍♀️\",\"🚶\",\"🚶‍♂️\",\"🚶‍♀️\",\"🏃\",\"🏃‍♂️\",\"🏃‍♀️\",\"💃\",\"🕺\",\"🕴\",\"👯\",\"👯‍♂️\",\"👯‍♀️\",\"🧖\",\"🧖‍♂️\",\"🧖‍♀️\",\"🧘\",\"👭\",\"👫\",\"👬\",\"💏\",\"👨‍❤️‍💋‍👨\",\"👩‍❤️‍💋‍👩\",\"💑\",\"👨‍❤️‍👨\",\"👩‍❤️‍👩\",\"👪\",\"👨‍👩‍👦\",\"👨‍👩‍👧\",\"👨‍👩‍👧‍👦\",\"👨‍👩‍👦‍👦\",\"👨‍👩‍👧‍👧\",\"👨‍👨‍👦\",\"👨‍👨‍👧\",\"👨‍👨‍👧‍👦\",\"👨‍👨‍👦‍👦\",\"👨‍👨‍👧‍👧\",\"👩‍👩‍👦\",\"👩‍👩‍👧\",\"👩‍👩‍👧‍👦\",\"👩‍👩‍👦‍👦\",\"👩‍👩‍👧‍👧\",\"👨‍👦\",\"👨‍👦‍👦\",\"👨‍👧\",\"👨‍👧‍👦\",\"👨‍👧‍👧\",\"👩‍👦\",\"👩‍👦‍👦\",\"👩‍👧\",\"👩‍👧‍👦\",\"👩‍👧‍👧\",\"👤\",\"👥\",\"👣\",\"🌂\",\"👓\",\"👔\",\"👕\",\"👖\",\"🧣\",\"🧤\",\"🧥\",\"🧦\",\"👗\",\"👘\",\"👙\",\"👚\",\"👛\",\"👜\",\"👝\",\"🎒\",\"👞\",\"👟\",\"👠\",\"👡\",\"👢\",\"👑\",\"👒\",\"🎩\",\"🎓\",\"🧢\",\"💄\",\"💍\",\"💼\"]},{\"name\":\"animals\",\"emojis\":[\"🙈\",\"🙉\",\"🙊\",\"💥\",\"💫\",\"💦\",\"💨\",\"🐵\",\"🐒\",\"🦍\",\"🐶\",\"🐕\",\"🐩\",\"🐺\",\"🦊\",\"🐱\",\"🐈\",\"🦁\",\"🐯\",\"🐅\",\"🐆\",\"🐴\",\"🐎\",\"🦄\",\"🦓\",\"🐮\",\"🐂\",\"🐃\",\"🐄\",\"🐷\",\"🐖\",\"🐗\",\"🐽\",\"🐏\",\"🐑\",\"🐐\",\"🐪\",\"🐫\",\"🦒\",\"🐘\",\"🦏\",\"🐭\",\"🐁\",\"🐀\",\"🐹\",\"🐰\",\"🐇\",\"🦔\",\"🦇\",\"🐻\",\"🐨\",\"🐼\",\"🐾\",\"🦃\",\"🐔\",\"🐓\",\"🐣\",\"🐤\",\"🐥\",\"🐦\",\"🐧\",\"🦅\",\"🦆\",\"🦉\",\"🐸\",\"🐊\",\"🐢\",\"🦎\",\"🐍\",\"🐲\",\"🐉\",\"🦕\",\"🦖\",\"🐳\",\"🐋\",\"🐬\",\"🐟\",\"🐠\",\"🐡\",\"🦈\",\"🐙\",\"🐚\",\"🐌\",\"🦋\",\"🐛\",\"🐜\",\"🐝\",\"🐞\",\"🦗\",\"🦂\",\"💐\",\"🌸\",\"💮\",\"🌹\",\"🥀\",\"🌺\",\"🌻\",\"🌼\",\"🌷\",\"🌱\",\"🌲\",\"🌳\",\"🌴\",\"🌵\",\"🌾\",\"🌿\",\"🍀\",\"🍁\",\"🍂\",\"🍃\",\"🍄\",\"🌰\",\"🦀\",\"🦐\",\"🦑\",\"🌍\",\"🌎\",\"🌏\",\"🌐\",\"🌑\",\"🌒\",\"🌓\",\"🌔\",\"🌕\",\"🌖\",\"🌗\",\"🌘\",\"🌙\",\"🌚\",\"🌛\",\"🌜\",\"🌝\",\"🌞\",\"⭐\",\"🌟\",\"🌠\",\"☁\",\"⛅\",\"🌈\",\"☔\",\"⚡\",\"⛄\",\"🔥\",\"💧\",\"🌊\",\"🎄\",\"✨\",\"🎋\",\"🎍\"]},{\"name\":\"food\",\"emojis\":[\"🍇\",\"🍈\",\"🍉\",\"🍊\",\"🍋\",\"🍌\",\"🍍\",\"🍎\",\"🍏\",\"🍐\",\"🍑\",\"🍒\",\"🍓\",\"🥝\",\"🍅\",\"🥥\",\"🥑\",\"🍆\",\"🥔\",\"🥕\",\"🌽\",\"🥒\",\"🥦\",\"🍄\",\"🥜\",\"🌰\",\"🍞\",\"🥐\",\"🥖\",\"🥨\",\"🥞\",\"🧀\",\"🍖\",\"🍗\",\"🥩\",\"🥓\",\"🍔\",\"🍟\",\"🍕\",\"🌭\",\"🥪\",\"🌮\",\"🌯\",\"🥙\",\"🍳\",\"🥘\",\"🍲\",\"🥣\",\"🥗\",\"🍿\",\"🥫\",\"🍱\",\"🍘\",\"🍙\",\"🍚\",\"🍛\",\"🍜\",\"🍝\",\"🍠\",\"🍢\",\"🍣\",\"🍤\",\"🍥\",\"🍡\",\"🥟\",\"🥠\",\"🥡\",\"🍦\",\"🍧\",\"🍨\",\"🍩\",\"🍪\",\"🎂\",\"🍰\",\"🥧\",\"🍫\",\"🍬\",\"🍭\",\"🍮\",\"🍯\",\"🍼\",\"🥛\",\"☕\",\"🍵\",\"🍶\",\"🍾\",\"🍷\",\"🍸\",\"🍹\",\"🍺\",\"🍻\",\"🥂\",\"🥃\",\"🥤\",\"🥢\",\"🍴\",\"🥄\"]},{\"name\":\"activity\",\"emojis\":[\"🕴\",\"🧗\",\"🧗‍♂️\",\"🧗‍♀️\",\"🏇\",\"⛷\",\"🏂\",\"🏌\",\"🏌️‍♂️\",\"🏌️‍♀️\",\"🏄\",\"🏄‍♂️\",\"🏄‍♀️\",\"🚣\",\"🚣‍♂️\",\"🚣‍♀️\",\"🏊\",\"🏊‍♂️\",\"🏊‍♀️\",\"⛹\",\"⛹️‍♂️\",\"⛹️‍♀️\",\"🏋\",\"🏋️‍♂️\",\"🏋️‍♀️\",\"🚴\",\"🚴‍♂️\",\"🚴‍♀️\",\"🚵\",\"🚵‍♂️\",\"🚵‍♀️\",\"🤸\",\"🤸‍♂️\",\"🤸‍♀️\",\"🤼\",\"🤼‍♂️\",\"🤼‍♀️\",\"🤽\",\"🤽‍♂️\",\"🤽‍♀️\",\"🤾\",\"🤾‍♂️\",\"🤾‍♀️\",\"🤹\",\"🤹‍♂️\",\"🤹‍♀️\",\"🧘\",\"🧘‍♂️\",\"🧘‍♀️\",\"🎪\",\"🎫\",\"🏆\",\"🏅\",\"🥇\",\"🥈\",\"🥉\",\"⚽\",\"⚾\",\"🏀\",\"🏈\",\"🏉\",\"🎾\",\"🎳\",\"🏏\",\"🏑\",\"🏒\",\"🏓\",\"🏸\",\"🥊\",\"🥋\",\"⛳\",\"⛸\",\"🎣\",\"🎽\",\"🎿\",\"🛷\",\"🥌\",\"🎯\",\"🎱\",\"🎮\",\"🎰\",\"🎲\",\"🎭\",\"🎨\",\"🎼\",\"🎤\",\"🎧\",\"🎷\",\"🎸\",\"🎹\",\"🎺\",\"🎻\",\"🥁\",\"🎬\",\"🏹\"]},{\"name\":\"travel\",\"emojis\":[\"🚣\",\"🗾\",\"🏔\",\"⛰\",\"🌋\",\"🗻\",\"🏠\",\"🏡\",\"🏢\",\"🏣\",\"🏤\",\"🏥\",\"🏦\",\"🏨\",\"🏩\",\"🏪\",\"🏫\",\"🏬\",\"🏭\",\"🏯\",\"🏰\",\"💒\",\"🗼\",\"🗽\",\"⛪\",\"🕌\",\"🕍\",\"🕋\",\"⛲\",\"⛺\",\"🌁\",\"🌃\",\"🌄\",\"🌅\",\"🌆\",\"🌇\",\"🌉\",\"🎠\",\"🎡\",\"🎢\",\"🚂\",\"🚃\",\"🚄\",\"🚅\",\"🚆\",\"🚇\",\"🚈\",\"🚉\",\"🚊\",\"🚝\",\"🚞\",\"🚋\",\"🚌\",\"🚍\",\"🚎\",\"🚐\",\"🚑\",\"🚒\",\"🚓\",\"🚔\",\"🚕\",\"🚖\",\"🚗\",\"🚘\",\"🚚\",\"🚛\",\"🚜\",\"🛵\",\"🚲\",\"🛴\",\"🚏\",\"⛽\",\"🚨\",\"🚥\",\"🚦\",\"🚧\",\"⚓\",\"⛵\",\"🚤\",\"🚢\",\"🛫\",\"🛬\",\"💺\",\"🚁\",\"🚟\",\"🚠\",\"🚡\",\"🚀\",\"🛸\",\"🌠\",\"🌌\",\"🎆\",\"🎇\",\"🎑\",\"💴\",\"💵\",\"💶\",\"💷\",\"🗿\",\"🛂\",\"🛃\",\"🛄\",\"🛅\"]},{\"name\":\"objects\",\"emojis\":[\"💌\",\"💣\",\"🛀\",\"🛌\",\"🔪\",\"🏺\",\"💈\",\"⌛\",\"⏳\",\"⌚\",\"⏰\",\"⏱\",\"⏲\",\"🎈\",\"🎉\",\"🎊\",\"🎎\",\"🎏\",\"🎐\",\"🎀\",\"🎁\",\"🔮\",\"📿\",\"💎\",\"📯\",\"📻\",\"📱\",\"📲\",\"📞\",\"📟\",\"📠\",\"🔋\",\"🔌\",\"💻\",\"💽\",\"💾\",\"💿\",\"📀\",\"🎥\",\"📽\",\"📺\",\"📷\",\"📸\",\"📹\",\"📼\",\"🔍\",\"🔎\",\"💡\",\"🔦\",\"🏮\",\"📔\",\"📕\",\"📖\",\"📗\",\"📘\",\"📙\",\"📚\",\"📓\",\"📃\",\"📜\",\"📄\",\"📰\",\"📑\",\"🔖\",\"💰\",\"💴\",\"💵\",\"💶\",\"💷\",\"💸\",\"💳\",\"📧\",\"📨\",\"📩\",\"📤\",\"📥\",\"📦\",\"📫\",\"📪\",\"📬\",\"📭\",\"📮\",\"📝\",\"📁\",\"📂\",\"📅\",\"📆\",\"📇\",\"📈\",\"📉\",\"📊\",\"📋\",\"📌\",\"📍\",\"📎\",\"📏\",\"📐\",\"🔒\",\"🔓\",\"🔏\",\"🔐\",\"🔑\",\"🔨\",\"🔫\",\"🔧\",\"🔩\",\"🔬\",\"🔭\",\"📡\",\"💉\",\"💊\",\"🚪\",\"🚽\",\"🚿\",\"🛁\",\"🚬\",\"🗿\",\"🚰\"]},{\"name\":\"symbols\",\"emojis\":[\"💘\",\"💝\",\"💖\",\"💗\",\"💓\",\"💞\",\"💕\",\"💟\",\"💔\",\"🧡\",\"💛\",\"💚\",\"💙\",\"💜\",\"🖤\",\"💯\",\"💢\",\"💬\",\"👁️‍🗨️\",\"💭\",\"💤\",\"💮\",\"💈\",\"🛑\",\"🕛\",\"🕧\",\"🕐\",\"🕜\",\"🕑\",\"🕝\",\"🕒\",\"🕞\",\"🕓\",\"🕟\",\"🕔\",\"🕠\",\"🕕\",\"🕡\",\"🕖\",\"🕢\",\"🕗\",\"🕣\",\"🕘\",\"🕤\",\"🕙\",\"🕥\",\"🕚\",\"🕦\",\"🌀\",\"🃏\",\"🀄\",\"🎴\",\"🔇\",\"🔈\",\"🔉\",\"🔊\",\"📢\",\"📣\",\"📯\",\"🔔\",\"🔕\",\"🎵\",\"🎶\",\"🏧\",\"🚮\",\"🚰\",\"♿\",\"🚹\",\"🚺\",\"🚻\",\"🚼\",\"🚾\",\"🚸\",\"⛔\",\"🚫\",\"🚳\",\"🚭\",\"🚯\",\"🚱\",\"🚷\",\"🔞\",\"🔃\",\"🔄\",\"🔙\",\"🔚\",\"🔛\",\"🔜\",\"🔝\",\"🛐\",\"🕎\",\"🔯\",\"♈\",\"♉\",\"♊\",\"♋\",\"♌\",\"♍\",\"♎\",\"♏\",\"♐\",\"♑\",\"♒\",\"♓\",\"⛎\",\"🔀\",\"🔁\",\"🔂\",\"▶\",\"⏩\",\"◀\",\"⏪\",\"🔼\",\"⏫\",\"🔽\",\"⏬\",\"⏹\",\"🎦\",\"🔅\",\"🔆\",\"📶\",\"📳\",\"📴\",\"🔱\",\"📛\",\"🔰\",\"⭕\",\"✅\",\"❌\",\"❎\",\"➕\",\"➖\",\"➗\",\"➰\",\"➿\",\"〽\",\"❓\",\"❔\",\"❕\",\"❗\",\"#️⃣\",\"0️⃣\",\"1️⃣\",\"2️⃣\",\"3️⃣\",\"4️⃣\",\"5️⃣\",\"6️⃣\",\"7️⃣\",\"8️⃣\",\"9️⃣\",\"🔟\",\"🔠\",\"🔡\",\"🔢\",\"🔣\",\"🔤\",\"🅰\",\"🆎\",\"🅱\",\"🆑\",\"🆒\",\"🆓\",\"🆔\",\"Ⓜ\",\"🆕\",\"🆖\",\"🅾\",\"🆗\",\"🅿\",\"🆘\",\"🆙\",\"🆚\",\"🈁\",\"🈂\",\"🈷\",\"🈶\",\"🈯\",\"🉐\",\"🈹\",\"🈚\",\"🈲\",\"🉑\",\"🈸\",\"🈴\",\"🈳\",\"㊗\",\"㊙\",\"🈺\",\"🈵\",\"🔴\",\"🔵\",\"⚫\",\"⚪\",\"⬛\",\"⬜\",\"◼\",\"🔶\",\"🔷\",\"🔸\",\"🔹\",\"🔺\",\"🔻\",\"💠\",\"🔳\",\"🔲\"]}]");

/***/ }),

/***/ "f3c1":
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ "f45d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"collapse-content":"UiCollapse_collapse-content_XEbXA"};

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8af":
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__("2474");

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ "f909":
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__("7e64"),
    assignMergeValue = __webpack_require__("b760"),
    baseFor = __webpack_require__("72af"),
    baseMergeDeep = __webpack_require__("4f50"),
    isObject = __webpack_require__("1a8c"),
    keysIn = __webpack_require__("9934"),
    safeGet = __webpack_require__("8adb");

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ "f9bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdown_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8756");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdown_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdown_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiInputDropdown_vue_vue_type_style_index_0_module_true_lang_less___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "fa21":
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__("7530"),
    getPrototype = __webpack_require__("2dcb"),
    isPrototype = __webpack_require__("eac5");

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ "fae0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"UiSkeleton_skeleton_3WJ7r","skeleton_rectangle":"UiSkeleton_skeleton_rectangle_2IHhb","skeleton_rectangle-sm":"UiSkeleton_skeleton_rectangle-sm_2J41_","skeleton_rectangle-md":"UiSkeleton_skeleton_rectangle-md_1ShGV","skeleton_rectangle-lg":"UiSkeleton_skeleton_rectangle-lg_3nXjl","skeleton_pulse":"UiSkeleton_skeleton_pulse_3RRu0","pulse":"UiSkeleton_pulse_pWz-O","skeleton_shimmer":"UiSkeleton_skeleton_shimmer_11Zes","shimmer":"UiSkeleton_shimmer_3A4cv","skeleton_circle":"UiSkeleton_skeleton_circle_2DbEZ","skeleton_circle-sm":"UiSkeleton_skeleton_circle-sm_1WOtF","skeleton_circle-lg":"UiSkeleton_skeleton_circle-lg_3cg82","skeleton_text":"UiSkeleton_skeleton_text_1nFSG","skeleton_text-sm":"UiSkeleton_skeleton_text-sm_VnN2d","skeleton_text-md":"UiSkeleton_skeleton_text-md_Prdgn","skeleton_text-lg":"UiSkeleton_skeleton_text-lg_2LK2P"};

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// NAMESPACE OBJECT: ./src/assets/icons/index.js
var icons_namespaceObject = {};
__webpack_require__.r(icons_namespaceObject);
__webpack_require__.d(icons_namespaceObject, "plus", function() { return plus; });
__webpack_require__.d(icons_namespaceObject, "error", function() { return icons_error; });
__webpack_require__.d(icons_namespaceObject, "success", function() { return success; });
__webpack_require__.d(icons_namespaceObject, "loading", function() { return loading; });
__webpack_require__.d(icons_namespaceObject, "circleLoading", function() { return circle_loading; });
__webpack_require__.d(icons_namespaceObject, "search", function() { return search; });
__webpack_require__.d(icons_namespaceObject, "done", function() { return done; });
__webpack_require__.d(icons_namespaceObject, "info", function() { return info; });
__webpack_require__.d(icons_namespaceObject, "star", function() { return star; });
__webpack_require__.d(icons_namespaceObject, "clearCircleOutlined", function() { return clear_circle_outlined; });
__webpack_require__.d(icons_namespaceObject, "addCircleOutlined", function() { return add_circle_outlined; });
__webpack_require__.d(icons_namespaceObject, "addCirclePlus", function() { return add_circle_plus; });
__webpack_require__.d(icons_namespaceObject, "arrowLongRight", function() { return arrow_long_right; });
__webpack_require__.d(icons_namespaceObject, "externalLink", function() { return external_link; });
__webpack_require__.d(icons_namespaceObject, "linkIcon", function() { return icons_link; });
__webpack_require__.d(icons_namespaceObject, "smsChatOutlined", function() { return sms_chat_outlined; });
__webpack_require__.d(icons_namespaceObject, "chevronRight", function() { return chevron_right; });
__webpack_require__.d(icons_namespaceObject, "chevronUp", function() { return chevron_up; });
__webpack_require__.d(icons_namespaceObject, "helpIcon", function() { return help_icon; });
__webpack_require__.d(icons_namespaceObject, "website", function() { return website; });
__webpack_require__.d(icons_namespaceObject, "doubleCaretDown", function() { return double_caret_down; });
__webpack_require__.d(icons_namespaceObject, "moreHorizontal", function() { return more_horizontal; });
__webpack_require__.d(icons_namespaceObject, "shopOutlined", function() { return shop_outlined; });
__webpack_require__.d(icons_namespaceObject, "warehouse", function() { return warehouse; });
__webpack_require__.d(icons_namespaceObject, "walletOutlined", function() { return wallet_outlined; });
__webpack_require__.d(icons_namespaceObject, "dataCode", function() { return data_code; });
__webpack_require__.d(icons_namespaceObject, "addedPin", function() { return added_pin; });
__webpack_require__.d(icons_namespaceObject, "alertSuccess", function() { return alert_success; });
__webpack_require__.d(icons_namespaceObject, "alertError", function() { return alert_error; });
__webpack_require__.d(icons_namespaceObject, "alertErrorFilled", function() { return alert_error_filled; });
__webpack_require__.d(icons_namespaceObject, "warning", function() { return warning; });
__webpack_require__.d(icons_namespaceObject, "errorOutlined", function() { return error_outlined; });
__webpack_require__.d(icons_namespaceObject, "newReleaseOutlined", function() { return new_release_outlined; });
__webpack_require__.d(icons_namespaceObject, "notifications", function() { return notifications; });
__webpack_require__.d(icons_namespaceObject, "chevronDown", function() { return chevron_down; });
__webpack_require__.d(icons_namespaceObject, "caretDown", function() { return caret_down; });
__webpack_require__.d(icons_namespaceObject, "caretUp", function() { return caret_up; });
__webpack_require__.d(icons_namespaceObject, "arrowDoublesidedHorizontal", function() { return arrow_doublesided_horizontal; });
__webpack_require__.d(icons_namespaceObject, "arrowBackward", function() { return arrow_backward; });
__webpack_require__.d(icons_namespaceObject, "pullRightLeft", function() { return pull_right_left; });
__webpack_require__.d(icons_namespaceObject, "equal", function() { return equal; });
__webpack_require__.d(icons_namespaceObject, "equalNot", function() { return equal_not; });
__webpack_require__.d(icons_namespaceObject, "more", function() { return more; });
__webpack_require__.d(icons_namespaceObject, "less", function() { return less; });
__webpack_require__.d(icons_namespaceObject, "equalAndMore", function() { return equal_and_more; });
__webpack_require__.d(icons_namespaceObject, "equalAndLess", function() { return equal_and_less; });
__webpack_require__.d(icons_namespaceObject, "allDone", function() { return all_done; });
__webpack_require__.d(icons_namespaceObject, "edit", function() { return edit; });
__webpack_require__.d(icons_namespaceObject, "deleteOutlined", function() { return delete_outlined; });
__webpack_require__.d(icons_namespaceObject, "settingsOutlined", function() { return settings_outlined; });
__webpack_require__.d(icons_namespaceObject, "formatBullets", function() { return format_bullets; });
__webpack_require__.d(icons_namespaceObject, "visible", function() { return visible; });
__webpack_require__.d(icons_namespaceObject, "toggleOff", function() { return toggle_off; });
__webpack_require__.d(icons_namespaceObject, "infoOutlined20", function() { return info_outlined_20; });
__webpack_require__.d(icons_namespaceObject, "actionsRefresh20", function() { return actions_refresh_20; });
__webpack_require__.d(icons_namespaceObject, "copy20", function() { return copy_20; });
__webpack_require__.d(icons_namespaceObject, "openInNew", function() { return open_in_new; });
__webpack_require__.d(icons_namespaceObject, "calendarMonth", function() { return calendar_month; });
__webpack_require__.d(icons_namespaceObject, "calendar", function() { return calendar; });
__webpack_require__.d(icons_namespaceObject, "timeIcon", function() { return time; });
__webpack_require__.d(icons_namespaceObject, "clearCircle", function() { return clear_circle; });
__webpack_require__.d(icons_namespaceObject, "checkmarkCircleOutlined", function() { return checkmark_circle_outlined; });
__webpack_require__.d(icons_namespaceObject, "checkmarkCircle", function() { return checkmark_circle; });
__webpack_require__.d(icons_namespaceObject, "infoOutlined", function() { return info_outlined; });
__webpack_require__.d(icons_namespaceObject, "clearOutlined", function() { return clear_outlined; });
__webpack_require__.d(icons_namespaceObject, "clear", function() { return clear; });
__webpack_require__.d(icons_namespaceObject, "add", function() { return add; });
__webpack_require__.d(icons_namespaceObject, "addCircle", function() { return add_circle; });
__webpack_require__.d(icons_namespaceObject, "remove", function() { return remove; });
__webpack_require__.d(icons_namespaceObject, "checkmarkSquareOutlined", function() { return checkmark_square_outlined; });
__webpack_require__.d(icons_namespaceObject, "discount", function() { return discount; });
__webpack_require__.d(icons_namespaceObject, "discountOutlined", function() { return discount_outlined; });
__webpack_require__.d(icons_namespaceObject, "pagesOutlined", function() { return pages_outlined; });
__webpack_require__.d(icons_namespaceObject, "labelsOutlined", function() { return labels_outlined; });
__webpack_require__.d(icons_namespaceObject, "shoppingBasket", function() { return shopping_basket; });
__webpack_require__.d(icons_namespaceObject, "shoppingBasketAdd", function() { return shopping_basket_add; });
__webpack_require__.d(icons_namespaceObject, "loader", function() { return loader; });
__webpack_require__.d(icons_namespaceObject, "restore", function() { return restore; });
__webpack_require__.d(icons_namespaceObject, "upload", function() { return upload; });
__webpack_require__.d(icons_namespaceObject, "help", function() { return help; });
__webpack_require__.d(icons_namespaceObject, "accountCircle", function() { return account_circle; });
__webpack_require__.d(icons_namespaceObject, "userOutlined", function() { return user_outlined; });
__webpack_require__.d(icons_namespaceObject, "groupAdd", function() { return group_add; });
__webpack_require__.d(icons_namespaceObject, "user", function() { return user; });
__webpack_require__.d(icons_namespaceObject, "userAdd", function() { return user_add; });
__webpack_require__.d(icons_namespaceObject, "pause", function() { return pause; });
__webpack_require__.d(icons_namespaceObject, "play", function() { return play; });
__webpack_require__.d(icons_namespaceObject, "stop", function() { return stop; });
__webpack_require__.d(icons_namespaceObject, "playCircle", function() { return play_circle; });
__webpack_require__.d(icons_namespaceObject, "playCircleOutlined", function() { return play_circle_outlined; });
__webpack_require__.d(icons_namespaceObject, "countryRu", function() { return ru; });
__webpack_require__.d(icons_namespaceObject, "tools", function() { return tools; });
__webpack_require__.d(icons_namespaceObject, "copy", function() { return copy; });
__webpack_require__.d(icons_namespaceObject, "color", function() { return media_and_editing_color; });
__webpack_require__.d(icons_namespaceObject, "diamond", function() { return diamond; });
__webpack_require__.d(icons_namespaceObject, "podium", function() { return podium; });
__webpack_require__.d(icons_namespaceObject, "sms", function() { return sms; });
__webpack_require__.d(icons_namespaceObject, "send", function() { return send; });
__webpack_require__.d(icons_namespaceObject, "email", function() { return email; });
__webpack_require__.d(icons_namespaceObject, "callTalking", function() { return call_talking; });
__webpack_require__.d(icons_namespaceObject, "shopping", function() { return shopping; });
__webpack_require__.d(icons_namespaceObject, "earthEast", function() { return earth_east; });
__webpack_require__.d(icons_namespaceObject, "folderOutlined", function() { return folder_outlined; });
__webpack_require__.d(icons_namespaceObject, "chartPie1", function() { return chart_pie_1; });
__webpack_require__.d(icons_namespaceObject, "savings", function() { return savings; });
__webpack_require__.d(icons_namespaceObject, "creditCardAdd", function() { return credit_card_add; });
__webpack_require__.d(icons_namespaceObject, "function", function() { return other_function; });
__webpack_require__.d(icons_namespaceObject, "flagOutlined", function() { return flag_outlined; });
__webpack_require__.d(icons_namespaceObject, "flag", function() { return flag; });
__webpack_require__.d(icons_namespaceObject, "fieldChange", function() { return field_change; });
__webpack_require__.d(icons_namespaceObject, "fieldValue", function() { return field_value; });
__webpack_require__.d(icons_namespaceObject, "vip", function() { return vip; });
__webpack_require__.d(icons_namespaceObject, "bad", function() { return bad; });
__webpack_require__.d(icons_namespaceObject, "lock", function() { return lock; });
__webpack_require__.d(icons_namespaceObject, "slightlySmilling", function() { return slightly_smilling; });

// NAMESPACE OBJECT: ./src/components/index.js
var components_namespaceObject = {};
__webpack_require__.r(components_namespaceObject);
__webpack_require__.d(components_namespaceObject, "UiIcon", function() { return components_UiIcon; });
__webpack_require__.d(components_namespaceObject, "UiAccordion", function() { return UiAccordion; });
__webpack_require__.d(components_namespaceObject, "UiAccordionItem", function() { return UiAccordionItem; });
__webpack_require__.d(components_namespaceObject, "UiActionBtn", function() { return components_UiActionBtn; });
__webpack_require__.d(components_namespaceObject, "UiAddButton", function() { return components_UiAddButton; });
__webpack_require__.d(components_namespaceObject, "UiAlert", function() { return components_UiAlert; });
__webpack_require__.d(components_namespaceObject, "UiAvatar", function() { return UiAvatar; });
__webpack_require__.d(components_namespaceObject, "UiAvatarList", function() { return UiAvatarList; });
__webpack_require__.d(components_namespaceObject, "UiBreadcrumbs", function() { return components_UiBreadcrumbs; });
__webpack_require__.d(components_namespaceObject, "UiButton", function() { return components_UiButton; });
__webpack_require__.d(components_namespaceObject, "UiCalendar", function() { return components_UiCalendar; });
__webpack_require__.d(components_namespaceObject, "UiCheckbox", function() { return components_UiCheckbox; });
__webpack_require__.d(components_namespaceObject, "UiCollapse", function() { return components_UiCollapse; });
__webpack_require__.d(components_namespaceObject, "UiCollapseBox", function() { return UiCollapseBox; });
__webpack_require__.d(components_namespaceObject, "UiCollapseGroup", function() { return UiCollapseGroup; });
__webpack_require__.d(components_namespaceObject, "UiCollapseMenuGroup", function() { return UiCollapseMenuGroup; });
__webpack_require__.d(components_namespaceObject, "UiCollapseMenu", function() { return UiCollapseMenu; });
__webpack_require__.d(components_namespaceObject, "UiMenuBtn", function() { return UiMenuBtn; });
__webpack_require__.d(components_namespaceObject, "UiSubmenuBtn", function() { return UiSubmenuBtn; });
__webpack_require__.d(components_namespaceObject, "UiContentBox", function() { return components_UiContentBox; });
__webpack_require__.d(components_namespaceObject, "UiCopyBtn", function() { return components_UiCopyBtn; });
__webpack_require__.d(components_namespaceObject, "UiDatepicker", function() { return components_UiDatepicker; });
__webpack_require__.d(components_namespaceObject, "UiDropBtn", function() { return components_UiDropBtn; });
__webpack_require__.d(components_namespaceObject, "UiDropdownMenu", function() { return components_UiDropdownMenu; });
__webpack_require__.d(components_namespaceObject, "UiDropSelect", function() { return components_UiDropSelect; });
__webpack_require__.d(components_namespaceObject, "UiErrors", function() { return components_UiErrors; });
__webpack_require__.d(components_namespaceObject, "UiField", function() { return components_UiField; });
__webpack_require__.d(components_namespaceObject, "UiInfoBox", function() { return components_UiInfoBox; });
__webpack_require__.d(components_namespaceObject, "UiInfoBtn", function() { return components_UiInfoBtn; });
__webpack_require__.d(components_namespaceObject, "UiInput", function() { return components_UiInput; });
__webpack_require__.d(components_namespaceObject, "UiInputDropdown", function() { return components_UiInputDropdown; });
__webpack_require__.d(components_namespaceObject, "UiInputGiant", function() { return components_UiInputGiant; });
__webpack_require__.d(components_namespaceObject, "UiInputNumber", function() { return components_UiInputNumber; });
__webpack_require__.d(components_namespaceObject, "UiIntegrationLayout", function() { return components_UiIntegrationLayout; });
__webpack_require__.d(components_namespaceObject, "UiColorPicker", function() { return components_UiColorPicker; });
__webpack_require__.d(components_namespaceObject, "UiLink", function() { return components_UiLink; });
__webpack_require__.d(components_namespaceObject, "UiListBtn", function() { return components_UiListBtn; });
__webpack_require__.d(components_namespaceObject, "UiLoader", function() { return components_UiLoader; });
__webpack_require__.d(components_namespaceObject, "UiModalSidebar", function() { return components_UiModalSidebar; });
__webpack_require__.d(components_namespaceObject, "UiNotification", function() { return components_UiNotification; });
__webpack_require__.d(components_namespaceObject, "UiScrollbar", function() { return components_UiScrollbar; });
__webpack_require__.d(components_namespaceObject, "UiPagination", function() { return components_UiPagination; });
__webpack_require__.d(components_namespaceObject, "UiPopup", function() { return components_UiPopup; });
__webpack_require__.d(components_namespaceObject, "UiProgress", function() { return components_UiProgress; });
__webpack_require__.d(components_namespaceObject, "UiRadio", function() { return components_UiRadio; });
__webpack_require__.d(components_namespaceObject, "UiRadiogroup", function() { return UiRadiogroup; });
__webpack_require__.d(components_namespaceObject, "UiRadiogroupOption", function() { return UiRadiogroupOption; });
__webpack_require__.d(components_namespaceObject, "UiRow", function() { return components_UiRow; });
__webpack_require__.d(components_namespaceObject, "UiSkeleton", function() { return components_UiSkeleton; });
__webpack_require__.d(components_namespaceObject, "UiSelect", function() { return UiSelect; });
__webpack_require__.d(components_namespaceObject, "UiOption", function() { return UiOption; });
__webpack_require__.d(components_namespaceObject, "UiOptionGroup", function() { return UiOptionGroup; });
__webpack_require__.d(components_namespaceObject, "UiSwitch", function() { return components_UiSwitch; });
__webpack_require__.d(components_namespaceObject, "UiTable", function() { return components_UiTable; });
__webpack_require__.d(components_namespaceObject, "UiTabs", function() { return UiTabs; });
__webpack_require__.d(components_namespaceObject, "UiTabsItem", function() { return UiTabsItem; });
__webpack_require__.d(components_namespaceObject, "UiTabsSwitch", function() { return UiTabsSwitch; });
__webpack_require__.d(components_namespaceObject, "UiTag", function() { return components_UiTag; });
__webpack_require__.d(components_namespaceObject, "UiText", function() { return components_UiText; });
__webpack_require__.d(components_namespaceObject, "UiTextarea", function() { return components_UiTextarea; });
__webpack_require__.d(components_namespaceObject, "UiTimeBox", function() { return components_UiTimeBox; });
__webpack_require__.d(components_namespaceObject, "UiTitle", function() { return components_UiTitle; });
__webpack_require__.d(components_namespaceObject, "UiTooltip", function() { return components_UiTooltip; });
__webpack_require__.d(components_namespaceObject, "UiTransition", function() { return components_UiTransition; });
__webpack_require__.d(components_namespaceObject, "UiUploader", function() { return components_UiUploader; });
__webpack_require__.d(components_namespaceObject, "UiInputDropdownGroup", function() { return components_UiInputDropdownGroup; });
__webpack_require__.d(components_namespaceObject, "UiPopconfirm", function() { return components_UiPopconfirm; });
__webpack_require__.d(components_namespaceObject, "UiAttachment", function() { return components_UiAttachment; });
__webpack_require__.d(components_namespaceObject, "UiInlineEdit", function() { return components_UiInlineEdit; });
__webpack_require__.d(components_namespaceObject, "UiEmoji", function() { return components_UiEmoji; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/v-tooltip/dist/v-tooltip.esm.js
var v_tooltip_esm = __webpack_require__("e37d");

// EXTERNAL MODULE: ./src/assets/styles/ui-layout.less
var ui_layout = __webpack_require__("cc5b");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIcon/UiIcon.vue?vue&type=template&id=4448eba1&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.name,{tag:"component",class:_vm.classes,attrs:{"title":_vm.title}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=template&id=4448eba1&

// CONCATENATED MODULE: ./src/assets/icons/plus.svg
/* harmony default export */ var plus = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 22 22",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M10.65.5A1.75 1.75 0 008.9 2.25V8.9H2.6a2.1 2.1 0 100 4.2h6.3v6.65c0 .966.784 1.75 1.75 1.75h.7a1.75 1.75 0 001.75-1.75V13.1h6.3a2.1 2.1 0 100-4.2h-6.3V2.25A1.75 1.75 0 0011.35.5h-.7z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/error.svg
/* harmony default export */ var icons_error = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 22 22",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M21.5 18.165l-7.276-7.183L21.4 3.735 18.165.5l-7.186 7.278L3.708.601.5 3.808l7.28 7.21L.6 18.292 3.809 21.5l7.208-7.278 7.25 7.178 3.234-3.235z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/success.svg
/* harmony default export */ var success = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 28 22",
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M10.5 21.5L0 11.463l3.256-3.337 7.182 6.827L24.683.5 28 3.774 10.5 21.5z",
        "fill": "#04C383"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/loading.svg
/* harmony default export */ var loading = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "version": "1.0",
        "viewBox": "0 0 128 32",
        "fill": "#0384fc"
      }, attrs),
      ...rest
    }, children.concat([_c('circle', {
      attrs: {
        "r": "11",
        "transform": "translate(16 16)"
      }
    }, [_c('animateTransform', {
      attrs: {
        "attributeName": "transform",
        "type": "scale",
        "additive": "sum",
        "values": "1;1.42;1;1;1;1;1;1;1;1",
        "dur": "900ms",
        "repeatCount": "indefinite"
      }
    })]), _c('circle', {
      attrs: {
        "r": "11",
        "transform": "translate(64 16)"
      }
    }, [_c('animateTransform', {
      attrs: {
        "attributeName": "transform",
        "type": "scale",
        "additive": "sum",
        "values": "1;1;1;1;1.42;1;1;1;1;1",
        "dur": "900ms",
        "repeatCount": "indefinite"
      }
    })]), _c('circle', {
      attrs: {
        "r": "11",
        "transform": "translate(112 16)"
      }
    }, [_c('animateTransform', {
      attrs: {
        "attributeName": "transform",
        "type": "scale",
        "additive": "sum",
        "values": "1;1;1;1;1;1;1;1.42;1;1",
        "dur": "900ms",
        "repeatCount": "indefinite"
      }
    })])]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/circle-loading.svg
/* harmony default export */ var circle_loading = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [{
        "padding": "2px"
      }, style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "version": "1.0",
        "viewBox": "0 0 128 128",
        "style": "padding:2px"
      }, attrs),
      ...rest
    }, children.concat([_c('g', {
      attrs: {
        "transform": "matrix(-1 0 0 1 128 0)"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "13"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "11.344",
        "transform": "rotate(45 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "9.531",
        "transform": "rotate(90 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "7.75",
        "transform": "rotate(135 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "7.063",
        "transform": "rotate(180 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "5.063",
        "transform": "rotate(225 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "4.438",
        "transform": "rotate(270 64 64)"
      }
    }), _c('circle', {
      attrs: {
        "cx": "16",
        "cy": "64",
        "r": "3.375",
        "transform": "rotate(315 64 64)"
      }
    }), _c('animateTransform', {
      attrs: {
        "attributeName": "transform",
        "type": "rotate",
        "values": "0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64;",
        "calcMode": "discrete",
        "dur": "960ms",
        "repeatCount": "indefinite"
      }
    })])]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/search.svg
/* harmony default export */ var search = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M16.333 15.072l3.556 3.56a.445.445 0 01-.018.613l-.622.623a.445.445 0 01-.631 0l-3.556-3.56a2.303 2.303 0 01-.266-.32l-.667-.89a6.218 6.218 0 01-3.885 1.362A6.232 6.232 0 017.531 4.613a6.217 6.217 0 017.572 1.753 6.235 6.235 0 01-.04 7.78l.888.614c.139.089.267.194.382.312zM5.8 10.23c0 2.458 1.99 4.45 4.445 4.45 1.178 0 2.309-.469 3.142-1.303a4.453 4.453 0 00-3.142-7.597 4.447 4.447 0 00-4.445 4.45z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/done.svg
/* harmony default export */ var done = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#fff",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.792 6.965a.77.77 0 01-.021 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.053.022l.688.731z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/info.svg
/* harmony default export */ var info = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M.333 12C.333 5.557 5.557.333 12 .333A11.666 11.666 0 0123.667 12c0 6.443-5.224 11.667-11.667 11.667S.333 18.443.333 12zm2.334 0a9.333 9.333 0 1018.667 0 9.333 9.333 0 00-18.667 0zm10.5.583a.583.583 0 00-.583-.583h-1.167a.583.583 0 00-.583.583v3.5c0 .323.26.584.583.584h1.167a.583.583 0 00.583-.584v-3.5zm-.583-5.25c.322 0 .583.261.583.584v1.166a.583.583 0 01-.583.584h-1.167a.583.583 0 01-.583-.584V7.917c0-.323.26-.584.583-.584h1.167z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/star.svg
/* harmony default export */ var star = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M2.201 9.854a.49.49 0 01-.18-.54l.08-.249a.49.49 0 01.44-.35l6.384-.51 2.448-5.884a.51.51 0 01.51-.32h.259a.49.49 0 01.47.32l2.457 5.885 6.384.51a.49.49 0 01.44.349l.08.25a.49.49 0 01-.15.54l-4.816 4.136 1.479 6.204a.51.51 0 01-.19.53l-.29.16a.5.5 0 01-.56 0l-5.434-3.298-5.465 3.327a.5.5 0 01-.56 0l-.219-.15a.51.51 0 01-.19-.53l1.439-6.244L2.2 9.855z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/clear-circle-outlined.svg
/* harmony default export */ var clear_circle_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "#1E2248",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm2.56-11.09l.53.53a.48.48 0 010 .7L13.24 12l1.85 1.86a.48.48 0 010 .7l-.53.53a.48.48 0 01-.7 0L12 13.24l-1.86 1.85a.48.48 0 01-.7 0l-.53-.53a.48.48 0 010-.7L10.76 12l-1.85-1.86a.48.48 0 010-.7l.53-.53a.48.48 0 01.7 0L12 10.76l1.86-1.85a.48.48 0 01.7 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/add-circle-outlined.svg
/* harmony default export */ var add_circle_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "none",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-9h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V8.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/add-circle-plus.svg
/* harmony default export */ var add_circle_plus = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm13.5 1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13V8.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h2.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrow-long-right.svg
/* harmony default export */ var arrow_long_right = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "none",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M1.997 12.493v-1a.5.5 0 01.5-.5h15.505v-2a.5.5 0 01.85-.35l3 3a.51.51 0 010 .71l-3 3a.5.5 0 01-.85-.36v-2H2.497a.5.5 0 01-.5-.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/external-link.svg
/* harmony default export */ var external_link = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "#0384FC",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M21 19v-5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V19H5V5h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2zm-.49-15.77l.27.27v-.01A.75.75 0 0121 4v6.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6.42l-8.44 8.43a.5.5 0 01-.71 0l-.7-.7a.5.5 0 010-.71L17.59 5H13.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H20a.75.75 0 01.51.23z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/link.svg
/* harmony default export */ var icons_link = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#919EAB",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M21 7.66V8a4 4 0 01-1.18 2.84L17 13.67a1.35 1.35 0 01-1.9 0l-.1-.11a.5.5 0 010-.7l3.44-3.44A2 2 0 0019 8v-.34a2 2 0 00-.59-1.42l-.65-.65A2 2 0 0016.34 5H16a2 2 0 00-1.42.59L11.14 9a.5.5 0 01-.7 0l-.11-.11a1.35 1.35 0 010-1.9l2.83-2.84A4 4 0 0116 3h.34a4 4 0 012.83 1.17l.66.66A4 4 0 0121 7.66zM8.65 13.94l5.29-5.29a.5.5 0 01.71 0l.7.7a.5.5 0 010 .71l-5.29 5.29a.5.5 0 01-.71 0l-.7-.7a.5.5 0 010-.71zM13.56 15a.5.5 0 00-.7 0l-3.43 3.41A2 2 0 018 19h-.34a2 2 0 01-1.42-.59l-.65-.65A2 2 0 015 16.34V16a2 2 0 01.59-1.42l3.42-3.44a.5.5 0 000-.7l-.11-.11a1.35 1.35 0 00-1.9 0l-2.82 2.83A4 4 0 003 16v.35a4 4 0 001.17 2.82l.66.66A4 4 0 007.66 21H8a4 4 0 002.82-1.14l2.85-2.85a1.35 1.35 0 000-1.9l-.11-.11z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/sms-chat-outlined.svg
/* harmony default export */ var sms_chat_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#C4CDD5",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.016 11.986a3.999 3.999 0 01-4.003 3.994H6.005a3.007 3.007 0 00-2.152.849L1.85 18.826a.49.49 0 01-.35.15.5.5 0 01-.501-.5V5.995A3.999 3.999 0 015.004 2h10.009a3.999 3.999 0 014.003 3.994v5.992zM3.002 5.994v8.988a5.012 5.012 0 013.003-1h9.008a2 2 0 002.002-1.996V5.994a2 2 0 00-2.002-1.997H5.003a2 2 0 00-2.001 1.997zm10.51 3.995h1a.5.5 0 00.5-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5zm-3.003 0H9.508a.5.5 0 01-.5-.5v-.998a.5.5 0 01.5-.5h1a.5.5 0 01.501.5v.998a.5.5 0 01-.5.5zm-3.504-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5h1.001a.5.5 0 00.5-.5zm10.01 8.488a3.999 3.999 0 004.003-3.994V5.994A2 2 0 0123 7.991v14.51a.5.5 0 01-.5.499.491.491 0 01-.35-.15l-2.003-1.997a3.006 3.006 0 00-2.131-.879H7.005a2 2 0 01-2.002-1.997h12.01z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/chevron-right.svg
/* harmony default export */ var chevron_right = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M15.78 11.28c.14.14.22.331.22.53v.38a.77.77 0 01-.22.53l-5.14 5.13a.5.5 0 01-.71 0l-.71-.71a.49.49 0 010-.7L13.67 12 9.22 7.56a.5.5 0 010-.71l.71-.7a.5.5 0 01.71 0l5.14 5.13z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/chevron-up.svg
/* harmony default export */ var chevron_up = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M11.28 8.22a.75.75 0 01.53-.22h.38a.77.77 0 01.53.22l5.13 5.14a.5.5 0 010 .71l-.71.71a.49.49 0 01-.7 0L12 10.33l-4.44 4.45a.5.5 0 01-.71 0l-.7-.71a.5.5 0 010-.71l5.13-5.14z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/help-icon.svg
/* harmony default export */ var help_icon = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "fill": "#0384FC",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12.203 5.835c-.508-.512-1.263-.796-2.126-.796-1.817 0-2.992 1.293-2.992 3.293h1.676c0-1.239.69-1.678 1.282-1.678.528 0 1.088.351 1.136 1.022.052.706-.325 1.064-.802 1.517-1.176 1.12-1.198 1.661-1.193 2.89h1.671c-.01-.553.026-1.002.78-1.815.563-.608 1.264-1.365 1.28-2.518.008-.77-.237-1.433-.712-1.915zm-1.161 8.332a1.042 1.042 0 11-2.085 0 1.042 1.042 0 012.085 0zM10 0C4.478 0 0 4.478 0 10c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm0 2c4.411 0 8 3.589 8 8 0 4.412-3.589 8-8 8s-8-3.588-8-8c0-4.411 3.589-8 8-8z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/website.svg
/* harmony default export */ var website = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#919EAB",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-9.5-2h-4a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zm3-4h4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zm2 4h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/double-caret-down.svg
/* harmony default export */ var double_caret_down = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#C4CDD5",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M16.288 9.295a.5.5 0 00-.148-.355l-3.79-3.79a.48.48 0 00-.7 0L7.86 8.94a.5.5 0 000 .71l.2.2a.49.49 0 00.36.15h7.16a.49.49 0 00.36-.15l.2-.2a.5.5 0 00.148-.355zm-8.576 5.41a.5.5 0 00.148.355l3.79 3.79a.48.48 0 00.7 0l3.79-3.79a.5.5 0 000-.71l-.2-.2a.49.49 0 00-.36-.15H8.42a.49.49 0 00-.36.15l-.2.2a.5.5 0 00-.148.355z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/more-horizontal.svg
/* harmony default export */ var more_horizontal = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#0384FC",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M6 10a2 2 0 110 4 2 2 0 010-4zm8 2a2 2 0 10-4 0 2 2 0 004 0zm4-2a2 2 0 110 4 2 2 0 010-4z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/shop-outlined.svg
/* harmony default export */ var shop_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#C4CDD5",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.5 5h-15a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm2.29 5.58l-1.51-3a1 1 0 00-.9-.55H4.62a1 1 0 00-.9.55l-1.51 3a2 2 0 00-.21.89V12a1 1 0 001 1h1v7a1 1 0 001 1h5a1 1 0 001-1v-2.75a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25V20a1 1 0 001 1h5a1 1 0 001-1v-7h1a1 1 0 001-1v-.53a2 2 0 00-.21-.89zM18 19h-3v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3H6v-6h12v6z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/warehouse.svg
/* harmony default export */ var warehouse = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M11.553 2.106a1 1 0 01.894 0l9 4.5a1 1 0 11-.894 1.788L12 4.118 3.447 8.394a1 1 0 11-.894-1.788l9-4.5z"
      }
    }), _c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M11.553 5.606a1 1 0 01.894 0l9 4.5A1 1 0 0122 11v10a1 1 0 01-1 1H3a1 1 0 01-1-1V11a1 1 0 01.553-.894l9-4.5zM20 20h-3v-3a1 1 0 00-1-1h-1v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3H8a1 1 0 00-1 1v3H4v-8.382l8-4 8 4V20zm-9-4h2v-2h-2v2zm-2 2v2h2v-2H9zm4 0v2h2v-2h-2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/wallet-outlined.svg
/* harmony default export */ var wallet_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19 7H6a1 1 0 010-2h13a2 2 0 00-2-2H6a3 3 0 00-3 3v13a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2zM5 19V9h14v2h-7a1 1 0 00-1 1v4a1 1 0 001 1h7v2H5zm10-4.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/data-code.svg
/* harmony default export */ var data_code = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 28 28",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "clip-rule": "evenodd",
        "d": "M16.753 4.699l1.132.43h-.047c.297.11.452.435.35.734l-6.194 17.09a.595.595 0 01-.747.349l-1.097-.396a.582.582 0 01-.35-.745l6.195-17.113c.12-.3.453-.453.758-.35zM5.052 14.012l4.013-4.005a.57.57 0 000-.815l-.828-.826a.584.584 0 00-.829 0L2.59 13.174a.895.895 0 00-.256.617v.442c0 .231.092.454.256.617l4.83 4.808a.584.584 0 00.829 0l.828-.815a.582.582 0 000-.826l-4.025-4.005zm20.615-.221v.442a.895.895 0 01-.257.617l-4.83 4.808a.584.584 0 01-.828 0l-.828-.827a.57.57 0 010-.814l4.024-4.005-4.024-4.005a.581.581 0 010-.826l.828-.815a.584.584 0 01.828 0l4.83 4.808a.872.872 0 01.257.617z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/added-pin.svg
/* harmony default export */ var added_pin = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 30 30",
        "fill": "#463D3D",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M14.206 18.58h1.508v4.9L14.206 25v-6.42zm2.819-9.35C16.994 6.787 18.959 6.6 18.993 5h-8.206c.08 1.602 1.916 1.787 1.957 4.23.042 3.165-2.826 2.177-2.742 7.817H20c-.084-5.64-2.923-4.652-2.975-7.818z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/alert-success.svg
/* harmony default export */ var alert_success = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#00AD73",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 .333C5.557.333.333 5.557.333 12S5.557 23.667 12 23.667c6.444 0 11.667-5.224 11.667-11.667A11.666 11.666 0 0012 .333zm0 21a9.333 9.333 0 110-18.666 9.333 9.333 0 010 18.666zm3.64-13.428a.583.583 0 01.817 0l.583.618a.583.583 0 010 .829l-6.556 6.556a.56.56 0 01-.817 0l-2.742-2.765a.583.583 0 010-.828l.619-.618a.56.56 0 01.816 0l1.75 1.738 5.53-5.53z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/alert-error.svg
/* harmony default export */ var alert_error = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#D24B4B",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 .333C5.557.333.333 5.557.333 12S5.557 23.667 12 23.667c6.444 0 11.667-5.224 11.667-11.667A11.666 11.666 0 0012 .333zm0 21a9.333 9.333 0 110-18.666 9.333 9.333 0 010 18.666zm2.987-12.938l.618.618a.56.56 0 010 .817L13.447 12l2.158 2.17a.56.56 0 010 .817l-.618.618a.56.56 0 01-.817 0L12 13.447l-2.17 2.158a.56.56 0 01-.816 0l-.619-.618a.56.56 0 010-.817L10.554 12 8.395 9.83a.56.56 0 010-.817l.619-.618a.56.56 0 01.816 0L12 10.553l2.17-2.158a.56.56 0 01.817 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/alert-error-filled.svg
/* harmony default export */ var alert_error_filled = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm1 13.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.47-3.5a.25.25 0 00.25-.22l.4-3.22a.5.5 0 00-.5-.56h-1.36a.5.5 0 00-.5.56l.4 3.22a.25.25 0 00.25.22h1.06z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/warning.svg
/* harmony default export */ var warning = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M22.905 19.63L12.813 2.37a.76.76 0 00-.65-.37h-.3a.76.76 0 00-.65.37L1.1 19.63a.79.79 0 000 .76l.14.23a.73.73 0 00.65.38h20.225a.73.73 0 00.65-.38l.14-.23a.79.79 0 000-.76zm-9.902-3.13a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.47-3.5a.25.25 0 00.25-.22l.4-3.22a.5.5 0 00-.5-.56h-1.36a.5.5 0 00-.5.56l.4 3.22a.25.25 0 00.25.22h1.06z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/error-outlined.svg
/* harmony default export */ var error_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm2 0a8 8 0 1016 0 8 8 0 00-16 0zm7.5 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-.18-6h1.36a.5.5 0 01.5.56l-.4 3.22a.25.25 0 01-.25.22h-1.06a.25.25 0 01-.25-.22l-.4-3.22a.5.5 0 01.5-.56z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/new-release-outlined.svg
/* harmony default export */ var new_release_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M21.783 10.38l-.17.46a3.199 3.199 0 000 2.32l.17.49a3.27 3.27 0 01-1.71 4.15l-.45.2a3.31 3.31 0 00-1.681 1.62l-.2.45a3.261 3.261 0 01-4.152 1.71l-.46-.17a3.312 3.312 0 00-2.32 0l-.46.17a3.261 3.261 0 01-4.152-1.71l-.2-.45a3.31 3.31 0 00-1.62-1.68l-.45-.2a3.27 3.27 0 01-1.711-4.15l.17-.46c.29-.746.29-1.574 0-2.32l-.17-.46a3.27 3.27 0 011.71-4.15l.45-.2a3.31 3.31 0 001.621-1.62l.23-.45a3.261 3.261 0 014.152-1.71l.46.17c.37.139.764.21 1.16.21.406.004.81-.067 1.19-.21l.46-.17a3.262 3.262 0 014.152 1.71l.2.45A3.31 3.31 0 0019.622 6l.45.23a3.27 3.27 0 011.711 4.15zm-2.98 5.77l.46-.21a1.25 1.25 0 00.66-1.6l-.17-.49a5.159 5.159 0 010-3.73l.16-.43a1.29 1.29 0 00-.66-1.64l-.44-.19A5.3 5.3 0 0116.15 5.2l-.21-.46a1.25 1.25 0 00-1.15-.74c-.155 0-.308.03-.45.09l-.49.17c-.59.23-1.218.345-1.851.34a5.063 5.063 0 01-1.88-.35l-.43-.16A1.451 1.451 0 009.21 4c-.502 0-.956.293-1.161.75l-.19.44A5.3 5.3 0 015.188 7.9l-.46.21a1.25 1.25 0 00-.65 1.6l.17.49c.465 1.2.465 2.53 0 3.73l-.16.43a1.29 1.29 0 00.66 1.64l.44.14a5.3 5.3 0 012.66 2.66l.21.46A1.25 1.25 0 009.21 20c.155 0 .308-.03.45-.09l.49-.17A5.003 5.003 0 0112 19.4a5.063 5.063 0 011.88.35l.43.16c.155.057.317.087.48.09.502 0 .956-.293 1.161-.75l.19-.44a5.301 5.301 0 012.661-2.66zM11.5 14a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-.18-6h1.36a.5.5 0 01.5.56l-.4 3.22a.25.25 0 01-.25.22h-1.06a.25.25 0 01-.25-.22l-.4-3.22a.5.5 0 01.5-.56z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/alert/notifications.svg
/* harmony default export */ var notifications = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M18.88 14.88l.83.83a1 1 0 01.29.7V17a1 1 0 01-1 1H5a1 1 0 01-1-1v-.59a1 1 0 01.29-.7l.83-.83A3 3 0 006 12.76V10a6 6 0 011.2-3.6l.9-1.2A3 3 0 0110.5 4h.5V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h.5a3 3 0 012.4 1.2l.9 1.2A6 6 0 0118 10v2.76a3 3 0 00.88 2.12zM12 22a2 2 0 002-2h-4a2 2 0 002 2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/chevron-down.svg
/* harmony default export */ var chevron_down = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12.72 15.78a.75.75 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-5.13-5.14a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L12 13.67l4.44-4.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-5.13 5.14z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/caret-down.svg
/* harmony default export */ var caret_down = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M8.138 11.06A.518.518 0 018 10.705c0-.133.05-.261.138-.355l.187-.2A.442.442 0 018.66 10h6.68a.443.443 0 01.335.15l.187.2a.519.519 0 01.138.355c0 .133-.05.26-.138.355l-3.536 3.788A.434.434 0 0112 15a.434.434 0 01-.326-.152L8.138 11.06z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/caret-up.svg
/* harmony default export */ var caret_up = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M16.14 12.94a.5.5 0 010 .71l-.2.2a.49.49 0 01-.36.15H8.42a.49.49 0 01-.36-.15l-.2-.2a.5.5 0 010-.71l3.79-3.79a.48.48 0 01.7 0l3.79 3.79z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/arrow-doublesided-horizontal.svg
/* harmony default export */ var arrow_doublesided_horizontal = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M16 16.003v1a.5.5 0 01-.5.5H5.995v2a.5.5 0 01-.85.35l-3.001-3a.51.51 0 010-.71l3-3a.5.5 0 01.851.36v2H15.5a.5.5 0 01.5.5zM8 7.003v1a.5.5 0 00.5.5h9.505v2a.5.5 0 00.85.35l3.001-3a.51.51 0 000-.71l-3-3a.5.5 0 00-.851.36v2H8.5a.5.5 0 00-.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/arrow-backward.svg
/* harmony default export */ var arrow_backward = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M22 11.5v1a.5.5 0 01-.5.5H5.33l4.45 4.44a.5.5 0 010 .71l-.71.7a.5.5 0 01-.71 0l-6.14-6.13a.75.75 0 01-.22-.53v-.38a.77.77 0 01.22-.53l6.14-6.13a.5.5 0 01.71 0l.71.71a.49.49 0 010 .7L5.33 11H21.5a.5.5 0 01.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/pull-right-left.svg
/* harmony default export */ var pull_right_left = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M8.928 15.795a.5.5 0 01-.148.355l-.71.7a.5.5 0 01-.71 0l-4.14-4.13a.75.75 0 01-.22-.53v-.38a.77.77 0 01.22-.53l4.13-4.13a.5.5 0 01.71 0l.71.71a.49.49 0 010 .7L5.33 12l3.45 3.44a.5.5 0 01.148.355zm7.357-8.793a.5.5 0 00-.355.148l-.71.7a.5.5 0 000 .71L18.67 12l-3.45 3.44a.49.49 0 000 .7l.71.71a.5.5 0 00.71 0l4.14-4.13a.77.77 0 00.22-.53v-.38a.75.75 0 00-.22-.53l-4.14-4.13a.5.5 0 00-.355-.148z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/equal.svg
/* harmony default export */ var equal = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M17 10.6a.4.4 0 01-.4.4H7.4a.4.4 0 01-.4-.4V9.4c0-.22.18-.4.4-.4h9.2c.22 0 .4.18.4.4v1.2zM17 14.6a.4.4 0 01-.4.4H7.4a.4.4 0 01-.4-.4v-1.2c0-.22.18-.4.4-.4h9.2c.22 0 .4.18.4.4v1.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/equal-not.svg
/* harmony default export */ var equal_not = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M8.158 17.501a.3.3 0 01-.116-.417l6.544-10.931a.323.323 0 01.433-.112l.823.458a.3.3 0 01.115.417L9.415 17.847a.323.323 0 01-.433.112l-.823-.458zM12.118 15H16.5c.276 0 .5-.18.5-.4v-1.2c0-.22-.224-.4-.5-.4h-3.185l-1.197 2zM14.513 11H16.5c.276 0 .5-.18.5-.4V9.4c0-.22-.224-.4-.5-.4h-.79l-1.197 2z"
      }
    }), _c('path', {
      attrs: {
        "d": "M13.882 9l-1.197 2H7.5c-.276 0-.5-.18-.5-.4V9.4c0-.22.224-.4.5-.4h6.382zM11.487 13l-1.197 2H7.5c-.276 0-.5-.18-.5-.4v-1.2c0-.22.224-.4.5-.4h3.987z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/more.svg
/* harmony default export */ var more = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M14.536 11.201l-.007-.004-5.347-3.142a.393.393 0 00-.542.145l-.587 1.036a.408.408 0 00.147.55l3.769 2.216L8.2 14.217a.408.408 0 00-.147.55l.587 1.037a.393.393 0 00.542.145l6.116-3.594c.05-.03.093-.07.125-.116l.022-.039a.402.402 0 000-.396l-.022-.04a.402.402 0 00-.125-.115l-.762-.447z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/less.svg
/* harmony default export */ var less = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M8.97 12.806l-.008-.004-.762-.447a.403.403 0 01-.125-.116l-.022-.039a.403.403 0 010-.396l.022-.04a.403.403 0 01.125-.115l6.116-3.594a.393.393 0 01.542.145l.588 1.036a.408.408 0 01-.148.55l-3.768 2.216 3.768 2.215c.19.112.256.358.147.55l-.587 1.037a.393.393 0 01-.542.145l-5.347-3.143z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/equal-and-more.svg
/* harmony default export */ var equal_and_more = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M14.529 9.197l.007.005.762.447c.05.03.093.07.125.115l.022.04a.402.402 0 010 .396l-.022.04a.402.402 0 01-.125.115l-6.116 3.594a.393.393 0 01-.542-.145l-.587-1.036a.408.408 0 01.147-.551l3.769-2.215L8.2 7.787a.408.408 0 01-.147-.55L8.64 6.2a.393.393 0 01.542-.145l5.347 3.142zM16 17.6a.4.4 0 01-.4.4H8.4a.4.4 0 01-.4-.4v-1.2c0-.22.18-.4.4-.4h7.2c.22 0 .4.18.4.4v1.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/arrows/equal-and-less.svg
/* harmony default export */ var equal_and_less = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M9.471 9.197l-.007.005-.762.447a.402.402 0 00-.125.115l-.022.04a.403.403 0 000 .396l.022.04a.403.403 0 00.125.115l6.116 3.594c.19.112.433.047.542-.145l.588-1.036a.408.408 0 00-.148-.551l-3.769-2.215L15.8 7.787a.408.408 0 00.147-.55L15.36 6.2a.393.393 0 00-.542-.145L9.47 9.197zM8 17.6c0 .22.18.4.4.4h7.2a.4.4 0 00.4-.4v-1.2a.4.4 0 00-.4-.4H8.4a.4.4 0 00-.4.4v1.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/all-done.svg
/* harmony default export */ var all_done = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M22.15 5.83l.7.71a.5.5 0 010 .71l-10.6 10.6a.5.5 0 01-.71 0l-5.39-5.39a.5.5 0 010-.71l.7-.7a.5.5 0 01.71 0l1.84 1.88 7-7.05a.51.51 0 01.71 0l.7.71a.5.5 0 010 .71l-7 7 1.08 1.08 9.55-9.55a.51.51 0 01.71 0zM8.31 16.79l-5.75-5.74a.5.5 0 00-.71 0l-.7.7a.5.5 0 000 .71l5.39 5.39a.5.5 0 00.71 0l1.06-1.06z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/edit.svg
/* harmony default export */ var edit = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19.902 3.44l.659.658c.28.28.439.66.439 1.058v.758c.005.404-.153.793-.44 1.078l-1.845 1.816a.499.499 0 01-.708 0l-2.804-2.844a.499.499 0 010-.698l1.806-1.827A1.497 1.497 0 0118.087 3h.758c.397 0 .777.158 1.057.44zm-3.082 7.245a.5.5 0 000-.699l-2.854-2.814a.499.499 0 00-.708 0l-8.052 8.053a1.995 1.995 0 00-.449.68l-1.716 4.33a.499.499 0 00.19.62.499.499 0 00.538.109l4.33-1.757c.255-.101.486-.254.679-.449l8.042-8.073z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/delete-outlined.svg
/* harmony default export */ var delete_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M20 5.5v-1a.5.5 0 00-.5-.5H15V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-4.662 14.64a1 1 0 00.998-.94L17 8h2l-.85 12.14a2 2 0 01-2 1.86H7.87a2 2 0 01-2-1.86L5 8h2l.664 11.2a1 1 0 00.998.94h6.676z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/settings-outlined.svg
/* harmony default export */ var settings_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "clip-rule": "evenodd",
        "d": "M20.21 14.074a2.005 2.005 0 01-.72-1.643v-.861c-.032-.632.235-1.24.72-1.644l.8-.661c.376-.312.473-.85.23-1.273l-1.16-2.004a1 1 0 00-.86-.501.838.838 0 00-.35.07l-1 .36c-.223.088-.46.133-.7.131a1.997 1.997 0 01-1.08-.32 5.479 5.479 0 00-.74-.431 2.004 2.004 0 01-1.06-1.453l-.17-1.002a1 1 0 00-1-.842h-2.3a1 1 0 00-1 .842l-.17 1.002a2.004 2.004 0 01-1.02 1.453 5.477 5.477 0 00-.74.43c-.322.209-.697.32-1.08.321a1.887 1.887 0 01-.7-.13l-1-.36a.839.839 0 00-.35-.071 1 1 0 00-.86.501L2.76 7.992c-.241.426-.14.964.24 1.273l.8.66c.485.404.752 1.013.72 1.644v.861c.032.632-.235 1.24-.72 1.644l-.8.661c-.38.309-.481.847-.24 1.273l1.16 2.004a1 1 0 00.86.501c.12.002.24-.022.35-.07l1-.36c.223-.088.46-.133.7-.131.383 0 .758.112 1.08.32.235.163.483.307.74.431.563.29.956.828 1.06 1.453l.17 1.002a1 1 0 001 .842h2.3a1 1 0 001-.842l.17-1.002a2.004 2.004 0 011.06-1.453c.258-.124.505-.268.74-.43.322-.209.697-.32 1.08-.321.24-.002.477.043.7.13l1 .36c.11.05.23.073.35.071a1 1 0 00.86-.501l1.16-2.004c.228-.44.1-.981-.3-1.273l-.79-.66zM12 17.511A5.506 5.506 0 016.5 12 5.506 5.506 0 0112 6.489c3.038 0 5.5 2.467 5.5 5.511 0 1.462-.58 2.863-1.61 3.897A5.494 5.494 0 0112 17.51zM10 12c0-1.107.896-2.004 2-2.004 1.105 0 2 .897 2 2.004a2.002 2.002 0 01-2 2.004c-1.104 0-2-.897-2-2.004z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/format-bullets.svg
/* harmony default export */ var format_bullets = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M2.25 4.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm13.125.75a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375h-8.25a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h8.25zm-8.25 3h8.25c.207 0 .375.168.375.375v.75a.375.375 0 01-.375.375h-8.25a.375.375 0 01-.375-.375v-.75c0-.207.168-.375.375-.375zm8.25 4.5h-8.25a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h8.25a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375zM3.75 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-1.5 6a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/visible.svg
/* harmony default export */ var visible = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M11.994 5a10.643 10.643 0 019.994 6.7c.016.1.016.2 0 .3a.81.81 0 01-.06.33A10.644 10.644 0 0111.994 19c-4.37.022-8.31-2.63-9.934-6.69A.81.81 0 012 12a1 1 0 01.06-.33A10.643 10.643 0 0111.994 5zm-2.998 7a3 3 0 102.998-3 3 3 0 00-2.998 3z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/ui/toggle-off.svg
/* harmony default export */ var toggle_off = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M8 7h8a5 5 0 010 10H8A5 5 0 018 7zm8-1H8a6 6 0 100 12h8a6 6 0 000-12zM4 12a4 4 0 108 0 4 4 0 00-8 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/20-20/info-outlined-20.svg
/* harmony default export */ var info_outlined_20 = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0010 0zm0 18a8 8 0 110-16 8 8 0 010 16zm.5-12.402a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm0 3c.276 0 .5.048.5.448v4.117c.266.074.53.138.76.189.14.03.241.153.241.296v.454a.3.3 0 01-.3.3H8.3a.3.3 0 01-.3-.3v-.454c0-.143.1-.265.24-.296.23-.05.495-.115.76-.189V9.837c-.265-.074-.53-.138-.76-.189A.305.305 0 018 9.352v-.454a.3.3 0 01.3-.3h2.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/20-20/actions-refresh-20.svg
/* harmony default export */ var actions_refresh_20 = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M17.084 8.333h-4.167a.417.417 0 01-.417-.416v-.242a.408.408 0 01.125-.3l1.483-1.483A5.775 5.775 0 0010 4.167a5.833 5.833 0 105.834 6.225.417.417 0 01.416-.392h.834a.433.433 0 01.3.133.416.416 0 01.108.309A7.5 7.5 0 1115.308 4.7l1.242-1.242a.408.408 0 01.292-.125h.242c.23 0 .416.187.416.417v4.167c0 .23-.186.416-.416.416z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/20-20/copy-20.svg
/* harmony default export */ var copy_20 = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M15 13.334v-10c0-.92-.746-1.667-1.667-1.667h-10c-.92 0-1.667.746-1.667 1.667v10c0 .92.747 1.666 1.667 1.666h10c.92 0 1.667-.746 1.667-1.666zm-11.667-10h10v10h-10v-10zM16.666 15V5c.921 0 1.667.747 1.667 1.667V15A3.333 3.333 0 0115 18.334H6.666c-.92 0-1.666-.747-1.666-1.667h10c.92 0 1.666-.746 1.666-1.667z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/open-in-new.svg
/* harmony default export */ var open_in_new = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M5.703 14.879l-.582-.587a.417.417 0 010-.586l7.066-7.047-5.177.006a.41.41 0 01-.413-.416l.005-.827a.416.416 0 01.414-.416L14.16 5c.164 0 .321.065.437.182l.221.223a.64.64 0 01.181.44l-.006 7.193a.416.416 0 01-.413.416h-.827a.402.402 0 01-.408-.41l.006-5.212-7.067 7.047a.41.41 0 01-.582 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/calendar-month.svg
/* harmony default export */ var calendar_month = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#DFE3E8",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19 4h-1V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H8V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H5a2 2 0 00-2 2v13a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 15H5V8h14v11zm-6.5-7h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm4 0a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM9 11.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm2.5 4.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zM9 15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/calendar.svg
/* harmony default export */ var calendar = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M18 4h1a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h8V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4zM5 19h14V8H5v11z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/time.svg
/* harmony default export */ var time = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#DFE3E8",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm.88-13.5v5.14l3.63 3.63a.51.51 0 010 .71l-.53.53a.51.51 0 01-.71 0l-4-4a.53.53 0 01-.15-.35V6.5a.5.5 0 01.5-.5h.76a.5.5 0 01.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/clear-circle.svg
/* harmony default export */ var clear_circle = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm11 2.045c0-.122-.05-.24-.14-.324L13.148 12l1.712-1.721a.445.445 0 000-.648l-.49-.49a.444.444 0 00-.649 0L12 10.851 10.279 9.14a.444.444 0 00-.648 0l-.49.49a.444.444 0 000 .649L10.851 12 9.14 13.721a.444.444 0 000 .648l.49.49a.444.444 0 00.649 0L12 13.149l1.721 1.712a.444.444 0 00.648 0l.49-.49a.445.445 0 00.141-.325z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/checkmark-circle-outlined.svg
/* harmony default export */ var checkmark_circle_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm3.12-11.51a.5.5 0 01.7 0l.5.53a.5.5 0 010 .71l-5.62 5.62a.48.48 0 01-.7 0l-2.35-2.37a.5.5 0 010-.71l.53-.53a.48.48 0 01.7 0l1.5 1.49 4.74-4.74z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/checkmark-circle.svg
/* harmony default export */ var checkmark_circle = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "clip-rule": "evenodd",
        "d": "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm8.73 3.35l5.62-5.62a.5.5 0 000-.69l-.53-.53a.5.5 0 00-.7 0l-4.74 4.74-1.5-1.49a.48.48 0 00-.7 0l-.53.53a.5.5 0 000 .71l2.38 2.35a.48.48 0 00.7 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/info-outlined.svg
/* harmony default export */ var info_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm.5-12.402a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm0 3c.276 0 .5.048.5.448v4.117c.266.074.53.138.76.189.14.03.241.153.241.296v.454a.3.3 0 01-.3.3H10.3a.3.3 0 01-.3-.3v-.454c0-.143.1-.265.24-.296.23-.05.495-.115.76-.189v-3.326c-.265-.074-.53-.138-.76-.189a.305.305 0 01-.24-.296v-.454a.3.3 0 01.3-.3h2.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/clear-outlined.svg
/* harmony default export */ var clear_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm2.56-11.09l.53.53a.48.48 0 010 .7L13.24 12l1.85 1.86a.48.48 0 010 .7l-.53.53a.48.48 0 01-.7 0L12 13.24l-1.86 1.85a.48.48 0 01-.7 0l-.53-.53a.48.48 0 010-.7L10.76 12l-1.85-1.86a.48.48 0 010-.7l.53-.53a.48.48 0 01.7 0L12 10.76l1.86-1.85a.48.48 0 01.7 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/clear.svg
/* harmony default export */ var clear = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/add.svg
/* harmony default export */ var add = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M19 11.5v1a.5.5 0 01-.5.5H13v5.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11h5.5a.5.5 0 01.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/add-circle.svg
/* harmony default export */ var add_circle = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm13.5 1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13V8.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h2.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/remove.svg
/* harmony default export */ var remove = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M5.5 13.25c-.276 0-.5-.28-.5-.625v-1.25c0-.345.224-.625.5-.625h13c.276 0 .5.28.5.625v1.25c0 .345-.224.625-.5.625h-13z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/checkmark-square-outlined.svg
/* harmony default export */ var checkmark_square_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zm-8.65-3.498a.48.48 0 01-.35-.152l-2.38-2.37a.5.5 0 010-.71l.53-.53a.48.48 0 01.7 0l1.5 1.49 4.74-4.74a.5.5 0 01.7 0l.53.53a.5.5 0 010 .71l-5.62 5.62a.48.48 0 01-.35.152z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/discount.svg
/* harmony default export */ var discount = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M14.33 3.307L12 2 9.67 3.307 7 3.34 5.636 5.636 3.34 7l-.033 2.67L2 12l1.307 2.33L3.34 17l2.296 1.364L7 20.66l2.67.033L12 22l2.33-1.307L17 20.66l1.364-2.296L20.66 17l.033-2.67L22 12l-1.307-2.33L20.66 7l-2.296-1.364L17 3.34l-2.67-.033zM12 9.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-.608-6.429l.758.758-7.071 7.07-.758-.757 7.071-7.07z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/discount-outlined.svg
/* harmony default export */ var discount_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2l.482.27 1.847 1.037 2.118.026.553.007.282.475 1.082 1.821 1.82 1.082.476.282.007.553.026 2.118 1.037 1.847L22 12l-.27.482-1.037 1.847-.026 2.118-.007.553-.475.282-1.821 1.082-1.082 1.82-.282.476-.553.007-2.118.026-1.847 1.037L12 22l-.482-.27-1.847-1.037-2.118-.026L7 20.66l-.282-.475-1.082-1.821-1.82-1.082L3.34 17l-.007-.553-.026-2.118-1.037-1.847L2 12l.27-.482L3.307 9.67l.026-2.118L3.34 7l.475-.282 1.821-1.082 1.082-1.82L7 3.34l.553-.007 2.118-.026 1.847-1.037L12 2zm0 2.26l-1.584.889-.219.122-.25.004-1.817.022-.927 1.561-.129.216-.216.129-1.561.927-.022 1.816-.004.251-.122.219L4.26 12l.889 1.584.122.219.004.25.022 1.817 1.561.928.216.128.129.216.927 1.561 1.816.023.251.003.219.122L12 19.74l1.584-.889.219-.122.25-.003 1.817-.023.928-1.561.128-.216.216-.128 1.561-.928.023-1.816.003-.251.122-.219L19.74 12l-.889-1.584-.122-.219-.003-.25-.023-1.817-1.561-.927-.216-.129-.128-.216-.928-1.561-1.816-.022-.251-.004-.219-.122L12 4.26zm0 5.24a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-.608-6.429l.758.758-7.071 7.07-.758-.757 7.071-7.07z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/pages-outlined.svg
/* harmony default export */ var pages_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 16",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10.5.5H2.167C1.247.5.5 1.246.5 2.167v11.666c0 .92.746 1.667 1.667 1.667H10.5c.92 0 1.667-.746 1.667-1.667V2.167C12.167 1.247 11.42.5 10.5.5zm0 1.667v11.666H2.167V2.167H10.5zM15.5 13V3a.833.833 0 00-.833-.833h-.834v11.666h.834c.46 0 .833-.373.833-.833z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/labels-outlined.svg
/* harmony default export */ var labels_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M8.275 1.667H14.9c.22.003.432.09.592.241l.1.1c.152.16.238.371.241.592v6.625c0 .444-.176.87-.491 1.183l-6.017 6.017a.833.833 0 01-1.175 0L1.075 9.35a.833.833 0 010-1.175l6.017-6.017c.313-.315.739-.492 1.183-.491zm5.892 7.558V3.333H8.275L2.842 8.758l5.9 5.9 5.425-5.433zM12.5 6.667a1.667 1.667 0 10-3.333 0 1.667 1.667 0 003.333 0zm6.325-1.425l.1.1c.152.16.239.37.242.591v3.984c0 .905-.366 1.77-1.017 2.4l-5.833 5.833a.625.625 0 01-.884 0l-.741-.742 6.316-6.308c.315-.313.492-.739.492-1.183V5h.733c.221.003.432.09.592.242z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/shopping-basket.svg
/* harmony default export */ var shopping_basket = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M18.5 10h4a.5.5 0 01.47.5v1a.5.5 0 01-.5.5H22l-1.68 7.65A3 3 0 0117.4 22H6.6a3 3 0 01-2.89-2.35L2 12h-.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4l5.77-7.7a.77.77 0 01.6-.3h.26a.77.77 0 01.6.3L18.5 10zM12 4.67L8 10h8l-4-5.33z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/shopping-basket-add.svg
/* harmony default export */ var shopping_basket_add = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M23 10.5a.5.5 0 00-.5-.5h-4l-5.77-7.7a.77.77 0 00-.6-.3h-.26a.77.77 0 00-.6.3L5.5 10h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H2l1.71 7.65A3 3 0 006.6 22h10.8a3 3 0 002.92-2.35L22 12h.47a.5.5 0 00.5-.5l.03-1zM8 10l4-5.33L16 10H8zm4.88 6.88h1.62a.5.5 0 00.5-.5v-.76a.5.5 0 00-.5-.5h-1.62V13.5a.5.5 0 00-.5-.5h-.76a.5.5 0 00-.5.5v1.62H9.5a.5.5 0 00-.5.5v.76a.5.5 0 00.5.5h1.62v1.62a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5v-1.62z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/loader.svg
/* harmony default export */ var loader = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M4 10a2 2 0 110 4 2 2 0 010-4zM14 12a2 2 0 10-4 0 2 2 0 004 0zM22 12a2 2 0 10-4 0 2 2 0 004 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/restore.svg
/* harmony default export */ var restore = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "none",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M22 12a9 9 0 01-9 9 8.89 8.89 0 01-5.16-1.63.5.5 0 01-.07-.76l.72-.73a.5.5 0 01.63-.06A6.91 6.91 0 0013 19a7 7 0 10-7-7h2.36a.49.49 0 01.36.15l.2.2a.5.5 0 010 .71L5.39 16.6a.51.51 0 01-.71 0l-3.53-3.54a.5.5 0 010-.71l.2-.2a.49.49 0 01.36-.15H4a9 9 0 0118 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/upload.svg
/* harmony default export */ var upload = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "fill": "none",
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M20.605 14.56V20c0 .56-.44 1-1 1h-15.2c-.56 0-1-.44-1-1v-5.44c0-.56.44-1 1-1s1 .44 1 1V19h13.2v-4.44c0-.56.44-1 1-1s1 .44 1 1zM8.725 8.78l2.28-2.32v8.66c0 .56.44 1 1 1s1-.44 1-1V6.46l2.28 2.32c.2.2.46.3.72.3s.5-.1.7-.28c.4-.38.4-1.02.02-1.42l-3.98-4.08a.95.95 0 00-.72-.3c-.26 0-.52.1-.72.3l-3.98 4.08c-.38.4-.38 1.02.02 1.42.36.38 1 .36 1.38-.02z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/actions/help.svg
/* harmony default export */ var help = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm1 15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm.88-5.21a2.89 2.89 0 002-2.73V9A2.88 2.88 0 0013 6.12h-2A2.88 2.88 0 008.12 9v.5a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5V9c0-.619.501-1.12 1.12-1.12h2A1.12 1.12 0 0114.16 9v.56a1.13 1.13 0 01-.76 1.07l-.95.31a1.88 1.88 0 00-1.29 1.78v.78a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5v-.78c0-.053.032-.1.08-.12l.88-.31z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/user/account-circle.svg
/* harmony default export */ var account_circle = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 3a3 3 0 110 6 3 3 0 010-6zm0 13.987a7 7 0 005.62-2.827 1 1 0 00.07-1.01l-.23-.47A3 3 0 0014.77 13H9.23a3 3 0 00-2.71 1.72l-.21.44a1 1 0 00.07 1A7 7 0 0012 18.987z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/user/user-outlined.svg
/* harmony default export */ var user_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#1E2248",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M16.004 8A4 4 0 118 7.998 4 4 0 0116.004 8zm-2 0a2 2 0 10-4.001 0 2 2 0 004 0zm5.892 10.55l-1.89-3.89A3.001 3.001 0 0015.263 13H8.742a3.001 3.001 0 00-2.691 1.66L4.11 18.55A1 1 0 005 20h14.006a1 1 0 00.89-1.45zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 00-.9-.55H8.741a1 1 0 00-.9.55z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/user/group-add.svg
/* harmony default export */ var group_add = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M11 11a3 3 0 10-.9-5.86 5 5 0 010 5.72 3 3 0 00.9.14zm-5 0a3 3 0 100-6 3 3 0 000 6zm5.89 5.55A1 1 0 0111 18H1a1 1 0 01-.89-1.45l1-1.9A3 3 0 013.74 13h4.52a3 3 0 012.68 1.65l.95 1.9zM21 10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H21v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V12h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H19V7.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10zm-7.74 3a3 3 0 012.68 1.65l.95 1.9A1 1 0 0116 18h-2.18a3 3 0 00-.13-2.35l-.95-1.89a4.891 4.891 0 00-.48-.76h1z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/user/user.svg
/* harmony default export */ var user = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12.003 4a4 4 0 104.001 4 4 4 0 00-4.001-4zm6.452 11.66l1.44 2.89a1 1 0 01-.89 1.45H5a1 1 0 01-.89-1.45l1.44-2.89A3.001 3.001 0 018.242 14h7.522a3.001 3.001 0 012.691 1.66z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/user/user-add.svg
/* harmony default export */ var user_add = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M9 12a4 4 0 100-8 4 4 0 000 8zm7.89 6.55A1 1 0 0116 20H2a1 1 0 01-.89-1.45l1.44-2.89A3 3 0 015.24 14h7.52a3 3 0 012.69 1.66l1.44 2.89zM20 10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H20v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V12h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H18V7.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/audiovisual/pause.svg
/* harmony default export */ var pause = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#FFB066",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M10 17.25V6.75A.76.76 0 009.25 6h-1.5a.76.76 0 00-.75.75v10.5a.76.76 0 00.75.75h1.5a.76.76 0 00.75-.75zM14.75 6h1.5a.76.76 0 01.75.75v10.5a.76.76 0 01-.75.75h-1.5a.76.76 0 01-.75-.75V6.75a.76.76 0 01.75-.75z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/audiovisual/play.svg
/* harmony default export */ var play = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "#04C383",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M18 11.86v.28a.76.76 0 01-.37.65L8.68 18c-.54.32-.82.32-1.06.18l-.25-.14a.76.76 0 01-.37-.63V6.59a.76.76 0 01.37-.65l.25-.14c.24-.14.52-.14 1.22.27l8.79 5.14a.76.76 0 01.37.65z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/audiovisual/stop.svg
/* harmony default export */ var stop = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M16 18H8a2 2 0 01-2-2V8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/audiovisual/play-circle.svg
/* harmony default export */ var play_circle = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "fill": "#0068FF",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M1.5 9a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0zm6.128 3.21L12 9.48a.57.57 0 000-.96L7.612 5.79a.563.563 0 00-.862.473v5.475a.563.563 0 00.878.472z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/audiovisual/play-circle-outlined.svg
/* harmony default export */ var play_circle_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zM9.39 7.697a.75.75 0 01.76.023L16 11.36a.76.76 0 010 1.28l-5.85 3.64A.75.75 0 019 15.65v-7.3a.75.75 0 01.39-.653z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/country/ru.svg
/* harmony default export */ var ru = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M17.071 2.929c3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0z",
        "fill": "#F0F0F0"
      }
    }), _c('path', {
      attrs: {
        "d": "M19.378 13.478A9.978 9.978 0 0020 10c0-1.223-.22-2.395-.622-3.479H.622A9.979 9.979 0 000 10c0 1.223.22 2.395.622 3.478l9.379.87 9.377-.87z",
        "fill": "#0052B4"
      }
    }), _c('path', {
      attrs: {
        "d": "M10 20c4.3 0 7.966-2.713 9.379-6.521H.623A10.004 10.004 0 0010 20z",
        "fill": "#D80027"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/media-and-editing/tools.svg
/* harmony default export */ var tools = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M21 7c0 2.2-1.8 4-4 4-.5 0-1.1-.1-1.5-.3l-1.7 1.7 1.2 1.2.5-.5c.2-.2.5-.2.7 0l4.5 4.5c.2.2.3.4.3.7v1.2c0 .3-.1.5-.3.7l-.5.5c-.2.2-.4.3-.7.3h-1.2c-.3 0-.5-.1-.7-.3l-4.5-4.5c-.2-.2-.2-.5 0-.7l.5-.5-6.8-6.8-1.6-.9c-.3-.1-.6-.3-.7-.7l-1.4-2c-.1-.2-.1-.4.1-.6l.8-.8c.2-.2.4-.2.6-.1l2.1 1.3c.3.2.5.5.6.8l.9 1.6 3.4 3.5 1.7-1.7c-.2-.5-.3-1.1-.3-1.6 0-2.2 1.8-4 4-4h.3c.2 0 .3 0 .4.1l.2.2c.2.2.2.5 0 .7l-1.6 1.6c-.2.2-.2.5 0 .7l1.4 1.4c.2.2.5.2.7 0L20 6.1c.2-.1.5-.1.7 0l.2.2c0 .05.025.125.05.2.025.075.05.15.05.2V7zM3 19.3c0-.3.1-.5.3-.7L9 12.9l2.1 2.1-5.7 5.7c-.2.2-.4.3-.7.3h-.2c-.2 0-.5-.1-.7-.3l-.5-.5c-.2-.2-.3-.4-.3-.7v-.2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/media-and-editing/copy.svg
/* harmony default export */ var copy = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M18 16V4a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2zM4 4h12v12H4V4zm16 14V6a2 2 0 012 2v10a4 4 0 01-4 4H8a2 2 0 01-2-2h12a2 2 0 002-2z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/media-and-editing/color.svg
/* harmony default export */ var media_and_editing_color = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M20 14a8 8 0 11-16 0c0-3.81 2.86-7.36 5.5-10l1.82-1.82a.75.75 0 01.53-.18h.3c.199 0 .39.08.53.22L14.5 4c2.64 2.64 5.5 6.19 5.5 10z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/premium/diamond.svg
/* harmony default export */ var diamond = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M21.74 8.16l-4.15-4.51A2 2 0 0016.12 3H7.88a2 2 0 00-1.47.65L2.26 8.16a1 1 0 00-.26.68v.3a1 1 0 00.23.64l9 10.86a1 1 0 001.54 0l9-10.86a1 1 0 00.23-.64v-.3a1 1 0 00-.26-.68zm-10.56 9.31l-6.65-8A.253.253 0 114.72 9h3.55a1 1 0 011 .69l2.39 7.55a.266.266 0 11-.48.23zM13.07 9h6.17a.25.25 0 00.18-.42L16.31 5.2a.25.25 0 00-.37 0l-3.06 3.38a.25.25 0 00.19.42z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/premium/podium.svg
/* harmony default export */ var podium = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M8.009 5.08a.212.212 0 00.072.227l1.926 1.742-.576 2.629a.22.22 0 00.076.223l.088.063a.192.192 0 00.224 0l2.186-1.4 2.174 1.387a.192.192 0 00.223 0l.116-.067a.22.22 0 00.076-.223l-.591-2.612 1.926-1.742a.213.213 0 00.06-.227l-.032-.105a.198.198 0 00-.176-.148l-2.553-.214-.983-2.478a.196.196 0 00-.188-.134h-.104a.203.203 0 00-.204.134l-.979 2.478-2.554.214a.198.198 0 00-.175.148l-.032.105zM10 12h4a1 1 0 011 1v8H9v-8a1 1 0 011-1zm6 8v-5h3a1 1 0 011 1v4a1 1 0 01-1 1h-3v-1zM5 15h3v6H5a1 1 0 01-1-1v-4a1 1 0 011-1z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/communication/sms.svg
/* harmony default export */ var sms = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M6 2h12a4 4 0 014 4v8a4 4 0 01-4 4H8a3 3 0 00-2.15.85l-3 3a.49.49 0 01-.35.15.5.5 0 01-.5-.5V6a4 4 0 014-4zm2.5 9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zm4.5-.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm3.5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/communication/send.svg
/* harmony default export */ var send = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M19.968 4.949l-5.99 16.722a.5.5 0 01-.469.329h-.16a.51.51 0 01-.459-.29l-2.355-4.991a1.997 1.997 0 01.339-2.206l2.995-3.275a.5.5 0 000-.688l-.38-.38a.5.5 0 00-.689 0l-3.274 2.995a1.996 1.996 0 01-2.206.34l-4.99-2.357A.51.51 0 012 10.69v-.16a.5.5 0 01.33-.509l16.72-5.99a.499.499 0 01.518.11l.26.26a.5.5 0 01.14.549z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/communication/email.svg
/* harmony default export */ var email = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 20 20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M3.333 3.333h13.334c.92 0 1.666.747 1.666 1.667v10c0 .92-.746 1.667-1.666 1.667H3.333c-.92 0-1.666-.747-1.666-1.667V5c0-.92.746-1.667 1.666-1.667zm8.042 9.542l5.292-3.708v-1.75l-6.125 4.291a.95.95 0 01-1.084 0L3.333 7.417v1.75l5.292 3.708a2.4 2.4 0 002.75 0z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/communication/call-talking.svg
/* harmony default export */ var call_talking = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M13 4.5v-1a.51.51 0 01.15-.37.53.53 0 01.4-.13A8 8 0 0121 10.45a.53.53 0 01-.13.38.51.51 0 01-.37.15h-1a.5.5 0 01-.5-.46A6 6 0 0013.48 5a.5.5 0 01-.48-.5zm.17 2.64a.5.5 0 00-.17.38v1a.49.49 0 00.4.49 2 2 0 011.6 1.57.49.49 0 00.49.4h1a.5.5 0 00.5-.57A4.05 4.05 0 0013.59 7a.52.52 0 00-.4.14h-.02zm5.92 13.27a2 2 0 01-1.42.59H17a10.07 10.07 0 01-4.78-1.23l-.45-.25a18 18 0 01-7.33-7.33l-.25-.45A10.07 10.07 0 013 7v-.67a2 2 0 01.59-1.42l1.69-1.69a.75.75 0 011.18.15l2.25 3.86a1 1 0 01-.16 1.21l-1.89 1.89a.5.5 0 00-.09.59l.35.66a13.53 13.53 0 005.5 5.49l.66.36a.5.5 0 00.59-.09l1.89-1.89a1 1 0 011.21-.16l3.86 2.25a.75.75 0 01.15 1.18l-1.69 1.69z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/map-and-places/shopping.svg
/* harmony default export */ var shopping = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "fill": "#0068FF",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12.75 5.25H15a.75.75 0 01.75.75v9a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5V6A.75.75 0 013 5.25h2.25a3.75 3.75 0 117.5 0zm-6.375 3a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375h-.75a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h.75zM9 3a2.25 2.25 0 012.25 2.25h-4.5A2.25 2.25 0 019 3zm3.375 5.25a.375.375 0 00.375-.375v-.75a.375.375 0 00-.375-.375h-.75a.375.375 0 00-.375.375v.75c0 .207.168.375.375.375h.75z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/map-and-places/earth-east.svg
/* harmony default export */ var earth_east = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 01-1-15.93v.43a.5.5 0 01-.5.5.5.5 0 00-.5.5v1a.5.5 0 00.5.5h3a.48.48 0 01.5.48.51.51 0 00.5.52A1.5 1.5 0 0116 9.5V11h-1a1 1 0 01-1-1v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 01-.5-.5.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V9a1 1 0 01-1 1 1 1 0 00-1 1v1a1 1 0 001 1h1.59a1 1 0 01.7.29l.42.42a1 1 0 01.29.7V17a1 1 0 001 1h.5a.5.5 0 00.5-.5.5.5 0 01.5-.5 1.5 1.5 0 001.5-1.5v-2a.49.49 0 01.45-.5.52.52 0 00.55-.48V11h1a1 1 0 001-1V9h1.41a7.9 7.9 0 01.59 3 8 8 0 01-8 8z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/files/folder-outlined.svg
/* harmony default export */ var folder_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 14",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M2.333.333h6.325c.219.001.428.088.584.242l1.183 1.183c.155.154.365.241.583.242h4.659c.92 0 1.666.746 1.666 1.667V12c0 .92-.746 1.667-1.666 1.667H2.333c-.92 0-1.666-.747-1.666-1.667V2c0-.92.746-1.667 1.666-1.667zm6.917 2.6L8.308 2H2.333v10h13.334V3.667h-4.659a2.5 2.5 0 01-1.758-.734z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/technology-and-data/chart-pie-1.svg
/* harmony default export */ var chart_pie_1 = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "fill": "#0068FF",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M15.653 8.13a.383.383 0 00.097-.278 6 6 0 00-5.602-5.602.375.375 0 00-.278.112.39.39 0 00-.12.278v5.61h5.625a.39.39 0 00.278-.12zM8.25 9.75h5.61a.375.375 0 01.375.39A6 6 0 117.86 3.765a.375.375 0 01.39.375v5.61z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/payment/savings.svg
/* harmony default export */ var savings = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 18",
        "fill": "#0068FF",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M9.747 4.5a3 3 0 11-5.999.001 3 3 0 016-.001zm-1.5 0a1.5 1.5 0 10-2.999 0 1.5 1.5 0 003 0zm3.562 6.315l.937-.938V7.5a.75.75 0 10-1.5 0v2.625c.241.181.434.418.563.69zm3.216-1.82c.2 0 .392.08.533.223h-.03a.75.75 0 010 1.065l-4.169 4.17c-.352.35-.83.547-1.327.547H6.973a.75.75 0 00-.524.217l-1.065 1.065a.75.75 0 01-1.057 0l-1.86-1.86a.75.75 0 010-1.057l2.122-2.183a2.488 2.488 0 011.942-.682h3.516c.6-.017 1.116.419 1.2 1.012a1.117 1.117 0 01-.952 1.238H7.123a.375.375 0 000 .75h3c1.009 0 1.837-.798 1.873-1.807l2.497-2.476a.75.75 0 01.532-.221z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/payment/credit-card-add.svg
/* harmony default export */ var credit_card_add = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M17 4a5 5 0 015 5 4.94 4.94 0 01-1 3v6a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2h10a4.94 4.94 0 013-1zm-.38 2a.5.5 0 00-.5.5v1.62H14.5a.5.5 0 00-.5.5v.76a.5.5 0 00.5.5h1.62v1.62a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5V9.88h1.62a.5.5 0 00.5-.5v-.76a.5.5 0 00-.5-.5h-1.62V6.5a.5.5 0 00-.5-.5h-.76zM4 7h8.42A4.94 4.94 0 0012 9c.003.336.036.67.1 1H4V7zm0 6v5h15v-4.42a4.93 4.93 0 01-5-.58H4z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/other/function.svg
/* harmony default export */ var other_function = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M10.847 8.616l-1.198 5.052c-.56 2.384-1.106 4.111-1.639 5.183-.532 1.072-1.155 1.864-1.868 2.378-.714.514-1.531.771-2.453.771-.58 0-1.006-.119-1.28-.355-.272-.237-.409-.516-.409-.837 0-.299.113-.557.338-.776.225-.219.522-.328.89-.328.308 0 .543.084.707.251.164.168.246.38.246.635 0 .233-.051.406-.154.52-.102.112-.153.187-.153.223l.05.077c.042.037.09.054.144.054.205 0 .379-.069.522-.207.362-.343.632-.759.809-1.247.123-.335.358-1.221.706-2.657l2.09-8.737H6.77l.338-1.28c.512.008.884-.062 1.116-.208.232-.146.478-.474.737-.984.75-1.48 1.543-2.54 2.375-3.182C12.17 2.321 13.098 2 14.122 2c.655 0 1.132.135 1.428.405.298.27.446.62.446 1.05 0 .379-.1.68-.297.902a.947.947 0 01-.737.333.904.904 0 01-.676-.273.906.906 0 01-.266-.656c0-.182.056-.376.168-.58.113-.203.17-.342.17-.415a.264.264 0 00-.078-.197.271.271 0 00-.2-.076c-.402 0-.815.266-1.238.798-.696.853-1.256 2.202-1.68 4.046h1.485l-.358 1.28h-1.442v-.001z"
      }
    }), _c('path', {
      attrs: {
        "d": "M13.294 7.686l3.573-.656a11.386 11.386 0 011.372 3.586c.669-1.057 1.174-1.796 1.515-2.22.458-.568.835-.938 1.132-1.11.297-.17.612-.256.947-.256.375 0 .663.11.865.328.201.219.302.514.302.886 0 .35-.101.636-.302.858a.973.973 0 01-.752.334c-.219 0-.47-.042-.753-.126-.283-.084-.48-.126-.589-.126-.286 0-.56.11-.819.328-.355.3-.792.937-1.31 1.914.58 2.187 1.044 3.521 1.392 4.002.205.285.413.427.624.427.178 0 .331-.048.461-.142.198-.153.502-.536.911-1.148l.369.23c-.6 1.034-1.188 1.763-1.761 2.186-.437.328-.867.492-1.29.492-.437 0-.8-.104-1.09-.312-.29-.208-.548-.547-.774-1.017-.225-.47-.49-1.223-.798-2.258-.799 1.086-1.425 1.88-1.879 2.378-.454.5-.83.826-1.131.979-.3.153-.621.23-.963.23-.354 0-.636-.11-.845-.328-.208-.219-.312-.503-.312-.853 0-.372.113-.678.338-.919.225-.24.512-.36.86-.36.184 0 .393.058.625.175.341.175.587.262.737.262.197 0 .375-.044.532-.131.205-.11.464-.347.778-.711.191-.226.543-.707 1.055-1.443-.655-2.596-1.167-4.148-1.536-4.659-.232-.328-.526-.491-.88-.491-.185 0-.41.029-.677.087l.073-.416z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/other/flag-outlined.svg
/* harmony default export */ var flag_outlined = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M11 4a2 2 0 012 2h6.5a.5.5 0 01.5.5v9a.5.5 0 01-.5.5H13a2 2 0 01-2-2H6v7.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h5zM6 6v6h6.5a.5.5 0 01.5.5V14h5V8h-6.5a.5.5 0 01-.5-.5V6H6z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/other/flag.svg
/* harmony default export */ var flag = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M20 6.5v9a.5.5 0 01-.5.5H14a2 2 0 01-2-2H6v7.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h6a2 2 0 012 2h5.5a.5.5 0 01.5.5z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/other/field-change.svg
/* harmony default export */ var field_change = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M7.324 11.059c-.293-.328-.705-.496-1.227-.496-.614 0-1.117.21-1.511.63-.394.42-.586.95-.586 1.588 0 .64.192 1.169.586 1.589.394.42.897.63 1.51.63.523 0 .935-.168 1.228-.496v.378h1.693v-4.201H7.324v.378zm-1.41 2.286a.831.831 0 010-1.127.809.809 0 01.595-.226c.247 0 .44.075.586.226a.813.813 0 010 1.127c-.147.15-.34.226-.586.226a.809.809 0 01-.595-.226zM15 4h2v16h-2V4z"
      }
    }), _c('path', {
      attrs: {
        "d": "M14 4h4v1h-4V4zM14 19h4v1h-4v-1zM14 6H3a2 2 0 00-2 2v8a2 2 0 002 2h11v-2H3V8h11V6zM18 6v2h3v8h-3v2h3a2 2 0 002-2V8a2 2 0 00-2-2h-3z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/other/field-value.svg
/* harmony default export */ var field_value = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 24 24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M3 6h18a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2zm18 10V8H3v8h18z"
      }
    }), _c('path', {
      attrs: {
        "d": "M7.324 11.059c-.293-.328-.705-.496-1.227-.496-.614 0-1.117.21-1.511.63-.394.42-.586.95-.586 1.588 0 .64.192 1.169.586 1.589.394.42.897.63 1.51.63.523 0 .935-.168 1.228-.496v.378h1.693v-4.201H7.324v.378zm-1.41 2.286a.831.831 0 010-1.127.809.809 0 01.595-.226c.247 0 .44.075.586.226a.813.813 0 010 1.127c-.147.15-.34.226-.586.226a.809.809 0 01-.595-.226zM12.903 10.563c-.521 0-.934.168-1.226.496V9H9.983v5.882h1.694v-.378c.293.328.705.496 1.226.496.614 0 1.117-.21 1.511-.63.394-.42.586-.95.586-1.588 0-.64-.192-1.169-.586-1.589-.394-.42-.897-.63-1.51-.63zm-1.007 2.781a.831.831 0 010-1.125.81.81 0 01.595-.227c.248 0 .44.075.586.226a.813.813 0 010 1.127c-.146.15-.338.226-.586.226a.81.81 0 01-.595-.226z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/vip.svg
/* harmony default export */ var vip = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 16 8",
        "fill": "#fff",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M3.373 6.016L5.058 0h1.704L4.175 8H2.577L0 0h1.7l1.673 6.016zM8.99 8H7.46V0H8.99v8zM11.84 8V5.181h1.343c.881 0 1.57-.225 2.067-.676.5-.454.75-1.073.75-1.857 0-.516-.114-.976-.342-1.379a2.314 2.314 0 00-.98-.94C14.256.11 13.766 0 13.208 0H10.31v8h1.532zm1.368-4.154h-1.367v-2.51h1.403c.378.006.674.131.888.373.214.242.322.558.322.95 0 .381-.108.674-.322.88-.21.205-.519.307-.924.307z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/bad.svg
/* harmony default export */ var bad = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 18 8",
        "fill": "#fff",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "d": "M0 0v8h2.867c.838-.007 1.483-.209 1.935-.604.453-.396.68-.978.68-1.748 0-.45-.11-.831-.33-1.143a1.54 1.54 0 00-.892-.62c.331-.14.59-.358.775-.654.186-.3.279-.647.279-1.039 0-.718-.231-1.262-.694-1.632C4.157.187 3.479 0 2.584 0H0zm1.52 6.676v-2.16h1.393c.699.011 1.048.383 1.048 1.116 0 .326-.1.582-.303.77-.2.182-.478.274-.836.274H1.52zm1.124-3.324H1.52V1.335h1.064c.418 0 .724.08.916.242.196.157.294.418.294.78 0 .648-.383.98-1.15.995zM7.503 6.352h2.665L10.679 8h1.616l-2.76-8H8.125L5.38 8h1.616l.507-1.648zm2.254-1.336H7.913l.917-2.994.927 2.994zM12.362 8V0h2.27c.648 0 1.227.16 1.737.478.513.315.913.766 1.2 1.352.288.582.431 1.245.431 1.989v.368c0 .743-.142 1.405-.425 1.983a3.168 3.168 0 01-1.191 1.346A3.263 3.263 0 0114.646 8h-2.284zm1.52-6.665v5.34h.734c.594 0 1.049-.21 1.363-.631.314-.421.474-1.024.481-1.808v-.423c0-.813-.155-1.428-.466-1.846-.31-.421-.765-.632-1.363-.632h-.75z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/lock.svg
/* harmony default export */ var lock = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 28 28",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "d": "M21 11.667V9.333a7 7 0 10-14 0v2.334A2.333 2.333 0 004.667 14v9.333A2.333 2.333 0 007 25.667h14a2.333 2.333 0 002.333-2.334V14A2.333 2.333 0 0021 11.667zM9.333 9.333a4.667 4.667 0 119.333 0v2.334H9.333V9.333zM15.166 21c.645 0 1.167-.522 1.167-1.167V17.5c0-.644-.522-1.167-1.166-1.167h-2.334c-.644 0-1.167.523-1.167 1.167v2.333c0 .645.523 1.167 1.167 1.167h2.333z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/gestures-and-emotions/slightly_smilling.svg
/* harmony default export */ var slightly_smilling = ({
  functional: true,

  render(_h, _vm) {
    const {
      _c,
      _v,
      data,
      children = []
    } = _vm;
    const {
      class: classNames,
      staticClass,
      style,
      staticStyle,
      attrs = {},
      ...rest
    } = data;
    return _c('svg', {
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }, attrs),
      ...rest
    }, children.concat([_c('path', {
      attrs: {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        "d": "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-10a2 2 0 114 0v.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V10zm-2.5 1a.5.5 0 00.5-.5V10a2 2 0 10-4 0v.5a.5.5 0 00.5.5h3zm4.93 2.49l.87.51a.51.51 0 01.24.33.49.49 0 01-.08.39 5.49 5.49 0 01-8.92 0 .49.49 0 01-.08-.39.51.51 0 01.24-.33l.87-.51a.51.51 0 01.65.13 3.48 3.48 0 005.56 0 .51.51 0 01.65-.13z"
      }
    })]));
  }

});
// CONCATENATED MODULE: ./src/assets/icons/index.js



























/* alert */








/* arrows */













/* ui */








/* 20*20 */




/* actions */

























/* user */






/* audiovisual */






/* country */


/* media & editing */




/* premium */



/* communication */





/* map and places */



/* files */


/* technology and data */


/* payment */



/* other */






/* vip & bad */




/* gestures & emotions */


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIcon/UiIcon.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var UiIconvue_type_script_lang_js_ = ({
  name: 'UiIcon',
  components: { ...icons_namespaceObject
  },
  props: {
    name: {
      type: String,
      required: true
    },
    btn: {
      type: Boolean
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['icon']]: true,
        [this.$style[`icon_btn`]]: this.btn
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiIcon_UiIconvue_type_script_lang_js_ = (UiIconvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiIcon/UiIcon.vue?vue&type=style&index=0&lang=less&module=true&
var UiIconvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("686b");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/UiIcon/UiIcon.vue








function injectStyles (context) {
  
  this["$style"] = (UiIconvue_type_style_index_0_lang_less_module_true_["default"].locals || UiIconvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var component = normalizeComponent(
  UiIcon_UiIconvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiIcon = (component.exports);
// CONCATENATED MODULE: ./src/components/UiIcon/index.js

/* harmony default export */ var components_UiIcon = (UiIcon);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAccordion/UiAccordion.vue?vue&type=template&id=050a8366&
var UiAccordionvue_type_template_id_050a8366_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var UiAccordionvue_type_template_id_050a8366_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordion.vue?vue&type=template&id=050a8366&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAccordion/UiAccordion.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var UiAccordionvue_type_script_lang_js_ = ({
  name: 'UiAccordion',
  props: {
    showMany: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      items: []
    };
  },

  provide() {
    return {
      'uiAccordion': this
    };
  }

});
// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordion.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAccordion_UiAccordionvue_type_script_lang_js_ = (UiAccordionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordion.vue





/* normalize component */

var UiAccordion_component = normalizeComponent(
  UiAccordion_UiAccordionvue_type_script_lang_js_,
  UiAccordionvue_type_template_id_050a8366_render,
  UiAccordionvue_type_template_id_050a8366_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiAccordion = (UiAccordion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAccordion/UiAccordionItem.vue?vue&type=template&id=4fa3cd9c&
var UiAccordionItemvue_type_template_id_4fa3cd9c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['item']},[_c('div',{class:_vm.$style['head'],on:{"mousedown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.toggleActive.apply(null, arguments)},"mouseup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"left",37,$event.key,["Left","ArrowLeft"])){ return null; }if('button' in $event && $event.button !== 0){ return null; }return _vm.toggleActive.apply(null, arguments)},"click":_vm.toggleItem}},[_c('div',{class:_vm.$style['head__title']},[_vm._t("title",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),_c('div',{class:[_vm.$style['head__btn-box']]},[_vm._t("icon",function(){
var _obj, _obj$1;
return [_c('UiButton',{class:[_vm.$style['head__button'], ( _obj = {}, _obj[_vm.$style['head__button_active']] = _vm.isOpen, _obj )],attrs:{"variant":"tertiary","shape":"square","active":_vm.isPressed}},[_c('UiIcon',{class:[_vm.$style['head__icon'], ( _obj$1 = {}, _obj$1[_vm.$style['head__icon_open']] = _vm.isOpen, _obj$1 )],attrs:{"name":"caretDown"}})],1)]})],2)]),_c('UiCollapse',{class:_vm.$style['content'],attrs:{"open":_vm.isOpen}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.descript)+" ")]})],2)],1)}
var UiAccordionItemvue_type_template_id_4fa3cd9c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordionItem.vue?vue&type=template&id=4fa3cd9c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiButton/UiButton.vue?vue&type=template&id=88edbf8e&
var UiButtonvue_type_template_id_88edbf8e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiButtonRoot',_vm._g({directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:_vm.classes,style:(_vm.styles),attrs:{"type":!_vm.href ? _vm.type : null,"href":_vm.href,"disabled":_vm.isDisabled}},_vm.$listeners),[_c('span',{class:_vm.$style['btn__inner']},[(_vm.predefinedIcon || _vm.$slots.icon)?_c('span',{class:_vm.$style['btn__icon']},[_vm._t("icon",function(){return [_c('UiIcon',{attrs:{"name":_vm.predefinedIcon}})]})],2):_vm._l((_vm.$slots.default),function(el,index){return _c('UiButtonContent',{key:'ui-button-content-' + index,attrs:{"node":el}})})],2)])}
var UiButtonvue_type_template_id_88edbf8e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiButton/UiButton.vue?vue&type=template&id=88edbf8e&

// CONCATENATED MODULE: ./src/components/UiButton/enum/sizes.js
/* harmony default export */ var sizes = ({
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs'
});
// CONCATENATED MODULE: ./src/components/UiButton/enum/shapes.js
/* harmony default export */ var shapes = ({
  CIRCLE: 'circle',
  // После 2.0.1 circle уже не используется в дизайн-системе, эффект как у square
  DEFAULT: 'default',
  SQUARE: 'square'
});
// CONCATENATED MODULE: ./src/components/UiButton/enum/states.js
/* harmony default export */ var states = ({
  CANCEL: 'cancel',
  DEFAULT: 'default',
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success'
});
// CONCATENATED MODULE: ./src/components/UiButton/enum/variants.js
/* harmony default export */ var variants = ({
  OUTLINED: 'outlined',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiButton/UiButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






const isTextual = node => node.text || ['b', 'i', 'span', 'strong'].includes(node.tag);

const DEFAULT_TOOLTIP_SETTINGS = {
  offset: '4',
  placement: 'bottom',
  template: '<div><div class=\'tooltip-inner\'></div></div>'
};
/* harmony default export */ var UiButtonvue_type_script_lang_js_ = ({
  name: 'UiButton',
  components: {
    /**
     * Если передана иконка с текстом, то оборачивает каждую сущность
     * в обертку с нужным классом
     */
    UiButtonContent: {
      name: 'UiButtonContent',
      functional: true,
      render: (h, {
        parent,
        props
      }) => {
        const node = props.node;
        const isTextNode = isTextual(node);

        if (node.isComment || isTextNode && [shapes.CIRCLE, shapes.SQUARE].includes(parent.$props.shape)) {
          return;
        }

        return h('span', {
          class: {
            [parent.$style['btn__txt']]: isTextNode,
            [parent.$style['btn__icon']]: !isTextNode
          }
        }, [node]);
      }
    },
    UiButtonRoot: {
      name: 'UiButtonRoot',
      functional: true,
      render: (h, {
        data,
        props,
        children
      }) => {
        return h(props.href ? 'a' : 'button', data, children);
      }
    },
    UiIcon: components_UiIcon
  },
  props: {
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      default: variants.PRIMARY
    },
    state: {
      type: String,
      default: states.DEFAULT
    },
    shape: {
      type: String,
      default: shapes.DEFAULT
    },
    size: {
      type: String,
      default: sizes.SM
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    ellipsis: {
      type: Boolean,
      default: true
    },

    /**
     * Модификация кнопки
     */
    modify: {
      type: String,
      default: null
    },

    /**
     * Для возможности делать из кнопки ссылку
     */
    href: {
      type: String,
      default: null
    },

    /**
     * Для кнопки, содержащей только текст
     * при смене состояния на loading
     * показывать иконку загрузки
     */
    showLoadIcon: {
      type: Boolean,
      default: true
    },

    /**
     * Для кнопки, содержащей только текст
     * при смене состояния на loading
     * фиксируем ширину, чтобы не было прыжков
     */
    fixWidthLoading: {
      type: Boolean,
      default: true
    },

    /**
     * При наличии пропса будет выводиться тултип
     */
    tooltipText: {
      type: String,
      default: null
    },

    /**
     * Настройки тултипа
     */
    tooltipSettings: {
      type: Object,
      default: () => {}
    },

    /**
     * Занимать всю доступную ширину
     */
    block: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hasLeftIcon: false,
      hasRightIcon: false,
      hasText: false,
      currentWidth: null
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['btn']]: true,
        [this.$style[`btn_${this.size}`]]: true,
        [this.$style[`btn_${this.shape}`]]: true,
        [this.$style[`btn_${this.variant}`]]: this.isDefault,
        [this.$style[`btn_${this.variant}-${this.state}`]]: !this.isDefault,
        [this.$style[`btn_${this.modify}`]]: this.modify,
        [this.$style[`btn_left-icon`]]: this.hasText && this.hasLeftIcon,
        [this.$style[`btn_right-icon`]]: this.hasText && this.hasRightIcon,
        [this.$style['btn_active']]: this.active,
        [this.$style['btn_ellipsis']]: this.ellipsis,
        [this.$style['btn_block']]: this.block
      };
    },

    styles() {
      return this.currentWidth ? `min-width: ${this.currentWidth}px;` : null;
    },

    isDefault() {
      return this.state === states.DEFAULT;
    },

    isLoading() {
      return this.state === states.LOADING;
    },

    isDisabled() {
      return this.disabled || this.isLoading;
    },

    isTextOnly() {
      return this.hasText && !this.hasLeftIcon && !this.hasRightIcon;
    },

    predefinedIcon() {
      if (this.showLoadIcon && this.isLoading && this.isTextOnly) {
        return 'circleLoading';
      }

      if (this.shape !== shapes.SQUARE) {
        return null;
      }

      switch (this.state) {
        case states.ERROR:
          return 'clear';

        case states.LOADING:
          return 'circleLoading';

        case states.SUCCESS:
          return 'done';
      }

      return null;
    },

    withoutText() {
      return [shapes.CIRCLE, shapes.SQUARE].includes(this.shape);
    },

    tooltip() {
      if (!this.tooltipText) {
        return null;
      }

      return {
        content: this.tooltipText,
        classes: this.$style['btn-tooltip'],
        ...DEFAULT_TOOLTIP_SETTINGS,
        ...this.tooltipSettings
      };
    }

  },
  watch: {
    state(value) {
      if (this.shape === shapes.SQUARE || !this.isTextOnly || !this.fixWidthLoading) {
        return;
      }

      this.currentWidth = value === states.LOADING ? this.$el.offsetWidth : null;
    }

  },

  mounted() {
    this._observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (['childList', 'subtree'].includes(mutation.type)) {
          this.updateFlags();
        }
      }
    });

    this._observer.observe(this.$el, {
      'childList': true,
      'subtree': true
    });

    this.updateFlags();
  },

  beforeDestroy() {
    this._observer = null;
  },

  methods: {
    updateFlags() {
      const children = this.$slots.default || [];
      const types = children.map(node => {
        return node.isComment ? 'comment' : isTextual(node) ? 'text' : 'icon';
      });
      this.hasLeftIcon = !this.withoutText && types.length && types[0] === 'icon';
      this.hasRightIcon = !this.withoutText && types.length && types[types.length - 1] === 'icon';
      this.hasText = types.some(t => t === 'text');
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiButton/UiButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiButton_UiButtonvue_type_script_lang_js_ = (UiButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiButton/UiButton.vue?vue&type=style&index=0&module=true&lang=less&
var UiButtonvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("b84b");

// CONCATENATED MODULE: ./src/components/UiButton/UiButton.vue








function UiButton_injectStyles (context) {
  
  this["$style"] = (UiButtonvue_type_style_index_0_module_true_lang_less_["default"].locals || UiButtonvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiButton_component = normalizeComponent(
  UiButton_UiButtonvue_type_script_lang_js_,
  UiButtonvue_type_template_id_88edbf8e_render,
  UiButtonvue_type_template_id_88edbf8e_staticRenderFns,
  false,
  UiButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiButton = (UiButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiButton/index.js

/* harmony default export */ var components_UiButton = (UiButton);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapse/UiCollapse.vue?vue&type=template&id=fefbde4a&
var UiCollapsevue_type_template_id_fefbde4a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.transitionEnter,"after-enter":_vm.transitionAfterEnter,"before-leave":_vm.beforeLeave,"leave":_vm.transitionLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],class:_vm.$style['collapse-content']},[_c('div',[_vm._t("default")],2)])])}
var UiCollapsevue_type_template_id_fefbde4a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapse/UiCollapse.vue?vue&type=template&id=fefbde4a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapse/UiCollapse.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiCollapsevue_type_script_lang_js_ = ({
  name: 'UiCollapse',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    beforeEnter(el) {
      el.style.maxHeight = 0;
      el.style.opacity = 0;
      el.style.overflow = 'hidden';
    },

    transitionEnter(el, done) {
      const duration = parseFloat(getComputedStyle(el).transitionDuration) * 1000 || 250;
      el.style.maxHeight = el.firstChild.clientHeight + 'px';
      el.style.opacity = 1;
      setTimeout(() => {
        done();
      }, duration);
    },

    transitionAfterEnter(el) {
      el.style.maxHeight = '';
      el.style.overflow = 'visible';
      this.$emit('ui::collapse::expanded');
    },

    beforeLeave(el) {
      el.style.maxHeight = el.firstChild.clientHeight + 'px';
      el.style.opacity = 1;
      el.style.overflow = 'hidden';
    },

    transitionLeave(el, done) {
      const duration = parseFloat(getComputedStyle(el).transitionDuration) * 1000 || 250;
      el.style.maxHeight = 0;
      el.style.opacity = 0;
      setTimeout(() => {
        this.$emit('ui::collapse::collapsed');
        done();
      }, duration);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapse/UiCollapse.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapse_UiCollapsevue_type_script_lang_js_ = (UiCollapsevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapse/UiCollapse.vue?vue&type=style&index=0&module=true&lang=less&
var UiCollapsevue_type_style_index_0_module_true_lang_less_ = __webpack_require__("b1ec");

// CONCATENATED MODULE: ./src/components/UiCollapse/UiCollapse.vue








function UiCollapse_injectStyles (context) {
  
  this["$style"] = (UiCollapsevue_type_style_index_0_module_true_lang_less_["default"].locals || UiCollapsevue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCollapse_component = normalizeComponent(
  UiCollapse_UiCollapsevue_type_script_lang_js_,
  UiCollapsevue_type_template_id_fefbde4a_render,
  UiCollapsevue_type_template_id_fefbde4a_staticRenderFns,
  false,
  UiCollapse_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCollapse = (UiCollapse_component.exports);
// CONCATENATED MODULE: ./src/components/UiCollapse/index.js

/* harmony default export */ var components_UiCollapse = (UiCollapse);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAccordion/UiAccordionItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiAccordionItemvue_type_script_lang_js_ = ({
  name: 'UiAccordionItem',
  components: {
    UiButton: components_UiButton,
    UiCollapse: components_UiCollapse,
    UiIcon: components_UiIcon
  },
  inject: ['uiAccordion'],
  props: {
    title: {
      type: String,
      default: ''
    },
    descript: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: this.open,
      isPressed: false
    };
  },

  mounted() {
    this.uiAccordion.items.push(this);
  },

  beforeDestroy() {
    const index = this.uiAccordion.items.indexOf(this);
    this.uiAccordion.items.splice(index, 1);
  },

  methods: {
    toggleItem() {
      if (!this.uiAccordion.showMany && !this.isOpen) {
        this.uiAccordion.items.forEach(el => {
          el.isOpen = false;
        });
      }

      this.isOpen = !this.isOpen;
    },

    toggleActive() {
      this.isPressed = !this.isPressed;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordionItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAccordion_UiAccordionItemvue_type_script_lang_js_ = (UiAccordionItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAccordion/UiAccordionItem.vue?vue&type=style&index=0&module=true&lang=less&
var UiAccordionItemvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("8205");

// CONCATENATED MODULE: ./src/components/UiAccordion/UiAccordionItem.vue








function UiAccordionItem_injectStyles (context) {
  
  this["$style"] = (UiAccordionItemvue_type_style_index_0_module_true_lang_less_["default"].locals || UiAccordionItemvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiAccordionItem_component = normalizeComponent(
  UiAccordion_UiAccordionItemvue_type_script_lang_js_,
  UiAccordionItemvue_type_template_id_4fa3cd9c_render,
  UiAccordionItemvue_type_template_id_4fa3cd9c_staticRenderFns,
  false,
  UiAccordionItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAccordionItem = (UiAccordionItem_component.exports);
// CONCATENATED MODULE: ./src/components/UiAccordion/index.js



// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiActionBtn/UiActionBtn.vue?vue&type=template&id=437a8cfe&
var UiActionBtnvue_type_template_id_437a8cfe_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classes,attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("default",function(){return [(_vm.isSuccess && !_vm.loading)?_c('UiIcon',{class:[_vm.$style['action-btn__icon'], _vm.$style['action-btn__icon_success']],attrs:{"name":"done"}}):_vm._e(),(_vm.isCancel && !_vm.loading)?_c('UiIcon',{class:[_vm.$style['action-btn__icon'], _vm.$style['action-btn__icon_cancel']],attrs:{"name":"clear"}}):_vm._e(),(_vm.loading)?_c('UiIcon',{class:[_vm.$style['action-btn__icon'], _vm.$style[("action-btn__icon_" + _vm.type)]],attrs:{"name":"loading"}}):_vm._e()]})],2)}
var UiActionBtnvue_type_template_id_437a8cfe_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiActionBtn/UiActionBtn.vue?vue&type=template&id=437a8cfe&

// CONCATENATED MODULE: ./src/components/UiActionBtn/enum/states.js
/* harmony default export */ var enum_states = ({
  CANCEL: 'cancel',
  DEFAULT: 'default',
  ERROR: 'error',
  LOADING: 'loading',
  SUCCESS: 'success'
});
// CONCATENATED MODULE: ./src/mixins/deprecated-message.js
/* harmony default export */ var deprecated_message = ({
  mounted() {
    if (false) {}
  }

});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiActionBtn/UiActionBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiActionBtnvue_type_script_lang_js_ = ({
  name: 'UiActionBtn',
  components: {
    UiIcon: components_UiIcon
  },
  mixins: [deprecated_message],
  props: {
    type: {
      type: String,
      default: enum_states.SUCCESS
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [this.$style['action-btn'], {
        [this.$style['action-btn_success']]: this.isSuccess,
        [this.$style['action-btn_cancel']]: this.isCancel,
        [this.$style['action-btn_loading']]: this.loading
      }];
    },

    isSuccess() {
      return this.type === enum_states.SUCCESS;
    },

    isCancel() {
      return this.type === enum_states.CANCEL;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiActionBtn/UiActionBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiActionBtn_UiActionBtnvue_type_script_lang_js_ = (UiActionBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiActionBtn/UiActionBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiActionBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("a4c5");

// CONCATENATED MODULE: ./src/components/UiActionBtn/UiActionBtn.vue








function UiActionBtn_injectStyles (context) {
  
  this["$style"] = (UiActionBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiActionBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiActionBtn_component = normalizeComponent(
  UiActionBtn_UiActionBtnvue_type_script_lang_js_,
  UiActionBtnvue_type_template_id_437a8cfe_render,
  UiActionBtnvue_type_template_id_437a8cfe_staticRenderFns,
  false,
  UiActionBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiActionBtn = (UiActionBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiActionBtn/index.js

/* harmony default export */ var components_UiActionBtn = (UiActionBtn);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAddButton/UiAddButton.vue?vue&type=template&id=acec5b48&
var UiAddButtonvue_type_template_id_acec5b48_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classes,style:(_vm.styles),attrs:{"type":_vm.type,"disabled":_vm.disabled}},_vm.$listeners),[_c('span',{class:_vm.$style['add-btn__content']},[_vm._t("icon",function(){return [_c('UiIcon',{attrs:{"name":"addCirclePlus"}})]}),_vm._t("default")],2)])}
var UiAddButtonvue_type_template_id_acec5b48_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAddButton/UiAddButton.vue?vue&type=template&id=acec5b48&

// CONCATENATED MODULE: ./src/components/UiAddButton/enum/sizes.js
/* harmony default export */ var enum_sizes = ({
  LG: 'lg',
  SM: 'sm'
});
// CONCATENATED MODULE: ./src/components/UiAddButton/enum/colors.js
/* harmony default export */ var colors = ({
  GREEN: 'green',
  BLUE: 'blue',
  RED: 'red',
  YELLOW: 'yellow',
  PURPLE: 'purple'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAddButton/UiAddButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiAddButtonvue_type_script_lang_js_ = ({
  name: 'UiAddButton',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    type: {
      type: String,
      default: 'button'
    },
    size: {
      type: String,
      validator: size => Object.values(enum_sizes).includes(size),
      default: enum_sizes.LG
    },
    height: {
      type: [String, Number],
      default: 80
    },
    color: {
      type: String,
      validator: color => Object.values(colors).includes(color),
      default: colors.GREEN
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['add-btn']]: true,
        [this.$style[`add-btn_${this.color}`]]: true,
        [this.$style[`add-btn_${this.size}`]]: true
      };
    },

    styles() {
      return {
        height: this.heightComputed
      };
    },

    heightComputed() {
      let height = null;

      if (this.size !== enum_sizes.LG) {
        return null;
      }

      if (!isNaN(this.height)) {
        height = `${this.height}px`;
      }

      if (typeof this.height === 'string' && !isNaN(this.height.replace('%', ''))) {
        height = this.height;
      }

      return height;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiAddButton/UiAddButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAddButton_UiAddButtonvue_type_script_lang_js_ = (UiAddButtonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAddButton/UiAddButton.vue?vue&type=style&index=0&lang=less&module=true&
var UiAddButtonvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("0eab");

// CONCATENATED MODULE: ./src/components/UiAddButton/UiAddButton.vue








function UiAddButton_injectStyles (context) {
  
  this["$style"] = (UiAddButtonvue_type_style_index_0_lang_less_module_true_["default"].locals || UiAddButtonvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiAddButton_component = normalizeComponent(
  UiAddButton_UiAddButtonvue_type_script_lang_js_,
  UiAddButtonvue_type_template_id_acec5b48_render,
  UiAddButtonvue_type_template_id_acec5b48_staticRenderFns,
  false,
  UiAddButton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAddButton = (UiAddButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiAddButton/index.js

/* harmony default export */ var components_UiAddButton = (UiAddButton);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAlert/UiAlert.vue?vue&type=template&id=6e1d7bfd&
var UiAlertvue_type_template_id_6e1d7bfd_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTransition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],class:_vm.classes},[_vm._t("icon",function(){return [(_vm.iconComputed)?_c('div',{class:_vm.$style['alert__icon-box']},[_c('UiIcon',{class:_vm.$style['alert__icon'],attrs:{"name":_vm.iconComputed}})],1):_vm._e()]}),_c('div',{class:( _obj = {}, _obj[_vm.$style['alert__title']] = true, _obj[_vm.$style['alert__title_ellipsis']] = _vm.ellipsis, _obj )},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.title)+" ")]})],2),(_vm.closable)?_c('div',{class:_vm.$style['alert__close'],on:{"click":_vm.close}},[_c('UiIcon',{class:_vm.$style['alert__close-icon'],attrs:{"name":"clear"}})],1):_vm._e()],2)])}
var UiAlertvue_type_template_id_6e1d7bfd_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAlert/UiAlert.vue?vue&type=template&id=6e1d7bfd&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTransition/UiTransition.vue?vue&type=template&id=151954b8&
var UiTransitionvue_type_template_id_151954b8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',_vm._g({attrs:{"name":_vm.name,"appear":_vm.appear}},_vm.$listeners),[_vm._t("default")],2)}
var UiTransitionvue_type_template_id_151954b8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTransition/UiTransition.vue?vue&type=template&id=151954b8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTransition/UiTransition.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiTransitionvue_type_script_lang_js_ = ({
  name: 'UiTransition',
  props: {
    name: {
      type: String,
      default: 'fade'
    },
    appear: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiTransition/UiTransition.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTransition_UiTransitionvue_type_script_lang_js_ = (UiTransitionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTransition/UiTransition.vue?vue&type=style&index=0&lang=less&
var UiTransitionvue_type_style_index_0_lang_less_ = __webpack_require__("33a8");

// CONCATENATED MODULE: ./src/components/UiTransition/UiTransition.vue






/* normalize component */

var UiTransition_component = normalizeComponent(
  UiTransition_UiTransitionvue_type_script_lang_js_,
  UiTransitionvue_type_template_id_151954b8_render,
  UiTransitionvue_type_template_id_151954b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiTransition = (UiTransition_component.exports);
// CONCATENATED MODULE: ./src/components/UiTransition/index.js

/* harmony default export */ var components_UiTransition = (UiTransition);
// CONCATENATED MODULE: ./src/components/UiAlert/enum/types.js
/* harmony default export */ var types = ({
  ERROR: 'error',
  INFO: 'info',
  NOTICE: 'notice',
  SUCCESS: 'success'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAlert/UiAlert.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const DEFAULT_ICONS = {
  [types.INFO]: 'info-outlined',
  [types.NOTICE]: 'errorOutlined',
  [types.SUCCESS]: 'checkmarkCircleOutlined',
  [types.ERROR]: 'clearOutlined'
};
/* harmony default export */ var UiAlertvue_type_script_lang_js_ = ({
  name: 'UiAlert',
  components: {
    UiIcon: UiIcon,
    UiTransition: components_UiTransition
  },
  model: {
    prop: 'visible',
    event: 'closeAlert'
  },
  props: {
    /**
     * Заголовок окна
     */
    title: {
      type: String,
      default: ''
    },

    /**
     * Тип окна
     * Возможные значения:
     * - info
     * - notice
     * - success
     * - error
     */
    type: {
      type: String,
      default: types.INFO,
      validator: type => Object.values(types).includes(type)
    },

    /**
     * Название иконки
     * (если нет имеющихся, то можно подставить через слот)
     */
    icon: {
      type: String,
      default: null
    },

    /**
     * Определяет видимость окна
     * (реализует v-model)
     */
    visible: {
      type: Boolean,
      default: true
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    titleSize: {
      type: String,
      default: null
    },

    /**
     * Скролл родителя к текущему алерту при его появлении
     * полезно при показе ошибок
     */
    scrollToAlert: {
      type: Boolean,
      default: false
    },
    scrollBehavior: {
      type: String,
      default: 'smooth'
    }
  },

  data() {
    return {
      isVisible: this.visible
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['alert']]: true,
        [this.$style['alert_error']]: this.type === types.ERROR,
        [this.$style['alert_notice']]: this.type === types.NOTICE,
        [this.$style['alert_success']]: this.type === types.SUCCESS,
        [this.$style[`title-${this.titleSize}`]]: this.titleSize
      };
    },

    iconComputed() {
      return this.icon || DEFAULT_ICONS[this.type] || null;
    }

  },
  watch: {
    visible(value) {
      this.isVisible = value;

      if (this.isVisible) {
        this.scrollToEl();
      }
    }

  },

  mounted() {
    this.scrollToEl();
  },

  methods: {
    close() {
      this.isVisible = false;
      this.$emit('closeAlert', false);
    },

    scrollToEl() {
      if (this.scrollToAlert) {
        this.$el.scrollIntoView({
          behavior: this.scrollBehavior
        });
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiAlert/UiAlert.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAlert_UiAlertvue_type_script_lang_js_ = (UiAlertvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAlert/UiAlert.vue?vue&type=style&index=0&module=true&lang=less&
var UiAlertvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("35ec");

// CONCATENATED MODULE: ./src/components/UiAlert/UiAlert.vue








function UiAlert_injectStyles (context) {
  
  this["$style"] = (UiAlertvue_type_style_index_0_module_true_lang_less_["default"].locals || UiAlertvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiAlert_component = normalizeComponent(
  UiAlert_UiAlertvue_type_script_lang_js_,
  UiAlertvue_type_template_id_6e1d7bfd_render,
  UiAlertvue_type_template_id_6e1d7bfd_staticRenderFns,
  false,
  UiAlert_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAlert = (UiAlert_component.exports);
// CONCATENATED MODULE: ./src/components/UiAlert/index.js


UiAlert.install = function (Vue) {
  Vue.component(UiAlert.name, UiAlert);
};

/* harmony default export */ var components_UiAlert = (UiAlert);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatar.vue?vue&type=template&id=a10bf780&
var UiAvatarvue_type_template_id_a10bf780_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.avatarClasses,attrs:{"href":_vm.href}},[_c('v-popover',{attrs:{"open":_vm.isOpen,"open-class":_vm.$style['open'],"offset":_vm.offset,"disabled":!_vm.hasPreview,"placement":_vm.placement,"popover-base-class":_vm.$style['popover'],"trigger":"hover"},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_c('div',{class:_vm.$style['popup']},[(_vm.previewText)?_c('div',{class:_vm.$style['popup__text']},[_vm._v(" "+_vm._s(_vm.previewText)+" ")]):_vm._e(),(_vm.previewSrc)?_c('img',{class:_vm.$style['popup__img'],attrs:{"src":_vm.previewSrc,"alt":_vm.alt,"draggable":"false","loading":"lazy"}}):_vm._e()])]},proxy:true}])},[_c('div',{class:_vm.$style['user-pic']},[(_vm.src)?_c('img',{class:_vm.$style['img'],attrs:{"src":_vm.src,"alt":_vm.alt,"draggable":"false"}}):_vm._e(),(_vm.status && !(_vm.vip || _vm.bad))?_c('span',{class:_vm.statusClasses}):_vm._e(),(_vm.$slots.default || _vm.initials)?_c('div',{class:_vm.$style['content']},[_c('UiAvatarName',{attrs:{"name":_vm.initials ? _vm.initials : _vm.$slots.default[0].text}})],1):_vm._e()])]),(_vm.vip || _vm.bad)?_c('div',{class:_vm.$style['labels']},[(_vm.vip)?_c('span',{class:[_vm.$style['label'], _vm.$style['label_vip']]},[_c('UiIcon',{class:_vm.$style['vip-icon'],attrs:{"name":"vip"}})],1):_vm._e(),(_vm.bad)?_c('span',{class:[_vm.$style['label'], _vm.$style['label_bad']]},[_c('UiIcon',{class:_vm.$style['bad-icon'],attrs:{"name":"bad"}})],1):_vm._e()]):_vm._e()],1)}
var UiAvatarvue_type_template_id_a10bf780_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=template&id=a10bf780&

// CONCATENATED MODULE: ./src/components/UiAvatar/enum/sizes.js
/* harmony default export */ var UiAvatar_enum_sizes = ({
  SM: 'sm',
  LG: 'lg'
});
// CONCATENATED MODULE: ./src/components/UiAvatar/enum/statuses.js
/* harmony default export */ var statuses = ({
  NONE: '',
  FREE: 'free',
  BUSY: 'busy',
  DINNER: 'dinner',
  BREAK: 'break'
});
// CONCATENATED MODULE: ./src/components/UiTooltip/enum/positions.js
/* harmony default export */ var positions = ({
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiAvatarvue_type_script_lang_js_ = ({
  name: 'UiAvatar',
  components: {
    UiIcon: components_UiIcon,
    UiAvatarName: {
      name: 'UiAvatarName',
      functional: true,
      render: (h, ctx) => {
        const getInitials = name => {
          if (!name) {
            return '';
          }

          name = name.trim(); // Когда для списка аватара надо передать число (+N)

          if (!isNaN(name)) {
            return name;
          }

          if (name.length === 1 || name.length === 2) {
            return name.toUpperCase();
          }

          let names = name.trim().split(' ');
          let initials = names[0][0];

          if (names.length > 1) {
            initials = initials + names[1][0];
          }

          return initials.toUpperCase();
        };

        return h('span', {}, getInitials(ctx.props.name));
      }
    }
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: UiAvatar_enum_sizes.SM
    },
    status: {
      type: String,
      validator: status => Object.values(statuses).includes(status),
      default: null
    },
    vip: {
      type: Boolean,
      default: false
    },
    bad: {
      type: Boolean,
      default: false
    },
    initials: {
      type: String,
      default: null
    },

    /**
     * Определяет позиционирование
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.RIGHT
    },

    /**
     * Определяет смещение тултипа
     * от целевого элемента в px
     */
    offset: {
      type: Number,
      default: 4
    },

    /**
     * Изображение в тултипе
     */
    previewSrc: {
      type: String,
      default: ''
    },

    /**
     * Текст в тултипе
     */
    previewText: {
      type: String,
      default: ''
    },

    /**
     * Если необходимо аватар сделать ссылкой
     */
    href: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    tag() {
      if (!this.href) {
        return 'div';
      }

      return 'a';
    },

    avatarClasses() {
      return {
        [this.$style['avatar']]: true,
        [this.$style[`avatar_size_${this.size}`]]: true,
        [this.$style['avatar_vip']]: this.vip,
        [this.$style['avatar_bad']]: this.bad,
        [this.$style['avatar_multiple']]: this.bad && this.vip
      };
    },

    statusClasses() {
      return {
        [this.$style['status']]: true,
        [this.$style[`status_${this.status.toLowerCase()}`]]: this.status
      };
    },

    hasPreview() {
      return !!this.previewSrc || !!this.previewText;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAvatar_UiAvatarvue_type_script_lang_js_ = (UiAvatarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAvatar/UiAvatar.vue?vue&type=style&index=0&lang=less&module=true&
var UiAvatarvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("72e0");

// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatar.vue








function UiAvatar_injectStyles (context) {
  
  this["$style"] = (UiAvatarvue_type_style_index_0_lang_less_module_true_["default"].locals || UiAvatarvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiAvatar_component = normalizeComponent(
  UiAvatar_UiAvatarvue_type_script_lang_js_,
  UiAvatarvue_type_template_id_a10bf780_render,
  UiAvatarvue_type_template_id_a10bf780_staticRenderFns,
  false,
  UiAvatar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAvatar = (UiAvatar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatarList.vue?vue&type=template&id=78ef32d4&
var UiAvatarListvue_type_template_id_78ef32d4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style['avatar-list'], _vm.$style[("avatar-list_size_" + _vm.size)]]},[(_vm.items.length)?_c('div',{class:_vm.$style['inner']},_vm._l((_vm.items),function(item,index){return _c('UiAvatar',{key:index,class:_vm.$style['item'],attrs:{"size":_vm.size,"src":item.src}},[(item.content)?[_vm._v(" "+_vm._s(item.content)+" ")]:_vm._e()],2)}),1):(_vm.$slots.default)?_c('div',{class:_vm.$style['inner']},_vm._l((_vm.$slots.default),function(node,index){return _c('UiAvatarWrapper',{key:index,attrs:{"node":node,"classes":_vm.$style['item'],"size":_vm.size}})}),1):_vm._e()])}
var UiAvatarListvue_type_template_id_78ef32d4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatarList.vue?vue&type=template&id=78ef32d4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAvatar/UiAvatarList.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiAvatarListvue_type_script_lang_js_ = ({
  name: 'UiAvatarList',
  components: {
    UiAvatar: UiAvatar,
    UiAvatarWrapper: {
      name: 'UiAvatarWrapper',
      functional: true,

      render(h, ctx) {
        const node = ctx.props.node;

        if (!node.tag) {
          return;
        }

        node.componentOptions.propsData.size = ctx.props.size;
        return h('div', {
          attrs: {
            class: ctx.props.classes
          }
        }, [node]);
      }

    }
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: UiAvatar_enum_sizes.SM
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatarList.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAvatar_UiAvatarListvue_type_script_lang_js_ = (UiAvatarListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAvatar/UiAvatarList.vue?vue&type=style&index=0&lang=less&module=true&
var UiAvatarListvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("4bbb");

// CONCATENATED MODULE: ./src/components/UiAvatar/UiAvatarList.vue








function UiAvatarList_injectStyles (context) {
  
  this["$style"] = (UiAvatarListvue_type_style_index_0_lang_less_module_true_["default"].locals || UiAvatarListvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiAvatarList_component = normalizeComponent(
  UiAvatar_UiAvatarListvue_type_script_lang_js_,
  UiAvatarListvue_type_template_id_78ef32d4_render,
  UiAvatarListvue_type_template_id_78ef32d4_staticRenderFns,
  false,
  UiAvatarList_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAvatarList = (UiAvatarList_component.exports);
// CONCATENATED MODULE: ./src/components/UiAvatar/index.js




// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBreadcrumbs/UiBreadcrumbs.vue?vue&type=template&id=6e85e17f&
var UiBreadcrumbsvue_type_template_id_6e85e17f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['breadcrumbs'],attrs:{"aria-label":"Breadcrumb"}},_vm._l((_vm.visibleItems),function(item,index){
var _obj;
return _c('div',{key:item.id,class:( _obj = {}, _obj[_vm.$style['breadcrumbs__item']] = true, _obj[_vm.$style['breadcrumbs__item_active']] = index === _vm.visibleItems.length - 1, _obj )},[_c(_vm.tag,{tag:"component",class:_vm.itemClasses,attrs:{"href":item.href ? item.href : 'javascript:void(0);'},on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(" "+_vm._s(item.title)+" "),(_vm.controls && index === _vm.visibleItems.length - 1)?_c('button',{class:_vm.$style['control'],attrs:{"type":"button"},on:{"click":function($event){return _vm.onControlClick(item)}}},[_c('UiIcon',{class:_vm.$style['control__icon'],attrs:{"name":_vm.controlIcon}})],1):_vm._e()]),(_vm.hiddenItems.length && index === 0)?[_c('span',{class:_vm.$style['divider']},[(_vm.$slots.divider)?_c('span',[_vm._t("divider")],2):_c('UiIcon',{class:_vm.$style['divider-icon'],attrs:{"name":_vm.dividerIcon}})],1),_c('div',{class:_vm.$style['more']},[_c('UiBreadcrumbsMore',{attrs:{"items":_vm.hiddenItems,"theme":_vm.theme,"placement":_vm.placement},on:{"select":_vm.onItemClick}})],1)]:_vm._e(),(index !== _vm.visibleItems.length - 1)?_c('span',{class:_vm.$style['divider']},[(_vm.$slots.divider)?_c('span',[_vm._t("divider")],2):_c('UiIcon',{class:_vm.$style['divider-icon'],attrs:{"name":_vm.dividerIcon}})],1):_vm._e()],2)}),0)}
var UiBreadcrumbsvue_type_template_id_6e85e17f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbs.vue?vue&type=template&id=6e85e17f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue?vue&type=template&id=1706fa3b&
var UiBreadcrumbsMorevue_type_template_id_1706fa3b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['more']},[_c('v-popover',{attrs:{"open":_vm.isOpen,"popover-base-class":_vm.$style['popover'],"open-class":_vm.$style['open'],"offset":"4","placement":_vm.placement,"trigger":"manual","auto-hide":""},on:{"auto-hide":function($event){_vm.isOpen = false}}},[_vm._t("target",function(){return [_c('div',{class:_vm.classes,on:{"click":function($event){_vm.isOpen = true}}},[_c('UiIcon',{class:_vm.$style['target__icon'],attrs:{"name":"loader"}})],1)]}),_c('template',{slot:"popover"},[_c('div',{class:_vm.$style['more-dropdown']},_vm._l((_vm.items),function(item){return _c('div',{key:item.id,class:_vm.$style['more-dropdown__item'],on:{"click":function($event){return _vm.onItemClick(item)}}},[_vm._v(" "+_vm._s(item.title)+" ")])}),0)])],2)],1)}
var UiBreadcrumbsMorevue_type_template_id_1706fa3b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue?vue&type=template&id=1706fa3b&

// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/enum/themes.js
/* harmony default export */ var themes = ({
  DARK: 'dark',
  LIGHT: 'light',
  RULES: 'rules'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiBreadcrumbsMorevue_type_script_lang_js_ = ({
  name: 'UiBreadcrumbsMore',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    theme: {
      type: String,
      default: themes.LIGHT,
      validator: theme => Object.values(themes).includes(theme)
    },
    placement: {
      type: String
    }
  },
  data: () => ({
    isOpen: false
  }),
  computed: {
    classes() {
      return {
        [this.$style['target']]: true,
        [this.$style[`target_${this.theme}`]]: true
      };
    }

  },
  methods: {
    onItemClick(item) {
      this.$emit('select', item);
      this.isOpen = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiBreadcrumbs_UiBreadcrumbsMorevue_type_script_lang_js_ = (UiBreadcrumbsMorevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue?vue&type=style&index=0&lang=less&module=true&
var UiBreadcrumbsMorevue_type_style_index_0_lang_less_module_true_ = __webpack_require__("fb99");

// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbsMore.vue








function UiBreadcrumbsMore_injectStyles (context) {
  
  this["$style"] = (UiBreadcrumbsMorevue_type_style_index_0_lang_less_module_true_["default"].locals || UiBreadcrumbsMorevue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiBreadcrumbsMore_component = normalizeComponent(
  UiBreadcrumbs_UiBreadcrumbsMorevue_type_script_lang_js_,
  UiBreadcrumbsMorevue_type_template_id_1706fa3b_render,
  UiBreadcrumbsMorevue_type_template_id_1706fa3b_staticRenderFns,
  false,
  UiBreadcrumbsMore_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiBreadcrumbsMore = (UiBreadcrumbsMore_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiBreadcrumbs/UiBreadcrumbs.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiBreadcrumbsvue_type_script_lang_js_ = ({
  name: 'UiBreadcrumbs',
  components: {
    UiIcon: components_UiIcon,
    UiBreadcrumbsMore: UiBreadcrumbsMore
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    tag: {
      type: String,
      default: 'a'
    },
    theme: {
      type: String,
      default: themes.LIGHT
    },
    dividerIcon: {
      type: String,
      default: 'chevronRight'
    },

    /**
     * Показывает кнопку у последнего пункта
     */
    controls: {
      type: Boolean,
      default: false
    },
    controlIcon: {
      type: String,
      default: 'edit'
    },

    /**
     * Определяет позиционирование выпадающего списка
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.BOTTOM_END
    }
  },

  data() {
    return {
      visibleItems: [],
      hiddenItems: [],
      currentWidth: null,
      previousWidth: null,
      firstRun: true,
      moved: false
    };
  },

  computed: {
    itemClasses() {
      return {
        [this.$style['item']]: true,
        [this.$style[`item_${this.theme}`]]: true,
        [this.$style['item_controls']]: this.controls
      };
    },

    totalWidthOfChildren() {
      if (this.visibleItems.length === 0) {
        return 0;
      }

      return Array.from(this.$el.children).reduce((total, child) => total + child.offsetWidth, 0);
    },

    isOverflown() {
      if (!this.currentWidth) {
        return false;
      }

      return this.currentWidth < this.totalWidthOfChildren;
    }

  },
  watch: {
    items() {
      this.preRender();
      this.$nextTick(this.moveItem);
    }

  },

  created() {
    this.preRender();
  },

  mounted() {
    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        this.currentWidth = entry.contentRect.width;

        if (this.previousWidth !== entry.contentRect.width || this.firstRun) {
          if (this.firstRun) {
            this.previousWidth = entry.contentRect.width;
          }

          this.moveItem();
          this.firstRun = false;
        }

        this.previousWidth = entry.contentRect.width;
      });
    });
    resizeObserver.observe(this.$el);
  },

  methods: {
    preRender() {
      this.visibleItems = [...this.items];
      this.hiddenItems = [];
    },

    moveItem() {
      if (this.isOverflown) {
        const secondElement = this.visibleItems[1] || null;
        this.hiddenItems.push(secondElement);
        this.visibleItems.splice(1, 1);
        this.moved = false;
        this.$nextTick(() => {
          this.moveItem();
        });
      } else if ((this.currentWidth > this.previousWidth || this.firstRun || this.moved) && this.hiddenItems.length) {
        const lastElement = this.hiddenItems[this.hiddenItems.length - 1];
        this.visibleItems.splice(1, 0, lastElement);
        this.hiddenItems.pop();
        this.moved = true;
        this.$nextTick(() => {
          this.moveItem();
        });
      }
    },

    onControlClick(item) {
      this.$emit('controlClick', item);
    },

    onItemClick(item) {
      this.$emit('click', item);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbs.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiBreadcrumbs_UiBreadcrumbsvue_type_script_lang_js_ = (UiBreadcrumbsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbs.vue?vue&type=style&index=0&lang=less&module=true&
var UiBreadcrumbsvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("bff8");

// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/UiBreadcrumbs.vue








function UiBreadcrumbs_injectStyles (context) {
  
  this["$style"] = (UiBreadcrumbsvue_type_style_index_0_lang_less_module_true_["default"].locals || UiBreadcrumbsvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiBreadcrumbs_component = normalizeComponent(
  UiBreadcrumbs_UiBreadcrumbsvue_type_script_lang_js_,
  UiBreadcrumbsvue_type_template_id_6e85e17f_render,
  UiBreadcrumbsvue_type_template_id_6e85e17f_staticRenderFns,
  false,
  UiBreadcrumbs_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiBreadcrumbs = (UiBreadcrumbs_component.exports);
// CONCATENATED MODULE: ./src/components/UiBreadcrumbs/index.js

/* harmony default export */ var components_UiBreadcrumbs = (UiBreadcrumbs);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendar.vue?vue&type=template&id=c15e889c&
var UiCalendarvue_type_template_id_c15e889c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['container']},_vm._l((_vm.viewsComputed),function(view,index){return _c('div',{key:'view-' + index + '-' + view.date,class:_vm.$style['calendar']},[(view.mode === _vm.VIEW_MODES.DAYS)?[_c('UiCalendarNavigation',{attrs:{"hide-prev":index === 1 && _vm.viewsIsSynchronized && _vm.views[0].mode === _vm.VIEW_MODES.DAYS,"hide-next":index === 0 && _vm.viewsIsSynchronized && _vm.views[1].mode === _vm.VIEW_MODES.DAYS},on:{"ui::calendar-navigation::main":function($event){_vm.views[index].mode = _vm.VIEW_MODES.MONTHS},"ui::calendar-navigation::prev":function($event){return _vm.showPrevMonth(index)},"ui::calendar-navigation::next":function($event){return _vm.showNextMonth(index)}}},[_vm._v(" "+_vm._s(_vm.I18N[_vm.localeComputed].months[view.date.month - 1])+" ")]),_c('div',{class:_vm.$style['table']},[_c('div',{class:_vm.$style['row']},_vm._l((_vm.weekdaysNames),function(name,i){return _c('div',{key:'weekday-' + i,class:_vm.$style['cell-weekday']},[_vm._v(" "+_vm._s(name)+" ")])}),0),_vm._l((view.days),function(week,i){
var _obj;
return _c('div',{key:'week-' + (i + 1),class:( _obj = {}, _obj[_vm.$style['row']] = true, _obj[_vm.$style['row_justify-end']] = i === 0, _obj )},[_vm._l((week),function(day){
                    var _obj;
return [(day.inSameMonth(view.date))?_c('UiCalendarCell',{key:'day-' + index + '-' + day,class:( _obj = {}, _obj[_vm.$style['cell-day']] = true, _obj[_vm.$style['cell-day_muted']] = _vm.isDisabledDay(day) ||
                                    !_vm.inSelectedMonth(day, index) &&
                                    !_vm.isSelectedDay(day), _obj ),attrs:{"current":_vm.isCurrentDay(day),"selected":_vm.isSelectedDay(day),"disabled":_vm.isDisabledDay(day),"in-range":_vm.inRange(day),"is-range-first":_vm.firstInRange(day),"is-range-last":_vm.lastInRange(day)},on:{"click":function($event){return _vm.onDayClick(day, index)},"mouseover":function($event){_vm.hoverDate = day},"mouseleave":function($event){_vm.hoverDate = null}}},[_vm._v(" "+_vm._s(day.dayInMonth)+" ")]):_vm._e()]})],2)})],2)]:_vm._e(),(view.mode === _vm.VIEW_MODES.MONTHS)?[_c('UiCalendarNavigation',{on:{"ui::calendar-navigation::main":function($event){_vm.views[index].mode = _vm.VIEW_MODES.YEARS},"ui::calendar-navigation::prev":function($event){return _vm.showYear(view.date.year - 1, index)},"ui::calendar-navigation::next":function($event){return _vm.showYear(view.date.year + 1, index)}}},[_vm._v(" "+_vm._s(view.date.year)+" ")]),_c('div',{class:_vm.$style['table']},_vm._l((_vm.monthsNames),function(name,i){
                            var _obj;
return _c('UiCalendarCell',{key:'month-' + (i + 1),class:( _obj = {}, _obj[_vm.$style['cell-month']] = true, _obj ),attrs:{"current":_vm.isCurrentMonth(i + 1, index)},on:{"click":function($event){return _vm.showMonth(i + 1, index)}}},[_c('span',[_vm._v(_vm._s(name))])])}),1)]:_vm._e(),(view.mode === _vm.VIEW_MODES.YEARS)?[_c('UiCalendarNavigation',{on:{"ui::calendar-navigation::prev":function($event){return _vm.showPrevDecade(index)},"ui::calendar-navigation::next":function($event){return _vm.showNextDecade(index)}}},[_vm._v(" "+_vm._s(view.decade[0])+"–"+_vm._s(view.decade[view.decade.length - 1])+" ")]),_c('div',{class:_vm.$style['table']},_vm._l((view.decade),function(year,i){
                            var _obj;
return _c('UiCalendarCell',{key:'year-' + (i + 1),class:( _obj = {}, _obj[_vm.$style['cell-year']] = true, _obj ),attrs:{"current":_vm.isCurrentYear(year)},on:{"click":function($event){return _vm.showYear(year, index)}}},[_c('span',[_vm._v(_vm._s(year))])])}),1)]:_vm._e()],2)}),0)}
var UiCalendarvue_type_template_id_c15e889c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendar.vue?vue&type=template&id=c15e889c&

// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarDate.js
const dateWithoutTime = (date = new Date()) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

class UiCalendarDate {
  /**
   * @param {Date|number} [options]
   */
  constructor(...options) {
    const [date] = options || [];
    const [year, month, dayInMonth = 1] = options || [];

    if (date instanceof Date) {
      this._date = dateWithoutTime(date);
    } else if (date instanceof UiCalendarDate) {
      this._date = dateWithoutTime(date.date);
    } else if (typeof year === 'number') {
      this._date = new Date(year, month - 1, dayInMonth);
    } else {
      this._date = dateWithoutTime();
    }
  }
  /**
   * @return {Date}
   */


  get date() {
    return new Date(this._date);
  }

  get dayInMonth() {
    return this._date.getDate();
  }

  get dayInWeek() {
    return this._date.getDay();
  }

  get month() {
    return this._date.getMonth() + 1;
  }

  get year() {
    return this._date.getFullYear();
  }

  get timestamp() {
    return this._date.getTime();
  }

  inSameDay(date) {
    return date.dayInMonth === this.dayInMonth && this.inSameMonth(date);
  }

  inSameMonth(date) {
    return date.month === this.month && date.year === this.year;
  }

  isBefore(date) {
    return date instanceof UiCalendarDate && date.timestamp > this.timestamp;
  }

  isAfter(date) {
    return date instanceof UiCalendarDate && date.timestamp < this.timestamp;
  }

  static max(a, b) {
    if (a instanceof UiCalendarDate) {
      if (b instanceof UiCalendarDate) {
        return a.isAfter(b) ? a : b;
      }

      return a;
    }

    return b instanceof UiCalendarDate ? b : null;
  }

  static min(a, b) {
    if (a instanceof UiCalendarDate) {
      if (b instanceof UiCalendarDate) {
        return a.isBefore(b) ? a : b;
      }

      return a;
    }

    return b instanceof UiCalendarDate ? b : null;
  }

  toString() {
    return this._date.toString();
  }

}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendarCell.vue?vue&type=template&id=83ab5da0&
var UiCalendarCellvue_type_template_id_83ab5da0_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:( _obj = {}, _obj[_vm.$style['cell']] = true, _obj[_vm.$style['cell_current']] = _vm.current, _obj[_vm.$style['cell_selected']] = _vm.selected, _obj[_vm.$style['cell_disabled']] = _vm.disabled, _obj[_vm.$style['cell_in-range']] = _vm.inRange, _obj[_vm.$style['cell_is-range-first']] = _vm.isRangeFirst, _obj[_vm.$style['cell_is-range-last']] = _vm.isRangeLast, _obj )},_vm.$listeners),[_c('div',{class:_vm.$style['cell__backdrop']}),_c('div',{class:_vm.$style['cell__content']},[_vm._t("default")],2)])}
var UiCalendarCellvue_type_template_id_83ab5da0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarCell.vue?vue&type=template&id=83ab5da0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendarCell.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiCalendarCellvue_type_script_lang_js_ = ({
  name: 'UiCalendarCell',
  props: {
    current: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    inRange: {
      type: Boolean,
      default: false
    },
    isRangeFirst: {
      type: Boolean,
      default: false
    },
    isRangeLast: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarCell.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCalendar_UiCalendarCellvue_type_script_lang_js_ = (UiCalendarCellvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCalendar/UiCalendarCell.vue?vue&type=style&index=0&module=true&lang=less&
var UiCalendarCellvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("93da");

// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarCell.vue








function UiCalendarCell_injectStyles (context) {
  
  this["$style"] = (UiCalendarCellvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCalendarCellvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCalendarCell_component = normalizeComponent(
  UiCalendar_UiCalendarCellvue_type_script_lang_js_,
  UiCalendarCellvue_type_template_id_83ab5da0_render,
  UiCalendarCellvue_type_template_id_83ab5da0_staticRenderFns,
  false,
  UiCalendarCell_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCalendarCell = (UiCalendarCell_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendarNavigation.vue?vue&type=template&id=1a8478ce&
var UiCalendarNavigationvue_type_template_id_1a8478ce_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.$style['navigation']},[(!_vm.hidePrev)?_c('UiButton',{attrs:{"variant":"tertiary","shape":"square"},on:{"click":function($event){return _vm.$emit('ui::calendar-navigation::prev')}}},[_c('UiIcon',{class:_vm.$style['navigation__icon'],staticStyle:{"transform":"scaleX(-1)"},attrs:{"name":"chevronRight"}})],1):_c('div',{class:_vm.$style['navigation__placeholder']}),_c('UiButton',{class:_vm.$style['navigation__button'],attrs:{"variant":"tertiary"},on:{"click":function($event){return _vm.$emit('ui::calendar-navigation::main')}}},[_c('span',{class:_vm.$style['navigation__text']},[_vm._t("default")],2)]),(!_vm.hideNext)?_c('UiButton',{attrs:{"variant":"tertiary","shape":"square"},on:{"click":function($event){return _vm.$emit('ui::calendar-navigation::next')}}},[_c('UiIcon',{class:_vm.$style['navigation__icon'],attrs:{"name":"chevronRight"}})],1):_c('div',{class:_vm.$style['navigation__placeholder']})],1)}
var UiCalendarNavigationvue_type_template_id_1a8478ce_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarNavigation.vue?vue&type=template&id=1a8478ce&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendarNavigation.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiCalendarNavigationvue_type_script_lang_js_ = ({
  name: 'UiCalendarNavigation',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon
  },
  props: {
    hidePrev: {
      type: Boolean,
      default: false
    },
    hideNext: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarNavigation.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCalendar_UiCalendarNavigationvue_type_script_lang_js_ = (UiCalendarNavigationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCalendar/UiCalendarNavigation.vue?vue&type=style&index=0&module=true&lang=less&
var UiCalendarNavigationvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("7c03");

// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendarNavigation.vue








function UiCalendarNavigation_injectStyles (context) {
  
  this["$style"] = (UiCalendarNavigationvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCalendarNavigationvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCalendarNavigation_component = normalizeComponent(
  UiCalendar_UiCalendarNavigationvue_type_script_lang_js_,
  UiCalendarNavigationvue_type_template_id_1a8478ce_render,
  UiCalendarNavigationvue_type_template_id_1a8478ce_staticRenderFns,
  false,
  UiCalendarNavigation_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCalendarNavigation = (UiCalendarNavigation_component.exports);
// CONCATENATED MODULE: ./src/utils/predicates.js
const isDate = value => value instanceof Date;
const isDateArray = value => Array.isArray(value) && value.every(isDate);
const isNull = value => value === null;
// CONCATENATED MODULE: ./src/utils/props.js
const createEnumProp = (variants, defaultValue) => ({
  type: String,
  validator: value => Object.values(variants).includes(value),
  default: defaultValue
});
// CONCATENATED MODULE: ./src/components/UiCalendar/utils.js

/**
 * @param {UiCalendarDate} day
 * @param {number} firstDayOfWeek
 */

const getDaysOfWeek = (day, firstDayOfWeek) => {
  const days = [];
  const offset = day.dayInWeek === 0 && firstDayOfWeek > 0 ? 7 : 0;

  for (let i = 0; i < 7; i++) {
    days.push(new UiCalendarDate(day.year, day.month, day.dayInMonth - day.dayInWeek + i + firstDayOfWeek - offset));
  }

  return days;
};
/**
 * @param {UiCalendarDate} date Первый день месяца, для которого строится календарная сетка
 * @param {number} firstDayOfWeek
 * @return {Array<Array<UiCalendarDate>>}
 */

const getDaysOfMonthGrid = (date, firstDayOfWeek) => {
  const days = [];

  for (let i = 0; i < 6; i++) {
    days.push(getDaysOfWeek(new UiCalendarDate(date.year, date.month, 1 + i * 7), firstDayOfWeek));
  }

  return days;
};
const getDecade = year => {
  const first = year - year % 10 - 1;
  return Array.from({
    length: 12
  }, (_, i) => i + first);
};
// CONCATENATED MODULE: ./src/components/UiCalendar/i18n.js
const LOCALES = {
  en_GB: 'en_GB',
  es_ES: 'es_ES',
  ru_RU: 'ru_RU'
};
/* harmony default export */ var i18n = ({
  [LOCALES.en_GB]: {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    firstDayOfWeek: 0
  },
  [LOCALES.es_ES]: {
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    weekdaysShort: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'],
    weekdaysMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
    firstDayOfWeek: 0
  },
  [LOCALES.ru_RU]: {
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    weekdaysShort: ['Вос', 'Пон', 'Вто', 'Сре', 'Чет', 'Пят', 'Суб'],
    weekdaysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    firstDayOfWeek: 1
  }
});
// CONCATENATED MODULE: ./src/components/UiCalendar/enum/appearance.js
/* harmony default export */ var appearance = ({
  SINGLE: 'single',
  DOUBLE: 'double'
});
// CONCATENATED MODULE: ./src/components/UiCalendar/enum/types.js
/* harmony default export */ var enum_types = ({
  SINGLE: 'single',
  RANGE: 'range'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCalendar/UiCalendar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









const VIEW_MODES = {
  DAYS: 'days',
  MONTHS: 'months',
  YEARS: 'years'
};
/* harmony default export */ var UiCalendarvue_type_script_lang_js_ = ({
  name: 'UiCalendar',
  components: {
    UiCalendarCell: UiCalendarCell,
    UiCalendarNavigation: UiCalendarNavigation
  },
  model: {
    prop: 'value',
    event: 'ui::calendar::change'
  },
  props: {
    value: {
      validator: value => isNull(value) || isDate(value) || isDateArray(value),
      default: null
    },
    type: createEnumProp(enum_types, enum_types.SINGLE),
    appearance: createEnumProp(appearance, appearance.SINGLE),
    locale: createEnumProp(LOCALES, LOCALES.ru_RU),
    firstDayOfWeek: {
      validator: value => value === undefined || Number.isInteger(value) && value >= 0 && value < 7,
      default: undefined
    },
    minDate: {
      type: Date,
      default: null
    },
    maxDate: {
      type: Date,
      default: null
    },
    // Очистка значения повторным кликом на дате
    toggleSelectedDay: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const today = new UiCalendarDate();
    return {
      hoverDate: null,
      views: [{
        date: new UiCalendarDate(today.year, today.month),
        decade: getDecade(today.year),
        mode: VIEW_MODES.DAYS
      }, {
        date: new UiCalendarDate(today.year, today.month + 1),
        decade: getDecade(today.year),
        mode: VIEW_MODES.DAYS
      }]
    };
  },

  computed: {
    I18N: () => i18n,
    VIEW_MODES: () => VIEW_MODES,

    monthsNames() {
      return i18n[this.localeComputed].monthsShort.slice();
    },

    weekdaysNames() {
      const names = i18n[this.localeComputed].weekdaysMin;
      return [...names.slice(this.firstDayOfWeekComputed), ...names.slice(0, this.firstDayOfWeekComputed)];
    },

    viewsComputed() {
      const views = [this.views[0]];

      if (this.appearance === appearance.DOUBLE) {
        views.push(this.views[1]);
      }

      return views.map(({
        date,
        decade,
        mode
      }) => ({
        date,
        decade,
        mode,
        days: getDaysOfMonthGrid(date, this.firstDayOfWeekComputed)
      }));
    },

    viewsIsSynchronized() {
      const [first, last] = this.views;
      return this.appearance === appearance.DOUBLE && first.mode === last.mode && first.date.inSameDay(new UiCalendarDate(last.date.year, last.date.month - 1));
    },

    range() {
      const [first, last] = this.valueComputed;
      const max = this.maxDate ? new UiCalendarDate(this.maxDate.getFullYear(), this.maxDate.getMonth() + 1, this.maxDate.getDate() + 1) : null;
      const min = this.minDate ? new UiCalendarDate(this.minDate.getFullYear(), this.minDate.getMonth() + 1, this.minDate.getDate() - 1) : null;

      const restrict = date => date ? UiCalendarDate.max(UiCalendarDate.min(date, max), min) : null;

      return this.type === enum_types.SINGLE ? [] : [restrict(first), restrict(last || this.hoverDate)].filter(date => !!date).sort((a, b) => a.isBefore(b) ? -1 : 1);
    },

    /**
     * @return {Array<UiCalendarDate>}
     */
    valueComputed() {
      const dates = Array.isArray(this.value) ? this.value : [this.value];
      return dates.filter(date => date).map(date => new UiCalendarDate(date));
    },

    localeComputed() {
      return this.$getLocale ? this.$getLocale() : this.locale;
    },

    firstDayOfWeekComputed() {
      if (this.firstDayOfWeek !== undefined) {
        return this.firstDayOfWeek;
      }

      if (i18n[this.localeComputed].firstDayOfWeek !== undefined) {
        return i18n[this.localeComputed].firstDayOfWeek;
      }

      return 0;
    }

  },
  methods: {
    /**
     * @param {UiCalendarDate} day
     * @param {number} viewIndex
     * @internal
     */
    onDayClick(day, viewIndex) {
      if (this.isSelectedDay(day) && !this.toggleSelectedDay) {
        return;
      }

      if (this.isDisabledDay(day)) {
        return;
      }

      if (!this.inSelectedMonth(day, viewIndex)) {
        this.views[viewIndex].date = new UiCalendarDate(day.year, day.month);
      }

      if (this.type === enum_types.SINGLE) {
        const [first] = this.valueComputed;
        this.$emit('ui::calendar::change', first && day.inSameDay(first) ? null : day.date);
      } else {
        this.$emit('ui::calendar::change', this.calculateValue(day));
      }
    },

    /**
     * @param {UiCalendarDate} day
     * @internal
     */
    calculateValue(day) {
      const [first, last] = this.valueComputed;

      if (!first) {
        return [day.date];
      }

      if (day.inSameDay(first)) {
        return [];
      }

      if (!last) {
        const value = [first.date, day.date];
        return first.isBefore(day) ? value : value.reverse();
      }

      if (day.inSameDay(last)) {
        return [first.date];
      }

      return [day.date];
    },

    showNextMonth(viewIndex) {
      if (this.viewsIsSynchronized) {
        this.showMonth(this.views[0].date.month + 1, 0);
        this.showMonth(this.views[1].date.month + 1, 1);
      } else {
        this.showMonth(this.views[viewIndex].date.month + 1, viewIndex);
      }
    },

    showPrevMonth(viewIndex) {
      if (this.viewsIsSynchronized) {
        this.showMonth(this.views[0].date.month - 1, 0);
        this.showMonth(this.views[1].date.month - 1, 1);
      } else {
        this.showMonth(this.views[viewIndex].date.month - 1, viewIndex);
      }
    },

    showMonth(month, viewIndex) {
      const year = this.views[viewIndex].date.year;
      this.views[viewIndex].date = new UiCalendarDate(year, month);
      this.views[viewIndex].mode = VIEW_MODES.DAYS;
    },

    showYear(year, viewIndex) {
      const month = this.views[viewIndex].date.month;
      this.views[viewIndex].date = new UiCalendarDate(year, month);
      this.views[viewIndex].mode = VIEW_MODES.MONTHS;
    },

    showPrevDecade(viewIndex) {
      this.views[viewIndex].decade = getDecade(this.views[viewIndex].decade[1] - 10);
    },

    showNextDecade(viewIndex) {
      this.views[viewIndex].decade = getDecade(this.views[viewIndex].decade[1] + 10);
    },

    /**
     * @param {UiCalendarDate} date
     * @internal
     */
    isCurrentDay(date) {
      return date.inSameDay(new UiCalendarDate());
    },

    /**
     * @internal
     */
    isCurrentMonth(month, viewIndex) {
      const date = new UiCalendarDate();
      return date.month === month && date.year === this.views[viewIndex].date.year;
    },

    /**
     * @internal
     */
    isCurrentYear(year) {
      return year === new UiCalendarDate().year;
    },

    /**
     * @param {UiCalendarDate} date
     * @internal
     */
    isSelectedDay(date) {
      return this.valueComputed.some(d => date.inSameDay(d));
    },

    isDisabledDay(date) {
      const max = this.maxDate ? new UiCalendarDate(this.maxDate.getFullYear(), this.maxDate.getMonth() + 1, this.maxDate.getDate()) : null;
      const min = this.minDate ? new UiCalendarDate(this.minDate.getFullYear(), this.minDate.getMonth() + 1, this.minDate.getDate()) : null;
      return date.isBefore(min) || date.isAfter(max);
    },

    /**
     * @param {UiCalendarDate} date
     * @param {number} viewIndex
     * @internal
     */
    inSelectedMonth(date, viewIndex) {
      return date.inSameMonth(this.views[viewIndex].date);
    },

    /**
     * @param {UiCalendarDate} date
     * @internal
     */
    inRange(date) {
      const [min, max] = this.range;
      return date.isAfter(min) && date.isBefore(max);
    },

    /**
     * @internal
     */
    firstInRange(date) {
      const [min] = this.range;
      return min && date.inSameDay(new UiCalendarDate(min.year, min.month, min.dayInMonth + 1));
    },

    /**
     * @internal
     */
    lastInRange(date) {
      const [, max] = this.range;
      return max && date.inSameDay(new UiCalendarDate(max.year, max.month, max.dayInMonth - 1));
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendar.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCalendar_UiCalendarvue_type_script_lang_js_ = (UiCalendarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCalendar/UiCalendar.vue?vue&type=style&index=0&module=true&lang=less&
var UiCalendarvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("7bf6");

// CONCATENATED MODULE: ./src/components/UiCalendar/UiCalendar.vue








function UiCalendar_injectStyles (context) {
  
  this["$style"] = (UiCalendarvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCalendarvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCalendar_component = normalizeComponent(
  UiCalendar_UiCalendarvue_type_script_lang_js_,
  UiCalendarvue_type_template_id_c15e889c_render,
  UiCalendarvue_type_template_id_c15e889c_staticRenderFns,
  false,
  UiCalendar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCalendar = (UiCalendar_component.exports);
// CONCATENATED MODULE: ./src/components/UiCalendar/index.js

/* harmony default export */ var components_UiCalendar = (UiCalendar);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCheckbox/UiCheckbox.vue?vue&type=template&id=513463bc&
var UiCheckboxvue_type_template_id_513463bc_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['checkbox-wrap']},[_c('label',{class:_vm.classes},[_c('span',{class:_vm.$style['checkbox__ch']},[_c('span',{class:_vm.$style['checkbox__ch-icon']},[(_vm.checked && !_vm.indeterminate)?_c('UiIcon',{class:_vm.$style['checkbox__ch-image'],attrs:{"name":"done"}}):_vm._e()],1),_c('input',{class:_vm.$style['checkbox__ch-input'],attrs:{"name":_vm.name,"disabled":_vm.disabled,"true-value":_vm.trueValue,"false-value":_vm.falseValue,"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange,"click":function($event){return _vm.$emit('click')}}})]),(_vm.label || _vm.desc || _vm.$slots.default)?_c('span',{class:_vm.$style['checkbox__text']},[(_vm.label || _vm.$slots.default)?_c('span',{class:[_vm.$style['checkbox__label'], ( _obj = {}, _obj[_vm.$style['checkbox__label_muted']] = _vm.disabled, _obj )]},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e(),(_vm.desc)?_c('span',{class:_vm.$style['checkbox__desc']},[_vm._v(" "+_vm._s(_vm.desc)+" ")]):_vm._e()]):_vm._e()])])}
var UiCheckboxvue_type_template_id_513463bc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=template&id=513463bc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCheckbox/UiCheckbox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiCheckboxvue_type_script_lang_js_ = ({
  name: 'UiCheckbox',
  components: {
    UiIcon: components_UiIcon
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    name: {
      type: String
    },
    model: [String, Boolean, Object, Number, Array],
    value: {
      type: [String, Boolean, Object, Number],
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trueValue: {
      validator: () => true,
      default: true
    },
    falseValue: {
      validator: () => true,
      default: false
    },
    min: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['checkbox']]: true,
        [this.$style['checkbox_checked']]: this.checked,
        [this.$style['checkbox_indeterminate']]: this.indeterminate,
        [this.$style['checkbox_disabled']]: this.disabled,
        [this.$style['checkbox_min']]: this.min
      };
    },

    checked() {
      if (this.model instanceof Array) {
        return this.model.includes(this.value);
      }

      return this.model === this.trueValue;
    }

  },
  methods: {
    onChange(e) {
      const checked = e.target.checked;

      if (this.model instanceof Array) {
        const newValue = [...this.model];

        if (checked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit('change', newValue);
      } else {
        this.$emit('change', checked ? this.trueValue : this.falseValue);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCheckbox_UiCheckboxvue_type_script_lang_js_ = (UiCheckboxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCheckbox/UiCheckbox.vue?vue&type=style&index=0&module=true&lang=less&
var UiCheckboxvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("983b");

// CONCATENATED MODULE: ./src/components/UiCheckbox/UiCheckbox.vue








function UiCheckbox_injectStyles (context) {
  
  this["$style"] = (UiCheckboxvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCheckboxvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCheckbox_component = normalizeComponent(
  UiCheckbox_UiCheckboxvue_type_script_lang_js_,
  UiCheckboxvue_type_template_id_513463bc_render,
  UiCheckboxvue_type_template_id_513463bc_staticRenderFns,
  false,
  UiCheckbox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCheckbox = (UiCheckbox_component.exports);
// CONCATENATED MODULE: ./src/components/UiCheckbox/index.js

/* harmony default export */ var components_UiCheckbox = (UiCheckbox);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseBox/UiCollapseBox.vue?vue&type=template&id=99dfa488&
var UiCollapseBoxvue_type_template_id_99dfa488_render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:_vm.classes,on:{"click":_vm.onHeadClick}},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:_vm.$style['box__inner-wrap']},[_c('div',{class:( _obj = {}, _obj[_vm.$style['box__row']] = true, _obj[_vm.$style['box__row_head']] = true, _obj[_vm.$style['pointer']] = (_vm.expandable && (_vm.toggleable || !_vm.internals.expanded)), _obj ),on:{"mouseenter":function($event){return _vm.toggleDisabledTooltip(true)},"mouseleave":function($event){return _vm.toggleDisabledTooltip(false)}}},[_c('div',{class:_vm.$style['box__col']},[(_vm.hasIcon)?_c('div',{class:[_vm.$style['box__icon'], _vm.$style[("box__icon_" + _vm.iconSize)]]},[_c('div',{class:_vm.$style['box__icon-inner']},[_vm._t("icon",function(){return [_c('UiIcon',{attrs:{"name":_vm.iconName}})]})],2)]):_vm._e()]),_c('div',{class:_vm.$style['box__head']},[_c('div',{class:_vm.$style['box__title-wrap']},[_c('UiTooltip',{class:_vm.$style['disabled-tooltip'],attrs:{"trigger-class-name":_vm.$style['disabled-tooltip__trigger'],"popover-base-class":_vm.$style['disabled-tooltip__popover'],"disabled":!_vm.disabled,"max-width":_vm.tooltipMaxWidth,"placement":"bottom-end","trigger":"manual","offset":"0"},scopedSlots:_vm._u([{key:"trigger",fn:function(){
            var _obj;
return [_c('div',{class:( _obj = {}, _obj[_vm.$style['box__title']] = true, _obj[_vm.$style['box__title_ellipsis']] = _vm.ellipsisTitle, _obj )},[_vm._t("title")],2)]},proxy:true}],null,true),model:{value:(_vm.isVisibleTooltip),callback:function ($$v) {_vm.isVisibleTooltip=$$v},expression:"isVisibleTooltip"}},[_vm._v(" "+_vm._s(_vm.disabledText)+" ")]),(_vm.hasError && !_vm.expanded)?_c('div',{class:_vm.$style['error-msg']},[_c('UiIcon',{class:_vm.$style['error-msg__icon'],attrs:{"name":"error-outlined"}}),_vm._t("error-msg")],2):_vm._e()],1),(_vm.$slots.description)?_c('div',{class:_vm.$style['box__description']},[_vm._t("description")],2):_vm._e(),(!_vm.disabled)?_c('div',{class:_vm.$style['box__action']},[_vm._t("action",function(){return [_c('UiIcon',{class:_vm.$style['box__arrow'],attrs:{"name":"chevronRight"}})]},{"arrowClassModifier":_vm.$style['box__arrow']})],2):_vm._e()])]),_c('UiCollapse',{class:( _obj$1 = {}, _obj$1[_vm.$style['box__collapse']] = true, _obj$1[_vm.contentClass] = !!_vm.contentClass, _obj$1 ),attrs:{"duration":_vm.transitionDurationComputed,"open":_vm.internals.expanded && !_vm.disabled},on:{"ui::collapse::expanded":function($event){return _vm.$emit('ui::collapse-box::expanded')},"ui::collapse::collapsed":function($event){return _vm.$emit('ui::collapse-box::collapsed')}}},[_vm._t("body",function(){return [_c('div',{class:[_vm.$style['box__row'], _vm.$style['box__row_body']]},[_c('div',{class:[
                            _vm.$style['box__inner'],
                            _vm.$style[("box__inner_" + _vm.iconSize)] ]},[_vm._t("body-content")],2)])]}),_vm._t("footer",function(){
                        var _obj;
return [(_vm.$slots['footer-content'])?_c('div',{class:( _obj = {}, _obj[_vm.$style['box__footer']] = true, _obj )},[_vm._t("footer-content")],2):_vm._e()]},{"classes":( _obj$2 = {}, _obj$2[_vm.$style['box__footer']] = true, _obj$2 )})],2)],1)])}
var UiCollapseBoxvue_type_template_id_99dfa488_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseBox.vue?vue&type=template&id=99dfa488&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTooltip/UiTooltip.vue?vue&type=template&id=c226478e&
var UiTooltipvue_type_template_id_c226478e_render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style['tooltip'], 'ui-tooltip']},[_c('div',[_c('v-popover',{class:_vm.$style['tooltip__popover'],attrs:{"trigger":_vm.tooltipTrigger,"container":_vm.container,"offset":_vm.offset,"open":_vm.isOpen,"open-class":_vm.$style['open'],"placement":_vm.placement,"popover-base-class":_vm.popoverBaseClasses,"popper-options":_vm.internalPopperOptions,"auto-hide":_vm.isAutoHide,"disabled":_vm.disabled},on:{"hide":function($event){return _vm.$emit('toggleTooltip', false)}}},[_c('div',{ref:"trigger",class:( _obj = {}, _obj[_vm.$style['tooltip__trigger']] = true, _obj[_vm.$style['tooltip__trigger_icon']] = !_vm.$slots.trigger, _obj[_vm.$style[("tooltip__trigger_icon-" + _vm.presetIconSize)]] = !_vm.$slots.trigger && _vm.presetIconSize, _obj[_vm.iconClassName] = (_vm.icon || _vm.$slots.trigger) && _vm.iconClassName, _obj[_vm.triggerClassName] = _vm.triggerClassName, _obj ),style:(_vm.inlineIconSize),on:{"click":_vm.showTooltip}},[_vm._t("trigger",function(){return [_c('UiIcon',{attrs:{"name":_vm.icon}})]})],2),_c('template',{slot:"popover"},[_c('div',{style:(_vm.biasToTarget)},[_c('div',{class:( _obj$1 = {}, _obj$1[_vm.$style['tooltip__content-inner']] = true, _obj$1[_vm.tooltipInnerClass] = _vm.tooltipInnerClass, _obj$1 ),style:(_vm.maxWidth ? ("max-width: " + (parseInt(_vm.maxWidth)) + "px;") : ''),on:{"click":_vm.onContentClick}},[_c('div',{class:( _obj$2 = {}, _obj$2[_vm.$style['tooltip__content-body']] = true, _obj$2[_vm.tooltipBodyClass] = _vm.tooltipBodyClass, _obj$2 ),style:(_vm.minHeight ? ("min-height: " + (parseInt(_vm.minHeight)) + "px;") : '')},[(_vm.closable)?_c('div',{class:( _obj$3 = {}, _obj$3[_vm.$style['tooltip__close']] = true, _obj$3[_vm.$style['tooltip__close_dark']] = _vm.dark, _obj$3 ),on:{"click":function($event){_vm.isOpen = false}}},[_c('UiIcon',{attrs:{"name":"clearCircle"}})],1):(_vm.$slots.steps)?_c('div',{class:_vm.$style['tooltip__steps']},[_vm._t("steps")],2):_vm._e(),(_vm.$slots.title)?_c('div',{class:( _obj$4 = {}, _obj$4[_vm.$style['tooltip__title']] = true, _obj$4[_vm.$style['tooltip__title_dark']] = _vm.dark, _obj$4[_vm.$style[("tooltip__title_" + _vm.size)]] = _vm.$style[("tooltip__title_" + _vm.size)], _obj$4[_vm.$style['tooltip__title_with-steps']] = _vm.$slots.steps, _obj$4 )},[_vm._t("title")],2):_vm._e(),_vm._t("default"),(_vm.$slots.footer && _vm.isLarge)?_c('div',{class:_vm.$style['tooltip__footer']},[_vm._t("footer")],2):_vm._e()],2)])])])],2)],1)])}
var UiTooltipvue_type_template_id_c226478e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTooltip/UiTooltip.vue?vue&type=template&id=c226478e&

// CONCATENATED MODULE: ./src/components/UiTooltip/enum/sizes.js
/* harmony default export */ var UiTooltip_enum_sizes = ({
  LG: 'lg',
  MD: 'md',
  SM: 'sm'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTooltip/UiTooltip.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



const LENGTH_TO_POINTER = 28; // Расстояние от края тултипа до центра указателя

/* harmony default export */ var UiTooltipvue_type_script_lang_js_ = ({
  name: 'UiTooltip',
  components: {
    UiIcon: components_UiIcon
  },
  model: {
    prop: 'show',
    event: 'toggleTooltip'
  },
  props: {
    /**
     * Определяет позиционирование
     * Возможные значения:
     * - left
     * - left-start
     * - left-end
     * - right
     * - right-start
     * - right-end
     * - top
     * - top-start
     * - top-end
     * - bottom
     * - bottom-start
     * - bottom-end
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.BOTTOM
    },

    /**
     * Иконка целевого элемента
     */
    icon: {
      type: String,
      default: 'helpIcon'
    },
    size: {
      type: String,
      validator: size => Object.values(UiTooltip_enum_sizes).includes(size),
      default: UiTooltip_enum_sizes.MD
    },
    trigger: {
      type: String,
      default: 'hover'
    },

    /**
     * Определяет смещение тултипа
     * от целевого элемента в px
     */
    offset: {
      type: String,
      default: '4'
    },

    /**
     * Определяет контейнер,
     * в который будет добавляться разметка тултипа
     */
    container: {
      type: String,
      default: 'body'
    },
    popoverBaseClass: {
      type: String,
      default: ''
    },
    tooltipInnerClass: {
      type: String,
      default: null
    },
    tooltipBodyClass: {
      type: String,
      default: null
    },
    openClass: {
      type: String,
      default: ''
    },

    /**
     * Позволяет передать модификатор
     * preventOverflow в popperOptions
     */
    isPreventOverflow: {
      type: Boolean,
      default: true
    },

    /**
     * Определяет темный тултип
     */
    dark: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет закрываемый тултип
     */
    closable: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет наличие указателя
     * По-умолчанию применяется, если тултип closable
     */
    withPointer: {
      type: Boolean,
      default: false
    },

    /**
     * Время в ms, через которое тултип автоматически скроется
     */
    hideTime: {
      type: [Number, String],
      default: 0
    },

    /**
     * Центрирование текста для простых тултипов
     */
    centerText: {
      type: Boolean
    },

    /**
     * Однострочный простой тултип
     */
    inline: {
      type: Boolean,
      default: false
    },

    /**
     * Вручную указать отображать ли тултип
     * реализует v-model
     */
    show: {
      type: Boolean,
      default: false
    },
    popperOptions: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: [Number, String],
      default: null
    },
    minHeight: {
      type: [Number, String],
      default: null
    },
    iconSize: {
      type: [Number, String],
      default: null
    },
    iconClassName: {
      type: String,
      default: null
    },
    triggerClassName: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isOpen: this.show,
      triggerSize: null
    };
  },

  computed: {
    popoverBaseClasses() {
      const classes = {
        [this.$style['tooltip__content']]: true,
        [this.$style[`tooltip__content_${this.size}`]]: this.$style[`tooltip__content_${this.size}`],
        [this.$style['tooltip__content_dark']]: this.dark,
        [this.$style['tooltip__content_closable']]: this.closable,
        [this.$style['tooltip__content_pointer']]: this.hasPointer,
        [this.$style['tooltip__content_center-text']]: this.centerText,
        [this.$style['tooltip__content_inline']]: this.inline,
        [this.$style['tooltip__content_with-steps']]: this.$slots.steps && !this.$slots.title,
        [this.popoverBaseClass]: !!this.popoverBaseClass
      };
      return Object.keys(classes).filter(k => classes[k]);
    },

    presetIconSize() {
      const variant = Object.values(UiTooltip_enum_sizes).includes(this.iconSize);

      if (variant) {
        return this.iconSize;
      }

      return false;
    },

    inlineIconSize() {
      const size = parseInt(this.iconSize);

      if (!isNaN(size)) {
        return {
          width: `${size}px`,
          height: `${size}px`
        };
      }

      return false;
    },

    internalPopperOptions() {
      if (this.popperOptions) {
        return this.popperOptions;
      }
      /**
       * По умолчанию, если тултип выходит за область просмотра,
       * он смещается, чтобы оставаться в ней.
       * Настройка отключает такое поведение
       */


      if (this.isPreventOverflow) {
        return {
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            }
          }
        };
      }

      return {};
    },

    isAutoHide() {
      if (this.trigger === 'manual' || this.hideTime) {
        return false;
      }

      return !this.closable;
    },

    tooltipBias() {
      if (this.triggerSize) {
        return {
          x: this.tooltipDirection * (LENGTH_TO_POINTER - this.triggerSize.width / 2),
          y: this.tooltipDirection * (LENGTH_TO_POINTER - this.triggerSize.height / 2)
        };
      }

      return {
        x: 0,
        y: 0
      };
    },

    tooltipDirection() {
      if (this.placement.includes('start')) {
        return 1;
      }

      if (this.placement.includes('end')) {
        return -1;
      }

      return 0;
    },

    tooltipTrigger() {
      if (this.closable || this.hideTime) {
        return 'manual';
      }

      return this.trigger;
    },

    hasPointer() {
      return this.withPointer || this.closable;
    },

    biasToTarget() {
      /**
       * Если тултип с указателем и ширина целевого элемента меньше, чем
       * расстояние от края тултипа до центра указателя, то тултип смещается так,
       * чтобы указатель находился по центру цели
       */
      if (!this.hasPointer || !this.triggerSize || this.triggerSize.width > LENGTH_TO_POINTER) {
        return {};
      }

      if (this.tooltipDirection === 0) {
        return {};
      }

      if (this.placement.includes('top') || this.placement.includes('bottom')) {
        return {
          transform: `translate3d(${this.tooltipBias.x}px, 0, 0)`
        };
      } else {
        return {
          transform: `translate3d(0, ${-1 * this.tooltipBias.y}px, 0)`
        };
      }
    },

    isLarge() {
      return this.size === UiTooltip_enum_sizes.LG;
    }

  },
  watch: {
    show(s) {
      this.isOpen = s;
    }

  },

  beforeCreate() {
    this._uiTooltipHideTimer = null;
  },

  beforeDestroy() {
    this.stopHideTimer();
  },

  methods: {
    onContentClick(e) {
      if (e.target.closest('[data-close-tooltip]')) {
        this.isOpen = false;
        this.$emit('toggleTooltip', false);
      }
    },

    showTooltip() {
      if (this.trigger === 'manual') {
        return;
      }

      const hideTime = parseInt(this.hideTime, 10) || 0;

      if (this.hasPointer) {
        this.triggerSize = {
          width: this.$refs.trigger.clientWidth,
          height: this.$refs.trigger.clientHeight
        };
      }

      this.isOpen = true;
      this.$emit('toggleTooltip', true);

      if (hideTime) {
        this.stopHideTimer();
        this.startHideTimer(hideTime);
      }
    },

    startHideTimer(hideTime) {
      this._uiTooltipHideTimer = setTimeout(() => {
        this.isOpen = false;
        this._uiTooltipHideTimer = null;
      }, hideTime);
    },

    stopHideTimer() {
      if (this._uiTooltipHideTimer) {
        clearTimeout(this._uiTooltipHideTimer);
        this._uiTooltipHideTimer = null;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTooltip/UiTooltip.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTooltip_UiTooltipvue_type_script_lang_js_ = (UiTooltipvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTooltip/UiTooltip.vue?vue&type=style&index=0&module=true&lang=less&
var UiTooltipvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("18a2");

// CONCATENATED MODULE: ./src/components/UiTooltip/UiTooltip.vue








function UiTooltip_injectStyles (context) {
  
  this["$style"] = (UiTooltipvue_type_style_index_0_module_true_lang_less_["default"].locals || UiTooltipvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTooltip_component = normalizeComponent(
  UiTooltip_UiTooltipvue_type_script_lang_js_,
  UiTooltipvue_type_template_id_c226478e_render,
  UiTooltipvue_type_template_id_c226478e_staticRenderFns,
  false,
  UiTooltip_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTooltip = (UiTooltip_component.exports);
// CONCATENATED MODULE: ./src/components/UiTooltip/index.js

/* harmony default export */ var components_UiTooltip = (UiTooltip);
// CONCATENATED MODULE: ./src/components/UiCollapseBox/enum/colors.js
/* harmony default export */ var enum_colors = ({
  BLACK: 'black',
  BLUE: 'blue',
  GREEN: 'green',
  GREY: 'grey',
  PURPLE: 'purple',
  RED: 'red',
  YELLOW: 'yellow'
});
// CONCATENATED MODULE: ./src/components/UiCollapseBox/enum/sizes.js
/* harmony default export */ var UiCollapseBox_enum_sizes = ({
  MD: 'md',
  SM: 'sm'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseBox/UiCollapseBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





const COLLAPSE_CANCEL_EVENT_NAME = 'ui::collapse-box::collapse-cancel';
const EXPAND_CANCEL_EVENT_NAME = 'ui::collapse-box::expand-cancel';
const TOGGLE_EVENT_NAME = 'ui::collapse::toggle';
const TRANSITION_DURATION_DEFAULT = 0.75;
let counter = 0;
/* harmony default export */ var UiCollapseBoxvue_type_script_lang_js_ = ({
  name: 'UiCollapseBox',
  components: {
    UiCollapse: components_UiCollapse,
    UiTooltip: components_UiTooltip,
    UiIcon: components_UiIcon
  },
  inheritAttrs: false,
  model: {
    prop: 'expanded',
    event: TOGGLE_EVENT_NAME
  },
  props: {
    /**
     * Должен быть уникальным как минимум в рамках группы
     */
    id: {
      type: String,
      default: () => 'ui-collapse-box-' + ++counter
    },
    expanded: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: true
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    toggleable: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledText: {
      type: String,
      default: ''
    },
    tooltipMaxWidth: {
      type: [Number, String],
      default: null
    },
    color: {
      type: String,
      default: enum_colors.BLUE
    },
    iconName: {
      type: String,
      default: ''
    },
    iconSize: {
      type: String,
      validator: size => Object.values(UiCollapseBox_enum_sizes).includes(size),
      default: UiCollapseBox_enum_sizes.SM
    },
    bordered: {
      type: Boolean,
      default: false
    },
    ellipsisTitle: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: null
    },
    transitionDuration: {
      type: [Number, String],
      default: TRANSITION_DURATION_DEFAULT
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isVisibleTooltip: false,
      internals: {
        expanded: this.expanded
      }
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['box']]: true,
        [this.$style['box_active']]: this.internals.expanded && !this.disabled,
        [this.$style['box_bordered']]: this.bordered,
        [this.$style['box_shadows']]: !this.bordered,
        [this.$style[`box_with-icon-${this.iconSize}`]]: this.hasIcon,
        [this.$style[`box_color_${this.color}`]]: !!this.color,
        [this.$style['box_disabled']]: this.disabled
      };
    },

    hasIcon() {
      return this.iconName.length > 0 || !!this.$slots.icon;
    },

    transitionDurationComputed() {
      const duration = this.transitionDuration;
      const isNumber = typeof duration === 'number';
      return isNumber ? duration : parseFloat(duration);
    }

  },
  inject: {
    __UiCollapseGroup_register: {
      default: () => () => {}
    },
    __UiCollapseGroup_unregister: {
      default: () => () => {}
    },
    __UiCollapseGroup_expand: {
      default: null
    },
    __UiCollapseGroup_collapse: {
      default: null
    }
  },
  watch: {
    expanded() {
      if (this.expanded) {
        this.expand();
      } else {
        this.collapse();
      }
    }

  },

  mounted() {
    this.__UiCollapseGroup_register(this.id, this);
  },

  beforeDestroy() {
    this.__UiCollapseGroup_unregister(this.id);
  },

  methods: {
    toggle(expanded = undefined) {
      if (expanded === undefined ? !this.internals.expanded : expanded) {
        this.expand();
      } else {
        this.collapse();
      }
    },

    expand() {
      if (!this.expandable) {
        this.$emit(EXPAND_CANCEL_EVENT_NAME);
        return;
      }

      if (this.__UiCollapseGroup_expand) {
        this.__UiCollapseGroup_expand(this.id);
      } else {
        this.toggleInternalAndEmit(true);
      }
    },

    collapse() {
      if (!this.collapsible) {
        this.$emit(COLLAPSE_CANCEL_EVENT_NAME);
        return;
      }

      if (this.__UiCollapseGroup_collapse) {
        this.__UiCollapseGroup_collapse(this.id);
      } else {
        this.toggleInternalAndEmit(false);
      }
    },

    /**
     * @internal
     * @param {Event} event
     * @return {void}
     */
    onHeadClick(event) {
      const targetIsHead = !!event.target.closest(`.${this.$style['box__row_head']}`);
      const toggleable = this.toggleable && targetIsHead;

      if (this.expandable && !this.internals.expanded && targetIsHead) {
        this.expand();
        return;
      }

      if (!toggleable) {
        return;
      }

      if (this.internals.expanded) {
        this.collapse();
      }
    },

    /**
     * @internal
     * @return {boolean}
     */
    toggleInternalAndEmit(expanded = undefined) {
      this.$emit(TOGGLE_EVENT_NAME, this.toggleInternal(expanded));
    },

    /**
     * @internal
     * @return {boolean}
     */
    toggleInternal(expanded = undefined) {
      this.internals.expanded = expanded === undefined ? !this.internals.expanded : expanded;
      return this.internals.expanded;
    },

    /**
     * @internal
     * @return {boolean}
     */
    canNotBeExpanded() {
      return !this.internals.expanded && !this.expandable;
    },

    /**
     * @internal
     * @return {boolean}
     */
    canNotBeCollapsed() {
      return this.internals.expanded && !this.collapsible;
    },

    /**
     * @internal
     */
    eventEmitter(eventName, payload) {
      this.$emit(eventName, payload);
    },

    toggleDisabledTooltip(show) {
      if (!this.disabledText) {
        return;
      }

      this.isVisibleTooltip = show;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseBox_UiCollapseBoxvue_type_script_lang_js_ = (UiCollapseBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapseBox/UiCollapseBox.vue?vue&type=style&index=0&lang=less&module=true&
var UiCollapseBoxvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("5d5f");

// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseBox.vue








function UiCollapseBox_injectStyles (context) {
  
  this["$style"] = (UiCollapseBoxvue_type_style_index_0_lang_less_module_true_["default"].locals || UiCollapseBoxvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiCollapseBox_component = normalizeComponent(
  UiCollapseBox_UiCollapseBoxvue_type_script_lang_js_,
  UiCollapseBoxvue_type_template_id_99dfa488_render,
  UiCollapseBoxvue_type_template_id_99dfa488_staticRenderFns,
  false,
  UiCollapseBox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCollapseBox = (UiCollapseBox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseBox/UiCollapseGroup.vue?vue&type=template&id=b00ba45a&
var UiCollapseGroupvue_type_template_id_b00ba45a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default")],2)}
var UiCollapseGroupvue_type_template_id_b00ba45a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseGroup.vue?vue&type=template&id=b00ba45a&

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseBox/UiCollapseGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//


const COMPONENT_ALREADY_REGISTERED = (prefix, id) => {
  return `[${prefix}] Component with id ${id} already registered. Unregister it before using again.`;
};

const EXPANDED_EVENT_NAME = 'ui::collapse-group::expanded'; // Будет выдано родительскому компоненту также в случае неудачной попытки
// синхронизации состояния activeBoxId, если переключение на указанную секцию невозможно произвести.
// Например, если одна из секций раскрыта, а её сворачивание отключено через флаг collapsible.

const EXPAND_CANCELLED_EVENT_NAME = 'ui::collapse-group::expand-cancelled';
/* harmony default export */ var UiCollapseGroupvue_type_script_lang_js_ = ({
  name: 'UiCollapseGroup',
  model: {
    prop: 'activeBoxId',
    event: EXPANDED_EVENT_NAME
  },
  props: {
    /**
     * Переключает группу на бокс с указанным id (или закрывает все если null или такого id нет).
     * Если не менять значение, то будет использован только для инициализации начального состояния.
     */
    activeBoxId: {
      validator: activeBoxId => activeBoxId === null || typeof activeBoxId === 'string',
      default: null
    }
  },

  provide() {
    return {
      __UiCollapseGroup_register: this.registerBox,
      __UiCollapseGroup_unregister: this.unregisterBox,
      __UiCollapseGroup_expand: this.expandBox,
      __UiCollapseGroup_collapse: this.collapseBox
    };
  },

  data() {
    return {
      internals: {
        activeBoxId: this.activeBoxId
      }
    };
  },

  watch: {
    activeBoxId: {
      immediate: true,

      handler() {
        if (this.activeBoxId !== this.internals.activeBoxId) {
          this.expandBox(this.activeBoxId);
        }
      }

    }
  },

  beforeCreate() {
    this.registry = new Map();
  },

  mounted() {
    // Компенсация асинхронной отрисовки слотов
    external_commonjs_vue_commonjs2_vue_root_Vue_default.a.nextTick(() => {
      this.toggleAllBoxes(this.internals.activeBoxId);
    });
  },

  methods: {
    /**
     * @internal
     * @param {string} id
     * @param vm
     */
    registerBox(id, vm) {
      if (this.registry.has(id)) {
        throw new Error(COMPONENT_ALREADY_REGISTERED(this.$options.name, id));
      }

      this.registry.set(id, vm);

      if (vm.expanded) {
        this.expandBox(id, true);
      }
    },

    /**
     * @internal
     * @param {string} id
     */
    unregisterBox(id) {
      this.registry.delete(id);
    },

    expandBox(id, isExpanded) {
      if (!isExpanded && this.canNotToggle(id)) {
        this.$emit(EXPAND_CANCELLED_EVENT_NAME, {
          tried: id,
          actual: this.internals.activeBoxId,
          boxEventEmitter: this.boxEventEmitter
        });
        return;
      }

      this.toggleAllBoxesAndEmitForEachOne(id);
      this.updateActiveBoxId(this.registry.has(id) ? id : null);
    },

    collapseBox(id) {
      if (this.registry.has(id)) {
        const vm = this.registry.get(id);

        if (!vm.canNotBeCollapsed()) {
          vm.toggleInternalAndEmit(false);

          if (this.internals.activeBoxId === id) {
            this.updateActiveBoxId(null);
          }
        } else {
          this.$emit(EXPAND_CANCELLED_EVENT_NAME, {
            tried: null,
            actual: id,
            boxEventEmitter: this.boxEventEmitter
          });
        }
      }
    },

    /**
     * external
     */
    collapseActiveBox() {
      this.collapseBox(this.internals.activeBoxId);
    },

    canNotToggle(idToTry) {
      const canNotBeToggled = vm => vm.canNotBeCollapsed() || vm.id === idToTry && vm.canNotBeExpanded();

      return [...this.registry.values()].some(canNotBeToggled);
    },

    /**
     * @internal
     * @param {string} id
     */
    toggleAllBoxesAndEmitForEachOne(id) {
      this.registry.forEach((vm, _id) => {
        const expanded = _id === id;

        if (expanded !== vm.internals.expanded) {
          vm.toggleInternalAndEmit(expanded);
        }
      });
    },

    /**
     * @internal
     * @param {string} id
     */
    toggleAllBoxes(id) {
      this.registry.forEach((vm, _id) => {
        const expanded = _id === id;
        vm.toggleInternal(expanded);
      });
    },

    /**
     * @internal
     * @param {string} id
     */
    updateActiveBoxId(id) {
      this.internals.activeBoxId = id;
      this.$emit(EXPANDED_EVENT_NAME, id);
    },

    /**
     * @param {string} id
     * @param {string} eventName
     * @param {*} data
     * @return {boolean}
     */
    boxEventEmitter(id, eventName, data) {
      if (!id || !this.registry.has(id) || !eventName) {
        return false;
      }

      const vm = this.registry.get(id);
      vm.eventEmitter(eventName, data);
      return true;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseBox_UiCollapseGroupvue_type_script_lang_js_ = (UiCollapseGroupvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiCollapseBox/UiCollapseGroup.vue





/* normalize component */

var UiCollapseGroup_component = normalizeComponent(
  UiCollapseBox_UiCollapseGroupvue_type_script_lang_js_,
  UiCollapseGroupvue_type_template_id_b00ba45a_render,
  UiCollapseGroupvue_type_template_id_b00ba45a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiCollapseGroup = (UiCollapseGroup_component.exports);
// CONCATENATED MODULE: ./src/components/UiCollapseBox/index.js



/* harmony default export */ var components_UiCollapseBox = (UiCollapseBox);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiCollapseMenu.vue?vue&type=template&id=6015c1ac&
var UiCollapseMenuvue_type_template_id_6015c1ac_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        _vm.$style['menu'], ( _obj = {}, _obj[_vm.$style['menu_opened']] = _vm.isOpen, _obj[_vm.$style['menu_active']] = _vm.activeState, _obj )
    ]},[_c('div',{class:_vm.$style['menu__group']},[_c('div',{class:_vm.$style['menu__trigger']},[_vm._t("trigger")],2),_c('UiCollapse',{class:_vm.$style['menu__collapse'],attrs:{"open":_vm.isOpen}},[_c('div',[_vm._t("collapse")],2)])],1)])}
var UiCollapseMenuvue_type_template_id_6015c1ac_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenu.vue?vue&type=template&id=6015c1ac&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiCollapseMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiCollapseMenuvue_type_script_lang_js_ = ({
  name: 'UiCollapseMenu',
  components: {
    UiCollapse: components_UiCollapse
  },

  provide() {
    return {
      submenu_register: this.registerSubmenu,
      submenu_unregister: this.unregisterSubmenu,
      trigger_register: this.triggerRegister
    };
  },

  inject: {
    menu_register: {
      default: null
    },
    menu_unregister: {
      default: null
    }
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: this.open,
      isActive: this.active,
      id: this._uid
    };
  },

  computed: {
    activeState() {
      return this.menu_register ? this.isActive : this.active;
    }

  },
  watch: {
    isActive: function (newVal) {
      if (!newVal) {
        this.submenuRegistry.forEach(value => {
          value.isActive = newVal;
        });
      }

      if (this.trigger) {
        this.trigger.isActive = newVal;
      }
    }
  },

  beforeCreate() {
    this.submenuRegistry = new Map();
    this.trigger = {};
  },

  mounted() {
    if (this.menu_register) {
      this.menu_register(this.id, this);
    }
  },

  beforeDestroy() {
    if (this.menu_unregister) {
      this.menu_unregister(this.id);
    }

    this.trigger = null;
  },

  methods: {
    triggerRegister(vm) {
      this.trigger = vm;
      this.trigger.$on('collapse-menu', isOpen => {
        this.isOpen = isOpen;
      });
      this.trigger.$on('activate-item', () => this.activateMenu());
    },

    registerSubmenu(id, vm) {
      if (!this.submenuRegistry.has(id)) {
        this.submenuRegistry.set(id, vm);
        vm.$on('activate-submenu', id => this.activateSubmenuItem(id));
      }
    },

    unregisterSubmenu(id) {
      this.submenuRegistry.delete(id);
    },

    activateMenu() {
      this.activateSubmenuItem(this.submenuRegistry.values().next().value._uid);
    },

    activateSubmenuItem(id) {
      this.isActive = this.isOpen = true;
      this.submenuRegistry.forEach(value => {
        value.isActive = value._uid === id;
      });
      this.$emit('activate-item', this.id);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseMenu_UiCollapseMenuvue_type_script_lang_js_ = (UiCollapseMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapseMenu/UiCollapseMenu.vue?vue&type=style&index=0&module=true&lang=less&
var UiCollapseMenuvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("49c4");

// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenu.vue








function UiCollapseMenu_injectStyles (context) {
  
  this["$style"] = (UiCollapseMenuvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCollapseMenuvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCollapseMenu_component = normalizeComponent(
  UiCollapseMenu_UiCollapseMenuvue_type_script_lang_js_,
  UiCollapseMenuvue_type_template_id_6015c1ac_render,
  UiCollapseMenuvue_type_template_id_6015c1ac_staticRenderFns,
  false,
  UiCollapseMenu_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCollapseMenu = (UiCollapseMenu_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue?vue&type=template&id=f3125c24&
var UiCollapseMenuGroupvue_type_template_id_f3125c24_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['menu']},[_vm._t("default")],2)}
var UiCollapseMenuGroupvue_type_template_id_f3125c24_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue?vue&type=template&id=f3125c24&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var UiCollapseMenuGroupvue_type_script_lang_js_ = ({
  name: 'UiCollapseMenuGroup',

  provide() {
    return {
      menu_register: this.registerMenu,
      menu_unregister: this.unregisterMenu
    };
  },

  beforeCreate() {
    this.registry = new Map();
  },

  methods: {
    activateItem(id) {
      this.registry.forEach((value, key) => {
        value.isActive = key === id;
      });
    },

    registerMenu(id, vm) {
      if (!this.registry.has(id)) {
        this.registry.set(id, vm);
        vm.$on('activate-item', id => this.activateItem(id));
      }
    },

    unregisterMenu(id) {
      this.registry.delete(id);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseMenu_UiCollapseMenuGroupvue_type_script_lang_js_ = (UiCollapseMenuGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue?vue&type=style&index=0&module=true&lang=less&
var UiCollapseMenuGroupvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("531a");

// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiCollapseMenuGroup.vue








function UiCollapseMenuGroup_injectStyles (context) {
  
  this["$style"] = (UiCollapseMenuGroupvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCollapseMenuGroupvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCollapseMenuGroup_component = normalizeComponent(
  UiCollapseMenu_UiCollapseMenuGroupvue_type_script_lang_js_,
  UiCollapseMenuGroupvue_type_template_id_f3125c24_render,
  UiCollapseMenuGroupvue_type_template_id_f3125c24_staticRenderFns,
  false,
  UiCollapseMenuGroup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCollapseMenuGroup = (UiCollapseMenuGroup_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiMenuBtn.vue?vue&type=template&id=71aec8a1&
var UiMenuBtnvue_type_template_id_71aec8a1_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes,on:{"click":_vm.activateMenu}},_vm.$listeners),[_c(_vm.tag,{tag:"component",class:_vm.$style['menu-btn__inner'],attrs:{"href":_vm.href}},[(_vm.icon)?_c('div',{class:_vm.$style['menu-btn__icon']},[_c('UiIcon',{class:_vm.$style['menu-btn__image'],attrs:{"name":_vm.icon}})],1):_vm._e(),_c('div',{class:_vm.$style['menu-btn__label']},[_vm._t("default")],2)]),(_vm.collapse)?_c('div',{class:[
            _vm.$style['menu-btn__icon'],
            _vm.$style['menu-btn__icon-collapse']
        ],on:{"click":function($event){$event.stopPropagation();return _vm.collapseMenu.apply(null, arguments)}}},[_c('UiIcon',{class:_vm.$style['menu-btn__image'],attrs:{"name":"caretDown"}})],1):_vm._e()],1)}
var UiMenuBtnvue_type_template_id_71aec8a1_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiMenuBtn.vue?vue&type=template&id=71aec8a1&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiMenuBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiMenuBtnvue_type_script_lang_js_ = ({
  name: 'UiMenuBtn',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    },

    /**
     * Если требуется сделать ссылку
    */
    href: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isOpen: this.open,
      isActive: this.active,
      id: this._uid
    };
  },

  inject: {
    menu_register: {
      default: null
    },
    menu_unregister: {
      default: null
    },
    trigger_register: {
      default: null
    }
  },
  computed: {
    classes() {
      return [this.$style['menu-btn'], {
        [this.$style['menu-btn_active']]: this.activeState,
        [this.$style['menu-btn_opened']]: this.collapse && this.isOpen
      }];
    },

    tag() {
      return this.href ? 'a' : 'div';
    },

    activeState() {
      return this.menu_register ? this.isActive : this.active;
    }

  },

  mounted() {
    if (this.menu_register && !this.collapse) {
      this.menu_register(this.id, this);
    }

    if (this.trigger_register) {
      this.trigger_register(this);
    }
  },

  beforeDestroy() {
    if (this.menu_unregister && !this.collapse) {
      this.menu_unregister(this.id);
    }
  },

  methods: {
    activateMenu() {
      this.isActive = true;

      if (this.collapse) {
        this.isOpen = true;
      }

      this.$emit('activate-item', this.id);
    },

    collapseMenu() {
      this.isOpen = !this.isOpen;
      this.$emit('collapse-menu', this.isOpen);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiMenuBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseMenu_UiMenuBtnvue_type_script_lang_js_ = (UiMenuBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapseMenu/UiMenuBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiMenuBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("2a45");

// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiMenuBtn.vue








function UiMenuBtn_injectStyles (context) {
  
  this["$style"] = (UiMenuBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiMenuBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiMenuBtn_component = normalizeComponent(
  UiCollapseMenu_UiMenuBtnvue_type_script_lang_js_,
  UiMenuBtnvue_type_template_id_71aec8a1_render,
  UiMenuBtnvue_type_template_id_71aec8a1_staticRenderFns,
  false,
  UiMenuBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiMenuBtn = (UiMenuBtn_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiSubmenuBtn.vue?vue&type=template&id=e1e089c4&
var UiSubmenuBtnvue_type_template_id_e1e089c4_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({tag:"component",class:( _obj = {}, _obj[_vm.$style['submenu-btn']] = true, _obj[_vm.$style['submenu-btn_active']] = _vm.activeState, _obj ),attrs:{"href":_vm.href},on:{"click":function($event){return _vm.$emit('activate-submenu', _vm._uid)}}},_vm.$listeners),[_vm._t("default")],2)}
var UiSubmenuBtnvue_type_template_id_e1e089c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiSubmenuBtn.vue?vue&type=template&id=e1e089c4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCollapseMenu/UiSubmenuBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiSubmenuBtnvue_type_script_lang_js_ = ({
  name: 'UiSubmenuBtn',
  props: {
    active: {
      type: Boolean,
      default: false
    },

    /**
     * Если требуется сделать ссылку
    */
    href: {
      type: String,
      default: null
    }
  },
  inject: {
    submenu_register: {
      default: null
    },
    submenu_unregister: {
      default: null
    }
  },

  data() {
    return {
      isActive: this.active
    };
  },

  computed: {
    tag() {
      return this.href ? 'a' : 'div';
    },

    activeState() {
      return this.submenu_register ? this.isActive : this.active;
    }

  },

  mounted() {
    if (this.submenu_register) {
      this.submenu_register(this._uid, this);
    }
  },

  beforeDestroy() {
    if (this.submenu_unregister) {
      this.submenu_unregister(this._uid);
    }
  }

});
// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiSubmenuBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCollapseMenu_UiSubmenuBtnvue_type_script_lang_js_ = (UiSubmenuBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCollapseMenu/UiSubmenuBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiSubmenuBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("23e8");

// CONCATENATED MODULE: ./src/components/UiCollapseMenu/UiSubmenuBtn.vue








function UiSubmenuBtn_injectStyles (context) {
  
  this["$style"] = (UiSubmenuBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiSubmenuBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiSubmenuBtn_component = normalizeComponent(
  UiCollapseMenu_UiSubmenuBtnvue_type_script_lang_js_,
  UiSubmenuBtnvue_type_template_id_e1e089c4_render,
  UiSubmenuBtnvue_type_template_id_e1e089c4_staticRenderFns,
  false,
  UiSubmenuBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiSubmenuBtn = (UiSubmenuBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiCollapseMenu/index.js





// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiContentBox/UiContentBox.vue?vue&type=template&id=5f977a70&
var UiContentBoxvue_type_template_id_5f977a70_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['content-box']},_vm.$listeners),[_vm._t("default")],2)}
var UiContentBoxvue_type_template_id_5f977a70_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiContentBox/UiContentBox.vue?vue&type=template&id=5f977a70&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiContentBox/UiContentBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var UiContentBoxvue_type_script_lang_js_ = ({
  name: 'UiContentBox',
  mixins: [deprecated_message]
});
// CONCATENATED MODULE: ./src/components/UiContentBox/UiContentBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiContentBox_UiContentBoxvue_type_script_lang_js_ = (UiContentBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiContentBox/UiContentBox.vue?vue&type=style&index=0&module=true&lang=less&
var UiContentBoxvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("207d");

// CONCATENATED MODULE: ./src/components/UiContentBox/UiContentBox.vue








function UiContentBox_injectStyles (context) {
  
  this["$style"] = (UiContentBoxvue_type_style_index_0_module_true_lang_less_["default"].locals || UiContentBoxvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiContentBox_component = normalizeComponent(
  UiContentBox_UiContentBoxvue_type_script_lang_js_,
  UiContentBoxvue_type_template_id_5f977a70_render,
  UiContentBoxvue_type_template_id_5f977a70_staticRenderFns,
  false,
  UiContentBox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiContentBox = (UiContentBox_component.exports);
// CONCATENATED MODULE: ./src/components/UiContentBox/index.js

/* harmony default export */ var components_UiContentBox = (UiContentBox);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCopyBtn/UiCopyBtn.vue?vue&type=template&id=5dbbce11&
var UiCopyBtnvue_type_template_id_5dbbce11_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['btn-wrap'],on:{"mouseenter":function($event){return _vm.toggleCopyTooltip(true)},"mouseleave":function($event){return _vm.toggleCopyTooltip(false)},"click":function($event){return _vm.copy()}}},[_c('UiTooltip',{attrs:{"placement":_vm.placement,"container":_vm.container,"trigger":"manual","dark":"","inline":""},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("copyTrigger",function(){return [_c('UiButton',{attrs:{"size":_vm.buttonSize,"variant":"tertiary","shape":"square"}},[_c('UiIcon',{attrs:{"name":"copy"}})],1)]})]},proxy:true}],null,true),model:{value:(_vm.copyTooltip),callback:function ($$v) {_vm.copyTooltip=$$v},expression:"copyTooltip"}},[_c('div',{class:_vm.$style['tooltip']},[(_vm.isCopy)?_c('div',{class:_vm.$style['tooltip__inline']},[_c('div',{class:_vm.$style['tooltip__icon']},[_c('UiIcon',{attrs:{"name":"checkmarkCircleOutlined"}})],1),_c('div',{class:_vm.$style['tooltip__txt']},[_vm._v(" "+_vm._s(_vm.copiedTooltipText)+" ")])]):_c('div',{class:_vm.$style['tooltip__inline']},[_vm._v(" "+_vm._s(_vm.copyTooltipText)+" ")])])]),(!_vm.isClipboard)?_c('input',{ref:"copy-area",class:_vm.$style['copy-area'],attrs:{"type":"text"},domProps:{"value":_vm.copyText}}):_vm._e()],1)}
var UiCopyBtnvue_type_template_id_5dbbce11_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiCopyBtn/UiCopyBtn.vue?vue&type=template&id=5dbbce11&

// CONCATENATED MODULE: ./src/components/UiCopyBtn/enum/sizes.js
/* harmony default export */ var UiCopyBtn_enum_sizes = ({
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiCopyBtn/UiCopyBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UiCopyBtnvue_type_script_lang_js_ = ({
  name: 'UiCopyBtn',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip
  },
  props: {
    /**
     * Размер кнопки
     */
    buttonSize: {
      type: String,
      default: UiCopyBtn_enum_sizes.XS
    },

    /**
     * Скопированный текст
     */
    copyText: {
      type: String,
      required: true
    },

    /**
     * Текст при наведении
     */
    copyTooltipText: {
      type: String,
      required: true
    },

    /**
     * Текст после копирования
     */
    copiedTooltipText: {
      type: String,
      required: true
    },

    /**
     * Определяет позиционирование
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.BOTTOM
    },

    /**
     * Селектор для контейнера тултипа
     */
    container: {
      type: String,
      default: 'body'
    }
  },

  data() {
    return {
      isCopy: false,
      copyTooltip: false,
      isClipboard: false
    };
  },

  mounted() {
    this.isClipboard = navigator.clipboard && navigator.clipboard.writeText;
  },

  methods: {
    copy() {
      if (this.isClipboard) {
        navigator.clipboard.writeText(this.copyText).then(() => {
          this.isCopy = true;
        }).catch(err => {
          console.error('Copy error:', err);
        });
      } else {
        this.$refs['copy-area'].focus();
        this.$refs['copy-area'].select();

        try {
          this.isCopy = document.execCommand('copy');
        } catch (err) {
          console.error('Copy error:', err);
        }
      }
    },

    toggleCopyTooltip(show) {
      this.copyTooltip = show;

      if (this._copyTimer) {
        clearTimeout(this._copyTimer);
        this._copyTimer = null;
      }

      if (!show) {
        this._copyTimer = setTimeout(() => {
          this.isCopy = false;
        }, 200);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiCopyBtn/UiCopyBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiCopyBtn_UiCopyBtnvue_type_script_lang_js_ = (UiCopyBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiCopyBtn/UiCopyBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiCopyBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("5239");

// CONCATENATED MODULE: ./src/components/UiCopyBtn/UiCopyBtn.vue








function UiCopyBtn_injectStyles (context) {
  
  this["$style"] = (UiCopyBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiCopyBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiCopyBtn_component = normalizeComponent(
  UiCopyBtn_UiCopyBtnvue_type_script_lang_js_,
  UiCopyBtnvue_type_template_id_5dbbce11_render,
  UiCopyBtnvue_type_template_id_5dbbce11_staticRenderFns,
  false,
  UiCopyBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiCopyBtn = (UiCopyBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiCopyBtn/index.js

/* harmony default export */ var components_UiCopyBtn = (UiCopyBtn);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDatepicker/UiDatepicker.vue?vue&type=template&id=2fd9ab7e&
var UiDatepickervue_type_template_id_2fd9ab7e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['datepicker']},[_c('v-popover',{attrs:{"open":_vm.isOpen,"open-class":_vm.$style['open'],"popover-base-class":[_vm.$style['datepicker__content'], _vm.baseClass],"container":_vm.container,"placement":_vm.placement,"popper-options":_vm.popperOptions,"offset":"4","trigger":"manual","auto-hide":""},on:{"auto-hide":_vm.closeMenu}},[_c('div',{class:_vm.$style['datepicker-trigger'],on:{"click":_vm.openMenu}},[(_vm.hasTrigger)?_c('div',[_vm._t("trigger")],2):_c('UiInput',{attrs:{"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"value":_vm.outputFormatDate,"placeholder":_vm.placeholder,"active":_vm.isOpen,"readonly":_vm.readonly,"disabled":_vm.disabled,"variant":_vm.inputVariant,"left-icon-class":"ui-icon-gray","right-icon-class":"ui-icon-gray","icon-left-state-fill":"","icon-right-state-fill":""}})],1),_c('template',{slot:"popover"},[_c('div',[_c('div',{class:_vm.$style['datepicker__content-inner']},[_c('UiCalendar',{ref:"calendar",class:_vm.$style['ui-kit-datepicker'],attrs:{"value":_vm.selectedToDate,"locale":_vm.locale,"first-day-of-week":_vm.firstDayOfWeek,"min-date":_vm.minToDate,"max-date":_vm.maxToDate,"toggle-selected-day":_vm.toggleSelectedDay},on:{"ui::calendar::change":_vm.selectDate}}),(_vm.timepicker)?_c('div',{class:_vm.$style['timepicker']},[_c('div',{class:_vm.$style['timepicker__label']},[_vm._v(" "+_vm._s(_vm.timepickerLabel)+" "),(_vm.timepickerTooltipText)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.handleClickOutside),expression:"handleClickOutside"}],class:_vm.$style['timepicker__tooltip'],on:{"click":_vm.toggleTooltip}},[_c('UiTooltip',{attrs:{"tooltip-body-class":_vm.$style['timepicker__tooltip-content'],"show":_vm.isTooltipOpen,"icon":"help","placement":"top","icon-size":"sm","dark":"","center-text":"","trigger":"manual"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.timepickerTooltipText)},on:{"click":_vm.toggleTooltip}})])],1):_vm._e()]),_c('UiTimeBox',{class:_vm.$style['timepicker__field'],attrs:{"icon-left":null,"right-icon-class":_vm.$style['timepicker__icon'],"icon-right":"timeIcon","placeholder":"00:00"},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1):_vm._e(),_c('div',{class:_vm.$style['datepicker__footer']},[_c('UiButton',{class:_vm.$style['datepicker__button'],attrs:{"variant":"tertiary","data-test-id":"reset-btn"},on:{"click":_vm.resetDate}},[_vm._v(" "+_vm._s(_vm.text.clear)+" ")]),_c('UiButton',{class:_vm.$style['datepicker__button'],attrs:{"data-test-id":"apply-btn"},on:{"click":function($event){return _vm.setDate(true)}}},[_vm._v(" "+_vm._s(_vm.text.apply)+" ")])],1)],1)])])],2)],1)}
var UiDatepickervue_type_template_id_2fd9ab7e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDatepicker/UiDatepicker.vue?vue&type=template&id=2fd9ab7e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInput/UiInput.vue?vue&type=template&id=9852ef66&
var UiInputvue_type_template_id_9852ef66_render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c('div',{ref:"wrap",class:_vm.classes,on:{"click":_vm.setAreaFocus}},[((_vm.$slots.iconLeft || _vm.iconLeft) && !_vm.hasPrefix)?_c('div',{class:( _obj = {}, _obj[_vm.$style['input__icon']] = true, _obj[_vm.$style['input__icon_left']] = true, _obj[_vm.$style['input__icon_state-fill']] = _vm.iconLeftStateFill, _obj )},[_vm._t("iconLeft",function(){return [_c('UiIcon',{class:_vm.leftIconClass,attrs:{"name":_vm.iconLeft}})]})],2):_vm._e(),(_vm.hasPrefix)?_c('div',{class:_vm.$style['input__prefix']},[_vm._t("prefix",function(){return [_vm._v(" "+_vm._s(_vm.prefix)+" ")]})],2):_vm._e(),_c('input',{ref:"inputArea",class:_vm.$style['input__area'],attrs:{"id":_vm.id,"type":!_vm.formattedNumber ? _vm.type : 'tel',"disabled":_vm.disabled,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"required":_vm.required,"name":_vm.name,"min":_vm.isNumberType ? _vm.minNumber : null,"max":_vm.isNumberType ? _vm.maxNumber : null,"maxlength":_vm.maxLength,"step":_vm.isNumberType && _vm.step ? _vm.step : null,"inputmode":_vm.inputmode,"pattern":_vm.pattern,"autocomplete":"off"},domProps:{"value":_vm.getValue},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput,"keydown":_vm.onKeyDown,"change":function($event){return _vm.$emit('change', $event.target.value)},"paste":function($event){return _vm.$emit('paste', $event)}}}),(_vm.clearable)?_c('div',{class:( _obj$1 = {}, _obj$1[_vm.$style['input__btn-clear']] = true, _obj$1[_vm.$style['input__btn-clear_disabled']] = _vm.disabled, _obj$1 ),on:{"click":_vm.clear}},[_c('UiTransition',{attrs:{"name":"fade-3"}},[_c('UiIcon',{directives:[{name:"show",rawName:"v-show",value:(!!_vm.value),expression:"!!value"}],class:_vm.$style['input__icon-btn-clear'],attrs:{"name":"clearCircle","btn":!_vm.disabled}})],1)],1):_vm._e(),(_vm.emoji)?_c('div',[_c('UiEmoji',{on:{"insert-emoji":_vm.onEmojiInput}})],1):_vm._e(),(_vm.loading)?_c('div',{class:_vm.$style['input__icon']},[_c('UiIcon',{class:_vm.$style['input__icon_loading'],attrs:{"name":"circleLoading"}})],1):(_vm.$slots.iconRight || _vm.iconRight)?_c('div',{class:( _obj$2 = {}, _obj$2[_vm.$style['input__icon']] = true, _obj$2[_vm.$style['input__icon_right']] = true, _obj$2[_vm.$style['input__icon_state-fill']] = _vm.iconRightStateFill, _obj$2 )},[_vm._t("iconRight",function(){return [_c('UiIcon',{class:_vm.rightIconClass,attrs:{"name":_vm.iconRight}})]})],2):_vm._e()]),(!_vm.isInputTooSmall && !_vm.isFocus && _vm.isDefault)?[_c('div',{class:_vm.$style['input__error-wrap']},_vm._l((_vm.errorList),function(err,i){
            var _obj;
return _c('div',{key:("error-" + _vm.id + "-" + i),class:( _obj = {}, _obj[_vm.$style['input__error']] = true, _obj[_vm.$style['input__error_ellipsis']] = _vm.ellipsisErrorText, _obj[_vm.$style[("input__error_" + _vm.errorTextAlign)]] = true, _obj )},[_vm._v(" "+_vm._s(err)+" ")])}),0)]:(_vm.errorList.length && !_vm.isFocus)?_c('UiTooltip',{class:_vm.$style['input__error-tooltip'],attrs:{"dark":_vm.isInlineEdit ? !_vm.inversion : true,"show":true,"placement":_vm.errorTooltipPlacement,"container":_vm.errorTooltipContainer,"popover-base-class":_vm.errorTooltipClass,"trigger":"manual"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{attrs:{"data-stub":""}})]},proxy:true}])},_vm._l((_vm.errorList),function(err,i){return _c('div',{key:("error-" + _vm.id + "-" + i)},[_vm._v(" "+_vm._s(err)+" ")])}),0):_vm._e(),(_vm.variableWidth)?_c('div',{ref:"placeholder",class:_vm.$style['ui-input__fake-placeholder']},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")]):_vm._e()],2)}
var UiInputvue_type_template_id_9852ef66_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInput/UiInput.vue?vue&type=template&id=9852ef66&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmoji/UiEmoji.vue?vue&type=template&id=250b3792&
var UiEmojivue_type_template_id_250b3792_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['emojis']},[_c('v-popover',{attrs:{"open":_vm.isOpen,"placement":_vm.placement,"offset":_vm.offset,"popover-base-class":_vm.$style['emojis-popover-wrapper'],"open-class":_vm.$style['open'],"popper-options":_vm.internalPopperOptions,"trigger":"click"},on:{"auto-hide":function($event){_vm.isOpen = false}},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_c('UiScrollbar',{class:_vm.$style['emojis__popover']},_vm._l((_vm.emojis),function(emojiGroup,index){return _c('div',{key:("emoji-group-" + index),class:_vm.$style['emojis__group']},[(emojiGroup.emojis.length > 0)?_c('h3',{class:_vm.$style['emojis__title']},[_vm._v(" "+_vm._s(_vm.i18n[emojiGroup.name])+" ")]):_vm._e(),_c('ul',{class:_vm.$style['emojis-list']},_vm._l((emojiGroup.emojis),function(emoji,i){return _c('li',{key:("emoji-" + i),class:_vm.$style['emojis-list__item'],on:{"click":_vm.insertEmoji}},[_vm._v(" "+_vm._s(emoji)+" ")])}),0)])}),0)]},proxy:true}])},[_vm._t("trigger",function(){
var _obj;
return [_c('div',{class:_vm.$style['emojis__button-wrapper']},[_c('button',{class:( _obj = {}, _obj[_vm.$style['emojis__button']] = true, _obj[_vm.$style['emojis__button_active']] = _vm.isOpen, _obj ),attrs:{"type":"button"},on:{"click":_vm.toggleEmojiModal}},[_c('UiIcon',{attrs:{"name":"slightlySmilling"}})],1)])]})],2)],1)}
var UiEmojivue_type_template_id_250b3792_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiEmoji/UiEmoji.vue?vue&type=template&id=250b3792&

// EXTERNAL MODULE: ./src/components/UiEmoji/emoji/emojis.json
var emojis = __webpack_require__("f37d");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiScrollbar/UiScrollbar.vue?vue&type=template&id=d29ff3c4&
var UiScrollbarvue_type_template_id_d29ff3c4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMac && !_vm.showOnMac)?_c('div',_vm._g({staticClass:"scroll-box",on:{"scroll":_vm.onScroll}},_vm.$listeners),[_vm._t("default")],2):_c('PerfectScrollbar',_vm._g(_vm._b({ref:"perfectScrollbar",class:{'ps_visible-on-hover': _vm.showOnHover}},'PerfectScrollbar',Object.assign({}, _vm.$props, _vm.$attrs),false),_vm.$listeners),[_vm._t("default")],2)}
var UiScrollbarvue_type_template_id_d29ff3c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiScrollbar/UiScrollbar.vue?vue&type=template&id=d29ff3c4&

// EXTERNAL MODULE: ./node_modules/vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.umd.js
var vue2_perfect_scrollbar_umd = __webpack_require__("a4a1");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiScrollbar/UiScrollbar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiScrollbarvue_type_script_lang_js_ = ({
  name: 'UiScrollbar',
  components: {
    PerfectScrollbar: vue2_perfect_scrollbar_umd["PerfectScrollbar"]
  },
  props: {
    showOnHover: {
      type: Boolean,
      default: false
    },

    /**
     * Показывать кастомный скролл даже на маках
     */
    showOnMac: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isMac() {
      return /Mac/i.test(navigator.userAgent);
    }

  },
  methods: {
    update() {
      if (this.$refs && this.$refs['perfectScrollbar']) {
        this.$refs['perfectScrollbar'].update();
      }
    },

    onScroll(e) {
      const tg = e.target;

      if (tg.scrollTop >= tg.scrollHeight - tg.clientHeight) {
        this.$emit('ps-y-reach-end', e);
      }

      if (tg.scrollTop <= 0) {
        this.$emit('ps-y-reach-start', e);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiScrollbar/UiScrollbar.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiScrollbar_UiScrollbarvue_type_script_lang_js_ = (UiScrollbarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiScrollbar/UiScrollbar.vue?vue&type=style&index=0&lang=less&
var UiScrollbarvue_type_style_index_0_lang_less_ = __webpack_require__("465b");

// CONCATENATED MODULE: ./src/components/UiScrollbar/UiScrollbar.vue






/* normalize component */

var UiScrollbar_component = normalizeComponent(
  UiScrollbar_UiScrollbarvue_type_script_lang_js_,
  UiScrollbarvue_type_template_id_d29ff3c4_render,
  UiScrollbarvue_type_template_id_d29ff3c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiScrollbar = (UiScrollbar_component.exports);
// CONCATENATED MODULE: ./src/components/UiScrollbar/index.js

/* harmony default export */ var components_UiScrollbar = (UiScrollbar);
// CONCATENATED MODULE: ./src/components/UiEmoji/enum/offset.js
/* harmony default export */ var enum_offset = ({
  XXS: 4,
  XS: 8,
  S: 16,
  M: 24,
  L: 32,
  XL: 40,
  XXL: 48
});
// CONCATENATED MODULE: ./src/components/UiEmoji/enum/placement.js
/* harmony default export */ var placement = ({
  AUTO: 'auto',
  'AUTO-START': 'auto-start',
  'AUTO-END': 'auto-end',
  TOP: 'top',
  'TOP-START': 'top-start',
  'TOP-END': 'top-end',
  RIGHT: 'right',
  'RIGHT-START': 'right-start',
  'RIGHT-END': 'right-end',
  BOTTOM: 'bottom',
  'BOTTOM-START': 'bottom-start',
  'BOTTOM-END': 'bottom-end',
  LEFT: 'left',
  'LEFT-START': 'left-start',
  'LEFT-END': 'left-end'
});
// CONCATENATED MODULE: ./src/components/UiEmoji/i18n/index.js
const i18n_LOCALES = {
  EN: 'en',
  ES: 'es',
  RU: 'ru'
};
/* harmony default export */ var UiEmoji_i18n = ({
  [i18n_LOCALES.EN]: {
    often: 'Frequently used',
    smileys: 'Emotions and people',
    animals: 'Animals and nature',
    food: 'Food and drink',
    activity: 'Activity',
    travel: 'Travel and places',
    objects: 'Objects',
    symbols: 'Symbols'
  },
  [i18n_LOCALES.ES]: {
    often: 'Más utilizados',
    smileys: 'Sentimientos y personas',
    animals: 'Animales y naturaleza',
    food: 'Comida y bebida',
    activity: 'Actividad',
    travel: 'Viajes y paisajes',
    objects: 'Objetos',
    symbols: 'Símbolos'
  },
  [i18n_LOCALES.RU]: {
    often: 'Часто используемые',
    smileys: 'Эмоции и людии',
    animals: 'Животные и природа',
    food: 'Еда и напитки',
    activity: 'Активность',
    travel: 'Путешествия и местности',
    objects: 'Предметы',
    symbols: 'Символы'
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiEmoji/UiEmoji.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UiEmojivue_type_script_lang_js_ = ({
  name: 'UiEmoji',
  components: {
    UiIcon: components_UiIcon,
    UiScrollbar: components_UiScrollbar
  },
  props: {
    placement: {
      type: [String],
      default: placement['BOTTOM-START']
    },
    offset: {
      type: [Number],
      default: enum_offset.XXS
    },
    lang: {
      type: [String],
      default: i18n_LOCALES.RU
    },

    /**
     * Позволяет передать модификатор
     * preventOverflow в popperOptions
     */
    isPreventOverflow: {
      type: Boolean,
      default: true
    },
    popperOptions: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      oftenUsedEmojis: {
        name: 'often',
        emojis: []
      },
      isOpen: false
    };
  },

  computed: {
    baseEmojis() {
      return emojis;
    },

    emojis() {
      return [this.oftenUsedEmojis, ...this.baseEmojis];
    },

    i18n() {
      return UiEmoji_i18n[this.lang];
    },

    internalPopperOptions() {
      if (this.popperOptions) {
        return this.popperOptions;
      }
      /**
       * По умолчанию, если тултип выходит за область просмотра,
       * он смещается, чтобы оставаться в ней.
       * Настройка отключает такое поведение
       */


      if (this.isPreventOverflow) {
        return {
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            }
          }
        };
      }

      return {};
    }

  },

  mounted() {
    this.setOftenUsedEmojis();
  },

  methods: {
    toggleEmojiModal() {
      this.isOpen = !this.isOpen;
    },

    insertEmoji(e) {
      var _e$target;

      const emoji = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.innerHTML.trim();
      this.$emit('insert-emoji', emoji);
      this.saveOftenUsedEmojis(emoji);
      this.isOpen = false;
    },

    getOftenUsedEmojis() {
      const oftenUsedEmojis = localStorage.getItem('oftenUsedEmojis');
      return (oftenUsedEmojis === null || oftenUsedEmojis === void 0 ? void 0 : oftenUsedEmojis.length) > 0 ? JSON.parse(oftenUsedEmojis) : [];
    },

    setOftenUsedEmojis() {
      this.oftenUsedEmojis.emojis = [...this.getOftenUsedEmojis()];
    },

    saveOftenUsedEmojis(emoji) {
      const emojis = this.getOftenUsedEmojis();
      let newEmojies = [];

      if (emojis.includes(emoji)) {
        newEmojies = [emoji, ...emojis.filter(e => e !== emoji)];
      } else {
        newEmojies = [emoji, ...emojis];
      }

      if (newEmojies.length > 14) {
        newEmojies = newEmojies.slice(0, 14);
      }

      localStorage.setItem('oftenUsedEmojis', JSON.stringify(newEmojies));
      this.setOftenUsedEmojis();
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiEmoji/UiEmoji.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiEmoji_UiEmojivue_type_script_lang_js_ = (UiEmojivue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiEmoji/UiEmoji.vue?vue&type=style&index=0&lang=less&module=true&
var UiEmojivue_type_style_index_0_lang_less_module_true_ = __webpack_require__("abde");

// CONCATENATED MODULE: ./src/components/UiEmoji/UiEmoji.vue








function UiEmoji_injectStyles (context) {
  
  this["$style"] = (UiEmojivue_type_style_index_0_lang_less_module_true_["default"].locals || UiEmojivue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiEmoji_component = normalizeComponent(
  UiEmoji_UiEmojivue_type_script_lang_js_,
  UiEmojivue_type_template_id_250b3792_render,
  UiEmojivue_type_template_id_250b3792_staticRenderFns,
  false,
  UiEmoji_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiEmoji = (UiEmoji_component.exports);
// CONCATENATED MODULE: ./src/components/UiEmoji/index.js

/* harmony default export */ var components_UiEmoji = (UiEmoji);
// CONCATENATED MODULE: ./src/utils/devices.js
/* harmony default export */ var devices = ({
  isAndriod() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
  },

  isDesktopSafari() {
    const uA = navigator.userAgent;
    const vendor = navigator.vendor;
    return /Safari/i.test(uA) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(uA);
  },

  isFirefox() {
    return navigator.userAgent.search(/Firefox/) > 0;
  }

});
// CONCATENATED MODULE: ./src/mixins/base-input.js

const ALLOW_NUMBER_CODES = [8, 46, 13, 37, 39];
const ALLOW_NUMBER_DELIMETERS = [',', '.'];
/* harmony default export */ var base_input = ({
  props: {
    /**
     * Текущее значение
     */
    value: {
      type: [String, Number],
      default: ''
    },

    /**
     * Атрибут name нативного инпута
     */
    name: {
      type: String,
      default: null
    },

    /**
     * Placeholder
     */
    placeholder: {
      type: String,
      default: ''
    },

    /**
     * Атрибут disabled нативного инпута
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Атрибут readonly нативного инпута
     */
    readonly: {
      type: Boolean,
      default: false
    },

    /**
     * Атрибут required нативного инпута
     */
    required: {
      type: Boolean,
      default: false
    },

    /**
     * Атрибут type нативного инпута
     */
    type: {
      type: String,
      default: 'text'
    },

    /**
     * Атрибут min нативного инпута type="number"
     */
    minNumber: {
      type: [String, Number],
      default: -Infinity
    },

    /**
     * Атрибут max нативного инпута type="number"
     */
    maxNumber: {
      type: [String, Number],
      default: Infinity
    },

    /**
     * Текст ошибки, выводимый при выходе значения
     * за пределы допустимого диапазона для input[type='number']
     */
    outOfRangeErrorText: {
      type: [String, Function],
      default: null
    },

    /**
     * Атрибут нативного инпута type="number"
     */
    step: {
      type: [String, Number],
      default: null
    },

    /**
     * Ошибки
     */
    error: {
      type: [Boolean, String, Array],
      default: false
    },

    /**
     * Позиционирование тултипа с ошибкой
     */
    errorTooltipPlacement: {
      type: String,
      default: 'right'
    },

    /**
     * Контейнер тултипа с ошибкой
     */
    errorTooltipContainer: {
      type: String,
      default: 'body'
    },

    /**
     * Класс тултипа с ошибкой
     */
    errorTooltipClass: {
      type: String,
      default: ''
    },

    /**
     * Максимальное количество знаков после запятой
     * Имеет смысл только для input[type=number]
     */
    maxDecimalPlaces: {
      type: Number,
      default: null
    },

    /**
     * Разделитель дробной части (. или ,)
     * Имеет смысл только для input[type=number]
     */
    numberDelimeter: {
      type: String,
      default: null,
      validator: value => {
        return ALLOW_NUMBER_DELIMETERS.some(el => el === value);
      }
    },

    /**
     * Ввод только целых значений
     */
    integer: {
      type: Boolean,
      default: false
    },

    /**
     * Отключить эмуляцию управления значением числового инпута
     * с помощью стрелок на клавиатуре
     */
    disableChangeValueByKeyArrow: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue, oldValue) {
      /**
       * При v-model.number Vue приводит значение в модели к числу
       * Из-за этого стирается разделитель при удалении десятых (когда стираем backspace)
       */
      if (this.formattedNumber && /\d*\.\d{1}$/.test(oldValue) && !/\d*\./.test(newValue)) {
        const value = this.inputRef.value;
        this.$nextTick(() => {
          this.inputRef.value = value;
        });
      }

      this.setAreaWidth();
    },

    numberDelimeter: {
      immediate: true,

      handler(newValue) {
        this.currentNumberDelimeter = newValue;
      }

    },

    maxDecimalPlaces() {
      this.setAreaWidth();
    }

  },

  data() {
    return {
      currentNumberDelimeter: this.numberDelimeter
    };
  },

  computed: {
    /**
     * Массив ошибок
     * @returns {Array}
     */
    errorList() {
      if (this.isOutOfRangeError && this.outOfRangeErrorText) {
        return [this.outOfRangeErrorText];
      }

      if (Array.isArray(this.error)) {
        return this.error;
      }

      if (typeof this.error === 'string') {
        return [this.error];
      }

      return [];
    },

    isErrors() {
      return !!this.error || this.isOutOfRangeError;
    },

    isOutOfRangeError() {
      if (this.isFocus || !this.isNumberType || isNaN(parseFloat(this.value)) || !this.value.toString().length) {
        return false;
      }

      return this.value > this.maxNumber || this.value < this.minNumber;
    },

    /**
     * Определяет, является ли текущий инпут числовым
     * @returns {boolean}
     */
    isNumberType() {
      return this.type === 'number' || this.type === 'decimal' || this.formattedNumber;
    },

    /**
     * Определяет допустимые разделители для числового инпута
     * @returns {Array}
     */
    numberDelimeters() {
      return this.numberDelimeter ? [this.numberDelimeter] : ALLOW_NUMBER_DELIMETERS;
    },

    /**
     * Определяет, требуется ли обработка числового значения
     * Например, кастомный разделитель или ограничение количества знаков после запятой
     * @return {boolean}
     */
    formattedNumber() {
      // @TODO для Chrome на Android не срабатывает prevent в keydown/keydown, пока отключаю эти доп. возможности
      return !devices.isAndriod() && (this.maxDecimalPlaces || this.numberDelimeter || this.integer);
    },

    getValue() {
      if (this.value === null) {
        return this.value;
      }

      let value = this.value.toString();

      if (this.overflowDecimalPlaces(value)) {
        const regExp = new RegExp('[0-9]*.[0-9]{' + this.maxDecimalPlaces + '}');
        value = value.match(regExp)[0];
      }

      if (this.formattedNumber && this.currentNumberDelimeter === ',') {
        value = value.toString().replace('.', ',');
      }

      return value;
    }

  },
  methods: {
    onKeyDown(e) {
      const code = e.keyCode;
      const isManualNumberControl = devices.isFirefox() || this.formattedNumber;
      const isE = code === 69; // Запрет на ввод e в числовые инпуты

      if (this.isNumberType && (isManualNumberControl && !this.allowSymbol(e) || isE)) {
        e.preventDefault();
        this.changeValueByKeyArrow(code);
        return false;
      }

      this.$emit('keydown', e);

      if (!this.isSaveOnBlur || typeof this.triggerBlur !== 'function') {
        return;
      }

      if (e.key === 'Enter') {
        this.triggerBlur(false);
        return;
      }

      if (e.key === 'Escape') {
        this.triggerBlur(true);
      }
    },

    /**
     * Определяет, разрешен ли введенный символ для числового инпута
     * Если символ является допустимым разделителем, то устанавливает его как текущий разделитель
     * @param {event} e
     * @returns {boolean}
     */
    allowSymbol(e) {
      const usesDelimeter = ALLOW_NUMBER_DELIMETERS.filter(el => e.target.value.includes(el));
      const isAllowDelimeter = !usesDelimeter.length && ALLOW_NUMBER_DELIMETERS.includes(e.key); // @TODO - Вынести установку разделителя отдельно, чтобы не было side-effects

      if (!this.numberDelimeter) {
        this.currentNumberDelimeter = usesDelimeter[0] ? usesDelimeter[0] : isAllowDelimeter ? e.key : null;
      }

      return !isNaN(+e.key) || isAllowDelimeter && !this.integer || ALLOW_NUMBER_CODES.includes(e.keyCode) || e.ctrlKey;
    },

    /**
     * Количество знаков после запятой
     * @param {(string|number)} value
     * @returns {number}
     */
    getDecimalPlaces(value) {
      const fraction = value.toString().replace(',', '.').split('.');
      return fraction[1] ? fraction[1].length : 0;
    },

    /**
     * Меняет значение инпута с formattedNumber при нажатии на стрелки
     * @param {number} keyCode
     */
    changeValueByKeyArrow(keyCode) {
      if (this.disableChangeValueByKeyArrow || keyCode !== 38 && keyCode !== 40) {
        return;
      }

      const toTop = keyCode === 38;
      const step = this.step || 1;
      const value = +this.value || 0;
      const newValue = toTop ? value + step : value - step;

      if (toTop && newValue <= this.maxNumber || !toTop && newValue >= this.minNumber) {
        const decimalPlaces = Math.max(this.getDecimalPlaces(step), this.getDecimalPlaces(value));
        this.$emit('input', newValue.toFixed(decimalPlaces));
        this.setAreaWidth();
      }
    },

    /**
     * Устанавливает ширину инпута в зависимости от содержимого
     */
    setAreaWidth() {
      if (!this.variableWidth) {
        return;
      }

      if (typeof this.setInputMinWidth === 'function') {
        this.setInputMinWidth();
      }

      this.inputRef.style.transition = 'none';
      this.inputRef.style.width = '0px';
      this.inputRef.style.minWidth = '0px';
      this.$nextTick(() => {
        let sw = this.inputRef.scrollWidth; // Safari не учитывает padding эл-та

        if (devices.isDesktopSafari()) {
          const s = getComputedStyle(this.inputRef);
          const pl = parseFloat(s.paddingLeft);
          const pr = parseFloat(s.paddingRight);
          sw += pl + pr;
        }

        if (this.inputMinWidth) {
          this.inputRef.style.minWidth = this.inputMinWidth + 'px';
        }

        this.inputRef.style.width = sw + 'px'; // eslint-disable-next-line no-unused-expressions

        this.inputRef.clientWidth; // force redraw

        this.inputRef.style.transition = '';
      });
    },

    needSetNumberValue(value, key) {
      if (this.overflowDecimalPlaces(value)) {
        this.inputRef.value = this.getValue;
        this.setAreaWidth();
        return true;
      }

      if (ALLOW_NUMBER_DELIMETERS.some(d => d === key) && +value === +this.value && this.currentNumberDelimeter !== key) {
        this.inputRef.value = value.replace(key, this.currentNumberDelimeter);
        this.setAreaWidth();
        return true;
      }

      return false;
    },

    overflowDecimalPlaces(value) {
      return this.maxDecimalPlaces && this.maxDecimalPlaces > 0 && this.getDecimalPlaces(value) > this.maxDecimalPlaces;
    },

    createIntersectionObserver() {
      if (window.IntersectionObserver) {
        this._observer = new window.IntersectionObserver(this.visibilityChanged);

        this._observer.observe(this.inputRef);
      }
    },

    visibilityChanged(entry) {
      if (entry[0].intersectionRatio > 0) {
        this.setAreaWidth();

        if (this.setInputWidth) {
          this.setInputWidth();
        }
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInput/enum/align.js
/* harmony default export */ var align = ({
  right: 'right',
  left: 'left'
});
// CONCATENATED MODULE: ./src/components/UiInput/enum/variants.js
/* harmony default export */ var enum_variants = ({
  DEFAULT: 'default',
  INLINE_EDIT: 'inline-edit'
});
// CONCATENATED MODULE: ./src/components/UiInput/enum/sizes.js
/* harmony default export */ var UiInput_enum_sizes = ({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInput/UiInput.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









let idCounter = 0;
/* harmony default export */ var UiInputvue_type_script_lang_js_ = ({
  name: 'UiInput',
  components: {
    UiIcon: components_UiIcon,
    UiEmoji: components_UiEmoji,
    UiTooltip: components_UiTooltip,
    UiTransition: components_UiTransition
  },
  mixins: [base_input],
  props: {
    id: {
      type: String,
      default: () => `ui-input-${++idCounter}`
    },
    variant: createEnumProp(enum_variants, enum_variants.DEFAULT),
    maxLength: {
      type: [String, Number],
      default: null
    },
    iconLeft: {
      type: String,
      default: ''
    },
    iconRight: {
      type: String,
      default: ''
    },

    /**
     * Будет изменяться заливка левой иконки,
     * в зависимости от состояния поля
     */
    iconLeftStateFill: {
      type: Boolean,
      default: true
    },

    /**
     * Будет изменяться заливка правой иконки,
     * в зависимости от состояния поля
     */
    iconRightStateFill: {
      type: Boolean,
      default: true
    },
    leftIconClass: {
      type: String,
      default: ''
    },
    rightIconClass: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: null
    },
    grey: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет вариант инпута с уменьшенной высотой
     */
    min: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },

    /**
     * Выводимый текст будет выглядеть как Placeholder
     */
    placeholderStyle: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет, будет ли текст ошибок обрезаться
     * через троеточие или переноситься на след.строку
     */
    ellipsisErrorText: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет, по какому краю будет выровнен текст ошибки
     */
    errorTextAlign: createEnumProp(align, align.left),

    /**
     * Включает автоматическое изменение ширины
     * по мере ввода текста
     */
    variableWidth: {
      type: Boolean,
      default: false
    },

    /**
     * Минимальное значение поля ввода (без учета иконок и т.п)
     * Для variableWidth минимальная ширина устанавлявается
     * по ширине плейсхолдена. Это свойство позволяет это переопределить
     */
    minAreaWidth: {
      type: Number,
      default: null
    },

    /**
     * Будет установлен фокус при монтировании элемента
     */
    withFocus: {
      type: Boolean,
      default: false
    },

    /**
     * Выделить содержимое поля ввода при получении фокуса
     */
    selectOnFocus: {
      type: Boolean,
      default: false
    },

    /**
     * Модификатор - обеспечение нестандартного поведения,
     * например для использования в других компонентах
     */
    modify: {
      type: String,
      default: null
    },
    baseClass: {
      type: String,
      default: null
    },

    /**
     * Подсказывает браузерам для устройств с экранной клавиатурой, какой вариант демонстрировать
    */
    inputmode: {
      type: String,
      default: null
    },
    pattern: {
      type: String,
      default: null
    },

    /**
     * Возможность добавлять эмоджи
     */
    emoji: {
      type: Boolean,
      default: false
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    },

    /**
     * Размер поля ввода. Сейчас применяется
     * только для variant === 'inline-edit'
     */
    size: createEnumProp(UiInput_enum_sizes, UiInput_enum_sizes.SM),

    /**
     * Инвертированные цвета инпута. Сейчас применяется
     * только для variant === 'inline-edit'
     */
    inversion: {
      type: Boolean,
      default: false
    },

    /**
     * Вызывает расфокус инпута при нажатии Enter и Esc
     * При расфокусе происходит эмит события input-save,
     * если этот расфокус вызван не нажатием esc
     * (Логика в ДС описана для InlineEdit)
     */
    saveOnBlur: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFocus: false,
      inputWidth: 0,
      inputMinWidth: 0
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['input']]: true,
        [this.$style['input_accent']]: this.accent,
        [this.$style['input_inversion']]: this.inversion && this.isInlineEdit,
        [this.$style[`input_${this.size}`]]: !this.isDefault,
        [this.$style['input_focus']]: this.isFocus || this.active,
        [this.$style['input_error']]: this.isErrors && !this.isFocus,
        [this.$style['input_disabled']]: this.disabled,
        [this.$style['input_readonly']]: this.readonly,
        [this.$style['input_readonly_grey']]: this.readonly && this.grey,
        [this.$style['input_with-left-icon']]: (this.$slots.iconLeft || this.iconLeft) && !this.prefix,
        [this.$style['input_with-right-icon']]: this.$slots.iconRight || this.iconRight,
        [this.$style['input_no-empty']]: !!this.value,
        [this.$style['input_min']]: this.min,
        [this.$style['input_clearable']]: !!this.clearable,
        [this.$style[`input_${this.modify}`]]: !!this.modify,
        [this.$style['input_placeholder-style']]: this.placeholderStyle,
        [this.baseClass]: this.baseClass
      };
    },

    wrapperClasses() {
      return {
        [this.$style['ui-input']]: true,
        [this.$style[`ui-input_${this.variant}`]]: this.variant,
        [this.$style['ui-input_variable-width']]: this.variableWidth
      };
    },

    hasPrefix() {
      return this.isDefault && (this.prefix || this.$slots.prefix);
    },

    isInputTooSmall() {
      return this.inputWidth < 192 && this.inputWidth > 0;
    },

    inputRef() {
      return this.$refs['inputArea'];
    },

    isDefault() {
      return this.variant === enum_variants.DEFAULT;
    },

    isInlineEdit() {
      return this.variant === enum_variants.INLINE_EDIT;
    },

    isSaveOnBlur() {
      return this.saveOnBlur || this.isInlineEdit;
    }

  },

  mounted() {
    this.setInputWidth();
    this.setAreaWidth();
    this.createIntersectionObserver();
    window.addEventListener('resize', this.setInputWidth);

    if (this.withFocus) {
      this.$nextTick(() => {
        this.setAreaFocus();
      });
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setInputWidth);
    this._observer = null;
  },

  methods: {
    onInput(e) {
      let value = e.target.value;
      const key = e.data;

      if (this.formattedNumber) {
        value = value.replace(',', '.');

        if (this.needSetNumberValue(value, key)) {
          return;
        }
      }

      this.$emit('input', value);
      this.setAreaWidth();
    },

    onFocus(e) {
      this.isFocus = true;

      if ((this.selectOnFocus || this.isInlineEdit) && this.inputRef && !this.readonly) {
        this.inputRef.scrollLeft = this.inputRef.scrollWidth;
        this.$nextTick(() => {
          this.inputRef.select();
        });
      }

      this.$emit('focus', e);
    },

    onBlur(e) {
      this.isFocus = false;
      this.$emit('blur', e);

      if (this.isSaveOnBlur && !this._esc) {
        this.$emit('input-save', e.target.value);
      }

      if (this._esc) {
        this._esc = false;
      }
    },

    setFocus(focus) {
      if (focus) {
        this.onFocus();
      } else {
        this.onBlur();
      }
    },

    setAreaFocus() {
      this.inputRef.focus();
    },

    setInputWidth() {
      if (this.$refs.wrap) {
        this.inputWidth = this.$refs.wrap.clientWidth;
      }
    },

    setInputMinWidth() {
      if (!isNaN(parseInt(this.minAreaWidth))) {
        this.inputMinWidth = this.minAreaWidth;
        return;
      }

      if (this.$refs.placeholder) {
        this.inputMinWidth = this.$refs.placeholder.clientWidth;
      }
    },

    clear(e) {
      if (this.disabled) {
        return;
      }

      this.$emit('input', '');
      this.$emit('clearInput');
    },

    setSelectionRange(start, end) {
      if (this.inputRef) {
        this.inputRef.setSelectionRange(start, end);
      }
    },

    onEmojiInput(emoji) {
      if (!emoji) {
        return;
      }

      const value = this.getValue;
      const start = this.inputRef.selectionStart;
      const end = this.inputRef.selectionEnd;
      const pos = start + emoji.length;
      this.$emit('input', value.substring(0, start) + emoji + value.substring(end));
      this.$nextTick(() => {
        this.setSelectionRange(pos, pos);
        this.inputRef.focus();
      });
    },

    /**
     * @param {boolean} isEsc - Вызов по нажатию клавиши Escape
     */
    triggerBlur(isEsc) {
      this._esc = isEsc;

      if (this.inputRef) {
        this.inputRef.blur();
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInput/UiInput.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInput_UiInputvue_type_script_lang_js_ = (UiInputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInput/UiInput.vue?vue&type=style&index=0&module=true&lang=less&
var UiInputvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("8fa9");

// CONCATENATED MODULE: ./src/components/UiInput/UiInput.vue








function UiInput_injectStyles (context) {
  
  this["$style"] = (UiInputvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInputvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInput_component = normalizeComponent(
  UiInput_UiInputvue_type_script_lang_js_,
  UiInputvue_type_template_id_9852ef66_render,
  UiInputvue_type_template_id_9852ef66_staticRenderFns,
  false,
  UiInput_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInput = (UiInput_component.exports);
// CONCATENATED MODULE: ./src/components/UiInput/index.js

/* harmony default export */ var components_UiInput = (UiInput);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTimeBox/UiTimeBox.vue?vue&type=template&id=0a4bad85&
var UiTimeBoxvue_type_template_id_0a4bad85_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['time-box']},[_c('UiInput',{ref:"input",attrs:{"value":_vm.formattedMask,"placeholder":_vm.placeholder || _vm.mask,"disabled":_vm.disabled,"error":_vm.error,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"right-icon-class":_vm.rightIconClass,"icon-left-state-fill":"","icon-right-state-fill":""},on:{"focus":_vm.focusHandler,"blur":_vm.blurHandler},nativeOn:{"input":function($event){return _vm.inputHandler.apply(null, arguments)}}})],1)}
var UiTimeBoxvue_type_template_id_0a4bad85_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTimeBox/UiTimeBox.vue?vue&type=template&id=0a4bad85&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTimeBox/UiTimeBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const PLACEHOLDER = '_';
const SEPARATOR = ':';
const MASK = `__${SEPARATOR}__`;

const isMaskChar = char => char === PLACEHOLDER || char === SEPARATOR;

const timeReduction = time => time < 10 ? `0${time}` : time;

/* harmony default export */ var UiTimeBoxvue_type_script_lang_js_ = ({
  name: 'UiTimeBox',
  components: {
    UiInput: components_UiInput
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: [Boolean, String, Array],
      default: false
    },
    iconLeft: {
      type: String,
      default: 'timeIcon'
    },
    iconRight: {
      type: String,
      default: null
    },
    rightIconClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      mask: MASK,
      rpSymbol: '_',
      currentValue: '',
      focusPosition: this.model.length,
      oldValueLength: this.model.length
    };
  },

  computed: {
    formattedMask() {
      if (!this.model) {
        return '';
      }

      let cnt = 0;
      return MASK.split('').map(char => {
        if (isMaskChar(char) && this.model.length > cnt) {
          const str = this.model[cnt];
          cnt++;
          return str;
        }

        return char;
      }).join('');
    }

  },
  methods: {
    /**
     * @param {UiInputEvent} e
     */
    inputHandler(e) {
      this.focus = e.target.selectionStart;
      let currentValue = e.target.value.split('').filter((el, index) => !isNaN(+el) && el !== ' ' && index <= 4);

      if (currentValue.length > 2) {
        currentValue.splice(2, 0, SEPARATOR);
      }

      if (this.focus === 3 && this.focus < currentValue.length && this.oldValueLength <= currentValue.length && this.oldValueLength !== this.focus) {
        this.focus += 1;
      }

      currentValue = currentValue.join('');
      this.oldValueLength = currentValue.length;
      this.$emit('change', currentValue);
      e.target.value = this.formattedMask;
      this.$nextTick(this.setCaret);
    },

    blurHandler(e) {
      const parsedTime = this.parseStr(this.model);
      const isTimeValid = /^([0-1]?\d|2[0-4]):([0-5]\d)(:[0-5]\d)?$/.test(parsedTime);
      this.$emit('blur', e);
      this.$emit('change', isTimeValid ? parsedTime : this.normalizeTime(parsedTime));
    },

    normalizeTime(value) {
      const time = value.split(SEPARATOR);
      let hours = parseInt(time[0]);
      let minutes = parseInt(time[1]);

      if (isNaN(hours) || isNaN(minutes)) {
        return '00:00';
      }

      if (hours > 24) {
        hours = hours - 24;
      }

      if (minutes > 60) {
        minutes = minutes - 60;
      }

      return [timeReduction(hours), timeReduction(minutes)].join(SEPARATOR);
    },

    focusHandler(e) {
      this.$emit('focus', e);
    },

    parseStr(str) {
      if (!/:/.test(str)) {
        str += `${SEPARATOR}00`;
      }

      return str.replace(/^\d{1}:/, '0$&').replace(/:\d{1}$/, '$&0');
    },

    setCaret() {
      // @TODO: стоит задать в UiInput метод setSelectionRange, и его $refs не вызывать
      const input = this.$refs.input.$refs.inputArea;
      input.setSelectionRange(this.focus, this.focus);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTimeBox/UiTimeBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTimeBox_UiTimeBoxvue_type_script_lang_js_ = (UiTimeBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTimeBox/UiTimeBox.vue?vue&type=style&index=0&lang=less&module=true&
var UiTimeBoxvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("6323");

// CONCATENATED MODULE: ./src/components/UiTimeBox/UiTimeBox.vue








function UiTimeBox_injectStyles (context) {
  
  this["$style"] = (UiTimeBoxvue_type_style_index_0_lang_less_module_true_["default"].locals || UiTimeBoxvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiTimeBox_component = normalizeComponent(
  UiTimeBox_UiTimeBoxvue_type_script_lang_js_,
  UiTimeBoxvue_type_template_id_0a4bad85_render,
  UiTimeBoxvue_type_template_id_0a4bad85_staticRenderFns,
  false,
  UiTimeBox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTimeBox = (UiTimeBox_component.exports);
// CONCATENATED MODULE: ./src/components/UiTimeBox/index.js

/* harmony default export */ var components_UiTimeBox = (UiTimeBox);
// CONCATENATED MODULE: ./src/components/UiDatepicker/i18n.js
const UiDatepicker_i18n_LOCALES = {
  en_GB: 'en_GB',
  es_ES: 'es_ES',
  ru_RU: 'ru_RU'
};
/* harmony default export */ var UiDatepicker_i18n = ({
  [UiDatepicker_i18n_LOCALES.en_GB]: {
    daysOfWeek: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    limit: 'Limit reached ({{limit}} items max).',
    loading: 'Loading...',
    minLength: 'Min. Length',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    notSelected: 'Nothing Selected',
    required: 'Required',
    search: 'Search',
    clear: 'Clear',
    apply: 'Apply'
  },
  [UiDatepicker_i18n_LOCALES.es_ES]: {
    daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    limit: 'Limit reached ({{limit}} items max).',
    loading: 'Loading...',
    minLength: 'Min. Length',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    notSelected: 'Nothing Selected',
    required: 'Required',
    search: 'Search',
    clear: 'Borrar',
    apply: 'Aplicar'
  },
  [UiDatepicker_i18n_LOCALES.ru_RU]: {
    daysOfWeek: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    limit: 'Limit reached ({{limit}} items max).',
    loading: 'Loading...',
    minLength: 'Min. Length',
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    notSelected: 'Nothing Selected',
    required: 'Required',
    search: 'Search',
    clear: 'Очистить',
    apply: 'Применить'
  }
});
// CONCATENATED MODULE: ./src/directives/click-outside.js
/* harmony default export */ var click_outside = ({
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };

    document.body.addEventListener('click', el.clickOutsideEvent);
    document.body.addEventListener('touchstart', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
    document.body.removeEventListener('touchstart', el.clickOutsideEvent);
  },

  stopProp(event) {
    event.stopPropagation();
  }

});
// CONCATENATED MODULE: ./src/directives/index.js

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDatepicker/UiDatepicker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/**
 * Возвращает текущую дату как инстанс Date
 */

const getDateInstance = date => {
  if (date instanceof Date) {
    return date;
  }

  if (/\d{2}\.\d{2}\.\d{4}/i.test(date)) {
    return new Date(date.split('.').reverse().join('/'));
  }

  return new Date(date);
};
/**
 * Форматирует дату в строку формата dd.mm.yyyy
 */


const defaultFormatDate = (date, withoutYear, time) => {
  date = getDateInstance(date);
  let month = date.getMonth() + 1;
  let day = date.getDate();

  if (month < 10) {
    month = `0${month}`;
  }

  if (day < 10) {
    day = `0${day}`;
  }

  if (withoutYear) {
    return `${day}.${month}`;
  }

  if (time) {
    return `${day}.${month}.${date.getFullYear()}, ${time}`;
  }

  return `${day}.${month}.${date.getFullYear()}`;
};

/* harmony default export */ var UiDatepickervue_type_script_lang_js_ = ({
  name: 'UiDatepicker',
  components: {
    UiCalendar: components_UiCalendar,
    UiInput: components_UiInput,
    UiButton: components_UiButton,
    UiTimeBox: components_UiTimeBox,
    UiTooltip: components_UiTooltip
  },
  directives: {
    clickOutside: click_outside
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [String, Date],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: true
    },
    lang: {
      type: String,
      validator: locale => Object.values(UiDatepicker_i18n_LOCALES).includes(locale) || Object.values(UiDatepicker_i18n_LOCALES).some(value => value.split('_')[0] === locale),
      default: UiDatepicker_i18n_LOCALES.ru_RU
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minDate: {
      type: String
    },
    maxDate: {
      type: String
    },
    iconRight: {
      type: String,
      default: 'calendar'
    },
    iconLeft: {
      type: String,
      default: null
    },
    container: {
      type: String,
      default: 'body'
    },

    /**
     * Определяет позиционирование
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.BOTTOM
    },
    baseClass: {
      type: String,
      default: null
    },
    popperOptions: {
      type: Object,
      default: null
    },
    withoutYear: {
      type: Boolean,
      default: false
    },

    /**
     * Функция для форматирования даты,
     * которая будет выводиться в инпут
     */
    outputDate: {
      type: Function,
      default: null
    },

    /**
     * Флаг определяет, будет ли дата возвращаться в виде
     * обычной даты или в виде строки формата (dd.mm.yyyy)
     */
    rawDate: {
      type: Boolean,
      default: false
    },

    /**
     * Возможность вводить время
     * при включении пропса в модели будет только Date
     */
    timepicker: {
      type: Boolean,
      default: false
    },
    timepickerValue: {
      type: String,
      default: ''
    },
    timepickerLabel: {
      type: String,
      default: ''
    },
    timepickerTooltipText: {
      type: String,
      default: ''
    },
    // Очистка значения повторным кликом на дате
    toggleSelectedDay: {
      type: Boolean,
      default: false
    },
    inputVariant: createEnumProp(enum_variants, enum_variants.DEFAULT)
  },

  data() {
    return {
      isOpen: false,
      firstDayOfWeek: 0,
      selectedDate: null,
      time:  false || this.timepickerValue,
      isTooltipOpen: false
    };
  },

  computed: {
    today() {
      return new Date();
    },

    selectedToDate() {
      return getDateInstance(this.selectedDate) || getDateInstance(this.today());
    },

    minToDate() {
      return getDateInstance(this.minDate);
    },

    maxToDate() {
      return getDateInstance(this.maxDate);
    },

    outputFormatDate() {
      const date = getDateInstance(this.model);
      const isValidDate = date instanceof Date && !isNaN(date);

      if (!this.model || !isValidDate) {
        return '';
      }

      if (this.outputDate) {
        return this.outputDate(date, this.withoutYear);
      }

      return defaultFormatDate(date, this.withoutYear, this.time);
    },

    locale() {
      if (this.$getLocale) {
        return this.$getLocale();
      }

      return this.lang.length === 2 ? Object.values(UiDatepicker_i18n_LOCALES).find(value => value.split('_')[0] === this.lang) : this.lang;
    },

    hasTrigger() {
      return !!this.$slots['trigger'] || !!this.$scopedSlots['trigger'];
    },

    text() {
      return UiDatepicker_i18n[this.locale];
    }

  },

  created() {
    if (this.locale === UiDatepicker_i18n_LOCALES.ru_RU) {
      this.firstDayOfWeek = 1;
    }
  },

  methods: {
    setDate(isApply) {
      let emitDate = !this.selectedDate && isApply ? this.getDate(this.today) : this.getDate(this.selectedDate);
      this.$emit('change', emitDate);

      if (isApply) {
        this.$emit('apply', emitDate);
        this.closeMenu();
      }
    },

    resetDate() {
      this.selectedDate = null;
      this.time = null;
      this.$emit('change', null);
      this.$emit('reset');
    },

    selectDate(date) {
      if (!date) {
        this.resetDate();
        return;
      }

      this.selectedDate = this.getDate(date);
      this.setDate(false);
    },

    getDate(date) {
      if (this.timepicker) {
        const time = this.time ? this.time.split(':') : ['00', '00'];
        const h = time[0];
        const m = time[1];
        this.time = `${h}:${m}`;
        date.setHours(h);
        date.setMinutes(m);
        return date;
      }

      return this.rawDate ? date : defaultFormatDate(date);
    },

    openMenu() {
      if (this.disabled) {
        return;
      }

      this.isOpen = true;
      this.$emit('open');
    },

    closeMenu() {
      this.isOpen = false;
      this.$emit('close');
    },

    toggleTooltip() {
      this.isTooltipOpen = !this.isTooltipOpen;
    },

    handleClickOutside() {
      this.isTooltipOpen = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiDatepicker/UiDatepicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiDatepicker_UiDatepickervue_type_script_lang_js_ = (UiDatepickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiDatepicker/UiDatepicker.vue?vue&type=style&index=0&module=true&lang=less&
var UiDatepickervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("2ae7");

// CONCATENATED MODULE: ./src/components/UiDatepicker/UiDatepicker.vue








function UiDatepicker_injectStyles (context) {
  
  this["$style"] = (UiDatepickervue_type_style_index_0_module_true_lang_less_["default"].locals || UiDatepickervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiDatepicker_component = normalizeComponent(
  UiDatepicker_UiDatepickervue_type_script_lang_js_,
  UiDatepickervue_type_template_id_2fd9ab7e_render,
  UiDatepickervue_type_template_id_2fd9ab7e_staticRenderFns,
  false,
  UiDatepicker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiDatepicker = (UiDatepicker_component.exports);
// CONCATENATED MODULE: ./src/components/UiDatepicker/index.js

/* harmony default export */ var components_UiDatepicker = (UiDatepicker);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropBtn/UiDropBtn.vue?vue&type=template&id=d5342b4a&
var UiDropBtnvue_type_template_id_d5342b4a_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['drop-btn']},_vm.$listeners),[_c('v-popover',{attrs:{"offset":"4","placement":"bottom-start","popover-base-class":_vm.$style['drop-btn__content'],"open-class":_vm.$style['open']},on:{"show":function($event){_vm.isOpen = true},"hide":function($event){_vm.isOpen = false}}},[_c('div',{class:( _obj = {}, _obj[_vm.$style['drop-btn__target']] = true, _obj[_vm.$style['drop-btn__target_active']] = _vm.isOpen, _obj )},[_vm._t("target",function(){return [_c('UiIcon',{class:_vm.$style['drop-btn__icon'],attrs:{"name":"moreHorizontal"}})]})],2),_c('template',{slot:"popover"},[_c('div',{directives:[{name:"close-popover",rawName:"v-close-popover"}],class:_vm.$style['drop-btn__content-inner']},[_vm._t("menu")],2)])],2)],1)}
var UiDropBtnvue_type_template_id_d5342b4a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDropBtn/UiDropBtn.vue?vue&type=template&id=d5342b4a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropBtn/UiDropBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiDropBtnvue_type_script_lang_js_ = ({
  name: 'UiDropBtn',
  components: {
    UiIcon: components_UiIcon
  },
  mixins: [deprecated_message],

  data() {
    return {
      isOpen: false
    };
  }

});
// CONCATENATED MODULE: ./src/components/UiDropBtn/UiDropBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiDropBtn_UiDropBtnvue_type_script_lang_js_ = (UiDropBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiDropBtn/UiDropBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiDropBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("248b");

// CONCATENATED MODULE: ./src/components/UiDropBtn/UiDropBtn.vue








function UiDropBtn_injectStyles (context) {
  
  this["$style"] = (UiDropBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiDropBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiDropBtn_component = normalizeComponent(
  UiDropBtn_UiDropBtnvue_type_script_lang_js_,
  UiDropBtnvue_type_template_id_d5342b4a_render,
  UiDropBtnvue_type_template_id_d5342b4a_staticRenderFns,
  false,
  UiDropBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiDropBtn = (UiDropBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiDropBtn/index.js

/* harmony default export */ var components_UiDropBtn = (UiDropBtn);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropdownMenu/UiDropdownMenu.vue?vue&type=template&id=bc252174&
var UiDropdownMenuvue_type_template_id_bc252174_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['dropdown']},[_c('v-popover',{attrs:{"offset":"4","placement":_vm.placement,"trigger":"manual","popover-base-class":_vm.$style['dropdown-content'],"open-class":_vm.$style['open'],"open":_vm.isOpen,"auto-hide":""},on:{"auto-hide":function($event){_vm.isOpen = false}}},[_c('div',{class:_vm.$style['dropdown-target'],on:{"click":_vm.openMenu}},[_c('div',{class:( _obj = {}, _obj[_vm.$style['dropdown-btn']] = true, _obj[_vm.$style['dropdown-btn_active']] = _vm.isOpen, _obj[_vm.$style['dropdown-btn_disabled']] = _vm.disabled, _obj[_vm.$style['dropdown-btn_white']] = _vm.white, _obj[_vm.$style['dropdown-btn_grey']] = _vm.grey, _obj[_vm.$style['dropdown-btn_tertiary']] = _vm.tertiaryStyle, _obj )},[_c('div',{class:_vm.$style['dropdown-btn__title']},[_vm._v(" "+_vm._s(_vm.model.label)+" ")]),_c('div',{class:_vm.$style['dropdown-btn__icon']},[_c('UiIcon',{class:_vm.$style['dropdown-btn__image'],attrs:{"name":"caret-down"}})],1)])]),_c('template',{slot:"popover"},[_c('div',{class:[_vm.$style['dropdown-content__inner'], _vm.$style['dropdown-content__inner_menu']],style:(("min-width: " + _vm.targetWidth)),on:{"click":function($event){$event.stopPropagation();_vm.isOpen = false}}},[_vm._t("content",function(){return _vm._l((_vm.options),function(option,index){return _c('div',{key:index,class:_vm.$style['dropdown-menu-item'],on:{"click":function($event){$event.stopPropagation();return _vm.setValue(option)}}},[_vm._v(" "+_vm._s(option.label)+" ")])})})],2)])],2)],1)}
var UiDropdownMenuvue_type_template_id_bc252174_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDropdownMenu/UiDropdownMenu.vue?vue&type=template&id=bc252174&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropdownMenu/UiDropdownMenu.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiDropdownMenuvue_type_script_lang_js_ = ({
  name: 'UiDropdownMenu',
  components: {
    UiIcon: components_UiIcon
  },
  mixins: [deprecated_message],
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: [Object],
    options: {
      type: Array
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    white: {
      type: Boolean
    },
    grey: {
      type: Boolean
    },
    tertiaryStyle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isOpen: false,
    targetWidth: 'auto'
  }),
  methods: {
    openMenu() {
      if (!this.disabled) {
        this.targetWidth = `${this.$el.clientWidth}px`;
        this.isOpen = true;
      }
    },

    setValue(option) {
      this.$emit('change', option);
      this.isOpen = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiDropdownMenu/UiDropdownMenu.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiDropdownMenu_UiDropdownMenuvue_type_script_lang_js_ = (UiDropdownMenuvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiDropdownMenu/UiDropdownMenu.vue?vue&type=style&index=0&module=true&lang=less&
var UiDropdownMenuvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("0933");

// CONCATENATED MODULE: ./src/components/UiDropdownMenu/UiDropdownMenu.vue








function UiDropdownMenu_injectStyles (context) {
  
  this["$style"] = (UiDropdownMenuvue_type_style_index_0_module_true_lang_less_["default"].locals || UiDropdownMenuvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiDropdownMenu_component = normalizeComponent(
  UiDropdownMenu_UiDropdownMenuvue_type_script_lang_js_,
  UiDropdownMenuvue_type_template_id_bc252174_render,
  UiDropdownMenuvue_type_template_id_bc252174_staticRenderFns,
  false,
  UiDropdownMenu_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiDropdownMenu = (UiDropdownMenu_component.exports);
// CONCATENATED MODULE: ./src/components/UiDropdownMenu/index.js

/* harmony default export */ var components_UiDropdownMenu = (UiDropdownMenu);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropSelect/UiDropSelect.vue?vue&type=template&id=3ef8a104&
var UiDropSelectvue_type_template_id_3ef8a104_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['select']},_vm.$listeners),[_c('v-popover',{attrs:{"offset":"4","placement":"bottom","trigger":"manual","popover-base-class":_vm.$style['select__content'],"open-class":_vm.$style['open'],"open":_vm.isOpen,"auto-hide":""},on:{"auto-hide":function($event){_vm.isOpen = false}}},[_c('div',{class:_vm.$style['select-trigger'],on:{"click":_vm.openMenu}},[_c('UiInput',{class:_vm.$style['select-menu'],attrs:{"value":_vm.value,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"readonly":"","grey":""}}),(_vm.error)?_c('div',{class:_vm.$style['select__error']},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1),_c('template',{slot:"popover"},[_c('div',[_c('div',{class:_vm.$style['select__content-inner'],style:(("width: " + _vm.targetWidth))},[(_vm.multiple)?_c('div',{class:_vm.$style['select__content-ch-wrap']},_vm._l((_vm.opts),function(opt,i){return _c('UiCheckbox',{key:i,class:_vm.$style['select__content-ch'],attrs:{"value":opt[_vm.valuePropName],"label":opt[_vm.labelPropName]},model:{value:(_vm.multipleModel),callback:function ($$v) {_vm.multipleModel=$$v},expression:"multipleModel"}})}),1):_c('div',_vm._l((_vm.opts),function(opt,i){return _c('UiInputDropdown',{key:i,attrs:{"active":opt[_vm.valuePropName] === _vm.model},on:{"click":function($event){return _vm.setValue(opt)}}},[_vm._v(" "+_vm._s(opt[_vm.labelPropName])+" ")])}),1),_c('div',{on:{"click":function($event){_vm.isOpen = false}}},[(_vm.$slots.footer)?_c('div',{class:_vm.$style['select__footer'],on:{"click":function($event){return _vm.$emit('dropSelectEvent')}}},[_vm._t("footer")],2):_vm._e()])])])])],2)],1)}
var UiDropSelectvue_type_template_id_3ef8a104_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiDropSelect/UiDropSelect.vue?vue&type=template&id=3ef8a104&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputDropdown/UiInputDropdown.vue?vue&type=template&id=eef6e75e&
var UiInputDropdownvue_type_template_id_eef6e75e_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes},_vm.$listeners),[_c('div',{class:( _obj = {}, _obj[_vm.$style['input__inner']] = true, _obj[_vm.$style['input__inner_disabled']] = _vm.disabled, _obj[_vm.$style['input__inner_center']] = _vm.$slots.avatar && !_vm.$slots.descript, _obj ),style:(_vm.styles),on:{"mouseover":_vm.onHover}},[(_vm.$slots.avatar)?_c('div',{class:_vm.$style['input__avatar']},[_vm._t("avatar")],2):(_vm.iconPrefix || _vm.$slots.iconPrefix)?_c('div',{class:[_vm.$style['input__icon'], _vm.$style['input__icon_prefix'], _vm.iconPrefixClass]},[_vm._t("iconPrefix",function(){return [(_vm.$style['input__image'])?_c('UiIcon',{attrs:{"name":_vm.iconPrefix}}):_vm._e()]})],2):_vm._e(),_c('div',{class:_vm.$style['input__content']},[_c('div',{class:_vm.$style['input__text'],style:(_vm.textStyles)},[_vm._t("default",function(){return [_vm._v("Input Text")]})],2),(_vm.$slots.descript || _vm.description)?_c('div',{class:[_vm.$style['input__descript'], _vm.descriptClass]},[_vm._t("descript",function(){return [_vm._v(" "+_vm._s(_vm.description)+" ")]})],2):_vm._e()]),(_vm.additionalText && (!_vm.isAlwaysShowIconContainer || _vm.addTextWithIcon))?_c('div',{class:_vm.$style['input__additional-txt']},[_vm._v(" "+_vm._s(_vm.additionalText)+" ")]):_vm._e(),(_vm.isAlwaysShowIconContainer)?_c('div',{class:[_vm.$style['input__icon'], _vm.$style['input__icon_suffix'], _vm.iconClass]},[(_vm.$slots.icon || _vm.iconComputed)?[_vm._t("icon",function(){
        var _obj;
return [_c('UiIcon',{class:( _obj = {}, _obj[_vm.$style['input__image']] = true, _obj[_vm.$style['input__image-hover']] = _vm.hoverIcon && !_vm.active, _obj[_vm.iconClass] = _vm.iconClass, _obj ),attrs:{"name":_vm.iconComputed}})]})]:_vm._e()],2):_vm._e()])])}
var UiInputDropdownvue_type_template_id_eef6e75e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInputDropdown/UiInputDropdown.vue?vue&type=template&id=eef6e75e&

// CONCATENATED MODULE: ./src/utils/style/deltaTransition.js
/* harmony default export */ var deltaTransition = (el => {
  const delta = el.scrollWidth - el.clientWidth;
  return delta === 0 ? '' : `--delta-width: -${delta}px; animation-duration: ${delta * 15}ms;`;
});
// CONCATENATED MODULE: ./src/components/UiInputDropdown/enum/sizes.js
/* harmony default export */ var UiInputDropdown_enum_sizes = ({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
});
// CONCATENATED MODULE: ./src/components/UiInputDropdown/enum/modify.js
/* harmony default export */ var modify = ({
  DELETE: 'delete'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputDropdown/UiInputDropdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiInputDropdownvue_type_script_lang_js_ = ({
  name: 'UiInputDropdown',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    /**
     * Размер
     */
    size: {
      type: String,
      default: UiInputDropdown_enum_sizes.MD
    },

    /**
     * Определяет отмеченный пункт
     */
    active: {
      type: Boolean,
      default: false
    },

    /**
     * Меняет местами текст и иконку
     * Не работает, если есть иконка и в начале и в конце
     */
    startIcon: {
      type: Boolean,
      default: false
    },

    /**
     * Имя иконки после текста
     */
    icon: {
      type: String
    },

    /**
     * Счетчик количества
     */
    additionalText: {
      type: [String, Number],
      default: null
    },

    /**
     * Показывать счетчик вместе с иконкой
     * По умолчанию счетчик показывается только
     * если нет иконки или active = false
     */
    addTextWithIcon: {
      type: Boolean,
      default: true
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    },

    /**
     * Имя иконки перед текстом
     */
    iconPrefix: {
      type: String
    },

    /**
     * Дополнительный класс для иконки после текста
     */
    iconClass: {
      type: String,
      default: ''
    },

    /**
     * Дополнительный класс для иконки перед текстом
     */
    iconPrefixClass: {
      type: String,
      default: ''
    },

    /**
     * Дополнительный класс для описания
     */
    descriptClass: {
      type: String,
      default: ''
    },

    /**
     * Определяет Иконку для отмеченного пункта
     */
    activeIcon: {
      type: String,
      default: 'checkmarkCircle'
    },

    /**
     * Иконка после текста показывается только по hover
     * Иконка перед текстом показывается всегда
     */
    hoverIcon: {
      type: Boolean,
      default: true
    },
    blackIcon: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    },

    /**
     * Неактивное состояние
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * Анимация бегущей строки при наведении
     */
    ticker: {
      type: Boolean,
      default: false
    },

    /**
     * Всегда отображать контейнер для иконки
     */
    alwaysShowIconContainer: {
      type: Boolean,
      default: false
    },

    /**
     * Модификатор
     */
    modify: {
      type: String,
      default: null
    },

    /**
     * Цвет текста
     */
    textColor: {
      type: String,
      default: null
    },

    /**
     * Фон элемента
     */
    background: {
      type: String,
      default: null
    },

    /**
     * Описание
     */
    description: {
      type: String,
      default: null
    }
  },
  data: () => ({
    deltaStyle: ''
  }),
  computed: {
    classes() {
      return {
        [this.$style['input']]: true,
        [this.$style[`input_${this.size}`]]: true,
        [this.$style['input_accent']]: this.accent,
        [this.$style['input_start-icon']]: this.startIcon && !this.iconPrefix && !this.$slots.iconPrefix,
        [this.$style['input_black-icon']]: this.blackIcon,
        [this.$style['input_simple']]: this.simple,
        [this.$style['input_disabled']]: this.disabled,
        [this.$style['input_delete']]: this.modify === modify.DELETE
      };
    },

    iconComputed() {
      if (this.active) {
        return this.activeIcon;
      }

      if (this.icon) {
        return this.icon;
      }

      return false;
    },

    isAlwaysShowIconContainer() {
      return this.alwaysShowIconContainer && !this.additionalText || this.$slots.icon || this.iconComputed;
    },

    styles() {
      let styles = '';

      if (this.background) {
        styles += `background-color: ${this.background}; `;
      }

      return styles;
    },

    textStyles() {
      let styles = this.deltaStyle;

      if (this.textColor) {
        styles += `color: ${this.textColor};`;
      }

      return styles;
    }

  },
  methods: {
    onHover() {
      if (!this.ticker) {
        return;
      }

      const text = this.$el.querySelector(`.${this.$style['input__text']}`);

      if (text) {
        this.deltaStyle = deltaTransition(text);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInputDropdown/UiInputDropdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInputDropdown_UiInputDropdownvue_type_script_lang_js_ = (UiInputDropdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInputDropdown/UiInputDropdown.vue?vue&type=style&index=0&module=true&lang=less&
var UiInputDropdownvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("f9bf");

// CONCATENATED MODULE: ./src/components/UiInputDropdown/UiInputDropdown.vue








function UiInputDropdown_injectStyles (context) {
  
  this["$style"] = (UiInputDropdownvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInputDropdownvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInputDropdown_component = normalizeComponent(
  UiInputDropdown_UiInputDropdownvue_type_script_lang_js_,
  UiInputDropdownvue_type_template_id_eef6e75e_render,
  UiInputDropdownvue_type_template_id_eef6e75e_staticRenderFns,
  false,
  UiInputDropdown_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInputDropdown = (UiInputDropdown_component.exports);
// CONCATENATED MODULE: ./src/components/UiInputDropdown/index.js

/* harmony default export */ var components_UiInputDropdown = (UiInputDropdown);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiDropSelect/UiDropSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiDropSelectvue_type_script_lang_js_ = ({
  name: 'UiDropSelect',
  components: {
    UiCheckbox: UiCheckbox,
    UiInput: components_UiInput,
    UiInputDropdown: components_UiInputDropdown
  },
  mixins: [deprecated_message],
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: {
      type: [String, Number, Array]
    },
    options: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    valuePropName: {
      type: String,
      default: 'value'
    },
    labelPropName: {
      type: String,
      default: 'label'
    },
    iconLeft: {
      type: String,
      default: 'website'
    },
    iconRight: {
      type: String,
      default: 'doubleCaretDown'
    },
    error: {
      type: [String, Boolean]
    }
  },

  data() {
    return {
      isOpen: false,
      targetWidth: 'auto',
      multipleModel: this.multiple ? this.model : []
    };
  },

  computed: {
    opts() {
      if (typeof this.options[0] === 'object') {
        return this.options;
      }

      const values = [];
      this.options.forEach(v => {
        const value = {};
        value[this.valuePropName] = v;
        value[this.labelPropName] = v;
        values.push(value);
      });
      return values;
    },

    value() {
      const v = [];

      for (const opt of this.opts) {
        if (Array.isArray(this.model)) {
          if (this.model.includes(opt[this.valuePropName])) {
            v.push(opt[this.labelPropName]);
          }
        } else {
          if (opt[this.valuePropName] === this.model) {
            v.push(opt[this.labelPropName]);
            break;
          }
        }
      }

      return v.join(', ');
    }

  },
  watch: {
    multipleModel(selected) {
      this.$emit('change', selected);
    }

  },
  methods: {
    openMenu() {
      this.targetWidth = `${this.$el.clientWidth}px`;
      this.isOpen = true;
    },

    setValue(option) {
      this.$emit('change', option[this.valuePropName]);
      this.isOpen = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiDropSelect/UiDropSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiDropSelect_UiDropSelectvue_type_script_lang_js_ = (UiDropSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiDropSelect/UiDropSelect.vue?vue&type=style&index=0&module=true&lang=less&
var UiDropSelectvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("39c6");

// EXTERNAL MODULE: ./src/components/UiDropSelect/UiDropSelect.vue?vue&type=style&index=1&lang=css&
var UiDropSelectvue_type_style_index_1_lang_css_ = __webpack_require__("8df4");

// CONCATENATED MODULE: ./src/components/UiDropSelect/UiDropSelect.vue









function UiDropSelect_injectStyles (context) {
  
  this["$style"] = (UiDropSelectvue_type_style_index_0_module_true_lang_less_["default"].locals || UiDropSelectvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiDropSelect_component = normalizeComponent(
  UiDropSelect_UiDropSelectvue_type_script_lang_js_,
  UiDropSelectvue_type_template_id_3ef8a104_render,
  UiDropSelectvue_type_template_id_3ef8a104_staticRenderFns,
  false,
  UiDropSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiDropSelect = (UiDropSelect_component.exports);
// CONCATENATED MODULE: ./src/components/UiDropSelect/index.js

/* harmony default export */ var components_UiDropSelect = (UiDropSelect);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiErrors/UiErrors.vue?vue&type=template&id=4a5cf1c9&
var UiErrorsvue_type_template_id_4a5cf1c9_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['error-wrap']},_vm._l((_vm.errorList),function(error,i){
var _obj;
return _c('div',{key:(_vm.id + "-" + i),class:( _obj = {}, _obj[_vm.$style['error']] = true, _obj[_vm.$style['error_ellipsis']] = _vm.ellipsisErrorText, _obj[_vm.$style[("error_" + _vm.errorTextAlign)]] = true, _obj ),domProps:{"innerHTML":_vm._s(error)}})}),0)}
var UiErrorsvue_type_template_id_4a5cf1c9_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiErrors/UiErrors.vue?vue&type=template&id=4a5cf1c9&

// CONCATENATED MODULE: ./src/components/UiErrors/enum/align.js
/* harmony default export */ var enum_align = ({
  right: 'right',
  left: 'left'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiErrors/UiErrors.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


let UiErrorsvue_type_script_lang_js_idCounter = 0;
/* harmony default export */ var UiErrorsvue_type_script_lang_js_ = ({
  name: 'UiErrors',
  props: {
    id: {
      type: String,
      default: () => `ui-error-${++UiErrorsvue_type_script_lang_js_idCounter}`
    },
    errors: {
      type: [String, Array],
      default: null
    },

    /**
     * Определяет, будет ли текст ошибок обрезаться
     * через троеточие или переноситься на след.строку
     */
    ellipsisErrorText: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет, по какому краю будет выровнен текст ошибки
     */
    errorTextAlign: createEnumProp(enum_align, enum_align.left)
  },
  computed: {
    errorList() {
      return Array.isArray(this.errors) ? this.errors : [this.errors];
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiErrors/UiErrors.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiErrors_UiErrorsvue_type_script_lang_js_ = (UiErrorsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiErrors/UiErrors.vue?vue&type=style&index=0&module=true&lang=less&
var UiErrorsvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("0a07");

// CONCATENATED MODULE: ./src/components/UiErrors/UiErrors.vue








function UiErrors_injectStyles (context) {
  
  this["$style"] = (UiErrorsvue_type_style_index_0_module_true_lang_less_["default"].locals || UiErrorsvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiErrors_component = normalizeComponent(
  UiErrors_UiErrorsvue_type_script_lang_js_,
  UiErrorsvue_type_template_id_4a5cf1c9_render,
  UiErrorsvue_type_template_id_4a5cf1c9_staticRenderFns,
  false,
  UiErrors_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiErrors = (UiErrors_component.exports);
// CONCATENATED MODULE: ./src/components/UiErrors/index.js

/* harmony default export */ var components_UiErrors = (UiErrors);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiField/UiField.vue?vue&type=template&id=11dad258&
var UiFieldvue_type_template_id_11dad258_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasLabelRow)?_c('div',{class:_vm.$style['field-row']},[_c('div',{class:_vm.$style['field-row__label-box']},[_c(_vm.tag,{tag:"component",class:[_vm.$style['field-row__label'], _vm.labelClass],attrs:{"for":_vm.areaId}},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2),(_vm.tooltipText || _vm.$slots.tooltipContent)?_c('div',{class:_vm.$style['field-row__icon']},[_c('UiTooltip',{attrs:{"placement":_vm.tooltipPlacement,"icon-size":16,"icon":_vm.tooltipIcon},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("icon")]},proxy:true}],null,true)},[_vm._t("tooltipContent",function(){return [_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]})],2)],1):_vm._e()],1),(_vm.subtitle || _vm.$slots.subtitle)?_c('div',{class:_vm.$style['field-row__subtitle']},[_vm._t("subtitle",function(){return [_vm._v(" "+_vm._s(_vm.subtitle)+" ")]})],2):_vm._e()]):_vm._e(),_c('div',[_vm._t("default")],2)])}
var UiFieldvue_type_template_id_11dad258_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiField/UiField.vue?vue&type=template&id=11dad258&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiField/UiField.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiFieldvue_type_script_lang_js_ = ({
  name: 'UiField',
  components: {
    UiTooltip: components_UiTooltip
  },
  props: {
    /**
     * Устанавливает атрибут for для лейбла
     * Наименование for напрямую использовать нельзя
     */
    areaId: {
      type: String,
      default: ''
    },

    /**
     * Текст лейбла
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * Опциональный текст справа
     */
    subtitle: {
      type: String,
      default: ''
    },

    /**
     * Тег лейбла
     */
    tag: {
      type: String,
      default: 'label'
    },

    /**
     * Класс для дополнительной стилизации лейбла
     */
    labelClass: {
      type: String,
      default: null
    },

    /**
     * Поясняющий текст, выводимый в тултипе
     */
    tooltipText: {
      type: String,
      default: null
    },

    /**
     * Выравнивание тултипа
     */
    tooltipPlacement: {
      type: String,
      default: 'right-end'
    },

    /**
     * Иконка для поясняющего тултипа
     */
    tooltipIcon: {
      type: String,
      default: 'help'
    }
  },
  computed: {
    hasLabelRow() {
      return this.label || this.$slots.label || this.subtitle || this.$slots.subtitle || this.tooltipText || this.$slots.tooltipContent;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiField/UiField.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiField_UiFieldvue_type_script_lang_js_ = (UiFieldvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiField/UiField.vue?vue&type=style&index=0&module=true&lang=less&
var UiFieldvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("3229");

// CONCATENATED MODULE: ./src/components/UiField/UiField.vue








function UiField_injectStyles (context) {
  
  this["$style"] = (UiFieldvue_type_style_index_0_module_true_lang_less_["default"].locals || UiFieldvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiField_component = normalizeComponent(
  UiField_UiFieldvue_type_script_lang_js_,
  UiFieldvue_type_template_id_11dad258_render,
  UiFieldvue_type_template_id_11dad258_staticRenderFns,
  false,
  UiField_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiField = (UiField_component.exports);
// CONCATENATED MODULE: ./src/components/UiField/index.js

/* harmony default export */ var components_UiField = (UiField);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInfoBox/UiInfoBox.vue?vue&type=template&id=c5b5db40&
var UiInfoBoxvue_type_template_id_c5b5db40_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes},_vm.$listeners),[(_vm.icon.length)?_c('div',{class:( _obj = {}, _obj[_vm.$style['box__icon-box']] = true, _obj[_vm.$style['box__icon-box_default']] = !_vm.iconSize, _obj )},[_vm._t("icon",function(){
        var _obj;
return [_c('UiIcon',{class:( _obj = {}, _obj[_vm.$style['box__icon']] = true, _obj[_vm.$style['box__icon_default']] = !_vm.iconSize, _obj[_vm.iconClass] = _vm.iconClass, _obj ),style:(_vm.iconStyles),attrs:{"name":_vm.icon}})]})],2):_vm._e(),(_vm.$slots.title)?_c('div',{class:_vm.$style['box__header']},[_c('div',{class:_vm.$style['box__title']},[_vm._t("title")],2),(_vm.expandable)?_c('div',{class:_vm.$style['box__toggle'],on:{"click":_vm.toggle}},[_c('span',[_vm._v(_vm._s(_vm.toggleText))]),_c('UiIcon',{class:_vm.$style['box__toggle-icon'],attrs:{"name":_vm.toggleIcon}})],1):_vm._e()]):_vm._e(),_c('UiCollapse',{class:_vm.$style['box__content'],attrs:{"open":!_vm.expandable || _vm.isOpen}},[(_vm.$slots.description)?[(_vm.replaceLink)?_c('Description'):_c('div',{class:_vm.$style['box__desc']},[_vm._t("description")],2)]:_vm._e(),_vm._t("default")],2)],1)}
var UiInfoBoxvue_type_template_id_c5b5db40_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInfoBox/UiInfoBox.vue?vue&type=template&id=c5b5db40&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLink/UiLink.vue?vue&type=template&id=6494229e&
var UiLinkvue_type_template_id_6494229e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g(_vm._b({class:_vm.classes,attrs:{"href":_vm.href,"target":_vm.target}},'a',Object.assign({}, _vm.$attrs),false),_vm.$listeners),[(_vm.dotBorder)?_c('span',{class:_vm.$style['link__inner']},[_vm._t("default")],2):[_vm._t("default")],(_vm.$slots.icon || _vm.external)?_c('span',{class:_vm.$style['link__icon'],style:(("margin-left: " + _vm.iconOffset + "px;"))},[_vm._t("icon",function(){return [_c('UiIcon',{attrs:{"name":"openInNew"}})]})],2):_vm._e()],2)}
var UiLinkvue_type_template_id_6494229e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiLink/UiLink.vue?vue&type=template&id=6494229e&

// CONCATENATED MODULE: ./src/components/UiLink/enum/sizes.js
/* harmony default export */ var UiLink_enum_sizes = ({
  ARTICLE: 'article',
  BODY: 'body',
  PARAGRAPH: 'paragraph',
  SMALL: 'small',
  TINY: 'tiny',
  TITLE01: 'title-01',
  TITLE02: 'title-02'
});
// CONCATENATED MODULE: ./src/components/UiLink/enum/variants.js
/* harmony default export */ var UiLink_enum_variants = ({
  BREADCRUMBS: 'breadcrumbs',
  DEFAULT: 'default',
  NAVIGATION: 'navigation',
  NAVIGATION_ANCHOR: 'navigation-anchor',
  TITLE: 'title'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLink/UiLink.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiLinkvue_type_script_lang_js_ = ({
  name: 'UiLink',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    href: {
      type: String,
      default: 'javascript:void(0);'
    },

    /**
     * Тип ссылок
     */
    type: {
      type: String,
      validator: variant => Object.values(UiLink_enum_variants).includes(variant),
      default: UiLink_enum_variants.DEFAULT
    },

    /**
     * Размер шрифта
     * Возможные значения совпадают с токенами для параметров шрифта
     * (tiny, small, body, paragraph, article, title-02, title-01)
     */
    size: {
      type: String,
      validator: size => Object.values(UiLink_enum_sizes).includes(size),
      default: UiLink_enum_sizes.BODY
    },

    /**
     * Инвертированный цвет ссылок
     * для тёмного фона
     */
    light: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет внешнюю ссылку
     * добавляется иконка внешней ссылки
     */
    external: {
      type: Boolean,
      default: false
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    },

    /**
     * Смещение иконки от текста
     */
    iconOffset: {
      type: [String, Number],
      default: 2
    },

    /**
     * Подчеркивание dotted
     * вместо стандартного поведения
     */
    dotBorder: {
      type: Boolean,
      default: false
    },

    /**
     * Для переполнение через "..."
     */
    ellipsis: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['link']]: true,
        [this.$style[`link_${this.type}`]]: true,
        [this.$style[`link_${this.size}`]]: true,
        [this.$style[`link_dark`]]: !this.light,
        [this.$style[`link_light`]]: this.light,
        [this.$style[`link_accent`]]: this.accent,
        [this.$style[`link_dot-border`]]: this.dotBorder,
        [this.$style[`link_ellipsis`]]: this.ellipsis
      };
    },

    target() {
      return this.external ? '_blank' : null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiLink/UiLink.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiLink_UiLinkvue_type_script_lang_js_ = (UiLinkvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiLink/UiLink.vue?vue&type=style&index=0&module=true&lang=less&
var UiLinkvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("0dc9");

// CONCATENATED MODULE: ./src/components/UiLink/UiLink.vue








function UiLink_injectStyles (context) {
  
  this["$style"] = (UiLinkvue_type_style_index_0_module_true_lang_less_["default"].locals || UiLinkvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiLink_component = normalizeComponent(
  UiLink_UiLinkvue_type_script_lang_js_,
  UiLinkvue_type_template_id_6494229e_render,
  UiLinkvue_type_template_id_6494229e_staticRenderFns,
  false,
  UiLink_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiLink = (UiLink_component.exports);
// CONCATENATED MODULE: ./src/components/UiLink/index.js

/* harmony default export */ var components_UiLink = (UiLink);
// CONCATENATED MODULE: ./src/components/UiInfoBox/enum/types.js
/* harmony default export */ var UiInfoBox_enum_types = ({
  SIMPLE: 'simple',
  WARNING: 'warning'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInfoBox/UiInfoBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





const makeLink = (el, createElement, Component) => {
  var _el$data, _el$data$attrs, _el$data2, _el$data2$attrs;

  if (el.tag !== 'a') {
    return el;
  }

  const href = el === null || el === void 0 ? void 0 : (_el$data = el.data) === null || _el$data === void 0 ? void 0 : (_el$data$attrs = _el$data.attrs) === null || _el$data$attrs === void 0 ? void 0 : _el$data$attrs.href;
  const target = !!(el !== null && el !== void 0 && (_el$data2 = el.data) !== null && _el$data2 !== void 0 && (_el$data2$attrs = _el$data2.attrs) !== null && _el$data2$attrs !== void 0 && _el$data2$attrs.target);
  return createElement(Component, {
    props: {
      href,
      size: 'small',
      external: target
    }
  }, el.children);
};

/* harmony default export */ var UiInfoBoxvue_type_script_lang_js_ = ({
  name: 'UiInfoBox',
  components: {
    UiCollapse: components_UiCollapse,
    UiIcon: components_UiIcon,
    Description: {
      name: 'Description',
      functional: true,
      components: {
        UiLink: components_UiLink
      },

      render(createElement, {
        props,
        parent
      }) {
        const desc = parent.$slots.description;
        const html = desc.map(item => {
          if (item.tag === 'a') {
            return makeLink(item, createElement, components_UiLink);
          }

          if (Array.isArray(item.children)) {
            return item.children.map(child => makeLink(child, createElement, components_UiLink));
          }

          return item;
        });
        return createElement('div', {
          attrs: {
            class: parent.$style['box__desc']
          }
        }, html);
      }

    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },

    /**
     * Возможность переопределить размер иконки
     */
    iconSize: {
      type: [Number, String],
      dfault: null
    },
    iconClass: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: UiInfoBox_enum_types.SIMPLE
    },

    /**
     * Содержимое может сворачиваться
     */
    expandable: {
      type: Boolean,
      default: false
    },

    /**
     * Для подстановки переводов Скрыть / Показать
     */
    collapseText: {
      type: String,

      default() {
        if (this.expandable) {
          console.error('Missing prop: «collapseText»');
        }

        return null;
      }

    },
    collapsedText: {
      type: String,

      default() {
        if (this.expandable) {
          console.error('Missing prop: «collapsedText»');
        }

        return null;
      }

    },
    open: {
      type: Boolean,
      default: false
    },

    /**
     * Автоматическая замена ссылок на UiLink external
     * Пока отключаем по умолчанию - требуется доработка функционала
     * Обычная разметка не отображается
     */
    replaceLink: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: this.open
    };
  },

  computed: {
    classes() {
      return [this.$style['box'], {
        [this.$style['box_simple']]: this.type === UiInfoBox_enum_types.SIMPLE,
        [this.$style['box_warning']]: this.type === UiInfoBox_enum_types.WARNING
      }];
    },

    iconStyles() {
      const size = parseInt(this.iconSize);

      if (!size) {
        return '';
      }

      return `width: ${size}px; height: ${size}px;`;
    },

    toggleText() {
      return this.isOpen ? this.collapseText : this.collapsedText;
    },

    toggleIcon() {
      return this.isOpen ? 'chevronUp' : 'chevronDown';
    }

  },
  watch: {
    open() {
      this.isOpen = this.open;
    }

  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('toggleInfobox', this.isOpen);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInfoBox/UiInfoBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInfoBox_UiInfoBoxvue_type_script_lang_js_ = (UiInfoBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInfoBox/UiInfoBox.vue?vue&type=style&index=0&module=true&lang=less&
var UiInfoBoxvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("8d16");

// CONCATENATED MODULE: ./src/components/UiInfoBox/UiInfoBox.vue








function UiInfoBox_injectStyles (context) {
  
  this["$style"] = (UiInfoBoxvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInfoBoxvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInfoBox_component = normalizeComponent(
  UiInfoBox_UiInfoBoxvue_type_script_lang_js_,
  UiInfoBoxvue_type_template_id_c5b5db40_render,
  UiInfoBoxvue_type_template_id_c5b5db40_staticRenderFns,
  false,
  UiInfoBox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInfoBox = (UiInfoBox_component.exports);
// CONCATENATED MODULE: ./src/components/UiInfoBox/index.js

/* harmony default export */ var components_UiInfoBox = (UiInfoBox);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInfoBtn/UiInfoBtn.vue?vue&type=template&id=542b597c&
var UiInfoBtnvue_type_template_id_542b597c_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['tooltip']},[_c('div',[_c('v-popover',{attrs:{"trigger":"hover","offset":"2","placement":_vm.placement,"open-class":_vm.$style['open'],"popover-base-class":_vm.$style['btn__content'],"disabled":_vm.disabled}},[_c('button',_vm._g({class:( _obj = {}, _obj[_vm.$style['btn__trigger']] = true, _obj[_vm.$style['btn__trigger_disabled']] = _vm.disabled, _obj ),attrs:{"disabled":_vm.disabled}},_vm.$listeners),[_vm._t("trigger",function(){return [_c('UiIcon',{attrs:{"name":_vm.icon}})]})],2),_c('template',{slot:"popover"},[_c('div',{class:_vm.$style['btn__content-inner']},[_vm._t("default")],2)])],2)],1)])}
var UiInfoBtnvue_type_template_id_542b597c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInfoBtn/UiInfoBtn.vue?vue&type=template&id=542b597c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInfoBtn/UiInfoBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiInfoBtnvue_type_script_lang_js_ = ({
  name: 'UiInfoBtn',
  components: {
    UiIcon: components_UiIcon
  },
  mixins: [deprecated_message],
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    icon: {
      type: String,
      default: 'deleteOutlined'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiInfoBtn/UiInfoBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInfoBtn_UiInfoBtnvue_type_script_lang_js_ = (UiInfoBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInfoBtn/UiInfoBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiInfoBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("9981");

// CONCATENATED MODULE: ./src/components/UiInfoBtn/UiInfoBtn.vue








function UiInfoBtn_injectStyles (context) {
  
  this["$style"] = (UiInfoBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInfoBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInfoBtn_component = normalizeComponent(
  UiInfoBtn_UiInfoBtnvue_type_script_lang_js_,
  UiInfoBtnvue_type_template_id_542b597c_render,
  UiInfoBtnvue_type_template_id_542b597c_staticRenderFns,
  false,
  UiInfoBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInfoBtn = (UiInfoBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiInfoBtn/index.js

/* harmony default export */ var components_UiInfoBtn = (UiInfoBtn);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputGiant/UiInputGiant.vue?vue&type=template&id=254dbf00&
var UiInputGiantvue_type_template_id_254dbf00_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.inputRef.focus()}}},[(_vm.$slots.label || _vm.label)?_c('div',{class:_vm.$style['label']},[_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2):_vm._e(),_c('div',{class:_vm.$style['content']},[_c('div',{ref:"inputContent",class:_vm.$style['content-inner']},[(_vm.$slots.prefix || _vm.leftIcon)?_c('div',{class:_vm.$style['prefix']},[(_vm.leftIcon)?_c('div',{class:_vm.$style['prefix__icon']},[_c('UiIcon',{attrs:{"name":_vm.leftIcon}})],1):_c('div',{class:_vm.$style['prefix__inner']},[_vm._t("prefix")],2)]):_vm._e(),_c('input',{ref:"giantArea",class:_vm.$style['area'],attrs:{"id":_vm.id,"type":_vm.areaType,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required,"maxlength":_vm.maxLength,"name":_vm.name,"min":_vm.isNumberType ? _vm.minNumber : null,"max":_vm.isNumberType ? _vm.maxNumber : null,"step":_vm.step},domProps:{"value":_vm.formatValue},on:{"focus":function($event){return _vm.onFocus()},"blur":function($event){return _vm.onBlur()},"input":_vm.onInput,"keydown":_vm.onKeyDown,"change":function($event){return _vm.$emit('change', $event.target.value)}}}),(_vm.$slots.suffix || _vm.suffix || _vm.rightIcon)?_c('div',{class:_vm.$style['suffix']},[(_vm.rightIcon)?_c('div',{class:_vm.$style['suffix__icon']},[_c('UiIcon',{attrs:{"name":_vm.rightIcon}})],1):[_vm._t("suffix",function(){return [_vm._v(" "+_vm._s(_vm.suffix)+" ")]})]],2):_vm._e()]),(_vm.$slots.postfix)?_c('div',{class:_vm.$style['postfix']},[_vm._t("postfix")],2):_vm._e()]),(_vm.isPlaceholder)?_c('div',{class:_vm.$style['placeholder']},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")]):_vm._e(),(_vm.errorList.length)?_c('UiTooltip',{class:_vm.$style['input__error-tooltip'],attrs:{"dark":true,"show":true,"placement":_vm.errorTooltipPlacement,"container":_vm.errorTooltipContainer,"popover-base-class":_vm.errorTooltipClass,"trigger":"manual"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{attrs:{"data-stub":""}})]},proxy:true}],null,false,3010486570)},_vm._l((_vm.errorList),function(err,i){return _c('div',{key:("error-" + _vm.id + "-" + i)},[_vm._v(" "+_vm._s(err)+" ")])}),0):_vm._e()],1)}
var UiInputGiantvue_type_template_id_254dbf00_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInputGiant/UiInputGiant.vue?vue&type=template&id=254dbf00&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputGiant/UiInputGiant.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



let UiInputGiantvue_type_script_lang_js_idCounter = 0;
/* harmony default export */ var UiInputGiantvue_type_script_lang_js_ = ({
  name: 'UiInputGiant',
  components: {
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip
  },
  mixins: [base_input],
  props: {
    id: {
      type: String,
      default: () => `ui-inp-giant-${++UiInputGiantvue_type_script_lang_js_idCounter}`
    },
    label: {
      type: String,
      default: null
    },
    leftIcon: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    },
    suffix: {
      type: String,
      default: null
    },
    maxLength: {
      type: [String, Number],
      default: null
    },

    /**
     * Форматирование тысячных значений
     */
    thousandsFormat: {
      type: Boolean,
      default: true
    },

    /**
     * К вводу доступны только числа
     */
    isNumber: {
      type: Boolean,
      default: true
    },

    /**
     * Разновидность Числового UiInputGiant
     * Рамка внизу
     * type='number'
     */
    linearStyle: {
      type: Boolean,
      default: false
    },

    /**
     * Включает автоматическое изменение ширины
     * по мере ввода текста
     */
    variableWidth: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isFocus: false,
      caretToEnd: 0,
      valueType: 'string'
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['input']]: true,
        [this.$style['input_focus']]: this.isFocus,
        [this.$style['input_placeholder']]: this.isPlaceholder,
        [this.$style['input_error']]: this.isErrors,
        [this.$style['input_disabled']]: this.disabled,
        [this.$style['input_line-style']]: this.linearStyle
      };
    },

    isPlaceholder() {
      return this.placeholder && !this.isFocus && !('' + this.value).length && !this.linearStyle;
    },

    formatValue() {
      const value = this.getValue;

      if (!this.thousandsFormat || this.linearStyle || this.isNumberType) {
        return value;
      }

      const separator = ' ';
      const formatValue = value.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, '$1' + separator); // Позиционирование каретки

      if (this.caretToEnd > 0) {
        let caretPos = formatValue.length - this.caretToEnd;

        if (caretPos < 0) {
          caretPos = 0;
        }

        this.$nextTick(() => {
          this.inputRef.setSelectionRange(caretPos, caretPos);
        });
      }

      return formatValue;
    },

    areaType() {
      if (this.formattedNumber) {
        return 'tel';
      }

      if (this.type) {
        return this.type;
      }

      if (this.linearStyle) {
        return 'number';
      }

      return 'text';
    },

    inputRef() {
      return this.$refs['giantArea'];
    }

  },

  mounted() {
    this.setAreaWidth();
    this.createIntersectionObserver();
  },

  beforeDestroy() {
    this._observer = null;
  },

  methods: {
    onFocus() {
      this.isFocus = true;
      this.$emit('focus', this.$event);

      if (this.linearStyle) {
        setTimeout(() => {
          this.inputRef.select();
        }, 50);
      }
    },

    onBlur() {
      this.isFocus = false;
      this.$emit('blur', this.$event);
    },

    onInput(e) {
      // Изменение ширины инпута
      this.setAreaWidth();
      let value = e.target.value;
      let val = value.split(' ').join('');
      const key = e.data;
      const caretPos = e.target.selectionStart;

      if (this.formattedNumber) {
        value = value.replace(',', '.');

        if (this.needSetNumberValue(value, key)) {
          return;
        }
      }

      if (this.linearStyle || this.formattedNumber) {
        this.$emit('input', value);
        return;
      } else if (this.isNumberType && isNaN(+val)) {
        this.$emit('input', this.value);
        return;
      } // Позиция каретки относительно конца строки


      this.caretToEnd = value.length - caretPos; // Удаляемый символ - пробел, добавленный при форматировании

      if (value.length < this.formatValue.length && val.length === ('' + this.value).length) {
        this.caretToEnd = this.caretToEnd + 1;
      }

      this.$emit('input', val);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInputGiant/UiInputGiant.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInputGiant_UiInputGiantvue_type_script_lang_js_ = (UiInputGiantvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInputGiant/UiInputGiant.vue?vue&type=style&index=0&module=true&lang=less&
var UiInputGiantvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("2f74");

// CONCATENATED MODULE: ./src/components/UiInputGiant/UiInputGiant.vue








function UiInputGiant_injectStyles (context) {
  
  this["$style"] = (UiInputGiantvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInputGiantvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInputGiant_component = normalizeComponent(
  UiInputGiant_UiInputGiantvue_type_script_lang_js_,
  UiInputGiantvue_type_template_id_254dbf00_render,
  UiInputGiantvue_type_template_id_254dbf00_staticRenderFns,
  false,
  UiInputGiant_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInputGiant = (UiInputGiant_component.exports);
// CONCATENATED MODULE: ./src/components/UiInputGiant/index.js

/* harmony default export */ var components_UiInputGiant = (UiInputGiant);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputNumber/UiInputNumber.vue?vue&type=template&id=4e13da66&
var UiInputNumbervue_type_template_id_4e13da66_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes},_vm.$listeners),[(_vm.label)?_c('span',{class:_vm.$style['input__label']},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('div',{class:_vm.$style['input__inner']},[_c('StepButton',{class:!_vm.isInlineEdit ? _vm.$style['control'] : '',attrs:{"disabled":_vm.disabled || _vm.minDisabled,"is-inline-edit":_vm.isInlineEdit},on:{"click":_vm.decrease}},[_c('UiIcon',{class:!_vm.isInlineEdit ? _vm.$style['icon'] : '',attrs:{"name":_vm.iconRemove}})],1),_c('UiInput',{class:_vm.$style[("field-" + _vm.type)],attrs:{"base-class":_vm.$style['control__input'],"disabled":_vm.disabled,"readonly":_vm.readonly,"clearable":_vm.clearable && !_vm.disabled,"modify":_vm.inputModify,"error":_vm.getError,"error-tooltip-placement":_vm.errorTooltipPlacement,"container":_vm.errorTooltipContainer,"popover-base-class":_vm.errorTooltipClass,"variant":_vm.isInlineEdit ? 'inline-edit' : 'default',"variable-width":_vm.isInlineEdit,"min-area-width":22,"size":"xs","select-on-focus":"","disable-change-value-by-key-arrow":"","type":"number"},on:{"blur":function($event){return _vm.setManualValue($event)},"focus":function($event){_vm.error=false},"input":_vm.onChange},nativeOn:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }$event.preventDefault();return _vm.increase.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }$event.preventDefault();return _vm.decrease.apply(null, arguments)}]},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}}),_c('StepButton',{class:!_vm.isInlineEdit ? _vm.$style['control'] : '',attrs:{"disabled":_vm.disabled || _vm.maxDisabled,"is-inline-edit":_vm.isInlineEdit},on:{"click":_vm.increase}},[_c('UiIcon',{class:!_vm.isInlineEdit ? _vm.$style['icon'] : '',attrs:{"name":_vm.iconAdd}})],1)],1)])}
var UiInputNumbervue_type_template_id_4e13da66_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInputNumber/UiInputNumber.vue?vue&type=template&id=4e13da66&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputNumber/elements/StepButton.vue?vue&type=template&id=9585145c&
var StepButtonvue_type_template_id_9585145c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInlineEdit)?_c('UiButton',_vm._g({attrs:{"disabled":_vm.disabled,"variant":"tertiary","shape":"square","size":"xs"}},_vm.$listeners),[_vm._t("default")],2):_c('button',_vm._g({attrs:{"disabled":_vm.disabled,"type":"button"}},_vm.$listeners),[_vm._t("default")],2)}
var StepButtonvue_type_template_id_9585145c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInputNumber/elements/StepButton.vue?vue&type=template&id=9585145c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputNumber/elements/StepButton.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var StepButtonvue_type_script_lang_js_ = ({
  name: 'StepButton',
  components: {
    UiButton: UiButton
  },
  props: {
    isInlineEdit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiInputNumber/elements/StepButton.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_StepButtonvue_type_script_lang_js_ = (StepButtonvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiInputNumber/elements/StepButton.vue





/* normalize component */

var StepButton_component = normalizeComponent(
  elements_StepButtonvue_type_script_lang_js_,
  StepButtonvue_type_template_id_9585145c_render,
  StepButtonvue_type_template_id_9585145c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StepButton = (StepButton_component.exports);
// CONCATENATED MODULE: ./src/components/UiInputNumber/enum/variants.js
/* harmony default export */ var UiInputNumber_enum_variants = ({
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  INLINE_EDIT: 'inline-edit'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputNumber/UiInputNumber.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiInputNumbervue_type_script_lang_js_ = ({
  name: 'UiInputNumber',
  components: {
    UiIcon: components_UiIcon,
    UiInput: components_UiInput,
    StepButton: StepButton
  },
  model: {
    prop: 'value',
    event: 'changeInputNumber'
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    step: {
      type: Number,
      default: 1
    },
    label: {
      type: String,
      default: ''
    },

    /**
     * Тип
     * Возможные значения:
     * - horizontal: кнопки по бокам
     * - vertical: кнопки справа
     */
    type: {
      type: String,
      validator: variant => Object.values(UiInputNumber_enum_variants).includes(variant),
      default: UiInputNumber_enum_variants.HORIZONTAL
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorText: {
      type: String,
      default: null
    },
    errorTooltipPlacement: {
      type: String,
      default: 'bottom'
    },
    errorTooltipContainer: {
      type: String,
      default: 'body'
    },
    errorTooltipClass: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    responsive: {
      type: Boolean,
      default: false
    },
    strict: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      currentValue: this.getValue(this.value),
      error: false
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['input']]: true,
        [this.$style[`input_type_${this.type}`]]: true,
        [this.$style['input_disabled']]: this.disabled,
        [this.$style['input_responsive']]: this.responsive,
        [this.$style['input_clearable']]: this.clearable
      };
    },

    minDisabled() {
      return this.currentValue <= this.min;
    },

    maxDisabled() {
      return this.currentValue >= this.max;
    },

    iconRemove() {
      return this.isHorisontal || this.isInlineEdit ? 'remove' : 'caretDown';
    },

    iconAdd() {
      return this.isHorisontal || this.isInlineEdit ? 'add' : 'caretUp';
    },

    inputModify() {
      if (this.clearable && !this.disabled) {
        return 'stepper-clearable';
      }

      if (this.isVertical) {
        return 'stepper-vertical';
      }

      if (this.isHorisontal) {
        return 'stepper-horizontal';
      }

      if (this.isInlineEdit) {
        return 'stepper-inline';
      }

      return null;
    },

    getError() {
      if (!this.error) {
        return null;
      }

      return this.errorText ? this.errorText : true;
    },

    isHorisontal() {
      return this.type === UiInputNumber_enum_variants.HORIZONTAL;
    },

    isVertical() {
      return this.type === UiInputNumber_enum_variants.VERTICAL;
    },

    isInlineEdit() {
      return this.type === UiInputNumber_enum_variants.INLINE_EDIT;
    }

  },
  watch: {
    value: {
      immediate: true,

      handler(val) {
        this.currentValue = val;
        this.checkErrors();
      }

    },
    min: {
      immediate: true,

      handler() {
        this.checkErrors();
      }

    },
    max: {
      immediate: true,

      handler() {
        this.checkErrors();
      }

    }
  },
  methods: {
    onChange(e) {
      this.currentValue = isNaN(this.currentValue) ? 0 : this.currentValue;
      this.$emit('changeInputNumber', !this.strict && this.currentValue === '' ? this.currentValue : +this.currentValue);
    },

    setCurrentValue(val) {
      this.currentValue = this.getValue(val);
      this.error = false;
      this.onChange();
    },

    setManualValue() {
      this.checkErrors();
      this.onChange();
    },

    checkErrors() {
      this.error = isNaN(this.currentValue) || this.currentValue > this.max || this.currentValue < this.min;
    },

    decrease() {
      if (this.disabled || this.minDisabled) {
        return false;
      }

      const newVal = (+this.currentValue - this.step).toFixed(1);
      this.setCurrentValue(newVal);
    },

    increase() {
      if (this.disabled || this.maxDisabled) {
        return false;
      }

      const newVal = (+this.currentValue + this.step).toFixed(1);
      this.setCurrentValue(newVal);
    },

    getValue(val) {
      const value = Number(val);

      if (isNaN(value)) {
        return this.currentValue;
      }

      if (value >= this.max) {
        return this.max;
      }

      if (value <= this.min) {
        return this.min;
      }

      return value;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInputNumber/UiInputNumber.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInputNumber_UiInputNumbervue_type_script_lang_js_ = (UiInputNumbervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInputNumber/UiInputNumber.vue?vue&type=style&index=0&module=true&lang=less&
var UiInputNumbervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("4413");

// CONCATENATED MODULE: ./src/components/UiInputNumber/UiInputNumber.vue








function UiInputNumber_injectStyles (context) {
  
  this["$style"] = (UiInputNumbervue_type_style_index_0_module_true_lang_less_["default"].locals || UiInputNumbervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInputNumber_component = normalizeComponent(
  UiInputNumber_UiInputNumbervue_type_script_lang_js_,
  UiInputNumbervue_type_template_id_4e13da66_render,
  UiInputNumbervue_type_template_id_4e13da66_staticRenderFns,
  false,
  UiInputNumber_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInputNumber = (UiInputNumber_component.exports);
// CONCATENATED MODULE: ./src/components/UiInputNumber/index.js

/* harmony default export */ var components_UiInputNumber = (UiInputNumber);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=template&id=72441838&
var UiIntegrationLayoutvue_type_template_id_72441838_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['layout']},_vm.$listeners),[_c('header',{class:_vm.$style['header']},[_c('div',{class:_vm.$style['header__inner']},[_c('nav',{class:_vm.$style['header__nav']},[_c('a',{attrs:{"href":_vm.mainLink}},[_vm._t("logo",function(){
var _obj;
return [_c('img',{class:[_vm.$style['header__nav-logo'], ( _obj = {}, _obj[_vm.logoClass] = _vm.logoClass, _obj )],attrs:{"src":_vm.logoImageSrc}})]})],2),_c('UiIcon',{class:_vm.$style['header__nav-arrow'],attrs:{"name":"arrowLongRight"}}),_c('a',{class:[_vm.$style['header__nav-item'], _vm.$style['header__nav-item_primary']],attrs:{"href":_vm.integrationLink}},[_vm._v(_vm._s(_vm.integration))]),_c('UiIcon',{class:_vm.$style['header__nav-arrow'],attrs:{"name":"arrowLongRight"}}),(_vm.integrationValueLink)?_c('a',{class:_vm.$style['header__nav-item'],attrs:{"href":_vm.integrationValueLink}},[_vm._v(_vm._s(_vm.integrationValue))]):_c('span',{class:_vm.$style['header__nav-item']},[_vm._v(_vm._s(_vm.integrationValue))])],1),_vm._t("headerContent")],2),(_vm.docLink.length)?_c('a',{class:_vm.$style['header__link'],attrs:{"href":_vm.docLink,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.docTitle)+" "),_c('UiIcon',{attrs:{"name":"externalLink"}})],1):_vm._e()]),_c('main',{class:_vm.$style['main']},[_c('aside',{class:_vm.$style['aside']},[_vm._t("asideContent")],2),_c('div',{ref:"content",class:_vm.$style['content']},[_vm._t("mainContent")],2)])])}
var UiIntegrationLayoutvue_type_template_id_72441838_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=template&id=72441838&

// CONCATENATED MODULE: ./src/components/UiIntegrationLayout/enum/brands.js
/* harmony default export */ var brands = ({
  RETAILCRM: 'retailcrm',
  SIMLA: 'simla'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiIntegrationLayoutvue_type_script_lang_js_ = ({
  name: 'UiIntegrationLayout',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    docLink: {
      type: String,
      default: ''
    },
    docTitle: {
      type: String,
      default: 'Документация по настройке'
    },
    mainLink: {
      type: String,
      default: '#'
    },
    integration: {
      type: String,
      required: true
    },
    integrationLink: {
      type: String,
      default: '#'
    },
    integrationValue: {
      type: String,
      required: true
    },
    integrationValueLink: {
      type: String,
      default: null
    },
    brand: {
      type: String,
      validator: brand => Object.values(brands).includes(brand),
      default: brands.RETAILCRM
    },
    logoSrc: {
      type: String,
      default: null
    },
    logoSrcHost: {
      type: String,
      default: 's3-s1.retailcrm.tech'
    },
    logoSrcRegion: {
      type: String,
      default: 'eu-central-1'
    },
    logoClass: {
      type: String,
      default: null
    },
    scrollBehavior: {
      type: String,
      default: 'smooth'
    }
  },
  computed: {
    logoImageSrc() {
      if (this.logoSrc) {
        return this.logoSrc;
      }

      return `//${this.logoSrcHost}/${this.logoSrcRegion}/retailcrm-static/branding/${this.brand}/logo/logo_icon.svg`;
    }

  },
  methods: {
    scrollContent(position = 0) {
      if (!this.$refs.content) {
        return;
      }

      this.$refs.content.scrollTo({
        top: position,
        behavior: this.scrollBehavior
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiIntegrationLayout_UiIntegrationLayoutvue_type_script_lang_js_ = (UiIntegrationLayoutvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=style&index=0&module=true&lang=less&
var UiIntegrationLayoutvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("7867");

// EXTERNAL MODULE: ./src/components/UiIntegrationLayout/UiIntegrationLayout.vue?vue&type=style&index=1&lang=css&
var UiIntegrationLayoutvue_type_style_index_1_lang_css_ = __webpack_require__("be9f");

// CONCATENATED MODULE: ./src/components/UiIntegrationLayout/UiIntegrationLayout.vue









function UiIntegrationLayout_injectStyles (context) {
  
  this["$style"] = (UiIntegrationLayoutvue_type_style_index_0_module_true_lang_less_["default"].locals || UiIntegrationLayoutvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiIntegrationLayout_component = normalizeComponent(
  UiIntegrationLayout_UiIntegrationLayoutvue_type_script_lang_js_,
  UiIntegrationLayoutvue_type_template_id_72441838_render,
  UiIntegrationLayoutvue_type_template_id_72441838_staticRenderFns,
  false,
  UiIntegrationLayout_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiIntegrationLayout = (UiIntegrationLayout_component.exports);
// CONCATENATED MODULE: ./src/components/UiIntegrationLayout/index.js

/* harmony default export */ var components_UiIntegrationLayout = (UiIntegrationLayout);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/UiColorPicker.vue?vue&type=template&id=591bb2e0&
var UiColorPickervue_type_template_id_591bb2e0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['cp']},[_c('v-popover',{attrs:{"open":_vm.isOpen,"open-class":_vm.$style['open'],"popover-base-class":[_vm.$style['cp__content'], _vm.baseClass],"container":_vm.container,"placement":_vm.placement,"popper-options":_vm.popperOptions,"offset":"4","trigger":"manual","auto-hide":false}},[_c('div',{class:_vm.$style['cp__trigger'],on:{"click":_vm.openMenu}},[_c('UiInput',{attrs:{"value":_vm.color,"disabled":_vm.disabled,"readonly":_vm.readonly,"icon-right-state-fill":false},on:{"input":_vm.onInput,"focus":function($event){_vm.isFocus = true},"blur":function($event){_vm.isFocus = false},"paste":function($event){$event.preventDefault();return _vm.onPasteValue.apply(null, arguments)}},scopedSlots:_vm._u([{key:"iconRight",fn:function(){return [_c('UiIcon',{style:(_vm.iconStyles),attrs:{"name":"color"}})]},proxy:true}])})],1),_c('template',{slot:"popover"},[_c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{class:_vm.$style['cp__content-inner']},[_c('ColorBox',{ref:"colorBox",attrs:{"color":_vm.currentColor,"active":_vm.isOpen},on:{"changeColor":_vm.onChangeColor}})],1)])])],2)],1)}
var UiColorPickervue_type_template_id_591bb2e0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiColorPicker/UiColorPicker.vue?vue&type=template&id=591bb2e0&

// EXTERNAL MODULE: ./node_modules/tinycolor2/tinycolor.js
var tinycolor = __webpack_require__("66cb");
var tinycolor_default = /*#__PURE__*/__webpack_require__.n(tinycolor);

// CONCATENATED MODULE: ./src/components/UiColorPicker/helpers/color-validate.js
/* harmony default export */ var color_validate = (color => {
  if (!color) {
    return null;
  }

  let resultColor = color; // Ввели частично невалидируемое - обрезаем лишнее

  for (let i = 0; i < resultColor.length; i++) {
    if (!/^[0-9A-F]$/i.test(resultColor[i])) {
      resultColor = resultColor.slice(0, i);
      break;
    }
  }

  if (resultColor.length <= 3) {
    resultColor = resultColor.repeat(6 / resultColor.length);
  } else if (resultColor.length === 4) {
    resultColor = `${resultColor}00`;
  } else if (resultColor.length === 5) {
    resultColor = `${resultColor}0`;
  } else if (resultColor.length > 8) {
    resultColor = resultColor.slice(0, 8);
  }

  return `#${resultColor}`;
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/ColorBox.vue?vue&type=template&id=737a71e4&
var ColorBoxvue_type_template_id_737a71e4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['color-box']},[_c('div',{staticClass:"color-box__saturation"},[_c('SaturationSlider',{attrs:{"hue":_vm.hue,"saturation":_vm.saturation,"value":_vm.value,"color":_vm.currentColor},on:{"changeValue":_vm.onChangeSaturationSlider}})],1),_c('div',{class:_vm.$style['color-box__sliders']},[_c('div',{class:_vm.$style['color-box__sliders-body']},[_c('div',{class:_vm.$style['color-box__row']},[_c('HueSlider',{on:{"changeHue":_vm.onChangeHue},model:{value:(_vm.hue),callback:function ($$v) {_vm.hue=$$v},expression:"hue"}})],1)])]),_c('div',{class:_vm.$style['panel']},[_c('UiInput',{ref:"colorValue",class:_vm.$style['panel__color'],attrs:{"value":_vm.hex},on:{"input":_vm.onInputValue,"keydown":_vm.onKeyDownInput,"focus":_vm.setInputFocus,"blur":_vm.onBlurValue,"paste":function($event){$event.preventDefault();return _vm.onPasteValue.apply(null, arguments)}}}),_c('UiInput',{ref:"alpha",class:_vm.$style['panel__alpha'],on:{"input":function($event){return _vm.setCaretPosition('alpha')}},model:{value:(_vm.currentAlpha),callback:function ($$v) {_vm.currentAlpha=$$v},expression:"currentAlpha"}}),_c('div',{class:_vm.$style['panel__color-value'],style:(("background: " + _vm.currentColor + ";"))})],1),_c('UiButton',{class:_vm.$style['color-box__btn'],on:{"click":_vm.apply}},[_vm._v(" "+_vm._s(_vm.I18N[_vm.locale].apply)+" ")])],1)}
var ColorBoxvue_type_template_id_737a71e4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorBox.vue?vue&type=template&id=737a71e4&

// CONCATENATED MODULE: ./src/components/UiColorPicker/enum/format.js
/* harmony default export */ var enum_format = ({
  HEX: 'hex',
  HEX8: 'hex8',
  RGB: 'rgb',
  RGBA: 'rgba'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/SaturationSlider.vue?vue&type=template&id=769ad607&
var SaturationSlidervue_type_template_id_769ad607_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['saturation'],style:(("background-color: hsl(" + _vm.hue + ", 100%, 50%);"))},[_c('div',{class:[_vm.$style['saturation__grad'], _vm.$style['saturation__grad_white']]}),_c('div',{class:[_vm.$style['saturation__grad'], _vm.$style['saturation__grad_black']]}),_c('div',{class:_vm.$style['saturation-pointer'],style:(("left: " + _vm.left + "%; top: " + _vm.top + "%;"))},[_c('div',{class:_vm.$style['saturation-pointer__inner']})])])}
var SaturationSlidervue_type_template_id_769ad607_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/SaturationSlider.vue?vue&type=template&id=769ad607&

// CONCATENATED MODULE: ./src/components/UiColorPicker/helpers/draggable.js
let isDragging = false;
/* harmony default export */ var draggable = (function (element, options) {
  const moveFn = function (event) {
    if (options.drag) {
      options.drag(event);
    }
  };

  const upFn = function (event) {
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.onselectstart = null;
    document.ondragstart = null;
    isDragging = false;

    if (options.end) {
      options.end(event);
    }
  };

  element.addEventListener('mousedown', function (event) {
    if (isDragging) return;

    document.onselectstart = function () {
      return false;
    };

    document.ondragstart = function () {
      return false;
    };

    document.addEventListener('mousemove', moveFn);
    document.addEventListener('mouseup', upFn);
    isDragging = true;

    if (options.start) {
      options.start(event);
    }
  });
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/SaturationSlider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SaturationSlidervue_type_script_lang_js_ = ({
  name: 'SaturationSlider',
  inject: ['colorBox'],
  props: {
    hue: {
      type: [Number, String],
      default: null
    },
    saturation: {
      type: [Number, String],
      default: null
    },
    value: {
      type: [Number, String],
      default: null
    },
    color: {
      type: [String],
      default: null
    }
  },

  data() {
    return {
      top: 0,
      left: 0
    };
  },

  watch: {
    color() {
      this.setPointerCoords();
    },

    saturation() {
      this.setPointerCoords();
    },

    value() {
      this.setPointerCoords();
    }

  },

  mounted() {
    draggable(this.$el, {
      drag: e => {
        this.colorBox._dragSV = true;
        this.onDragPointer(e);
      },
      end: e => {
        setTimeout(() => {
          this.colorBox._dragSV = false;
        }, 100);
        this.onDragPointer(e);
      }
    });
    this.$nextTick(() => {
      this.setPointerCoords();
    });
  },

  methods: {
    onDragPointer(e) {
      const el = this.$el;
      const rect = el.getBoundingClientRect();
      let left = e.clientX - rect.left;
      let top = e.clientY - rect.top;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);
      left = Math.round(left / rect.width * 100);
      top = Math.max(0, top);
      top = Math.min(top, rect.height);
      top = Math.round(top / rect.height * 100);
      this.left = left;
      this.top = top;
      this.$emit('changeValue', {
        saturation: left,
        value: 100 - top
      });
    },

    setPointerCoords() {
      if (this.saturation === null || this.value === null) {
        return;
      }

      this.left = this.saturation;
      this.top = 100 - this.value;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/SaturationSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_SaturationSlidervue_type_script_lang_js_ = (SaturationSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiColorPicker/elements/SaturationSlider.vue?vue&type=style&index=0&module=true&lang=less&
var SaturationSlidervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("a523");

// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/SaturationSlider.vue








function SaturationSlider_injectStyles (context) {
  
  this["$style"] = (SaturationSlidervue_type_style_index_0_module_true_lang_less_["default"].locals || SaturationSlidervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var SaturationSlider_component = normalizeComponent(
  elements_SaturationSlidervue_type_script_lang_js_,
  SaturationSlidervue_type_template_id_769ad607_render,
  SaturationSlidervue_type_template_id_769ad607_staticRenderFns,
  false,
  SaturationSlider_injectStyles,
  null,
  null
  
)

/* harmony default export */ var SaturationSlider = (SaturationSlider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/HueSlider.vue?vue&type=template&id=63b39d75&
var HueSlidervue_type_template_id_63b39d75_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['hue-slider']},[_c('ColorSlider',{attrs:{"track-class":_vm.$style['hue-slider-track']},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})],1)}
var HueSlidervue_type_template_id_63b39d75_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/HueSlider.vue?vue&type=template&id=63b39d75&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/ColorSlider.vue?vue&type=template&id=97657590&
var ColorSlidervue_type_template_id_97657590_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['color-slider']},[_c('div',{ref:"track",class:[_vm.$style['color-slider__track'], ( _obj = {}, _obj[_vm.trackClass] = _vm.trackClass, _obj )]},[_c('div',{class:_vm.$style['slider-pointer'],style:(("left: " + _vm.value + "%;"))},[_c('div',{class:_vm.$style['slider-pointer__inner'],style:(("background: hsl(" + (_vm.colorBox.hue) + ", 100%, 50%);"))})])])])}
var ColorSlidervue_type_template_id_97657590_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorSlider.vue?vue&type=template&id=97657590&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/ColorSlider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ColorSlidervue_type_script_lang_js_ = ({
  name: 'ColorSlider',
  model: {
    prop: 'value',
    event: 'changeValue'
  },
  inject: ['colorBox'],
  props: {
    /**
     * Положение ползунка от левого края в %
     */
    value: {
      type: Number,
      default: 0,
      required: true
    },

    /**
     * Сss класс для ползунка
     */
    trackClass: {
      type: String,
      default: null
    }
  },

  mounted() {
    draggable(this.$el, {
      drag: e => {
        this.colorBox._dragSV = true;
        this.onDragPointer(e);
      },
      end: e => {
        setTimeout(() => {
          this.colorBox._dragSV = false;
        }, 100);
        this.onDragPointer(e);
      }
    });
  },

  methods: {
    onDragPointer(e) {
      if (!this.$refs.track) {
        return;
      }

      const el = this.$refs.track;
      const rect = el.getBoundingClientRect();
      let left = e.clientX - rect.left;
      left = Math.max(0, left);
      left = Math.min(left, rect.width);
      this.$emit('changeValue', Math.round(left / rect.width * 100));
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_ColorSlidervue_type_script_lang_js_ = (ColorSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiColorPicker/elements/ColorSlider.vue?vue&type=style&index=0&module=true&lang=less&
var ColorSlidervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("1680");

// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorSlider.vue








function ColorSlider_injectStyles (context) {
  
  this["$style"] = (ColorSlidervue_type_style_index_0_module_true_lang_less_["default"].locals || ColorSlidervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var ColorSlider_component = normalizeComponent(
  elements_ColorSlidervue_type_script_lang_js_,
  ColorSlidervue_type_template_id_97657590_render,
  ColorSlidervue_type_template_id_97657590_staticRenderFns,
  false,
  ColorSlider_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ColorSlider = (ColorSlider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/HueSlider.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HueSlidervue_type_script_lang_js_ = ({
  name: 'HueSlider',
  components: {
    ColorSlider: ColorSlider
  },
  model: {
    prop: 'hue',
    event: 'changeHue'
  },
  props: {
    /**
     * Текущее значение цветового тона
     */
    hue: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    sliderValue: {
      get() {
        return Math.round(this.hue / 360 * 100);
      },

      set(value) {
        this.$emit('changeHue', Math.round(value / 100 * 360));
      }

    }
  }
});
// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/HueSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_HueSlidervue_type_script_lang_js_ = (HueSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiColorPicker/elements/HueSlider.vue?vue&type=style&index=0&module=true&lang=less&
var HueSlidervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("eda1");

// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/HueSlider.vue








function HueSlider_injectStyles (context) {
  
  this["$style"] = (HueSlidervue_type_style_index_0_module_true_lang_less_["default"].locals || HueSlidervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var HueSlider_component = normalizeComponent(
  elements_HueSlidervue_type_script_lang_js_,
  HueSlidervue_type_template_id_63b39d75_render,
  HueSlidervue_type_template_id_63b39d75_staticRenderFns,
  false,
  HueSlider_injectStyles,
  null,
  null
  
)

/* harmony default export */ var HueSlider = (HueSlider_component.exports);
// CONCATENATED MODULE: ./src/components/UiColorPicker/i18n.js
const UiColorPicker_i18n_LOCALES = {
  EN: 'en',
  ES: 'es',
  RU: 'ru'
};
/* harmony default export */ var UiColorPicker_i18n = ({
  [UiColorPicker_i18n_LOCALES.EN]: {
    apply: 'Apply'
  },
  [UiColorPicker_i18n_LOCALES.ES]: {
    apply: 'Aplicar'
  },
  [UiColorPicker_i18n_LOCALES.RU]: {
    apply: 'Применить'
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/elements/ColorBox.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var ColorBoxvue_type_script_lang_js_ = ({
  name: 'ColorBox',
  components: {
    SaturationSlider: SaturationSlider,
    HueSlider: HueSlider,
    UiInput: components_UiInput,
    UiButton: components_UiButton
  },
  model: {
    prop: 'color',
    event: 'changeColor'
  },
  props: {
    /**
     * Текущее значение цвета
     */
    color: {
      type: String,
      default: '#ffffff'
    },

    /**
     * Состояние поповера,
     * в котором находится компонент
     */
    active: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String,
      validator: locale => Object.values(UiColorPicker_i18n_LOCALES).includes(locale),
      default: UiColorPicker_i18n_LOCALES.RU
    }
  },

  provide() {
    return {
      'colorBox': this
    };
  },

  data() {
    return {
      format: enum_format.HEX,
      hue: null,
      saturation: null,
      value: null,
      alpha: 1,
      hex: 'ffffff'
    };
  },

  computed: {
    I18N: () => UiColorPicker_i18n,
    currentColor: {
      get() {
        const tColor = tinycolor_default()(`#${this.hex}`);

        if (this.alpha < 1) {
          tColor.setAlpha(this.alpha);
          return tColor.toHex8String();
        }

        return tColor.toHexString();
      },

      set() {}

    },
    currentAlpha: {
      get() {
        return `${Math.round(this.alpha * 100)}%`;
      },

      set(value) {
        let alpha = value.replace('%', '');

        if (isNaN(alpha)) {
          return;
        }

        if (alpha >= 0 && alpha <= 1) {
          this.alpha = alpha;
        }

        alpha = alpha < 0 ? 0 : alpha > 100 ? 100 : alpha;
        this.alpha = alpha / 100;
      }

    },

    getComputedColor() {
      return this.hex.replace('#', '').slice(0, 6);
    },

    locale() {
      if (this.$getLocale) {
        return this.$getLocale().split('_')[0];
      }

      return this.lang;
    }

  },
  watch: {
    color(color) {
      this.setColor(color);
    },

    alpha(alpha) {
      let color = tinycolor_default()(this.currentColor).setAlpha(alpha);
      this.currentColor = alpha === 1 ? color.toHexString() : color.toHex8String();
      this.alpha = alpha;
    },

    active: {
      immediate: true,

      handler(value) {
        if (value) {
          this.setInputFocus();
        }
      }

    }
  },

  mounted() {
    this.setColor(this.color);
  },

  methods: {
    setColor(color, setAlpha = true, isCurrentHex) {
      if (!color) {
        color = '#ffffff';
      }

      const tColor = tinycolor_default()(color);
      const format = tColor.getFormat();

      if (!format || this._dragSV) {
        return;
      }

      const hsv = tColor.toHsv();
      this.format = format;
      this.hue = Math.round(hsv.h);
      this.saturation = Math.round(hsv.s * 100);
      this.value = Math.round(hsv.v * 100);

      if (setAlpha && (color.length >= 7 || hsv.a === 1)) {
        this.alpha = hsv.a;
      }

      if (!isCurrentHex) {
        this.hex = tColor.toHexString().replace('#', '');
      } else {
        this.hex = color.replace('#', '');
      }
    },

    onChangeSaturationSlider(e) {
      this.saturation = e.saturation;
      this.value = e.value;
      this.updateValue();
    },

    onChangeHue(e) {
      this.hue = e;
      this.updateValue();
    },

    updateValue() {
      const colorString = `hsv(${this.hue}, ${this.saturation}%, ${this.value}%)`;
      const color = tinycolor_default()(colorString);
      this.hex = color.toHexString().replace('#', '');
    },

    setCaretPosition(ref) {
      if (!this.$refs[ref]) {
        return;
      }

      const input = this.$refs[ref].$el.querySelector('input');
      const cursorPosition = input.selectionStart;
      this.$nextTick(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    },

    onInputValue(e) {
      if (!this.$refs['colorValue']) {
        return;
      }

      if (e.length > this.oldValue.length && (!/^[0-9A-F]$/i.test(this.lastSymbol) || this.oldValue.length >= 6)) {
        const input = this.$refs['colorValue'].$el.querySelector('input');
        const cursorPosition = input.selectionStart;
        input.value = this.oldValue;
        this.$nextTick(() => {
          input.setSelectionRange(cursorPosition, cursorPosition);
        });
      }

      const transformColor = tinycolor_default()(`#${e}`);

      if (transformColor.isValid()) {
        this.setColor(`#${e}`, false, true);
      }

      this.oldValue = '';
      this.lastSymbol = '';
    },

    onBlurValue(e) {
      const value = color_validate(e.target.value);

      if (value) {
        this.setColor(value, false);
      }
    },

    onKeyDownInput(e) {
      this.oldValue = e.target.value;
      this.lastSymbol = e.key.toUpperCase();
    },

    onPasteValue(e) {
      const text = e.clipboardData.getData('text').replace('#', '');
      const value = color_validate(text);
      const transformColor = tinycolor_default()(value);

      if (transformColor.isValid()) {
        this.setColor(transformColor.toHexString());
      }
    },

    setInputFocus() {
      if (!this.$refs['colorValue']) {
        return;
      }

      setTimeout(() => {
        this.$refs['colorValue'].$el.querySelector('input').select();
      }, 200);
    },

    apply() {
      this.$emit('changeColor', this.currentColor);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorBox.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_ColorBoxvue_type_script_lang_js_ = (ColorBoxvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiColorPicker/elements/ColorBox.vue?vue&type=style&index=0&module=true&lang=less&
var ColorBoxvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("5d6f");

// CONCATENATED MODULE: ./src/components/UiColorPicker/elements/ColorBox.vue








function ColorBox_injectStyles (context) {
  
  this["$style"] = (ColorBoxvue_type_style_index_0_module_true_lang_less_["default"].locals || ColorBoxvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var ColorBox_component = normalizeComponent(
  elements_ColorBoxvue_type_script_lang_js_,
  ColorBoxvue_type_template_id_737a71e4_render,
  ColorBoxvue_type_template_id_737a71e4_staticRenderFns,
  false,
  ColorBox_injectStyles,
  null,
  null
  
)

/* harmony default export */ var ColorBox = (ColorBox_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiColorPicker/UiColorPicker.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var UiColorPickervue_type_script_lang_js_ = ({
  name: 'UiColorPicker',
  components: {
    UiInput: components_UiInput,
    ColorBox: ColorBox,
    UiIcon: components_UiIcon
  },
  model: {
    prop: 'value',
    event: 'changeColor'
  },
  props: {
    value: {
      type: String,
      default: '#fffff'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    container: {
      type: String,
      default: 'body'
    },
    placement: {
      type: String,
      default: 'bottom-start'
    },
    baseClass: {
      type: String,
      default: null
    },
    popperOptions: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isOpen: false,
      isFocus: false
    };
  },

  computed: {
    color: {
      get() {
        return this.value.replace('#', '');
      },

      set(color) {
        this.$emit('changeColor', color);
      }

    },
    currentColor: {
      get() {
        return this.color;
      },

      set(color) {
        if (this.isFocus && this.color !== color) {
          return;
        }

        this.color = color;
      }

    },

    iconStyles() {
      let stroke = 'none';
      let fill = '#C7CDD4';
      const color = tinycolor_default()(`#${this.color}`);

      if (!color.isValid() || color.isLight()) {
        stroke = '#DEE2E6';
      }

      if (this.color) {
        fill = `#${this.color}`;
      }

      return `fill: ${fill}; stroke: ${stroke};`;
    }

  },

  mounted() {
    document.addEventListener('click', this.onDocumentClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.onDocumentClick);
  },

  methods: {
    openMenu() {
      if (this.disabled) {
        return;
      }

      this.isOpen = true;
    },

    onInput(e) {
      if (!e) {
        this.color = '';
      }

      if (/^[0-9A-F]{1,8}$/i.test(e.toUpperCase())) {
        this.color = e;
      } else {
        const input = this.$el.querySelector('input');
        const cursorPosition = input.selectionStart;
        input.value = this.color;
        this.$nextTick(() => {
          input.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    },

    onPasteValue(e) {
      const text = e.clipboardData.getData('text').replace('#', '');
      const value = color_validate(text);
      const transformColor = tinycolor_default()(value);

      if (transformColor.isValid()) {
        this.color = value;
      }
    },

    onDocumentClick(e) {
      const isDragPointer = !!(this.$refs.colorBox && this.$refs.colorBox._dragSV);

      if (!e.target.closest(`.${this.$style['cp__trigger']}`) && !isDragPointer) {
        this.isOpen = false;
      }
    },

    onChangeColor(e) {
      this.color = e;
      this.isOpen = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiColorPicker/UiColorPicker.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiColorPicker_UiColorPickervue_type_script_lang_js_ = (UiColorPickervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiColorPicker/UiColorPicker.vue?vue&type=style&index=0&module=true&lang=less&
var UiColorPickervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("b889");

// CONCATENATED MODULE: ./src/components/UiColorPicker/UiColorPicker.vue








function UiColorPicker_injectStyles (context) {
  
  this["$style"] = (UiColorPickervue_type_style_index_0_module_true_lang_less_["default"].locals || UiColorPickervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiColorPicker_component = normalizeComponent(
  UiColorPicker_UiColorPickervue_type_script_lang_js_,
  UiColorPickervue_type_template_id_591bb2e0_render,
  UiColorPickervue_type_template_id_591bb2e0_staticRenderFns,
  false,
  UiColorPicker_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiColorPicker = (UiColorPicker_component.exports);
// CONCATENATED MODULE: ./src/components/UiColorPicker/index.js

/* harmony default export */ var components_UiColorPicker = (UiColorPicker);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiListBtn/UiListBtn.vue?vue&type=template&id=184496aa&
var UiListBtnvue_type_template_id_184496aa_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['list-btn']},_vm.$listeners),[(_vm.icon.length)?_c('div',{class:_vm.$style['list-btn__icon']},[_c('UiIcon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_c('div',{class:_vm.$style['list-btn__content']},[_vm._t("default")],2),_c('div',{class:_vm.$style['list-btn__remove'],on:{"click":function($event){return _vm.$emit('remove')}}},[_c('UiIcon',{attrs:{"name":"clear"}})],1)])}
var UiListBtnvue_type_template_id_184496aa_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiListBtn/UiListBtn.vue?vue&type=template&id=184496aa&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiListBtn/UiListBtn.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiListBtnvue_type_script_lang_js_ = ({
  name: 'UiListBtn',
  components: {
    UiIcon: components_UiIcon
  },
  mixins: [deprecated_message],
  props: {
    icon: {
      type: String,
      default: ''
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiListBtn/UiListBtn.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiListBtn_UiListBtnvue_type_script_lang_js_ = (UiListBtnvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiListBtn/UiListBtn.vue?vue&type=style&index=0&module=true&lang=less&
var UiListBtnvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("8824");

// CONCATENATED MODULE: ./src/components/UiListBtn/UiListBtn.vue








function UiListBtn_injectStyles (context) {
  
  this["$style"] = (UiListBtnvue_type_style_index_0_module_true_lang_less_["default"].locals || UiListBtnvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiListBtn_component = normalizeComponent(
  UiListBtn_UiListBtnvue_type_script_lang_js_,
  UiListBtnvue_type_template_id_184496aa_render,
  UiListBtnvue_type_template_id_184496aa_staticRenderFns,
  false,
  UiListBtn_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiListBtn = (UiListBtn_component.exports);
// CONCATENATED MODULE: ./src/components/UiListBtn/index.js

/* harmony default export */ var components_UiListBtn = (UiListBtn);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLoader/UiLoader.vue?vue&type=template&id=0e3eaa5a&
var UiLoadervue_type_template_id_0e3eaa5a_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getWrapper,_vm._b({tag:"component"},'component',_vm.wrapperProps,false),[_c('div',{class:( _obj = {}, _obj[_vm.$style['loader']] = true, _obj[_vm.$style['loader_fixed']] = _vm.fixed, _obj[_vm.$style['loader_without-overlay']] = !_vm.overlay, _obj ),style:(_vm.styles)},[_vm._t("default",function(){return [_c('div',{class:_vm.$style['loader__icon']})]})],2)])}
var UiLoadervue_type_template_id_0e3eaa5a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiLoader/UiLoader.vue?vue&type=template&id=0e3eaa5a&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiLoader/UiLoader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiLoadervue_type_script_lang_js_ = ({
  name: 'UiLoader',
  components: {
    UiTransition: components_UiTransition
  },
  props: {
    /**
     * fixed loader
     */
    fixed: {
      type: Boolean,
      default: false
    },

    /**
     * Показывать полупрозрачную подложку
     */
    overlay: {
      type: Boolean,
      default: true
    },

    /**
     * Название эффекта появления лоадера
     */
    transitionName: {
      type: String,
      default: 'fade-2'
    },

    /**
     * Не использовать плавное появление лоадера
     */
    useTransition: {
      type: Boolean,
      default: true
    },

    /**
     * Размер окружности лоадера
     */
    size: {
      type: [Number, String],
      default: 40
    },

    /**
     * Толщина линии лоадера
     */
    lineWidth: {
      type: [Number, String],
      default: 2
    }
  },
  computed: {
    getWrapper() {
      if (this.useTransition) {
        return components_UiTransition;
      }

      return 'div';
    },

    wrapperProps() {
      if (this.useTransition) {
        return {
          name: this.transitionName,
          appear: true,
          class: 'ui-loader-wrapper'
        };
      }

      return {};
    },

    styles() {
      return `--loader-size: ${parseInt(this.size)}px; --loader-line-width: ${parseInt(this.lineWidth)}px;`;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiLoader/UiLoader.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiLoader_UiLoadervue_type_script_lang_js_ = (UiLoadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiLoader/UiLoader.vue?vue&type=style&index=0&module=true&lang=less&
var UiLoadervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("2b16");

// EXTERNAL MODULE: ./src/components/UiLoader/UiLoader.vue?vue&type=style&index=1&lang=less&
var UiLoadervue_type_style_index_1_lang_less_ = __webpack_require__("d1f7");

// CONCATENATED MODULE: ./src/components/UiLoader/UiLoader.vue









function UiLoader_injectStyles (context) {
  
  this["$style"] = (UiLoadervue_type_style_index_0_module_true_lang_less_["default"].locals || UiLoadervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiLoader_component = normalizeComponent(
  UiLoader_UiLoadervue_type_script_lang_js_,
  UiLoadervue_type_template_id_0e3eaa5a_render,
  UiLoadervue_type_template_id_0e3eaa5a_staticRenderFns,
  false,
  UiLoader_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiLoader = (UiLoader_component.exports);
// CONCATENATED MODULE: ./src/components/UiLoader/index.js

/* harmony default export */ var components_UiLoader = (UiLoader);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModalSidebar/UiModalSidebar.vue?vue&type=template&id=e33de286&
var UiModalSidebarvue_type_template_id_e33de286_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTransition',{key:("id-" + (1)),attrs:{"name":"fade-2"}},[_c('div',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],class:_vm.overlayClasses,attrs:{"id":_vm.id,"data-overlay":""},on:{"click":_vm.close}},_vm.$listeners),[_c('UiTransition',{key:("id-" + (2)),attrs:{"name":_vm.transitionName}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],class:_vm.sidebarClasses},[_c('div',{class:_vm.$style['modal-sidebar__head']},[_c('div',{class:_vm.$style['modal-sidebar__head-inner']},[_c('div',{class:( _obj = {}, _obj[_vm.$style['modal-sidebar__title']] = true, _obj[_vm.$style['modal-sidebar__title_ellipsis']] = _vm.ellipsisTitle, _obj )},[_vm._t("head")],2)]),_c('div',{class:_vm.$style['modal-sidebar__close'],attrs:{"data-close-sidebar":""}},[_c('UiTooltip',{attrs:{"container":("#" + _vm.id),"placement":"bottom","offset":"0","dark":"","center-text":""},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('UiIcon',{attrs:{"name":"clear"}})]},proxy:true}])},[_vm._v(" Esc ")])],1)]),(_vm.fixedBody)?_c('div',{class:_vm.$style['modal-sidebar__body-fixed']},[_vm._t("default")],2):_c('UiScrollbar',{class:_vm.$style['modal-sidebar__body']},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{class:_vm.$style['modal-sidebar__footer']},[_vm._t("footer")],2):_vm._e()],1)])],1)])}
var UiModalSidebarvue_type_template_id_e33de286_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiModalSidebar/UiModalSidebar.vue?vue&type=template&id=e33de286&

// CONCATENATED MODULE: ./src/mixins/close-on-esc.js
/* harmony default export */ var close_on_esc = ({
  methods: {
    closeOnEsc(e) {
      if (!this.isOpen || !this.close || e.key !== 'Escape') {
        return;
      }

      this.close();
    }

  },

  mounted() {
    document.addEventListener('keydown', this.closeOnEsc);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.closeOnEsc);
  }

});
// CONCATENATED MODULE: ./src/components/UiModalSidebar/enum/directions.js
/* harmony default export */ var directions = ({
  LEFT: 'left',
  RIGHT: 'right'
});
// CONCATENATED MODULE: ./src/components/UiModalSidebar/enum/sizes.js
/* harmony default export */ var UiModalSidebar_enum_sizes = ({
  LG: 'lg',
  SM: 'sm'
});
// CONCATENATED MODULE: ./src/components/UiModalSidebar/enum/types.js
/* harmony default export */ var UiModalSidebar_enum_types = ({
  DEFAULT: 'default',
  FIXED: 'fixed'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiModalSidebar/UiModalSidebar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








let UiModalSidebarvue_type_script_lang_js_idCounter = 0;
/* harmony default export */ var UiModalSidebarvue_type_script_lang_js_ = ({
  name: 'UiModalSidebar',
  components: {
    UiIcon: components_UiIcon,
    UiTransition: components_UiTransition,
    UiScrollbar: components_UiScrollbar,
    UiTooltip: components_UiTooltip
  },
  mixins: [close_on_esc],
  model: {
    prop: 'open',
    event: 'toggleSidebar'
  },
  props: {
    id: {
      type: String,
      default: () => `ui-sidebar-${++UiModalSidebarvue_type_script_lang_js_idCounter}`
    },
    open: {
      type: Boolean,
      default: false
    },
    canClose: {
      type: Boolean,
      default: true
    },

    /**
     * Определяет направление появления сайдбара
     */
    direction: {
      type: String,
      default: directions.RIGHT
    },

    /**
     * Тип сайдбара
     * fixed - фиксированный сайдбар без оверлея
     */
    type: {
      type: String,
      default: UiModalSidebar_enum_types.DEFAULT
    },
    size: {
      type: String,
      default: UiModalSidebar_enum_sizes.SM
    },

    /**
     * Определяет сокращение текста закоголовка шторки
     * через троеточие
     */
    ellipsisTitle: {
      type: Boolean,
      default: true
    },

    /**
     * Содержимое шторки не будет скроллится
     * и не будет иметь внутренних отступов
     */
    fixedBody: {
      type: Boolean,
      default: false
    },

    /**
     * Контент страницы не будет скроллиться
     * при открытой шторке
     */
    blockScroll: {
      type: Boolean,
      default: true
    },

    /**
     * Переданный класс будет навешиваться на тэг html
     * при открытой шторке
     */
    disableScrollClass: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      isOpen: this.open
    };
  },

  computed: {
    overlayClasses() {
      return {
        [this.$style['modal-overlay']]: true,
        [this.$style[`modal-overlay_${this.type}`]]: this.type !== UiModalSidebar_enum_types.DEFAULT,
        [this.$style[`modal-overlay_${this.direction}`]]: this.type !== UiModalSidebar_enum_types.DEFAULT
      };
    },

    sidebarClasses() {
      return {
        [this.$style['modal-sidebar']]: true,
        [this.$style[`modal-sidebar_${this.size}`]]: true,
        [this.$style[`modal-sidebar_${this.direction}`]]: this.direction !== directions.RIGHT
      };
    },

    transitionName() {
      return `slide-${this.direction}`;
    }

  },
  watch: {
    open(open) {
      this.isOpen = open;
      this.toggleBodyOverflow(open);
    }

  },

  mounted() {
    this.toggleBodyOverflow(this.open);
  },

  beforeDestroy() {
    this.toggleBodyOverflow(false);
  },

  methods: {
    close(e) {
      const clickedEl = e === null || e === void 0 ? void 0 : e.target;
      const overlayClick = (clickedEl === null || clickedEl === void 0 ? void 0 : clickedEl.hasAttribute('data-overlay')) && (clickedEl === null || clickedEl === void 0 ? void 0 : clickedEl.getAttribute('id')) === this.id;
      const closeOnClick = (e === null || e === void 0 ? void 0 : e.type) === 'click' && (overlayClick || clickedEl.closest('[data-close-sidebar]'));

      if (closeOnClick || !e) {
        if (this.canClose) {
          this.isOpen = false;
          this.$emit('toggleSidebar', false);
        } else {
          this.$emit('cantClose');
        }
      }
    },

    toggleBodyOverflow(isOpen) {
      const root = document.documentElement;

      switch (true) {
        case this.type === 'fixed':
          break;

        case isOpen && Boolean(this.disableScrollClass):
          root.classList.add(this.disableScrollClass);
          break;

        case isOpen && this.blockScroll:
          root.style.overflow = 'hidden';
          break;

        default:
          root.style.overflow = '';

          if (this.disableScrollClass) {
            root.classList.remove(this.disableScrollClass);
          }

          break;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiModalSidebar/UiModalSidebar.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiModalSidebar_UiModalSidebarvue_type_script_lang_js_ = (UiModalSidebarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiModalSidebar/UiModalSidebar.vue?vue&type=style&index=0&module=true&lang=less&
var UiModalSidebarvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("a0b1");

// CONCATENATED MODULE: ./src/components/UiModalSidebar/UiModalSidebar.vue








function UiModalSidebar_injectStyles (context) {
  
  this["$style"] = (UiModalSidebarvue_type_style_index_0_module_true_lang_less_["default"].locals || UiModalSidebarvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiModalSidebar_component = normalizeComponent(
  UiModalSidebar_UiModalSidebarvue_type_script_lang_js_,
  UiModalSidebarvue_type_template_id_e33de286_render,
  UiModalSidebarvue_type_template_id_e33de286_staticRenderFns,
  false,
  UiModalSidebar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiModalSidebar = (UiModalSidebar_component.exports);
// CONCATENATED MODULE: ./src/components/UiModalSidebar/index.js

/* harmony default export */ var components_UiModalSidebar = (UiModalSidebar);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiNotification/UiNotification.vue?vue&type=template&id=5385b7ab&
var UiNotificationvue_type_template_id_5385b7ab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTransition',{attrs:{"name":"fade"},on:{"after-leave":function($event){return _vm.$emit('transition-end')}}},[_c('div',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],class:_vm.classes},_vm.$listeners),[(_vm.expandable)?_c('div',{class:_vm.$style['notification__btn-collapse'],on:{"click":_vm.toggle}},[_c('UiIcon',{class:_vm.$style['notification__action-icon'],attrs:{"name":_vm.toggleIcon}})],1):_vm._e(),_c('div',{class:_vm.$style['notification__content']},[(_vm.isHeaderNotEmpty)?_c('UiRow',{class:_vm.$style['notification__header'],attrs:{"pt":"5","pb":"5"}},[_c('div',{class:_vm.$style['notification__header-left']},[_c('div',{class:_vm.$style['notification__time']},[_vm._t("time")],2),_c('div',{class:_vm.$style['notification__department']},[_vm._t("department")],2)]),_c('div',{class:_vm.$style['notification__badges']},[_vm._t("badges")],2)]):_vm._e(),(_vm.$slots.title)?_c('div',{class:[
                    _vm.$style['notification__title'],
                    _vm.$style[("notification__title_" + _vm.titleSize)]
                ]},[_vm._t("title")],2):_vm._e(),_c('UiCollapse',{class:_vm.$style['notification__collapse'],attrs:{"open":!_vm.expandable || _vm.isOpen}},[(_vm.$slots.description)?_c('div',{class:_vm.$style['notification__desc']},[_vm._t("description")],2):_vm._e(),(_vm.$slots.controls)?_c('div',{class:_vm.$style['notification__controls']},_vm._l((_vm.$slots.controls),function(el,index){return _c('UiNotificationControl',{key:index,attrs:{"node":el,"css-class":_vm.$style['notification__control']}})}),1):_vm._e(),_vm._t("default"),(_vm.$slots.footer)?_c('div',{class:_vm.$style['notification__footer']},[_vm._t("footer")],2):_vm._e()],2)],1),_c('div',{class:_vm.$style['notification__close-wrap'],on:{"click":_vm.close}},[_c('div',{class:_vm.$style['notification__close']},[_c('UiIcon',{attrs:{"name":"clear"}})],1)])])])}
var UiNotificationvue_type_template_id_5385b7ab_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiNotification/UiNotification.vue?vue&type=template&id=5385b7ab&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRow/UiRow.vue?vue&type=template&id=b47c46f2&
var UiRowvue_type_template_id_b47c46f2_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.classes,style:(_vm.styles)},[_vm._t("default")],2)}
var UiRowvue_type_template_id_b47c46f2_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiRow/UiRow.vue?vue&type=template&id=b47c46f2&

// CONCATENATED MODULE: ./src/components/UiRow/enum/spacing.js
/* harmony default export */ var spacing = ({
  XXS: 'xxs',
  XS: 'xs',
  S: 's',
  M: 'm',
  L: 'l',
  XL: 'xl'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRow/UiRow.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiRowvue_type_script_lang_js_ = ({
  name: 'UiRow',
  props: {
    /**
     * HTML тег компонента
     */
    tag: {
      type: String,
      default: 'div'
    },

    /**
     * Размеры отступов
     */
    mt: {
      type: [String, Number],
      default: null
    },
    mb: {
      type: [String, Number],
      default: null
    },
    pt: {
      type: [String, Number],
      default: null
    },
    pb: {
      type: [String, Number],
      default: null
    },

    /**
     * Определение максимальной ширины
     */
    maxWidth: {
      type: [String, Number],
      validator: value => !isNaN(value),
      default: null
    },

    /**
     * Определение максимальной высоты
     */
    maxHeight: {
      type: [String, Number],
      validator: value => !isNaN(value),
      default: null
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['row']]: true,
        [this.$style[`row_top-${this.mt}`]]: this.isInSpacing(this.mt),
        [this.$style[`row_bottom-${this.mb}`]]: this.isInSpacing(this.mb),
        [this.$style[`row_inner-top-${this.pt}`]]: this.isInSpacing(this.pt),
        [this.$style[`row_inner-bottom-${this.pb}`]]: this.isInSpacing(this.pb)
      };
    },

    styles() {
      return {
        'max-width': this.maxWidth ? `${this.maxWidth}px` : null,
        'max-height': this.maxHeight ? `${this.maxHeight}px` : null,
        'margin-top': !this.isInSpacing(this.mt) ? `${this.mt}px` : null,
        'margin-bottom': !this.isInSpacing(this.mb) ? `${this.mb}px` : null,
        'padding-top': !this.isInSpacing(this.pt) ? `${this.pt}px` : null,
        'padding-bottom': !this.isInSpacing(this.pb) ? `${this.pb}px` : null
      };
    }

  },
  methods: {
    isInSpacing(props) {
      if (Object.values(spacing).includes(props)) {
        return true;
      } else if (!isNaN(props)) {
        return false;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiRow/UiRow.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiRow_UiRowvue_type_script_lang_js_ = (UiRowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiRow/UiRow.vue?vue&type=style&index=0&module=true&lang=less&
var UiRowvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("a648");

// CONCATENATED MODULE: ./src/components/UiRow/UiRow.vue








function UiRow_injectStyles (context) {
  
  this["$style"] = (UiRowvue_type_style_index_0_module_true_lang_less_["default"].locals || UiRowvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiRow_component = normalizeComponent(
  UiRow_UiRowvue_type_script_lang_js_,
  UiRowvue_type_template_id_b47c46f2_render,
  UiRowvue_type_template_id_b47c46f2_staticRenderFns,
  false,
  UiRow_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiRow = (UiRow_component.exports);
// CONCATENATED MODULE: ./src/components/UiRow/index.js

/* harmony default export */ var components_UiRow = (UiRow);
// CONCATENATED MODULE: ./src/components/UiNotification/enum/types.js
/* harmony default export */ var UiNotification_enum_types = ({
  ERROR: 'error',
  INFO: 'info',
  NOTICE: 'notice',
  SUCCESS: 'success'
});
// CONCATENATED MODULE: ./src/components/UiNotification/enum/sizes.js
/* harmony default export */ var UiNotification_enum_sizes = ({
  SM: 'sm',
  MD: 'md'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiNotification/UiNotification.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UiNotificationvue_type_script_lang_js_ = ({
  name: 'UiNotification',
  components: {
    UiIcon: components_UiIcon,
    UiTransition: components_UiTransition,
    UiCollapse: components_UiCollapse,
    UiRow: components_UiRow,
    UiNotificationControl: {
      name: 'UiNotificationControl',
      functional: true,
      render: (h, ctx) => {
        return h('div', {
          attrs: {
            class: ctx.props.cssClass
          }
        }, [ctx.props.node]);
      }
    }
  },
  model: {
    prop: 'visible',
    event: 'close-notification'
  },
  props: {
    icon: {
      type: String
    },
    type: {
      type: String,
      default: UiNotification_enum_types.INFO
    },
    expandable: {
      type: Boolean,
      default: false
    },
    titleSize: {
      types: String,
      validator: size => Object.values(UiNotification_enum_sizes).includes(size),
      default: UiNotification_enum_sizes.SM
    },
    open: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    },
    hideOnClose: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isVisible: this.visible,
      isOpen: this.open
    };
  },

  computed: {
    classes() {
      return [this.$style['notification'], {
        [this.$style['notification_error']]: this.type === UiNotification_enum_types.ERROR,
        [this.$style['notification_info']]: this.type === UiNotification_enum_types.INFO,
        [this.$style['notification_notice']]: this.type === UiNotification_enum_types.NOTICE,
        [this.$style['notification_success']]: this.type === UiNotification_enum_types.SUCCESS
      }];
    },

    toggleIcon() {
      return this.isOpen ? 'chevronUp' : 'chevronDown';
    },

    isHeaderNotEmpty() {
      return this.$slots.time || this.$slots.department || this.$slots.badges;
    }

  },
  watch: {
    open() {
      this.isOpen = this.open;
    },

    visible() {
      this.isVisible = this.visible;
    }

  },
  methods: {
    toggle() {
      if (!this.expandable) {
        return;
      }

      this.isOpen = !this.isOpen;
      this.$emit('collapse-notification', this.isOpen);
    },

    close() {
      if (this.hideOnClose) {
        this.isVisible = false;
      }

      this.$emit('close-notification');
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiNotification/UiNotification.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiNotification_UiNotificationvue_type_script_lang_js_ = (UiNotificationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiNotification/UiNotification.vue?vue&type=style&index=0&module=true&lang=less&
var UiNotificationvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("de55");

// CONCATENATED MODULE: ./src/components/UiNotification/UiNotification.vue








function UiNotification_injectStyles (context) {
  
  this["$style"] = (UiNotificationvue_type_style_index_0_module_true_lang_less_["default"].locals || UiNotificationvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiNotification_component = normalizeComponent(
  UiNotification_UiNotificationvue_type_script_lang_js_,
  UiNotificationvue_type_template_id_5385b7ab_render,
  UiNotificationvue_type_template_id_5385b7ab_staticRenderFns,
  false,
  UiNotification_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiNotification = (UiNotification_component.exports);
// CONCATENATED MODULE: ./src/components/UiNotification/index.js

/* harmony default export */ var components_UiNotification = (UiNotification);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPagination/UiPagination.vue?vue&type=template&id=5cea7138&
var UiPaginationvue_type_template_id_5cea7138_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination",class:_vm.$style['pagination']},[(_vm.arrowPlacement === 'on-sides')?[(_vm.currentPage !== 1)?_c('div',{class:_vm.arrowClassname('prev'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage - 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e()]:_vm._e(),(_vm.arrowPlacement === 'start')?_c('div',{class:_vm.arrowsWrapClassname},[(_vm.currentPage !== 1)?_c('div',{class:_vm.arrowClassname('prev'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage - 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e(),(_vm.currentPage !== _vm.pagesCount)?_c('div',{class:_vm.arrowClassname('next'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage + 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e()]):_vm._e(),_c('div',{ref:"itemsWrapper",class:_vm.$style['pagination__pages-wrap']},[_vm._l((_vm.visiblePages),function(page,i){return [(page !== '...')?_c('div',{key:i,class:_vm.pageClassname(page),on:{"click":function($event){return _vm.$emit('currentPageChange', page)}}},[_vm._v(" "+_vm._s(page)+" ")]):_c('div',{key:i,class:[_vm.$style['pagination__dots'], _vm.$style['pagination__square']]},[_c('UiIcon',{class:_vm.$style['pagination__dots-icon'],attrs:{"name":"moreHorizontal"}})],1)]})],2),(_vm.arrowPlacement === 'on-sides')?[(_vm.currentPage !== _vm.pagesCount)?_c('div',{class:_vm.arrowClassname('next'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage + 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e()]:_vm._e(),(_vm.arrowPlacement === 'end')?_c('div',{class:_vm.arrowsWrapClassname},[(_vm.currentPage !== 1)?_c('div',{class:_vm.arrowClassname('prev'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage - 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e(),(_vm.currentPage !== _vm.pagesCount)?_c('div',{class:_vm.arrowClassname('next'),on:{"click":function($event){return _vm.$emit('currentPageChange', _vm.currentPage + 1)}}},[_c('UiIcon',{class:_vm.$style['pagination__arrow-icon'],attrs:{"name":"arrowBackward"}})],1):_vm._e()]):_vm._e()],2)}
var UiPaginationvue_type_template_id_5cea7138_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiPagination/UiPagination.vue?vue&type=template&id=5cea7138&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPagination/UiPagination.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function range(from, to) {
  const range = [];

  for (let i = from; i <= to; i++) {
    range.push(i);
  }

  return range;
}

/* harmony default export */ var UiPaginationvue_type_script_lang_js_ = ({
  name: 'UiPagination',
  components: {
    UiIcon: components_UiIcon
  },
  model: {
    prop: 'currentPage',
    event: 'currentPageChange'
  },
  props: {
    pagesCount: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    arrowPlacement: {
      type: String,
      default: 'on-sides',

      validator(value) {
        return ['on-sides', 'start', 'end'].includes(value);
      }

    }
  },
  data: () => ({
    availableCount: 7
  }),
  computed: {
    visiblePages() {
      if (this.availableCount >= this.pagesCount) {
        return range(1, this.pagesCount);
      } else if ([1, 2, 3, 4].includes(this.currentPage)) {
        return range(1, this.availableCount);
      } else if (this.currentPage + 4 > this.pagesCount) {
        return [1, '...', ...range(this.pagesCount - 5, this.pagesCount)];
      } else {
        return [1, '...', ...range(this.currentPage - 2, this.currentPage + 3)];
      }
    },

    arrowsWrapClassname() {
      return {
        [this.$style['pagination__arrows-wrap']]: true,
        [this.$style['pagination__arrows-wrap_start']]: this.arrowPlacement === 'start',
        [this.$style['pagination__arrows-wrap_end']]: this.arrowPlacement === 'end'
      };
    }

  },
  methods: {
    arrowClassname(dir) {
      return [this.$style['pagination__arrow'], this.$style[`pagination__arrow_${dir}`], this.$style['pagination__square'], this.$style['pagination__hover-style']];
    },

    pageClassname(page) {
      return {
        [this.$style['pagination__page']]: true,
        [this.$style['pagination__square']]: true,
        [this.$style['pagination__hover-style']]: true,
        [this.$style['pagination__page_active']]: page === this.currentPage
      };
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiPagination/UiPagination.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiPagination_UiPaginationvue_type_script_lang_js_ = (UiPaginationvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiPagination/UiPagination.vue?vue&type=style&index=0&module=true&lang=less&
var UiPaginationvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("556c");

// CONCATENATED MODULE: ./src/components/UiPagination/UiPagination.vue








function UiPagination_injectStyles (context) {
  
  this["$style"] = (UiPaginationvue_type_style_index_0_module_true_lang_less_["default"].locals || UiPaginationvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiPagination_component = normalizeComponent(
  UiPagination_UiPaginationvue_type_script_lang_js_,
  UiPaginationvue_type_template_id_5cea7138_render,
  UiPaginationvue_type_template_id_5cea7138_staticRenderFns,
  false,
  UiPagination_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiPagination = (UiPagination_component.exports);
// CONCATENATED MODULE: ./src/components/UiPagination/index.js

/* harmony default export */ var components_UiPagination = (UiPagination);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPopup/UiPopup.vue?vue&type=template&id=645484c4&
var UiPopupvue_type_template_id_645484c4_render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTransition',{attrs:{"name":"fade-2"}},[_c('div',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],class:[
            _vm.$style['popup-wrapp'],
            ( _obj = {}, _obj[_vm.$style['popup_responsive']] = _vm.responsive && _vm.isPopup, _obj[_vm.$style['popup_with-fixed-title']] = _vm.$slots.title && _vm.fixedTitle && _vm.isPopup && !_vm.responsive, _obj[_vm.$style['popup_fullscreen']] = _vm.fullscreen, _obj ),
            _vm.popupWrapperClass
        ],attrs:{"id":_vm.id}},_vm.$listeners),[_c('div',{class:_vm.$style['popup-overlay']}),_c('UiScrollbar',{ref:"scrollbar",class:[
                _vm.$style['popup-body-wrapp'],
                _vm.popupBodyWrappClass
            ],on:{"click":_vm.close,"scroll":_vm.onScroll}},[_c('UiTransition',{attrs:{"name":"zoom"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],ref:"popup",class:[
                        _vm.$style['popup'],
                        _vm.$style[("popup_" + _vm.type)],
                        _vm.popupClass
                    ],on:{"click":function($event){$event.stopPropagation();}}},[(_vm.isAlert)?_c('div',{class:_vm.$style['popup__head']},[(_vm.icon)?_c('div',{class:_vm.$style['popup__head-icon']},[_vm._t("icon",function(){return [_c('UiIcon',{attrs:{"name":_vm.icon}})]})],2):_vm._e(),_c('div',{class:_vm.$style['popup__head-title']},[_vm._t("title")],2)]):_c('div',{class:_vm.$style['popup__title-wrap'],style:(("min-width: " + _vm.popupWidth + "px;"))},[(_vm.$slots.title)?_c('div',{class:_vm.$style['popup__title']},[_vm._t("title")],2):_vm._e(),(_vm.showCloseBtn)?_c('div',{class:[
                                _vm.$style['popup__close'],
                                _vm.popupCloseClass
                            ],on:{"click":_vm.close}},[(_vm.$slots['close-btn'])?[_vm._t("close-btn")]:_c('UiTooltip',{attrs:{"popover-base-class":!_vm.isOpen ? _vm.$style['shortcut-tooltip'] : _vm.$style['popup__tooltip'],"placement":"bottom","offset":"0","dark":"","center-text":""},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('UiIcon',{attrs:{"name":"clear"}})]},proxy:true}],null,false,856086677)},[_vm._v(" Esc ")])],2):_vm._e()]),(_vm.responsive)?_c('UiScrollbar',{class:[
                            _vm.$style['popup__content'],
                            _vm.popupContentClass
                        ]},[_vm._t("default")],2):_c('div',{class:[
                            _vm.$style['popup__content'],
                            _vm.popupContentClass
                        ]},[_vm._t("default")],2),(_vm.$slots.footer)?_c('div',{class:( _obj$1 = {}, _obj$1[_vm.$style['popup__footer']] = true, _obj$1[_vm.footerClass] = _vm.footerClass, _obj$1 )},[(_vm.isHint)?_c('p',{class:_vm.$style['popup__footer-description']},[_vm._t("footer")],2):_vm._t("footer")],2):_vm._e()],1)])],1)],1)])}
var UiPopupvue_type_template_id_645484c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiPopup/UiPopup.vue?vue&type=template&id=645484c4&

// CONCATENATED MODULE: ./src/components/UiPopup/enum/types.js
/* harmony default export */ var UiPopup_enum_types = ({
  ALERT: 'alert',
  DIALOG: 'confirm',
  POPUP: 'popup',
  HINT: 'hint'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPopup/UiPopup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






let UiPopupvue_type_script_lang_js_idCounter = 0;
/* harmony default export */ var UiPopupvue_type_script_lang_js_ = ({
  name: 'UiPopup',
  components: {
    UiTransition: components_UiTransition,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip,
    UiScrollbar: components_UiScrollbar
  },
  mixins: [close_on_esc],
  model: {
    prop: 'open',
    event: 'togglePopup'
  },
  props: {
    id: {
      type: [String, Function],
      default: () => `ui-popup-${++UiPopupvue_type_script_lang_js_idCounter}`
    },
    open: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: UiPopup_enum_types.POPUP
    },
    responsive: {
      type: Boolean,
      default: false
    },
    canClose: {
      type: Boolean,
      default: true
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    popupCloseClass: {
      type: String,
      default: ''
    },
    popupContentClass: {
      type: String,
      default: ''
    },
    popupWrapperClass: {
      type: String,
      default: ''
    },
    popupBodyWrappClass: {
      type: String,
      default: ''
    },
    popupClass: {
      type: String,
      default: ''
    },
    footerClass: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'warning'
    },

    /**
     * Возможность выводить попап на весь экран
     */
    fullscreen: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpen: this.open,
      fixedTitle: false,
      popupWidth: 0
    };
  },

  computed: {
    isAlert() {
      return this.type === UiPopup_enum_types.ALERT;
    },

    isPopup() {
      return this.type === UiPopup_enum_types.POPUP;
    },

    isHint() {
      return this.type === UiPopup_enum_types.HINT;
    }

  },
  watch: {
    open() {
      this.isOpen = this.open;

      if (this.open && this.$refs.popup) {
        this.$nextTick(() => {
          this.popupWidth = this.$refs.popup.clientWidth;
        });
      }

      if (this.responsive && this.isOpen) {
        this.toggleBodyScroll(true);
      } else {
        this.toggleBodyScroll();
      }
    }

  },
  methods: {
    openPopup() {
      this.isOpen = true;
      this.$emit('togglePopup', true);
    },

    close(e) {
      if (e && e.target && e.target.closest('.ps__thumb-y')) {
        return;
      }

      if (this.canClose) {
        this.isOpen = false;
        this.$emit('togglePopup', false);
      } else {
        this.$emit('ui::popup::close-cancel');
      }
    },

    updateScroll() {
      this.$refs['scrollbar'].update();
    },

    onScroll() {
      this.fixedTitle = this.$refs.popup.getBoundingClientRect().top <= 0;
    },

    toggleBodyScroll(disable = false) {
      if (disable) {
        document.documentElement.style.overflow = 'hidden';
      } else if (document.documentElement.style.overflow === 'hidden') {
        document.documentElement.style.removeProperty('overflow');
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiPopup/UiPopup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiPopup_UiPopupvue_type_script_lang_js_ = (UiPopupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiPopup/UiPopup.vue?vue&type=style&index=0&module=true&lang=less&
var UiPopupvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("6097");

// CONCATENATED MODULE: ./src/components/UiPopup/UiPopup.vue








function UiPopup_injectStyles (context) {
  
  this["$style"] = (UiPopupvue_type_style_index_0_module_true_lang_less_["default"].locals || UiPopupvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiPopup_component = normalizeComponent(
  UiPopup_UiPopupvue_type_script_lang_js_,
  UiPopupvue_type_template_id_645484c4_render,
  UiPopupvue_type_template_id_645484c4_staticRenderFns,
  false,
  UiPopup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiPopup = (UiPopup_component.exports);
// CONCATENATED MODULE: ./src/components/UiPopup/index.js

/* harmony default export */ var components_UiPopup = (UiPopup);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiProgress/UiProgress.vue?vue&type=template&id=3ec21dd6&
var UiProgressvue_type_template_id_3ec21dd6_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['progress']] = true, _obj[_vm.$style['progress_box']] = _vm.withBackground, _obj ),style:(_vm.boxColorStyles)},[_vm._t("default",function(){return [(_vm.label)?_c('div',{class:_vm.$style['progress__text']},[_c('div',{class:_vm.$style['progress__label']},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{class:_vm.percentClasses,style:(_vm.percentStyles)},[_vm._v(" "+_vm._s(_vm.currentPercent)+" ")])]):_vm._e()]}),_c('div',{class:_vm.$style['progress__line'],style:(_vm.lineColorStyles)},[_c('div',{class:_vm.$style['progress__current-value'],style:(_vm.currentValueStyles)})])],2)}
var UiProgressvue_type_template_id_3ec21dd6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=template&id=3ec21dd6&

// CONCATENATED MODULE: ./src/enums/colors.js
/* harmony default export */ var enums_colors = ({
  'RED-100': 'red-100',
  'RED-200': 'red-200',
  'RED-300': 'red-300',
  'RED-400': 'red-400',
  'RED-500': 'red-500',
  'RED-600': 'red-600',
  'RED-700': 'red-700',
  'RED-800': 'red-800',
  'RED-900': 'red-900',
  'BLUE-100': 'blue-100',
  'BLUE-200': 'blue-200',
  'BLUE-300': 'blue-300',
  'BLUE-400': 'blue-400',
  'BLUE-500': 'blue-500',
  'BLUE-600': 'blue-600',
  'BLUE-700': 'blue-700',
  'BLUE-800': 'blue-800',
  'BLUE-900': 'blue-900',
  'YELLOW-100': 'yellow-100',
  'YELLOW-200': 'yellow-200',
  'YELLOW-300': 'yellow-300',
  'YELLOW-400': 'yellow-400',
  'YELLOW-500': 'yellow-500',
  'YELLOW-600': 'yellow-600',
  'YELLOW-700': 'yellow-700',
  'YELLOW-800': 'yellow-800',
  'YELLOW-900': 'yellow-900',
  'GREEN-100': 'green-100',
  'GREEN-200': 'green-200',
  'GREEN-300': 'green-300',
  'GREEN-400': 'green-400',
  'GREEN-500': 'green-500',
  'GREEN-600': 'green-600',
  'GREEN-700': 'green-700',
  'GREEN-800': 'green-800',
  'GREEN-900': 'green-900',
  'PURPLE-100': 'purple-100',
  'PURPLE-200': 'purple-200',
  'PURPLE-300': 'purple-300',
  'PURPLE-400': 'purple-400',
  'PURPLE-500': 'purple-500',
  'PURPLE-600': 'purple-600',
  'PURPLE-700': 'purple-700',
  'PURPLE-800': 'purple-800',
  'PURPLE-900': 'purple-900',
  'BLACK-100': 'black-100',
  'BLACK-200': 'black-200',
  'BLACK-300': 'black-300',
  'BLACK-400': 'black-400',
  'BLACK-500': 'black-500',
  'BLACK-600': 'black-600',
  'BLACK-700': 'black-700',
  'BLACK-800': 'black-800',
  'BLACK-900': 'black-900',
  'GREY-100': 'grey-100',
  'GREY-200': 'grey-200',
  'GREY-300': 'grey-300',
  'GREY-400': 'grey-400',
  'GREY-500': 'grey-500',
  'GREY-600': 'grey-600',
  'GREY-700': 'grey-700',
  'GREY-800': 'grey-800',
  'GREY-900': 'grey-900',
  'BLUE-TRANSPARENT': 'blue-transparent',
  'GREEN-TRANSPARENT': 'green-transparent',
  'RED-TRANSPARENT': 'red-transparent',
  'YELLOW-TRANSPARENT': 'yellow-transparent',
  'PURPLE-TRANSPARENT': 'purple-transparent'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiProgress/UiProgress.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiProgressvue_type_script_lang_js_ = ({
  name: 'UiProgress',
  props: {
    /**
     * Значение прогресса
     */
    percent: {
      type: [String, Number],
      default: 0,
      validator: value => value >= 0 && value <= 100
    },

    /**
     * Текст сообщения
     */
    label: {
      type: String,
      default: null
    },

    /**
     * Включить или отключить контейнер с фоном и отступами
     */
    withBackground: {
      type: Boolean,
      default: true
    },

    /**
     * Цвет заполняющей линии
     */
    progressColor: {
      type: String,
      validator: color => Object.values(enums_colors).includes(color),
      default: null
    },

    /**
     * Цвет основной линии
     */
    lineColor: {
      type: String,
      validator: color => Object.values(enums_colors).includes(color),
      default: null
    },

    /**
     * Цвет фона обёртки
     */
    boxColor: {
      type: String,
      validator: color => Object.values(enums_colors).includes(color),
      default: null
    }
  },
  computed: {
    currentPercent() {
      return this.currentValue + '%';
    },

    currentValue() {
      const number = parseInt(this.percent);
      return number > 100 ? 100 : number < 0 ? 0 : number;
    },

    percentClasses() {
      return {
        [this.$style['progress__percent']]: true,
        [this.$style['progress__percent_zero']]: this.currentValue === 0,
        [this.$style['progress__percent_full']]: this.currentValue === 100
      };
    },

    percentStyles() {
      return {
        'color': this.currentValue === 100 && this.progressColor ? `var(--${this.progressColor})` : null
      };
    },

    currentValueStyles() {
      return {
        'transform': `translateX(${this.currentValue - 100}%)`,
        'background-color': this.progressColor ? `var(--${this.progressColor})` : null
      };
    },

    textStyles() {
      return this.textColor ? `color: var(--${this.textColor});` : null;
    },

    boxColorStyles() {
      return this.boxColor ? `background-color: var(--${this.boxColor});` : null;
    },

    lineColorStyles() {
      return this.lineColor ? `background-color: var(--${this.lineColor});` : null;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiProgress_UiProgressvue_type_script_lang_js_ = (UiProgressvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiProgress/UiProgress.vue?vue&type=style&index=0&module=true&lang=less&
var UiProgressvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("9203");

// CONCATENATED MODULE: ./src/components/UiProgress/UiProgress.vue








function UiProgress_injectStyles (context) {
  
  this["$style"] = (UiProgressvue_type_style_index_0_module_true_lang_less_["default"].locals || UiProgressvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiProgress_component = normalizeComponent(
  UiProgress_UiProgressvue_type_script_lang_js_,
  UiProgressvue_type_template_id_3ec21dd6_render,
  UiProgressvue_type_template_id_3ec21dd6_staticRenderFns,
  false,
  UiProgress_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiProgress = (UiProgress_component.exports);
// CONCATENATED MODULE: ./src/components/UiProgress/index.js

/* harmony default export */ var components_UiProgress = (UiProgress);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadio/UiRadio.vue?vue&type=template&id=11bc652e&
var UiRadiovue_type_template_id_11bc652e_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['radio-wrap']] = !_vm.focused, _obj ),on:{"click":_vm.onClick}},[_c('div',{class:_vm.classes},[_c('label',{class:_vm.$style['radio__btn']},[_c('span',{class:_vm.$style['radio__btn-icon']}),_c('input',{class:_vm.$style['radio__btn-input'],attrs:{"name":_vm.name,"disabled":_vm.disabled,"type":"radio"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.onChange,"click":function($event){return _vm.$emit('click')}}})]),(_vm.hasContent)?_c('span',{class:_vm.$style['radio__text']},[(_vm.label || _vm.$slots.default)?_c('span',{class:_vm.$style['radio__label'],attrs:{"data-label":""}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e(),(_vm.$slots.desc || _vm.desc)?_c('span',{class:_vm.$style['radio__desc']},[_vm._t("desc",function(){return [_vm._v(_vm._s(_vm.desc))]})],2):_vm._e()]):_vm._e()])])}
var UiRadiovue_type_template_id_11bc652e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiRadio/UiRadio.vue?vue&type=template&id=11bc652e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadio/UiRadio.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiRadiovue_type_script_lang_js_ = ({
  name: 'UiRadio',
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    name: {
      type: String
    },
    model: [String, Boolean, Object, Number, Array],
    value: {
      type: [String, Boolean, Object, Number],
      default: false,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    isCheckedCustom: {
      type: Function,
      default: null
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['radio']]: true,
        [this.$style['radio_checked']]: this.isChecked,
        [this.$style['radio_disabled']]: this.disabled,
        [this.$style['radio_focused']]: this.focused
      };
    },

    isChecked() {
      if (this.isCheckedCustom) {
        return this.isCheckedCustom(this.value, this.model);
      }

      return this.model === this.value;
    },

    hasContent() {
      return this.label || this.desc || this.$slots.default;
    }

  },
  methods: {
    onChange() {
      this.$emit('change', this.value);
    },

    onClick(e) {
      if (!this.disabled && (this.focused || e.target.closest('[data-label]'))) {
        this.onChange();
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiRadio/UiRadio.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiRadio_UiRadiovue_type_script_lang_js_ = (UiRadiovue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiRadio/UiRadio.vue?vue&type=style&index=0&module=true&lang=less&
var UiRadiovue_type_style_index_0_module_true_lang_less_ = __webpack_require__("262c");

// CONCATENATED MODULE: ./src/components/UiRadio/UiRadio.vue








function UiRadio_injectStyles (context) {
  
  this["$style"] = (UiRadiovue_type_style_index_0_module_true_lang_less_["default"].locals || UiRadiovue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiRadio_component = normalizeComponent(
  UiRadio_UiRadiovue_type_script_lang_js_,
  UiRadiovue_type_template_id_11bc652e_render,
  UiRadiovue_type_template_id_11bc652e_staticRenderFns,
  false,
  UiRadio_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiRadio = (UiRadio_component.exports);
// CONCATENATED MODULE: ./src/components/UiRadio/index.js

/* harmony default export */ var components_UiRadio = (UiRadio);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadiogroup/UiRadiogroup.vue?vue&type=template&id=7dfb598f&
var UiRadiogroupvue_type_template_id_7dfb598f_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_vm._t("default"),(!_vm.$slots.default)?_vm._l((_vm.options),function(option,i){return _c('UiRadiogroupOption',{key:((option[_vm.labelPropName]) + "-" + i),attrs:{"size":_vm.size,"icon":option.icon,"label":option[_vm.labelPropName],"value":option[_vm.valuePropName],"disabled":option.disabled}})}):_vm._e()],2)}
var UiRadiogroupvue_type_template_id_7dfb598f_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroup.vue?vue&type=template&id=7dfb598f&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadiogroup/UiRadiogroupOption.vue?vue&type=template&id=5bf656d0&
var UiRadiogroupOptionvue_type_template_id_5bf656d0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.classes,attrs:{"data-active":_vm.isActive},on:{"click":_vm.onClick}},_vm.$listeners),[_vm._t("default"),(!_vm.$slots.default)?[_c('div',{class:_vm.$style['option__head']},[(_vm.$slots.icon || _vm.icon)?_c('span',{class:_vm.$style.icon},[_vm._t("icon",function(){return [(_vm.icon)?_c('UiIcon',{attrs:{"name":_vm.icon}}):_vm._e()]})],2):_vm._e(),(_vm.$slots.label || _vm.label)?_c('div',{class:_vm.$style.label},[(_vm.label)?[_vm._v(" "+_vm._s(_vm.label)+" ")]:_vm._t("label")],2):_vm._e()]),(_vm.$slots.description || _vm.description)?_c('div',{class:_vm.$style.description},[(_vm.description)?[_vm._v(" "+_vm._s(_vm.description)+" ")]:_vm._t("description")],2):_vm._e(),(_vm.isSection && _vm.isActive)?_c('UiIcon',{class:_vm.$style.done,attrs:{"name":"allDone"}}):_vm._e()]:_vm._e()],2)}
var UiRadiogroupOptionvue_type_template_id_5bf656d0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroupOption.vue?vue&type=template&id=5bf656d0&

// CONCATENATED MODULE: ./src/utils/uuid4.js
/* harmony default export */ var uuid4 = (() => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, char => {
    const rand = Math.random() * 16 | 0;
    const replacement = char === 'x' ? rand : rand & 0x3 | 0x8;
    return replacement.toString(16);
  });
});
// CONCATENATED MODULE: ./src/components/UiRadiogroup/enum/sizes.js
/* harmony default export */ var UiRadiogroup_enum_sizes = ({
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
});
// CONCATENATED MODULE: ./src/components/UiRadiogroup/enum/types.js
/* harmony default export */ var UiRadiogroup_enum_types = ({
  DEFAULT: 'default',
  SECTION: 'section'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadiogroup/UiRadiogroupOption.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiRadiogroupOptionvue_type_script_lang_js_ = ({
  name: 'UiRadiogroupOption',
  inject: {
    option_register: {
      default: null
    },
    option_unregister: {
      default: null
    },
    type: {
      default: UiRadiogroup_enum_types.DEFAULT
    }
  },
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    uuid: {
      type: String,
      default: () => uuid4()
    },

    /**
     * Размер табов (sm, md, lg)
     */
    size: {
      type: String,
      validator: size => Object.values(UiRadiogroup_enum_sizes).includes(size),
      default: UiRadiogroup_enum_sizes.MD
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: null,
      required: true
    },

    /**
     * Используется только c type=section
     */
    description: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  computed: {
    classes() {
      if (this.$slots.default) {
        return;
      }

      return {
        [this.$style['option']]: true,
        [this.$style[`option_${this.type}`]]: true,
        [this.$style[`size-${this.size}`]]: !this.isSection,
        [this.$style['active']]: this.isActive,
        [this.$style['disabled']]: this.disabled
      };
    },

    isSection() {
      return this.type === UiRadiogroup_enum_types.SECTION;
    }

  },

  mounted() {
    if (this.option_register) {
      this.option_register(this.uuid, this);
    }
  },

  beforeDestroy() {
    if (this.option_unregister) {
      this.option_unregister(this.uuid);
    }
  },

  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('select', this.uuid);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroupOption.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiRadiogroup_UiRadiogroupOptionvue_type_script_lang_js_ = (UiRadiogroupOptionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiRadiogroup/UiRadiogroupOption.vue?vue&type=style&index=0&lang=less&module=true&
var UiRadiogroupOptionvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("c789");

// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroupOption.vue








function UiRadiogroupOption_injectStyles (context) {
  
  this["$style"] = (UiRadiogroupOptionvue_type_style_index_0_lang_less_module_true_["default"].locals || UiRadiogroupOptionvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiRadiogroupOption_component = normalizeComponent(
  UiRadiogroup_UiRadiogroupOptionvue_type_script_lang_js_,
  UiRadiogroupOptionvue_type_template_id_5bf656d0_render,
  UiRadiogroupOptionvue_type_template_id_5bf656d0_staticRenderFns,
  false,
  UiRadiogroupOption_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiRadiogroupOption = (UiRadiogroupOption_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiRadiogroup/UiRadiogroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiRadiogroupvue_type_script_lang_js_ = ({
  name: 'UiRadiogroup',
  components: {
    UiRadiogroupOption: UiRadiogroupOption
  },
  model: {
    prop: 'value',
    event: 'change'
  },

  provide() {
    return {
      option_register: this.registerOption,
      option_unregister: this.unregisterOption,
      type: this.type
    };
  },

  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: null
    },

    /**
     * Размер табов (sm, md, lg)
     */
    size: {
      type: String,
      validator: size => Object.values(UiRadiogroup_enum_sizes).includes(size),
      default: UiRadiogroup_enum_sizes.MD
    },

    /**
     * Тип радиогруппы (default, section)
     */
    type: {
      type: String,
      validator: type => Object.values(UiRadiogroup_enum_types).includes(type),
      default: UiRadiogroup_enum_types.DEFAULT
    },

    /**
     * Растягивание контейнера взависимости от контента
     */
    rubber: {
      type: Boolean,
      default: false
    },

    /**
     * Список элементов
     */
    options: {
      type: Array,
      default: () => []
    },

    /**
     * Обработчик значений, можно изменить для того, чтобы сравнивать сложные значения
     */
    processor: {
      type: Function,
      default: a => a
    },

    /**
     * Строгое сравнение, используйте false, если нужно например,
     * считать равными число и его строковое представление
     */
    strict: {
      type: Boolean,
      default: true
    },

    /**
     * Определяет, какое свойство используется для вывода
     */
    labelPropName: {
      type: String,
      default: 'label'
    },

    /**
     * Определяет, какое свойство используется для значения
     */
    valuePropName: {
      type: String,
      default: 'value'
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['radiogroup']]: true,
        [this.$style[`size-${this.size}`]]: !this.isSection,
        [this.$style['radiogroup_section']]: this.isSection,
        [this.$style['rubber']]: this.rubber
      };
    },

    optionsList() {
      return Array.from(this.optionsRegistry.values());
    },

    isSection() {
      return this.type === UiRadiogroup_enum_types.SECTION;
    }

  },
  watch: {
    value(val) {
      this.optionsList.forEach(opt => {
        opt.isActive = opt[this.valuePropName] === val;
      });
    }

  },

  beforeCreate() {
    this.optionsRegistry = new Map();
  },

  methods: {
    registerOption(id, option) {
      if (this.optionsRegistry.has(id)) {
        return;
      }

      if (option[this.valuePropName] === this.value) {
        option.isActive = true;
      }

      this.optionsRegistry.set(id, option);
      option.$on('select', id => this.optionsList.forEach(opt => {
        if (opt.uuid === id) {
          opt.isActive = true;
          this.$emit('change', opt[this.valuePropName]);
        } else {
          opt.isActive = false;
        }
      }));
    },

    unregisterOption(id) {
      this.optionsRegistry.delete(id);
    },

    /**
     * ВАЖНО: Если не строгий режим, то сравнение тоже не строгое
     * @param a
     * @param b
     * @return {boolean}
     */
    compare(a, b) {
      if (this.strict) {
        return this.processor(a) === this.processor(b);
      } // eslint-disable-next-line eqeqeq


      return this.processor(a) == this.processor(b);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiRadiogroup_UiRadiogroupvue_type_script_lang_js_ = (UiRadiogroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiRadiogroup/UiRadiogroup.vue?vue&type=style&index=0&lang=less&module=true&
var UiRadiogroupvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("8b68");

// CONCATENATED MODULE: ./src/components/UiRadiogroup/UiRadiogroup.vue








function UiRadiogroup_injectStyles (context) {
  
  this["$style"] = (UiRadiogroupvue_type_style_index_0_lang_less_module_true_["default"].locals || UiRadiogroupvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiRadiogroup_component = normalizeComponent(
  UiRadiogroup_UiRadiogroupvue_type_script_lang_js_,
  UiRadiogroupvue_type_template_id_7dfb598f_render,
  UiRadiogroupvue_type_template_id_7dfb598f_staticRenderFns,
  false,
  UiRadiogroup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiRadiogroup = (UiRadiogroup_component.exports);
// CONCATENATED MODULE: ./src/components/UiRadiogroup/index.js



// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSkeleton/UiSkeleton.vue?vue&type=template&id=4d9ed73b&
var UiSkeletonvue_type_template_id_4d9ed73b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles)})}
var UiSkeletonvue_type_template_id_4d9ed73b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSkeleton/UiSkeleton.vue?vue&type=template&id=4d9ed73b&

// CONCATENATED MODULE: ./src/components/UiSkeleton/enum/animations.js
/* harmony default export */ var animations = ({
  PULSE: 'pulse',
  SHIMMER: 'shimmer'
});
// CONCATENATED MODULE: ./src/components/UiSkeleton/enum/sizes.js
/* harmony default export */ var UiSkeleton_enum_sizes = ({
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
});
// CONCATENATED MODULE: ./src/components/UiSkeleton/enum/types.js
/* harmony default export */ var UiSkeleton_enum_types = ({
  CIRCLE: 'circle',
  RECTANGLE: 'rectangle',
  TEXT: 'text'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSkeleton/UiSkeleton.vue?vue&type=script&lang=js&
//
//
//
//



/* harmony default export */ var UiSkeletonvue_type_script_lang_js_ = ({
  name: 'UiSkeleton',
  props: {
    /**
     * Ширина
     */
    width: {
      type: [String, Number],
      default: null
    },

    /**
     * Высота
     */
    height: {
      type: [String, Number],
      default: null
    },

    /**
     * Тип скелетона
     */
    type: {
      type: String,
      validator: type => Object.values(UiSkeleton_enum_types).includes(type),
      default: UiSkeleton_enum_types.RECTANGLE
    },

    /**
     * Анимированный фон
     */
    animated: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      validator: animation => Object.values(animations).includes(animation),
      default: animations.PULSE
    },

    /**
     * Размер скелетона
     */
    size: {
      type: String,
      validator: size => Object.values(UiSkeleton_enum_sizes).includes(size),
      default: UiSkeleton_enum_sizes.LG
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['skeleton']]: true,
        [this.$style[`skeleton_${this.type}`]]: true,
        [this.$style[`skeleton_${this.type}-${this.size}`]]: true,
        [this.$style[`skeleton_${this.animation}`]]: this.animated
      };
    },

    styles() {
      return {
        width: this.guessDimensionStyleValue(this.width),
        height: this.guessDimensionStyleValue(this.height)
      };
    }

  },
  methods: {
    guessDimensionStyleValue(value) {
      if (typeof value === 'number' || typeof value === 'string' && /^\d*$/.test(value)) {
        return value + 'px';
      }

      return value;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiSkeleton/UiSkeleton.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiSkeleton_UiSkeletonvue_type_script_lang_js_ = (UiSkeletonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiSkeleton/UiSkeleton.vue?vue&type=style&index=0&module=true&lang=less&
var UiSkeletonvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("2217");

// CONCATENATED MODULE: ./src/components/UiSkeleton/UiSkeleton.vue








function UiSkeleton_injectStyles (context) {
  
  this["$style"] = (UiSkeletonvue_type_style_index_0_module_true_lang_less_["default"].locals || UiSkeletonvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiSkeleton_component = normalizeComponent(
  UiSkeleton_UiSkeletonvue_type_script_lang_js_,
  UiSkeletonvue_type_template_id_4d9ed73b_render,
  UiSkeletonvue_type_template_id_4d9ed73b_staticRenderFns,
  false,
  UiSkeleton_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiSkeleton = (UiSkeleton_component.exports);
// CONCATENATED MODULE: ./src/components/UiSkeleton/index.js

/* harmony default export */ var components_UiSkeleton = (UiSkeleton);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiSelect.vue?vue&type=template&id=07aaa646&
var UiSelectvue_type_template_id_07aaa646_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['select']},[_c('v-popover',{attrs:{"offset":"4","trigger":"manual","placement":_vm.placement,"popover-base-class":[_vm.$style['select__content'], _vm.baseClass],"open-class":_vm.$style['open'],"open":_vm.isOpen,"popper-options":_vm.popperOptions,"container":_vm.container,"auto-hide":_vm.autoHide},on:{"auto-hide":_vm.onAutoHide}},[_c('div',{class:_vm.$style['select-target'],on:{"click":_vm.openMenu}},[(_vm.multiple && !_vm.$slots.target)?_c('div',{ref:"fakeArea",class:_vm.$style['fake-area']},[_vm._v(" "+_vm._s(_vm.outputLabel.value)+" ")]):_vm._e(),_vm._t("target",function(){return [(_vm.overflowing)?_c('UiTooltip',{class:_vm.$style['tooltip'],attrs:{"show":_vm.isOpen,"disabled":_vm.isOpen || !_vm.currentValue || !_vm.inputOverflowing,"popover-base-class":_vm.isOpen ? _vm.$style['hide']: '',"trigger-class-name":_vm.$style['overflowing-trigger'],"max-width":_vm.targetWidth !== 'auto' ? _vm.targetWidth : null,"dark":"","placement":"bottom"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('UiInput',{class:[_vm.$style['select-menu'], _vm.$style['overflowing']],attrs:{"id":_vm.areaId,"value":_vm.currentValue,"placeholder":_vm.getPlaceholder,"placeholder-style":_vm.placeholderStyle,"active":_vm.isOpen,"readonly":_vm.isReadonly,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"disabled":_vm.disabled,"clearable":_vm.clearable,"error":_vm.error,"variant":_vm.inputVariant},on:{"input":_vm.onInputEventHandler,"focus":_vm.onFocusHandler,"blur":_vm.onBlurHandler,"clearInput":_vm.clearValue},scopedSlots:_vm._u([{key:"iconLeft",fn:function(){return [_vm._t("iconLeft")]},proxy:true}],null,true)})]},proxy:true}],null,false,3527547507)},[_vm._v(" "+_vm._s(_vm.currentValue)+" ")]):_c('UiInput',{class:_vm.$style['select-menu'],attrs:{"id":_vm.areaId,"value":_vm.currentValue,"placeholder":_vm.getPlaceholder,"placeholder-style":_vm.placeholderStyle,"active":_vm.isOpen,"readonly":_vm.isReadonly,"icon-left":_vm.iconLeft,"icon-right":_vm.iconRight,"disabled":_vm.disabled,"clearable":_vm.clearable,"error":_vm.error,"variant":_vm.inputVariant},on:{"input":_vm.onInputEventHandler,"focus":_vm.onFocusHandler,"blur":_vm.onBlurHandler,"clearInput":_vm.clearValue},scopedSlots:_vm._u([{key:"iconLeft",fn:function(){return [_vm._t("iconLeft")]},proxy:true}],null,true)})]},{"data":{
                    value: _vm.outputValue || _vm.placeholder,
                    active: _vm.isOpen
                }})],2),_c('template',{slot:"popover"},[_c('div',{class:_vm.$style['select__content-wrap']},[(_vm.isRendered)?_c('UiScrollbar',{ref:"scrollbar",class:( _obj = {}, _obj[_vm.$style['select__content-inner']] = true, _obj[_vm.$style['select__content-inner_long']] = _vm.overflowing, _obj[_vm.dropdownClass] = _vm.dropdownClass, _obj ),style:(_vm.styles),on:{"click":_vm.onClickHandler,"ps-scroll-y":function($event){return _vm.$emit('ps-scroll-y', $event)},"ps-scroll-x":function($event){return _vm.$emit('ps-scroll-x', $event)},"ps-x-reach-end":function($event){_vm.scrollUpdated ? _vm.$emit('ps-x-reach-end', $event) : _vm.scrollUpdated = true},"ps-y-reach-end":function($event){_vm.scrollUpdated ? _vm.$emit('ps-y-reach-end', $event) : _vm.scrollUpdated = true}}},[(!!_vm.noResultsString)?_c('div',{class:_vm.$style['emty-filter']},[_vm._v(" "+_vm._s(_vm.noResultsString)+" ")]):_vm._e(),_vm._t("default",function(){return _vm._l((_vm.labels),function(label,index){return _c('UiOption',{key:(_vm.id + "-" + index),attrs:{"label":label,"value":_vm.options[index],"icon":_vm.defaultIconRight,"hover-icon":""}})})})],2):_vm._e()],1)])],2),(_vm.multiple && (_vm.tags || _vm.$slots.tags))?_c('div',{class:_vm.$style['tag-list']},[_vm._t("tags",function(){return _vm._l((_vm.value),function(tag,index){return _c('div',{key:("tag-" + _vm.id + "-" + index),class:_vm.$style['tag-item']},[_c('UiTag',{class:_vm.$style['tag'],attrs:{"type":_vm.tagsType,"dark-bg":_vm.tagsDarkBg},on:{"removeTag":function($event){return _vm.setValue(tag)}}},[_vm._v(" "+_vm._s(_vm.labelPropName ? tag[_vm.labelPropName] : tag.name)+" ")]),(index + 1 < _vm.value.length)?_vm._t("tags-divider"):_vm._e()],2)})},{"remove":_vm.setValue})],2):_vm._e()],1)}
var UiSelectvue_type_template_id_07aaa646_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSelect/UiSelect.vue?vue&type=template&id=07aaa646&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiOption.vue?vue&type=template&id=48b157c4&
var UiOptionvue_type_template_id_48b157c4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],attrs:{"data-ui-option":""},on:{"click":_vm.clickHandler}},_vm.$listeners),[_vm._t("default",function(){return [_c('UiInputDropdown',{attrs:{"icon":_vm.uiSelect.defaultIconRight,"active":_vm.isActive,"hover-icon":_vm.hoverIcon,"disabled":_vm.disabled,"size":_vm.size,"ticker":_vm.uiSelect.overflowing,"always-show-icon-container":_vm.uiSelect.maxWidthDropdown,"accent":_vm.accent,"additional-text":_vm.additionalText,"add-text-with-icon":_vm.addTextWithIcon},scopedSlots:_vm._u([{key:"iconPrefix",fn:function(){return [_vm._t("iconPrefix")]},proxy:true},(_vm.description)?{key:"descript",fn:function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.highlightDescript)}})]},proxy:true}:null],null,true)},[_vm._t("value",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.highlightValue)}})]})],2)]},{"isActive":_vm.isActive})],2)}
var UiOptionvue_type_template_id_48b157c4_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSelect/UiOption.vue?vue&type=template&id=48b157c4&

// CONCATENATED MODULE: ./src/utils/preq-quote.js
/**
 * @description Экранирует спецсимволы в строке. Полезна для создания регулярного выражения из строки
 * @return {string}
 */
/* harmony default export */ var preq_quote = (function (str) {
  // eslint-disable-next-line
  return (str + '').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, '\\$1');
});
// CONCATENATED MODULE: ./src/utils/compareObjects.js
const sortObjectProps = object => {
  if (typeof object !== 'object' || object === null) {
    return;
  }

  const sortedObject = {};
  Object.keys(object).sort().forEach(key => {
    if (typeof object[key] === 'object' && object[key] !== null) {
      sortedObject[key] = sortObjectProps(object[key]);
    } else {
      sortedObject[key] = object[key];
    }
  });
  return sortedObject;
};

const compareObjects = (firstObject, secondObject) => {
  if (firstObject === secondObject) {
    return true;
  }

  const firstSortedObject = sortObjectProps(firstObject);
  const secondSortedObject = sortObjectProps(secondObject);

  if (firstSortedObject && secondSortedObject) {
    return JSON.stringify(firstSortedObject) === JSON.stringify(secondSortedObject);
  }

  return false;
};

const shallowCompareObjects = (firstObject, secondObject) => {
  if (firstObject === secondObject) {
    return true;
  }

  for (let key in firstObject) {
    if (firstObject[key] !== secondObject[key]) {
      return false;
    }
  }

  return true;
};


// CONCATENATED MODULE: ./src/components/UiSelect/enum/sizes.js
/* harmony default export */ var UiSelect_enum_sizes = ({
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiOption.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var UiOptionvue_type_script_lang_js_ = ({
  name: 'UiOption',
  inject: ['uiSelect'],
  components: {
    UiInputDropdown: components_UiInputDropdown
  },
  props: {
    label: {
      type: String,
      required: true,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    value: {
      validator: prop => {
        return typeof prop === 'object' || typeof prop === 'string' || typeof prop === 'number';
      },
      required: true,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    },
    hoverIcon: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: UiSelect_enum_sizes.MD
    },

    /**
     * Счетчик количества
     */
    additionalText: {
      type: [String, Number],
      default: null
    },

    /**
     * Показывать счетчик вместе с иконкой
     * По умолчанию счетчик показывается только
     * если нет иконки или active = false
     */
    addTextWithIcon: {
      type: Boolean,
      default: true
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isActive() {
      let currentValue = this.uiSelect.valuePropName && typeof this.value === 'object' ? this.value[this.uiSelect.valuePropName] : this.value;

      if (this.active) {
        return this.active;
      }

      if (Array.isArray(this.uiSelect.value)) {
        let isEqual = false;

        for (let i = 0; i < this.uiSelect.value.length; i++) {
          if (typeof this.uiSelect.value[i] !== 'object' || typeof currentValue !== 'object') {
            break;
          }

          if (compareObjects(this.uiSelect.value[i], currentValue)) {
            isEqual = true;
            break;
          }
        }

        return isEqual || this.uiSelect.value.includes(currentValue);
      }

      if (typeof currentValue === 'object') {
        return compareObjects(this.uiSelect.value, currentValue);
      }

      return this.uiSelect.value === currentValue;
    },

    isVisible() {
      if (this.isDefaultValue) {
        return true;
      }

      if (!this.highlightDescript) {
        return this.highlightValue !== this.label;
      }

      return this.highlightValue !== this.label || this.highlightDescript !== this.description;
    },

    isDefaultValue() {
      return !this.uiSelect.filtered || !this.uiSelect.inputValue;
    },

    highlightValue() {
      if (this.isDefaultValue) {
        return this.label;
      }

      return this.label.replace(new RegExp(`(${preq_quote(this.uiSelect.inputValue)})`, 'gi'), "<span style='font-weight: 500;'>$1</span>");
    },

    highlightDescript() {
      if (!this.description) {
        return null;
      }

      if (this.isDefaultValue) {
        return this.description;
      }

      return this.description.replace(new RegExp(`(${preq_quote(this.uiSelect.inputValue)})`, 'gi'), "<span style='font-weight: 600;'>$1</span>");
    }

  },

  mounted() {
    this.uiSelect.cachedOptions.push(this);
  },

  beforeDestroy() {
    const index = this.uiSelect.cachedOptions.indexOf(this);
    this.uiSelect.cachedOptions.splice(index, 1);
  },

  methods: {
    clickHandler() {
      if (this.disabled) {
        return;
      }

      this.uiSelect.setValue(this.value);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiSelect/UiOption.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiSelect_UiOptionvue_type_script_lang_js_ = (UiOptionvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiSelect/UiOption.vue





/* normalize component */

var UiOption_component = normalizeComponent(
  UiSelect_UiOptionvue_type_script_lang_js_,
  UiOptionvue_type_template_id_48b157c4_render,
  UiOptionvue_type_template_id_48b157c4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiOption = (UiOption_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTag/UiTag.vue?vue&type=template&id=327f39ab&
var UiTagvue_type_template_id_327f39ab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['tag-wrap']},_vm.$listeners),[_c('div',{class:_vm.classes,style:(_vm.styles)},[(_vm.$slots.leftIcon || _vm.isAttached)?_c('div',{class:_vm.$style['tag__left-icon']},[_vm._t("leftIcon",function(){return [_c('UiIcon',{attrs:{"name":"addedPin"}})]})],2):_vm._e(),_c('div',{class:_vm.$style['tag__content']},[_vm._t("default")],2),(_vm.isClosable || _vm.$slots.rightIcon)?_c('div',{class:_vm.$style['tag__close'],on:{"click":function($event){$event.stopPropagation();return _vm.$emit('removeTag')}}},[_vm._t("rightIcon",function(){return [_c('UiIcon',{attrs:{"name":"clear"}})]})],2):_vm._e()])])}
var UiTagvue_type_template_id_327f39ab_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTag/UiTag.vue?vue&type=template&id=327f39ab&

// CONCATENATED MODULE: ./src/components/UiTag/enum/sizes.js
/* harmony default export */ var UiTag_enum_sizes = ({
  LARGE: 'large',
  BIG: 'big',
  SMALL: 'small',
  CAPS: 'caps'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTag/UiTag.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiTagvue_type_script_lang_js_ = ({
  name: 'UiTag',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    /**
     * Тип тега
     * - large
     * - big
     * - small
     * - caps
     */
    type: {
      type: String,
      default: UiTag_enum_sizes.LARGE
    },

    /**
     * Светлый фон - текст тёмный
     */
    darkBg: {
      type: Boolean,
      default: false
    },

    /**
     * Слева выводим иконку закреплённого тега
     */
    atached: {
      type: Boolean,
      default: false
    },

    /**
     * Доступна иконка удаления
     */
    closable: {
      type: Boolean,
      default: true
    },

    /**
     * Курсор - pointer
     */
    pointer: {
      type: Boolean,
      default: false
    },

    /**
     * Произвольный фоновый цвет
     */
    background: {
      type: String,
      default: null
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['tag']]: true,
        [this.$style[`tag_${this.type}`]]: true,
        [this.$style['tag_pointer']]: this.pointer,
        [this.$style['tag_light']]: !this.darkBg,
        [this.$style['tag_dark']]: this.darkBg
      };
    },

    styles() {
      return {
        background: this.background
      };
    },

    isAttached() {
      return this.atached && [UiTag_enum_sizes.BIG, UiTag_enum_sizes.SMALL].includes(this.type);
    },

    isClosable() {
      return this.closable && (this.type === UiTag_enum_sizes.LARGE || this.type === UiTag_enum_sizes.BIG && !this.atached);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTag/UiTag.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTag_UiTagvue_type_script_lang_js_ = (UiTagvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTag/UiTag.vue?vue&type=style&index=0&module=true&lang=less&
var UiTagvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("3f06");

// CONCATENATED MODULE: ./src/components/UiTag/UiTag.vue








function UiTag_injectStyles (context) {
  
  this["$style"] = (UiTagvue_type_style_index_0_module_true_lang_less_["default"].locals || UiTagvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTag_component = normalizeComponent(
  UiTag_UiTagvue_type_script_lang_js_,
  UiTagvue_type_template_id_327f39ab_render,
  UiTagvue_type_template_id_327f39ab_staticRenderFns,
  false,
  UiTag_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTag = (UiTag_component.exports);
// CONCATENATED MODULE: ./src/components/UiTag/index.js

/* harmony default export */ var components_UiTag = (UiTag);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiSelect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







let UiSelectvue_type_script_lang_js_idCounter = 0;
/* harmony default export */ var UiSelectvue_type_script_lang_js_ = ({
  name: 'UiSelect',
  components: {
    UiOption: UiOption,
    UiInput: components_UiInput,
    UiScrollbar: components_UiScrollbar,
    UiTag: components_UiTag,
    UiTooltip: components_UiTooltip
  },
  model: {
    prop: 'value',
    event: 'changeSelect'
  },
  props: {
    id: {
      type: String,
      default: () => `ui-select-${++UiSelectvue_type_script_lang_js_idCounter}`
    },

    /**
     * id Внутреннего инпута
     */
    areaId: {
      type: String,
      default: null
    },

    /**
     * Определяет множественный ввод
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Текущее значение селекта
     */
    value: {
      validator: prop => {
        return typeof prop === 'object' || typeof prop === 'string' || typeof prop === 'number';
      },

      default() {
        if (this.multiple) {
          return [];
        }

        return null;
      }

    },

    /**
     * Если значением является объект,
     * то свойство определяет, какое из его полей
     * используется для вывода в input
     */
    labelPropName: {
      type: String,
      default: 'value'
    },

    /**
     * Если значением является объект,
     * то свойство определяет, какое из его полей
     * используется для передачи в модель.
     * По-умолчанию передается сам объект
     */
    valuePropName: {
      type: String,
      default: null
    },

    /**
     * Массив пунктов селекта
     * Будет использован только если пункты
     * не переданы напрямую через слот.
     * Для совместимости со старыми приложениями
     */
    options: {
      type: Array,
      default: () => []
    },
    openWithActiveFocus: {
      type: Boolean,
      default: false
    },

    /**
     * Плейсхолдер селекта - строка,
     * которая будет отображаться при отсутствии значения у самого селекта
     */
    placeholder: {
      type: String,
      default: ''
    },

    /**
     * Плейсхолдер фильтра - строка,
     * которая будет отображаться при отсутствии значения у инпута фильтра
     * Имеет смысл, только когда селекс filtered или :readonly="false"
     */
    searchPlaceholder: {
      type: String,
      default: ''
    },

    /**
     * Определяет активность поля ввода
     */
    readonly: {
      type: Boolean,
      default: true
    },

    /**
     * Фильтрация Пунктов
     */
    filtered: {
      type: Boolean,
      default: false
    },

    /**
     * Определяет состояние disabled селекта
     */
    disabled: {
      type: Boolean,
      default: false
    },

    /**
     * В качестве выводимого значения
     * будет использован только placeholder
     */
    onlyPlaceholder: {
      type: Boolean,
      default: false
    },

    /**
     * Строка-префикс, выводимая перед
     * количеством выбранных пунктов
     * в случае множественного выбора
     */
    selectedText: {
      type: String,
      default: 'Выбрано'
    },
    optionIconRight: {
      type: String,
      default: null
    },

    /**
     * Иконка, выводимая в input слева
     */
    iconLeft: {
      type: String,
      default: ''
    },

    /**
     * Иконка, выводимая в input справа
     */
    iconRight: {
      type: String,
      default: 'caret-down'
    },

    /**
     * Будут выводиться теги под полем ввода
     * при множественном выборе
     */
    tags: {
      type: Boolean,
      default: false
    },

    /**
     * Тип тега
     */
    tagsType: {
      type: String,
      default: 'large'
    },

    /**
     * Тёмный фон для тегов
     */
    tagsDarkBg: {
      type: Boolean,
      default: false
    },

    /**
     * Выводит иконку для сброса значения
     */
    clearable: {
      type: Boolean,
      default: false
    },

    /**
     * Переключает состояние выпадашки
     */
    open: {
      type: Boolean,
      default: false
    },

    /**
     * Закрывает селект при клике на содержимое выпадашки
     * Нужно для произвольного содержимого (без UiOption)
     */
    closeOnClick: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'bottom'
    },

    /**
     * По умолчанию, ширина выпадашки устанавливается
     * по ширине целевого элемента.
     * Данная опция отключает такое поведение
     */
    maxWidthDropdown: {
      type: Boolean,
      default: false
    },
    dropdownClass: {
      type: String,
      default: null
    },
    baseClass: {
      type: String,
      default: null
    },
    container: {
      type: String,
      default: 'body'
    },
    autoHide: {
      type: Boolean,
      default: true
    },

    /**
     * Проброс ошибок в Инпут
     */
    error: {
      type: [Boolean, String, Array],
      default: false
    },

    /**
     * Вывод строки, когда результат не найден
     * Имеет смысл только когда селект filtered
     */
    noResult: {
      type: [String, Function]
    },

    /**
     * Переполняемый селект
     */
    overflowing: {
      type: Boolean,
      default: false
    },

    /**
     * Скролл селекта к выбранному элементу
     */
    scrollToActiveOption: {
      type: Boolean,
      default: true
    },
    inputVariant: createEnumProp(enum_variants, enum_variants.DEFAULT)
  },

  data() {
    return {
      isRendered: false,
      isOpen: this.open,
      targetWidth: 'auto',
      areaWidth: 0,
      scrollUpdated: false,
      inputValue: '',
      cachedOptions: [],
      inputOverflowing: false
    };
  },

  provide() {
    return {
      'uiSelect': this
    };
  },

  computed: {
    isReadonly() {
      return !this.filtered && (this.readonly || this.multiple);
    },

    isOpenWithActiveFocus() {
      return this.openWithActiveFocus || this.filtered;
    },

    getPlaceholder() {
      if (this.searchPlaceholder && !this.isReadonly && this.isOpen) {
        return this.searchPlaceholder;
      }

      return this.placeholder;
    },

    noResultsString() {
      if (!this.filtered || !this.noResult || this.visibleOptionsLength) {
        return '';
      }

      return typeof this.noResult === 'function' ? this.noResult(this.inputValue) : `${this.noResult} «${this.inputValue}»`;
    },

    labels() {
      if (typeof this.options[0] !== 'object') {
        return this.options;
      }

      const labels = [];
      this.options.forEach(opt => {
        labels.push(opt[this.labelPropName]);
      });
      return labels;
    },

    /**
     * @description Работает только для режима multiply
     * @return {object} объект вида {value, length}, где value - строка с именами, разделёнными "," length - количество названий
     */
    outputLabel() {
      const labels = [];

      for (let i = 0; i < this.value.length; i++) {
        if (this.value[i] === null) {
          continue;
        }

        if (typeof this.value[i] === 'object' && this.value[i][this.labelPropName]) {
          labels.push(this.value[i][this.labelPropName]);
          continue;
        }

        const label = this.getActiveLabel(this.value[i]);

        if (label) {
          labels.push(label);
        }
      }

      return {
        value: labels.join(', '),
        length: labels.length
      };
    },

    /**
     * @description Метод возвращает значение, отображаемое в input
     * @return {string}
     */
    outputValue() {
      if ((this.onlyPlaceholder || this.tags) && this.placeholder.length) {
        return this.placeholder;
      }

      if (Array.isArray(this.value)) {
        let width = 0;

        if (this.outputBox) {
          width = this.outputBox.clientWidth;
        }

        if (width > 0 && this.areaWidth > width) {
          return `${this.selectedText}: ${this.outputLabel.length}`;
        }

        return this.outputLabel.value;
      }

      if (typeof this.value === 'object' && this.value !== null) {
        return this.value[this.labelPropName] ? this.value[this.labelPropName] : '';
      }

      return this.getActiveLabel(this.value);
    },

    currentValue() {
      return !this.isReadonly && this.isOpen ? this.inputValue : this.outputValue;
    },

    styles() {
      if (this.maxWidthDropdown) {
        return `min-width: ${this.targetWidth}`;
      }

      let width = `width: ${this.targetWidth}; `;

      if (parseInt(this.targetWidth) > 500) {
        width += `max-width: ${this.targetWidth};`;
      }

      return width;
    },

    popperOptions() {
      if (this.placement) {
        return {
          modifiers: {
            preventOverflow: {
              enabled: false
            },
            hide: {
              enabled: false
            }
          }
        };
      }

      return {};
    },

    defaultIconRight() {
      if (this.optionIconRight) {
        return this.optionIconRight;
      }

      if (this.multiple) {
        return 'addCircleOutlined';
      }

      return null;
    },

    visibleOptionsLength() {
      return this.cachedOptions.filter(el => el.isVisible).length;
    },

    placeholderStyle() {
      if (this.isOpen || this.tags && this.value.length) {
        return false;
      }

      return (this.onlyPlaceholder || this.tags) && this.placeholder.length > 0;
    }

  },
  watch: {
    open(val) {
      if (val) {
        this.openMenu();
      } else {
        this.closeMenu();
      }
    },

    value(val) {
      this.setAreaWidth();
      this.setInputOverflowing();

      if (this.filtered && this.outputBox) {
        this.inputValue = '';
        this.$nextTick(() => {
          this.outputBox.focus();
        });
      }
    }

  },

  mounted() {
    this.outputBox = this.$el.querySelector('input');
    this.setAreaWidth();
    this.setInputOverflowing();
    this.targetWidth = `${this.$el.clientWidth}px`;
    this.cachedGroup = [];
  },

  methods: {
    openMenu() {
      if (this.disabled) {
        return;
      }

      this.targetWidth = `${this.$el.clientWidth}px`;

      if ((this.options.length || this.$slots.default) && (this.isOpenWithActiveFocus || this.value && this.value.length || this.isReadonly)) {
        this.isRendered = true;
        this.isOpen = true;
        this.$emit('openSelect', true);

        if (!this.readonly) {
          this.inputValue = this.outputValue;
        }

        clearTimeout(this._clearInputTimer);
        setTimeout(() => {
          var _this$cachedOptions$f;

          const activeOption = (_this$cachedOptions$f = this.cachedOptions.find(el => el.isActive)) === null || _this$cachedOptions$f === void 0 ? void 0 : _this$cachedOptions$f.$el;

          if (this.scrollToActiveOption && activeOption) {
            const optGroup = activeOption.closest('[data-dropdown-group]');
            const groupHeadH = (optGroup === null || optGroup === void 0 ? void 0 : optGroup.firstChild.clientHeight) || 0;
            const optHroupTop = (optGroup === null || optGroup === void 0 ? void 0 : optGroup.offsetTop) || 0;
            const st = optHroupTop + activeOption.offsetTop - groupHeadH;

            if (this.$refs.scrollbar) {
              this.$refs.scrollbar.$el.scrollTop = st;
            }
          }

          if (this.$refs.scrollbar) {
            this.$refs.scrollbar.update();
          }

          this.setAreaWidth();
        }, 100);
      }
    },

    closeMenu() {
      this.isOpen = false;
      this.$emit('closeSelect', true);
      this._clearInputTimer = setTimeout(() => {
        this.inputValue = '';
        this.$emit('input', '');
      }, 250);
    },

    setValue(value) {
      let selectValue;
      let currentValue = this.valuePropName && typeof value === 'object' ? value[this.valuePropName] : value;

      if (this.multiple) {
        if (Array.isArray(this.value)) {
          selectValue = [...this.value];
        } else if (this.value) {
          selectValue = [this.value];
        } else {
          selectValue = [];
        }

        let itemInArray = false;

        for (let i = 0; i < selectValue.length; i++) {
          if (JSON.stringify(selectValue[i]) === JSON.stringify(currentValue)) {
            selectValue.splice(i, 1);
            itemInArray = true;
          }
        }

        if (!itemInArray) {
          selectValue.push(currentValue);
        }
      } else {
        selectValue = currentValue;
      }

      this.$emit('changeSelect', selectValue);

      if (!this.multiple) {
        this.closeMenu();
      }
    },

    clearValue() {
      let value = '';

      if (this.multiple) {
        value = [];
      } else if (typeof this.value === 'object') {
        value = null;
      }

      this.$emit('changeSelect', value);
    },

    getActiveLabel(val) {
      if (!this.cachedOptions.length) {
        this.isRendered = true;
      }

      for (let i = 0; i < this.cachedOptions.length; i++) {
        const opt = this.cachedOptions[i];

        if (typeof opt.value === 'object' && opt.value !== null && this.isOptContainsValue(val, opt)) {
          return opt.value[this.labelPropName];
        }

        if (opt.value === val || opt.value === undefined && val === null) {
          return opt.label;
        }
      }

      return '';
    },

    isOptContainsValue(value, option) {
      if (this.valuePropName) {
        return option.value[this.valuePropName] === value;
      }

      return Object.values(option.value).filter(el => el === value).length > 0;
    },

    onAutoHide() {
      if (this.outputBox) {
        this.outputBox.blur();
      }

      this.closeMenu();
    },

    onInputEventHandler(event) {
      const value = Array.isArray(this.value) && !event ? [] : event;
      this.$emit('input', value);

      if (!this.isReadonly) {
        this.inputValue = value;
      }
    },

    onFocusHandler(event) {
      this.$emit('focus', event);
    },

    onBlurHandler(event) {
      this.$emit('blur', event);
    },

    setAreaWidth() {
      if (this.multiple && !this.$slots.target && !this.onlyPlaceholder && !this.tags) {
        this.$nextTick(() => {
          this.areaWidth = this.$refs['fakeArea'].clientWidth;
        });
      }
    },

    onClickHandler() {
      if (this.closeOnClick) {
        this.closeMenu();
      }
    },

    setInputOverflowing() {
      if (!this.overflowing) {
        return;
      }

      this.$nextTick(() => {
        this.inputOverflowing = this.outputBox.scrollWidth > this.outputBox.clientWidth;
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiSelect/UiSelect.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiSelect_UiSelectvue_type_script_lang_js_ = (UiSelectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiSelect/UiSelect.vue?vue&type=style&index=0&module=true&lang=less&
var UiSelectvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("3e95");

// EXTERNAL MODULE: ./src/components/UiSelect/UiSelect.vue?vue&type=style&index=1&lang=css&
var UiSelectvue_type_style_index_1_lang_css_ = __webpack_require__("c4d9");

// CONCATENATED MODULE: ./src/components/UiSelect/UiSelect.vue









function UiSelect_injectStyles (context) {
  
  this["$style"] = (UiSelectvue_type_style_index_0_module_true_lang_less_["default"].locals || UiSelectvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiSelect_component = normalizeComponent(
  UiSelect_UiSelectvue_type_script_lang_js_,
  UiSelectvue_type_template_id_07aaa646_render,
  UiSelectvue_type_template_id_07aaa646_staticRenderFns,
  false,
  UiSelect_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiSelect = (UiSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiOptionGroup.vue?vue&type=template&id=be415f1e&
var UiOptionGroupvue_type_template_id_be415f1e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hideGroup),expression:"!hideGroup"}],class:_vm.$style['optgroup-wrap']},[_c('UiInputDropdownGroup',{scopedSlots:_vm._u([{key:"option",fn:function(){return [_vm._t("option")]},proxy:true},{key:"label",fn:function(){return [_vm._t("label",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})]},proxy:true},{key:"quantity",fn:function(){return [_vm._t("quantity",function(){return [_vm._v(" "+_vm._s(_vm.quantity || _vm.childrenQnt)+" ")]})]},proxy:true},{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})],1)}
var UiOptionGroupvue_type_template_id_be415f1e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSelect/UiOptionGroup.vue?vue&type=template&id=be415f1e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue?vue&type=template&id=4aadafe5&
var UiInputDropdownGroupvue_type_template_id_4aadafe5_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['optgroup'],attrs:{"data-dropdown-group":""}},[_c('div',{class:_vm.$style['optgroup__head']},[(_vm.$slots.option)?[_c('div',{class:_vm.$style['optgroup__head-option']},[_vm._t("option")],2)]:_c('div',{class:_vm.$style['optgroup__head-inner']},[_c('div',{class:[_vm.$style['optgroup__title'], ( _obj = {}, _obj[_vm.$style['optgroup__title_upper']] = !_vm.$slots.option, _obj )]},[_vm._t("label")],2),(_vm.$slots.quantity)?[_c('div',{class:_vm.$style['optgroup__cnt']},[_vm._t("quantity")],2)]:_vm._e()],2)],2),_vm._t("default")],2)}
var UiInputDropdownGroupvue_type_template_id_4aadafe5_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue?vue&type=template&id=4aadafe5&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiInputDropdownGroupvue_type_script_lang_js_ = ({
  name: 'UiInputDropdownGroup'
});
// CONCATENATED MODULE: ./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInputDropdownGroup_UiInputDropdownGroupvue_type_script_lang_js_ = (UiInputDropdownGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue?vue&type=style&index=0&lang=less&module=true&
var UiInputDropdownGroupvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("2b58");

// CONCATENATED MODULE: ./src/components/UiInputDropdownGroup/UiInputDropdownGroup.vue








function UiInputDropdownGroup_injectStyles (context) {
  
  this["$style"] = (UiInputDropdownGroupvue_type_style_index_0_lang_less_module_true_["default"].locals || UiInputDropdownGroupvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiInputDropdownGroup_component = normalizeComponent(
  UiInputDropdownGroup_UiInputDropdownGroupvue_type_script_lang_js_,
  UiInputDropdownGroupvue_type_template_id_4aadafe5_render,
  UiInputDropdownGroupvue_type_template_id_4aadafe5_staticRenderFns,
  false,
  UiInputDropdownGroup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInputDropdownGroup = (UiInputDropdownGroup_component.exports);
// CONCATENATED MODULE: ./src/components/UiInputDropdownGroup/index.js

/* harmony default export */ var components_UiInputDropdownGroup = (UiInputDropdownGroup);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSelect/UiOptionGroup.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiOptionGroupvue_type_script_lang_js_ = ({
  name: 'UiOptionGroup',
  components: {
    UiInputDropdownGroup: components_UiInputDropdownGroup
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    quantity: {
      type: [String, Number],
      default: null
    }
  },
  inject: ['uiSelect'],
  computed: {
    hideGroup() {
      if (this.isFilteredSelect) {
        return !this.childrenQnt;
      }

      return false;
    },

    isFilteredSelect() {
      return this.uiSelect && this.uiSelect.filtered;
    },

    childrenQnt() {
      const opt = this.$slots.default || [];

      if (!this.isFilteredSelect || !this.uiSelect.inputValue) {
        return opt.length;
      }

      return opt.filter(el => el && el.componentInstance && el.componentInstance.isVisible).length;
    }

  },

  mounted() {
    if (this.uiSelect && this.uiSelect.cachedGroup) {
      this.uiSelect.cachedGroup.push(this);
    }
  },

  beforeDestroy() {
    if (this.uiSelect && this.uiSelect.cachedGroup) {
      const index = this.uiSelect.cachedGroup.indexOf(this);
      this.uiSelect.cachedGroup.splice(index, 1);
    }
  }

});
// CONCATENATED MODULE: ./src/components/UiSelect/UiOptionGroup.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiSelect_UiOptionGroupvue_type_script_lang_js_ = (UiOptionGroupvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiSelect/UiOptionGroup.vue?vue&type=style&index=0&lang=less&module=true&
var UiOptionGroupvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("3c97");

// CONCATENATED MODULE: ./src/components/UiSelect/UiOptionGroup.vue








function UiOptionGroup_injectStyles (context) {
  
  this["$style"] = (UiOptionGroupvue_type_style_index_0_lang_less_module_true_["default"].locals || UiOptionGroupvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiOptionGroup_component = normalizeComponent(
  UiSelect_UiOptionGroupvue_type_script_lang_js_,
  UiOptionGroupvue_type_template_id_be415f1e_render,
  UiOptionGroupvue_type_template_id_be415f1e_staticRenderFns,
  false,
  UiOptionGroup_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiOptionGroup = (UiOptionGroup_component.exports);
// CONCATENATED MODULE: ./src/components/UiSelect/index.js




// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitch/UiSwitch.vue?vue&type=template&id=ee797990&
var UiSwitchvue_type_template_id_ee797990_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[_c('div',{class:_vm.$style['switch__inner'],on:{"click":_vm.onContentClick}},[_c('label',{class:_vm.$style['label']},[_c('input',{class:_vm.$style['switch__input'],attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{class:_vm.$style['switch__thumb-wrap']},[_c('span',{class:_vm.$style['switch__thumb']},[_c('UiIcon',{class:_vm.$style['switch__icon'],attrs:{"name":"done"}})],1)])]),(_vm.hasContent)?_c('div',{class:_vm.$style['switch__text']},[(_vm.label || _vm.$slots.default)?_c('div',{class:[_vm.$style['switch__label'], ( _obj = {}, _obj[_vm.$style['switch__label_normal']] = _vm.normalText, _obj )],attrs:{"data-label":""}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e(),(_vm.$slots.desc || _vm.desc)?_c('div',{class:_vm.$style['switch__desc']},[_c('div',{class:_vm.$style['switch__description-inner'],attrs:{"data-description":""}},[_vm._t("desc",function(){return [_vm._v(" "+_vm._s(_vm.desc)+" ")]})],2)]):_vm._e(),(_vm.error)?_c('div',{class:_vm.$style['switch__error']},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()]):_vm._e()])])}
var UiSwitchvue_type_template_id_ee797990_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=template&id=ee797990&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiSwitch/UiSwitch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiSwitchvue_type_script_lang_js_ = ({
  name: 'UiSwitch',
  components: {
    UiIcon: components_UiIcon
  },
  model: {
    prop: 'model',
    event: 'change'
  },
  props: {
    model: [Boolean],
    value: {
      type: [Boolean],
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    error: {
      type: [String, Boolean]
    },
    type: {
      type: String
    },
    square: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    normalText: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return {
        [this.$style['switch']]: true,
        [this.$style[`switch_${this.type}`]]: !!this.type,
        [this.$style['switch_checked']]: this.checked,
        [this.$style['switch_focused']]: this.focused,
        [this.$style['switch_disabled']]: this.disabled
      };
    },

    checked() {
      return this.model === true;
    },

    hasContent() {
      return this.label || this.desc || this.$slots.default;
    }

  },
  methods: {
    /**
     * @param {UiMouseEvent} event
     */
    onChange(event) {
      this.$emit('change', event.target.checked);
    },

    /**
     * @param {UiMouseEvent} event
     */
    onContentClick(event) {
      if (!this.disabled && !event.target.closest('[data-description]') && (this.focused || event.target.closest('[data-label]'))) {
        event.preventDefault();
        this.$emit('change', !this.model);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiSwitch_UiSwitchvue_type_script_lang_js_ = (UiSwitchvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiSwitch/UiSwitch.vue?vue&type=style&index=0&module=true&lang=less&
var UiSwitchvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("edc5");

// CONCATENATED MODULE: ./src/components/UiSwitch/UiSwitch.vue








function UiSwitch_injectStyles (context) {
  
  this["$style"] = (UiSwitchvue_type_style_index_0_module_true_lang_less_["default"].locals || UiSwitchvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiSwitch_component = normalizeComponent(
  UiSwitch_UiSwitchvue_type_script_lang_js_,
  UiSwitchvue_type_template_id_ee797990_render,
  UiSwitchvue_type_template_id_ee797990_staticRenderFns,
  false,
  UiSwitch_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiSwitch = (UiSwitch_component.exports);
// CONCATENATED MODULE: ./src/components/UiSwitch/index.js

/* harmony default export */ var components_UiSwitch = (UiSwitch);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTable/UiTable.vue?vue&type=template&id=07fb207b&
var UiTablevue_type_template_id_07fb207b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style['table-wrap']},[_c('table',_vm._g({class:_vm.$style['table']},_vm.$listeners),[_vm._t("default")],2)])}
var UiTablevue_type_template_id_07fb207b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue?vue&type=template&id=07fb207b&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTable/UiTable.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
/* harmony default export */ var UiTablevue_type_script_lang_js_ = ({
  name: 'UiTable'
});
// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTable_UiTablevue_type_script_lang_js_ = (UiTablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTable/UiTable.vue?vue&type=style&index=0&module=true&lang=less&
var UiTablevue_type_style_index_0_module_true_lang_less_ = __webpack_require__("4c96");

// EXTERNAL MODULE: ./src/components/UiTable/UiTable.vue?vue&type=style&index=1&lang=less&
var UiTablevue_type_style_index_1_lang_less_ = __webpack_require__("cd64");

// CONCATENATED MODULE: ./src/components/UiTable/UiTable.vue









function UiTable_injectStyles (context) {
  
  this["$style"] = (UiTablevue_type_style_index_0_module_true_lang_less_["default"].locals || UiTablevue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTable_component = normalizeComponent(
  UiTable_UiTablevue_type_script_lang_js_,
  UiTablevue_type_template_id_07fb207b_render,
  UiTablevue_type_template_id_07fb207b_staticRenderFns,
  false,
  UiTable_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTable = (UiTable_component.exports);
// CONCATENATED MODULE: ./src/components/UiTable/index.js

/* harmony default export */ var components_UiTable = (UiTable);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabs.vue?vue&type=template&id=4812a49a&
var UiTabsvue_type_template_id_4812a49a_render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(!_vm.withoutControls)?_c('div',{ref:"controls",class:_vm.$style['tabs__controls']},[_vm._l((_vm.separatedTabs.main),function(tab){
var _obj, _obj$1;
return _c('button',{key:tab.index,class:( _obj = {}, _obj[_vm.$style['tabs__control']] = true, _obj[_vm.$style['tabs__control_active']] = _vm.activeTab === tab.index, _obj[_vm.$style['tabs__control_disabled']] = tab.tab.disabled, _obj[_vm.$style['tabs__control_icon-without-text']] = !tab.tab.label && !tab.tab.$slots.label, _obj[tab.buttonClass] = tab.tab.buttonClass, _obj ),attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.changeTab(tab.index)}}},[(tab.tab.$slots.icon)?_c('UiTabIconWrapper',{attrs:{"node":tab.tab.$slots.icon}}):(tab.tab.icon)?_c('UiIcon',{class:[
                    _vm.$style['tabs__icon'],
                    ( _obj$1 = {}, _obj$1[_vm.$style['tabs__icon_text']] = tab.tab.$slots.label || tab.tab.label, _obj$1 )
                ],attrs:{"name":tab.tab.icon}}):_vm._e(),(tab.tab.$slots.label)?_c('UiTabLabel',{attrs:{"elm":tab.tab.$slots.label}}):[_vm._v(" "+_vm._s(tab.tab.label)+" ")],(!tab.tab.disabled && tab.tab.counter)?_c('span',{class:_vm.$style['tabs__counter']},[_vm._v(" "+_vm._s(tab.tab.counter)+" ")]):_vm._e()],2)}),(_vm.separatedTabs.extra.length !== 0)?_c('div',{class:( _obj = {}, _obj[_vm.$style['extra']] = true, _obj[_vm.$style['extra_open']] = _vm.extraOpen, _obj ),on:{"click":function($event){$event.stopPropagation();return _vm.toggleExtra.apply(null, arguments)}}},[_c('UiButton',{class:_vm.$style['extra__btn'],attrs:{"variant":"tertiary","shape":"square","size":"sm"}},[_c('UiIcon',{attrs:{"name":"moreHorizontal"}})],1),_c('div',{class:_vm.$style['extra__wrap']},_vm._l((_vm.separatedTabs.extra),function(tab){return _c('div',{key:tab.index,on:{"click":function($event){$event.preventDefault();tab.tab.disabled ? null : _vm.changeTab(tab.index)}}},[_c('UiInputDropdown',{attrs:{"icon-prefix":tab.tab.icon,"disabled":tab.tab.disabled,"icon-prefix-class":_vm.$style['extra__icon'],"icon-class":_vm.$style['extra__counter'],"ticker":""},scopedSlots:_vm._u([(!tab.tab.disabled && tab.tab.counter)?{key:"icon",fn:function(){return [_vm._v(" "+_vm._s(tab.tab.counter)+" ")]},proxy:true}:null],null,true)},[_vm._v(" "+_vm._s(tab.tab.label)+" ")])],1)}),0)],1):_vm._e()],2):_vm._e(),_c('div',{class:( _obj$1 = {}, _obj$1[_vm.$style['tabs__content']] = true, _obj$1[_vm.$style['tabs__content_no-ctr']] = _vm.withoutControls || _vm.isRadioGroup, _obj$1 )},[_vm._t("default")],2)])}
var UiTabsvue_type_template_id_4812a49a_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTabs/UiTabs.vue?vue&type=template&id=4812a49a&

// CONCATENATED MODULE: ./src/components/UiTabs/enum/sizes.js
/* harmony default export */ var UiTabs_enum_sizes = ({
  SM: 'sm',
  MD: 'md',
  LG: 'lg'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabs.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const EXTRA_BTN_WIDTH = 36;
/* harmony default export */ var UiTabsvue_type_script_lang_js_ = ({
  name: 'UiTabs',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiInputDropdown: components_UiInputDropdown,
    UiTabIconWrapper: {
      functional: true,

      render(h, {
        props,
        parent
      }) {
        const iconClass = [parent.$style['tabs__icon'], parent.$style['tabs__icon_text']].join(' ');
        return h('span', {
          attrs: {
            class: iconClass
          }
        }, [props.node]);
      }

    },
    UiTabLabel: {
      functional: true,

      render(h, ctx) {
        return ctx.props.elm;
      }

    }
  },
  model: {
    prop: 'value',
    event: 'changeTab'
  },

  provide() {
    return {
      registerTab: this.registerTab,
      unregisterTab: this.unregisterTab
    };
  },

  props: {
    value: {
      type: [Number, String]
    },
    global: {
      type: Boolean,
      default: false
    },

    /**
     * Вид табов (обычный/радиогруппа)
     */
    type: {
      type: String,
      default: null
    },

    /**
     * Размер табов (sm, md, lg)
     */
    size: {
      type: String,
      validator: size => Object.values(UiTabs_enum_sizes).includes(size),
      default: UiTabs_enum_sizes.MD
    },

    /**
     * Растягивание таба по контенту внутри
     */
    rubber: {
      type: Boolean,
      default: false
    },

    /**
     * Растягивание навигации за границы контентной области (40px)
     */
    expanded: {
      type: Boolean,
      default: false
    },

    /**
     * Возможность не выводить панель с кнопками
     */
    withoutControls: {
      type: Boolean,
      default: false
    },

    /**
     * Обрезка в выпадающий блок при переполнении
     */
    overflowing: {
      type: Boolean,
      default: false
    },

    /**
     * Установка ключа активного таба в location.search
     */
    queryString: {
      type: Boolean,
      default: false
    },

    /**
     * Имя ключа активного таба в location.search
     */
    queryStringName: {
      type: String,
      default: 'active_tab'
    },

    /**
     * Линия разделитель вверху
     */
    topLine: {
      type: Boolean,
      default: false
    },

    /**
     * Ключ для переключения табов
     */
    activeTabKey: {
      type: [String, Boolean],
      default: false
    },

    /**
     * Блок переключателей на всю ширину враппера
     */
    fullWidthControls: {
      type: Boolean,
      default: false
    },

    /**
     * Флаг позволяет заблокировать переключение таба
     */
    canChangeTab: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      separatedTabs: {
        main: [],
        extra: []
      },
      tabsWidths: [],
      activeTab: 0,
      extraOpen: false,
      timeout: null
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['tabs']]: true,
        [this.$style['tabs_global']]: this.global,
        [this.$style['tabs_default']]: !this.isRadioGroup,
        [this.$style['tabs_radiogroup']]: this.isRadioGroup,
        [this.$style['tabs_expanded']]: this.expanded,
        [this.$style[`tabs_top-line`]]: this.topLine,
        [this.$style[`tabs_size-${this.size}`]]: true,
        [this.$style['tabs_rubber']]: this.rubber,
        [this.$style['tabs_full-width']]: this.fullWidthControls
      };
    },

    isRadioGroup() {
      return this.type === 'radiogroup';
    },

    tabs() {
      return Array.from(this.tabsRegistry.values());
    }

  },
  watch: {
    value() {
      const index = this.value || 0;
      this.changeTab(index);
    },

    activeTabKey(key) {
      this.setActiveTabOnKey(key);
    }

  },

  beforeCreate() {
    this.tabsRegistry = new Map();
  },

  mounted() {
    this.activeTab = this.value || 0;

    if (this.activeTab < this.tabs.length) {
      this.tabs[this.activeTab].isActive = true;
    }

    this.groupTabs(this.tabs.length); // Отрисовка всех табов для расчета из ширины

    this.$nextTick(() => {
      this.calculateTabsWidth();
      this.checkActiveTabData(); // Проверка данных активного таба в адресной строке

      if (this.overflowing) {
        this.regroupTabs();
        window.addEventListener('resize', this.resizeHandler, false);
      }
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler, false);
  },

  methods: {
    registerTab(id, vm) {
      if (!this.tabsRegistry.has(id)) {
        this.tabsRegistry.set(id, vm);
      }
    },

    unregisterTab(id) {
      this.tabsRegistry.delete(id);
    },

    changeTab(index) {
      if (!this.canChangeTab) {
        var _this$tabs$index;

        this.$emit('changeTabCancel', {
          index: index,
          tabKey: (_this$tabs$index = this.tabs[index]) === null || _this$tabs$index === void 0 ? void 0 : _this$tabs$index.tabKey,
          current: this.value
        });
        return;
      }

      if (this.activeTab === index || this.tabs[index] === undefined) {
        return;
      }

      if (this.tabs[index].disabled === true) {
        return;
      }

      if (this.activeTab < this.tabs.length) {
        this.tabs[this.activeTab].deactivate();
      }

      this.tabs[index].activate(this.activeTab, index);
      this.activeTab = index;

      if (this.queryString) {
        this.setQueryString(this.tabs[index].tabKey);
      } else {
        this.setLocationHash(this.tabs[index].tabKey);
      }

      if (this.overflowing) {
        this.regroupTabs();
      }

      this.$emit('changeTab', index);
    },

    setLocationHash(key) {
      if (key) {
        window.location.hash = `#${key}`;
      }
    },

    setQueryString(key) {
      let {
        queries,
        queryIndex
      } = this.getQueryData();

      if (queryIndex !== -1) {
        queries.splice(queryIndex, 1);
      }

      if (key) {
        queries.push(`${this.queryStringName}=${key}`);
      }

      window.history.replaceState(null, '', `?${queries.join('&')}${window.location.hash}`);
    },

    getQueryData() {
      const queries = window.location.search.slice(1).split('&');
      return {
        queries,
        queryIndex: queries.findIndex(query => query.includes(this.queryStringName))
      };
    },

    calculateTabsWidth() {
      if (!this.$refs['controls']) {
        return;
      }

      const tabsButtons = [...this.$refs['controls'].querySelectorAll(`.${this.$style['tabs__control']}`)];
      this.tabsWidths = tabsButtons.map(el => {
        const style = el.currentStyle || window.getComputedStyle(el);
        const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        return el.offsetWidth + margin;
      });
    },

    regroupTabs() {
      /** @type {HTMLElement} */
      const wrapper = this.$refs.controls;
      const wrapperStyle = wrapper.currentStyle || window.getComputedStyle(wrapper);
      const wrapperWidth = wrapper.clientWidth - parseInt(wrapperStyle.paddingLeft, 10) - parseInt(wrapperStyle.paddingRight, 10);
      const tabsWidths = [...this.tabsWidths]; // Swap active and first element for menu max width calculate

      if (this.activeTab !== 0) {
        [tabsWidths[0], tabsWidths[this.activeTab]] = [tabsWidths[this.activeTab], tabsWidths[0]];
      }

      let index = this.tabsWidths.length;
      let visibleWidth = EXTRA_BTN_WIDTH;

      for (let i = 0; i < tabsWidths.length; i++) {
        visibleWidth += tabsWidths[i];

        if (visibleWidth > wrapperWidth) {
          index = i - 1;
          break;
        }
      }

      this.groupTabs(Math.max(index, 1));
    },

    groupTabs(splitIndex) {
      const main = [];
      const extra = [];
      this.tabs.forEach((tab, index) => {
        if (index < splitIndex) {
          main.push({
            index,
            tab
          });
        } else if (index === this.activeTab) {
          extra.unshift(main.pop());
          main.push({
            index,
            tab
          });
        } else {
          extra.push({
            index,
            tab
          });
        }
      });
      this.separatedTabs = {
        main,
        extra
      };
    },

    resizeHandler() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(this.regroupTabs, 100);
    },

    toggleExtra() {
      this.extraOpen = !this.extraOpen;

      if (this.extraOpen) {
        document.addEventListener('click', this.toggleExtra);
      } else {
        document.removeEventListener('click', this.toggleExtra);
      }
    },

    checkActiveTabData() {
      let key = null;

      if (!this.queryString && window.location.hash) {
        key = window.location.hash.slice(1);
      } else if (this.queryString && window.location.search) {
        const {
          queries,
          queryIndex
        } = this.getQueryData();

        if (queryIndex !== -1) {
          key = queries[queryIndex].split('=')[1];
        }
      }

      this.setActiveTabOnKey(key);
    },

    setActiveTabOnKey(key) {
      const tabId = this.tabs.findIndex(tab => tab.tabKey === key);
      this.changeTab(tabId === -1 ? this.activeTab : tabId);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTabs/UiTabs.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTabs_UiTabsvue_type_script_lang_js_ = (UiTabsvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTabs/UiTabs.vue?vue&type=style&index=0&module=true&lang=less&
var UiTabsvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("7999");

// CONCATENATED MODULE: ./src/components/UiTabs/UiTabs.vue








function UiTabs_injectStyles (context) {
  
  this["$style"] = (UiTabsvue_type_style_index_0_module_true_lang_less_["default"].locals || UiTabsvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTabs_component = normalizeComponent(
  UiTabs_UiTabsvue_type_script_lang_js_,
  UiTabsvue_type_template_id_4812a49a_render,
  UiTabsvue_type_template_id_4812a49a_staticRenderFns,
  false,
  UiTabs_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTabs = (UiTabs_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabsItem.vue?vue&type=template&id=04dd2ce0&
var UiTabsItemvue_type_template_id_04dd2ce0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],class:_vm.$style['tabs-item']},[_vm._t("default")],2)}
var UiTabsItemvue_type_template_id_04dd2ce0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsItem.vue?vue&type=template&id=04dd2ce0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabsItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
/* harmony default export */ var UiTabsItemvue_type_script_lang_js_ = ({
  name: 'UiTabsItem',
  inject: {
    registerTab: {
      default: null
    },
    unregisterTab: {
      default: null
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    buttonClass: {
      type: String,
      default: null
    },
    tabKey: {
      type: String
    },
    counter: {
      type: [String, Number]
    }
  },

  data() {
    return {
      isActive: false
    };
  },

  mounted() {
    if (this.registerTab) {
      this.registerTab(this._uid, this);
    } else {
      this.$destroy();
      throw new Error('You should wrap UiTabsItem on a UiTabs');
    }
  },

  beforeDestroy() {
    if (this.unregisterTab) {
      this.unregisterTab(this._uid);
    }
  },

  methods: {
    activate() {
      this.isActive = true;
    },

    deactivate() {
      this.isActive = false;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTabs_UiTabsItemvue_type_script_lang_js_ = (UiTabsItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTabs/UiTabsItem.vue?vue&type=style&index=0&module=true&lang=less&
var UiTabsItemvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("5b0a");

// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsItem.vue








function UiTabsItem_injectStyles (context) {
  
  this["$style"] = (UiTabsItemvue_type_style_index_0_module_true_lang_less_["default"].locals || UiTabsItemvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTabsItem_component = normalizeComponent(
  UiTabs_UiTabsItemvue_type_script_lang_js_,
  UiTabsItemvue_type_template_id_04dd2ce0_render,
  UiTabsItemvue_type_template_id_04dd2ce0_staticRenderFns,
  false,
  UiTabsItem_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTabsItem = (UiTabsItem_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabsSwitch.vue?vue&type=template&id=e16e3758&
var UiTabsSwitchvue_type_template_id_e16e3758_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTabs',_vm._b({attrs:{"value":_vm.indexComputed,"type":"radiogroup"},on:{"changeTab":function($event){_vm.indexComputed = $event}}},'UiTabs',_vm.$attrs,false),_vm._l((_vm.options),function(option,i){return _c('UiTabsItem',{key:_vm.name + '-option-' + i,attrs:{"label":option.label}})}),1)}
var UiTabsSwitchvue_type_template_id_e16e3758_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsSwitch.vue?vue&type=template&id=e16e3758&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTabs/UiTabsSwitch.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


const OPTIONS_MINIMUM = 2;

const hasProps = (obj, props) => props.reduce((hasAll, p) => hasAll && obj.hasOwnProperty(p), true);

/* harmony default export */ var UiTabsSwitchvue_type_script_lang_js_ = ({
  name: 'UiTabsSwitch',
  components: {
    UiTabs: UiTabs,
    UiTabsItem: UiTabsItem
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      validator: () => true,
      default: null
    },
    options: {
      type: Array,
      required: true,

      validator(options) {
        return options.length >= OPTIONS_MINIMUM && !options.some(o => !hasProps(o, ['label', 'value']));
      }

    },
    name: {
      type: String,
      default: 'tab-switch'
    },

    /**
     * Обработчик значений, можно изменить для того, чтобы сравнивать сложные значения
     */
    processor: {
      type: Function,
      default: a => a
    },

    /**
     * Строгое сравнение, используйте false, если нужно например,
     * считать равными число и его строковое представление
     */
    strict: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      index: this.options.findIndex(o => this.compare(o.value, this.value))
    };
  },

  computed: {
    indexComputed: {
      get() {
        return this.index === -1 ? 0 : this.index;
      },

      set(index) {
        if (this.options[index] !== undefined) {
          this.index = index;
          this.$emit('change', this.options[index].value);
        }
      }

    }
  },
  watch: {
    value() {
      this.index = this.options.findIndex(o => this.compare(o.value, this.value));
    }

  },
  methods: {
    /**
     * ВАЖНО: Если не строгий режим, то сравнение тоже не строгое
     * @param a
     * @param b
     * @return {boolean}
     */
    compare(a, b) {
      if (this.strict) {
        return this.processor(a) === this.processor(b);
      } else {
        // eslint-disable-next-line eqeqeq
        return this.processor(a) == this.processor(b);
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsSwitch.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTabs_UiTabsSwitchvue_type_script_lang_js_ = (UiTabsSwitchvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiTabs/UiTabsSwitch.vue





/* normalize component */

var UiTabsSwitch_component = normalizeComponent(
  UiTabs_UiTabsSwitchvue_type_script_lang_js_,
  UiTabsSwitchvue_type_template_id_e16e3758_render,
  UiTabsSwitchvue_type_template_id_e16e3758_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiTabsSwitch = (UiTabsSwitch_component.exports);
// CONCATENATED MODULE: ./src/components/UiTabs/index.js




// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiText/UiText.vue?vue&type=template&id=3018f01e&
var UiTextvue_type_template_id_3018f01e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",class:_vm.classes},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var UiTextvue_type_template_id_3018f01e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiText/UiText.vue?vue&type=template&id=3018f01e&

// CONCATENATED MODULE: ./src/components/UiText/enum/sizes.js
/* harmony default export */ var UiText_enum_sizes = ({
  hero: 'hero',
  title_01: 'title-01',
  title_02: 'title-02',
  article: 'article',
  paragraph: 'paragraph',
  body: 'body',
  small: 'small',
  tiny: 'tiny'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiText/UiText.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiTextvue_type_script_lang_js_ = ({
  name: 'UiText',
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    color: {
      type: String,
      default: 'black'
    },
    size: {
      type: String,
      default: UiText_enum_sizes.small
    },
    accent: {
      type: Boolean,
      default: false
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    link: {
      type: Boolean,
      default: false
    },
    title: {
      type: [Boolean, String],
      default: false
    },
    uppercase: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [this.$style['text'], this.$style[`text_${this.color}`], {
        [this.$style[`text_${this.size}`]]: !!this.size,
        [this.$style[`text_accent`]]: this.accent,
        [this.$style[`text_ellipsis`]]: this.ellipsis,
        [this.$style[`text_link`]]: this.link || this.tag === 'a',
        [this.$style[`text_title`]]: this.title,
        [this.$style[`text_uppercase`]]: this.uppercase
      }];
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiText/UiText.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiText_UiTextvue_type_script_lang_js_ = (UiTextvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiText/UiText.vue?vue&type=style&index=0&module=true&lang=less&
var UiTextvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("1a4f");

// CONCATENATED MODULE: ./src/components/UiText/UiText.vue








function UiText_injectStyles (context) {
  
  this["$style"] = (UiTextvue_type_style_index_0_module_true_lang_less_["default"].locals || UiTextvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiText_component = normalizeComponent(
  UiText_UiTextvue_type_script_lang_js_,
  UiTextvue_type_template_id_3018f01e_render,
  UiTextvue_type_template_id_3018f01e_staticRenderFns,
  false,
  UiText_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiText = (UiText_component.exports);
// CONCATENATED MODULE: ./src/components/UiText/index.js

/* harmony default export */ var components_UiText = (UiText);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTextarea/UiTextarea.vue?vue&type=template&id=b2b494de&
var UiTextareavue_type_template_id_b2b494de_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes,style:(_vm.styles),on:{"click":function($event){return _vm.$refs.inputArea.focus()}}},[(_vm.code)?_c('div',{class:_vm.$style['controls']},[_c('div',{class:_vm.$style['controls__container'],style:(("transform: translateY(" + (-_vm.scrolledLength) + "px)"))},[_c('div',{class:_vm.$style['highlight'],style:(_vm.highlightPosition)}),_c('div',{class:_vm.$style['rows']},_vm._l((_vm.lines),function(row,index){return _c('div',{key:index,class:_vm.$style['rows__item']},[_vm._v(" "+_vm._s(row)+" ")])}),0)])]):_vm._e(),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content),expression:"content"}],ref:"inputArea",class:_vm.areaClasses,attrs:{"id":_vm.id,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"name":_vm.name,"rows":1},domProps:{"value":(_vm.content)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.content=$event.target.value},_vm.onInput],"change":function($event){return _vm.$emit('change', $event.target.value)},"focus":function($event){return _vm.setFocus(true)},"blur":function($event){return _vm.setFocus(false)},"scroll":_vm.onScroll,"click":_vm.getLineNumber}}),(_vm.error.length && _vm.isDefault)?_c('div',{class:[
            _vm.$style['textarea__error'],
            _vm.$style[("textarea__error_" + _vm.errorTextAlign)]
        ]},[_vm._v(" "+_vm._s(_vm.error)+" ")]):(_vm.error.length && _vm.isInlineEdit)?_c('UiTooltip',{class:_vm.$style['textarea__error-tooltip'],attrs:{"dark":_vm.isInlineEdit ? !_vm.inversion : true,"show":true,"placement":_vm.errorTooltipPlacement,"container":_vm.errorTooltipContainer,"popover-base-class":_vm.errorTooltipClass,"trigger":"manual"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{attrs:{"data-stub":""}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e()],1)}
var UiTextareavue_type_template_id_b2b494de_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTextarea/UiTextarea.vue?vue&type=template&id=b2b494de&

// CONCATENATED MODULE: ./src/components/UiTextarea/enum/align.js
/* harmony default export */ var UiTextarea_enum_align = ({
  right: 'right',
  left: 'left'
});
// CONCATENATED MODULE: ./src/components/UiTextarea/enum/variants.js
/* harmony default export */ var UiTextarea_enum_variants = ({
  DEFAULT: 'default',
  INLINE_EDIT: 'inline-edit'
});
// CONCATENATED MODULE: ./src/components/UiTextarea/enum/sizes.js
/* harmony default export */ var UiTextarea_enum_sizes = ({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTextarea/UiTextarea.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





let UiTextareavue_type_script_lang_js_idCounter = 0;
const VERTICAL_BORDER_SUM = 2;
const MAX_LINES_HEIGHT = 5;
/* harmony default export */ var UiTextareavue_type_script_lang_js_ = ({
  name: 'UiTextarea',
  components: {
    UiTooltip: UiTooltip
  },
  props: {
    id: {
      type: String,
      default: () => `ui-textarea-${++UiTextareavue_type_script_lang_js_idCounter}`
    },
    variant: createEnumProp(UiTextarea_enum_variants, UiTextarea_enum_variants.DEFAULT),
    name: {
      type: String
    },
    value: {
      type: String,
      default: ''
    },
    error: {
      type: [Boolean, String],
      default: ''
    },

    /**
     * Определяет, по какому краю будет выровнен текст ошибки
     */
    errorTextAlign: createEnumProp(UiTextarea_enum_align, UiTextarea_enum_align.right),
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    code: {
      type: Boolean,
      default: false
    },
    resize: {
      type: [Boolean, String],
      default: false
    },
    autoHeight: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: [String, Number],
      default: null
    },
    minHeight: {
      type: [String, Number],
      default: null
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    },

    /**
     * Размер поля ввода. Сейчас применяется
     * только для variant === 'inline-edit'
     */
    size: createEnumProp(UiTextarea_enum_sizes, UiTextarea_enum_sizes.SM),

    /**
     * Инвертированные цвета инпута. Сейчас применяется
     * только для variant === 'inline-edit'
     */
    inversion: {
      type: Boolean,
      default: false
    },

    /**
     * Позиционирование тултипа с ошибкой
     */
    errorTooltipPlacement: {
      type: String,
      default: 'right'
    },

    /**
     * Контейнер тултипа с ошибкой
     */
    errorTooltipContainer: {
      type: String,
      default: 'body'
    },

    /**
     * Класс тултипа с ошибкой
     */
    errorTooltipClass: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isFocus: false,
      content: this.value,
      lineNumber: 1,
      scrolledLength: 0,

      /**
       * Автоматически вычисляемая максимальная высота,
       * для правила: при variant='inline-edit' макс. высота = 5 строк
       */
      calcMaxHeight: null
    };
  },

  computed: {
    classes() {
      return {
        [this.$style['textarea']]: true,
        [this.$style[`textarea_${this.variant}`]]: true,
        [this.$style['textarea_error']]: !!this.error,
        [this.$style['textarea_focus']]: this.isFocus,
        [this.$style['textarea_disabled']]: this.disabled,
        [this.$style['textarea_code']]: this.code,
        [this.$style[`textarea_${this.size}`]]: !this.isDefault,
        [this.$style['textarea_accent']]: this.accent,
        [this.$style['textarea_inversion']]: this.inversion && this.isInlineEdit
      };
    },

    areaClasses() {
      return {
        [this.$style['textarea__area']]: true,
        [this.$style['textarea__area_resize']]: this.resize,
        [this.$style['textarea__area_resize_vertical']]: this.resize === 'vertical',
        [this.$style['textarea__area_resize_horizontal']]: this.resize === 'horizontal'
      };
    },

    styles() {
      if (!this.isAutoHeight) {
        return;
      }

      const maxHeight = !isNaN(parseInt(this.calcMaxHeight)) ? this.calcMaxHeight : this.maxHeight;
      return {
        'max-height': maxHeight ? `${parseInt(maxHeight)}px` : null,
        'min-height': this.minHeight ? `${parseInt(this.minHeight)}px` : null
      };
    },

    lines() {
      if (this.content === '' || this.content === null) {
        return [1];
      }

      let count = 1;
      const lineNumbers = [];
      this.content.split('\n').forEach(line => {
        const wrapTimes = this.getWrapTimes(line, this.numPerLine) - 1;
        lineNumbers.push(count);

        for (let i = 0; i < wrapTimes; i++) {
          lineNumbers.push('&nbsp;');
        }

        count++;
      });
      return lineNumbers;
    },

    highlightPosition() {
      return `transform: translateY(${this.lineNumber * 24}px)`;
    },

    maxHeightComputedStyle() {
      return !isNaN(parseInt(this.calcMaxHeight)) ? this.calcMaxHeight : getComputedStyle(this.$el).maxHeight;
    },

    isDefault() {
      return this.variant === UiTextarea_enum_variants.DEFAULT;
    },

    isInlineEdit() {
      return this.variant === UiTextarea_enum_variants.INLINE_EDIT;
    },

    isAutoHeight() {
      return this.autoHeight || this.isInlineEdit;
    }

  },
  watch: {
    value(val) {
      if (val !== this.content) {
        this.content = val;
      }
    }

  },

  mounted() {
    this.$nextTick(() => {
      this.setHeight();
    });
  },

  methods: {
    getLineNumber(event) {
      const area = event.target;
      const lineNumber = area.value.substr(0, area.selectionStart).split('\n').map(line => 1 + Math.floor(line.length / area.cols)).reduce((a, b) => a + b, 0);
      this.lineNumber = lineNumber;
    },

    getSelectionStart() {
      return this.$refs.inputArea.selectionStart;
    },

    getSelectionEnd() {
      return this.$refs.inputArea.selectionEnd;
    },

    setFocus(focus) {
      this.isFocus = focus;
    },

    setHeight() {
      const textAreaElement = this.$el.querySelector('textarea');

      if (!this.isAutoHeight) {
        return;
      }

      if (this.isInlineEdit && !this.maxHeight) {
        var _getComputedStyle;

        const fz = parseInt((_getComputedStyle = getComputedStyle(textAreaElement)) === null || _getComputedStyle === void 0 ? void 0 : _getComputedStyle.fontSize);
        this.calcMaxHeight = fz ? fz * MAX_LINES_HEIGHT : null;
      }

      this.$el.style.height = 'auto';
      this.$el.style.height = `${textAreaElement.scrollHeight + VERTICAL_BORDER_SUM}px`;

      if (parseInt(this.$el.style.height) >= parseInt(this.maxHeightComputedStyle)) {
        textAreaElement.style['overflow-y'] = 'auto';
      } else {
        textAreaElement.style['overflow-y'] = 'hidden';
      }
    },

    getWrapTimes(sentence, width) {
      if (width <= 0) {
        console.warn('Please set the min-width of textarea to allow at least one character per line.');
        return sentence.length + 1;
      }

      const words = sentence.split(' ');
      let currentLine = 1;
      let spaceLeft = width;
      words.forEach(word => {
        while (word.length >= spaceLeft) {
          currentLine++;
          word = word.slice(width);
        }

        if (spaceLeft === width) {
          spaceLeft -= word.length;
          return;
        }

        if (word.length + 1 > spaceLeft) {
          currentLine++;
          spaceLeft = width;
        }

        spaceLeft -= spaceLeft === width ? word.length : word.length + 1;
      });
      return spaceLeft === width ? currentLine - 1 : currentLine;
    },

    onScroll(event) {
      this.scrolledLength = event.target.scrollTop;
    },

    onInput(event) {
      this.setHeight();
      this.$emit('input', event.target.value);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiTextarea/UiTextarea.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTextarea_UiTextareavue_type_script_lang_js_ = (UiTextareavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTextarea/UiTextarea.vue?vue&type=style&index=0&module=true&lang=less&
var UiTextareavue_type_style_index_0_module_true_lang_less_ = __webpack_require__("ed70");

// CONCATENATED MODULE: ./src/components/UiTextarea/UiTextarea.vue








function UiTextarea_injectStyles (context) {
  
  this["$style"] = (UiTextareavue_type_style_index_0_module_true_lang_less_["default"].locals || UiTextareavue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTextarea_component = normalizeComponent(
  UiTextarea_UiTextareavue_type_script_lang_js_,
  UiTextareavue_type_template_id_b2b494de_render,
  UiTextareavue_type_template_id_b2b494de_staticRenderFns,
  false,
  UiTextarea_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTextarea = (UiTextarea_component.exports);
// CONCATENATED MODULE: ./src/components/UiTextarea/index.js

/* harmony default export */ var components_UiTextarea = (UiTextarea);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTitle/UiTitle.vue?vue&type=template&id=64789d08&
var UiTitlevue_type_template_id_64789d08_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({class:_vm.$style['title']},_vm.$listeners),[_vm._t("default")],2)}
var UiTitlevue_type_template_id_64789d08_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiTitle/UiTitle.vue?vue&type=template&id=64789d08&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiTitle/UiTitle.vue?vue&type=script&lang=js&
//
//
//
//
//
//

/* harmony default export */ var UiTitlevue_type_script_lang_js_ = ({
  name: 'UiTitle',
  mixins: [deprecated_message]
});
// CONCATENATED MODULE: ./src/components/UiTitle/UiTitle.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiTitle_UiTitlevue_type_script_lang_js_ = (UiTitlevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiTitle/UiTitle.vue?vue&type=style&index=0&module=true&lang=less&
var UiTitlevue_type_style_index_0_module_true_lang_less_ = __webpack_require__("1e74");

// CONCATENATED MODULE: ./src/components/UiTitle/UiTitle.vue








function UiTitle_injectStyles (context) {
  
  this["$style"] = (UiTitlevue_type_style_index_0_module_true_lang_less_["default"].locals || UiTitlevue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiTitle_component = normalizeComponent(
  UiTitle_UiTitlevue_type_script_lang_js_,
  UiTitlevue_type_template_id_64789d08_render,
  UiTitlevue_type_template_id_64789d08_staticRenderFns,
  false,
  UiTitle_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiTitle = (UiTitle_component.exports);
// CONCATENATED MODULE: ./src/components/UiTitle/index.js

/* harmony default export */ var components_UiTitle = (UiTitle);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/UiUploader.vue?vue&type=template&id=1e47a2bc&
var UiUploadervue_type_template_id_1e47a2bc_render = function () {
var _obj, _obj$1, _obj$2;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style['uploader']]},[(!!_vm.$slots.label)?_c('div',{class:_vm.$style['label']},[_c('div',{class:_vm.$style['label__content']},[_vm._t("label")],2),(_vm.texts.restrictions && _vm.appearance === _vm.APPEARANCE.SIMPLE)?_c('div',{class:_vm.$style['label__restrictions']},[(_vm.isWide)?[_vm._v(" "+_vm._s(_vm.texts.restrictions)+" ")]:[_c('UiTooltip',{attrs:{"placement":"right"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('UiIcon',{class:_vm.$style['label__trigger'],attrs:{"name":"help"}})]},proxy:true}],null,false,658707726)},[_c('div',[_vm._v(_vm._s(_vm.texts.restrictions))])])]],2):_vm._e()]):_vm._e(),_c('div',{class:[
            _vm.$style['drop-area'],
            _vm.$style['drop-area_' + _vm.appearance],
            ( _obj = {}, _obj[_vm.$style['drop-area_' + _vm.state]] = _vm.state, _obj ),
            ( _obj$1 = {}, _obj$1[_vm.$style['drop-area_waiting-for-drop']] = _vm.waitingForDrop, _obj$1 ) ]},[_c('input',{ref:"input",class:_vm.$style['drop-area__input'],attrs:{"multiple":_vm.multiple,"disabled":_vm.maxFilesReached,"type":"file"},on:{"change":function($event){return _vm.prepare(_vm.$refs.input.files)}}}),_c('div',{ref:"dropArea",class:_vm.$style['drop-area__trigger'],on:{"click":function($event){return _vm.$refs.input.click()}}},[(_vm.appearance === _vm.APPEARANCE.BUTTON)?_c('div',{class:[
                    _vm.$style['btn'],
                    ( _obj$2 = {}, _obj$2[_vm.$style['btn_inline-restriction']] = _vm.inlineRestriction, _obj$2 )
                ]},[(!_vm.multiple && _vm.items.length)?_c('div',{class:_vm.$style['btn__file']},[_c('UiUploaderFile',{attrs:{"item":_vm.items[0],"uploadable":""},on:{"reupload":_vm.reupload,"remove":_vm.remove}})],1):(_vm.multiple || _vm.items.length === 0)?_c('div',{class:_vm.$style['btn__btn']},[_vm._t("customBtn",function(){return [_c('UiButton',[_c('UiIcon',{attrs:{"name":"upload"}}),_vm._v(" "+_vm._s(_vm.I18N[_vm.lang].uploadFile)+" ")],1)]})],2):_vm._e(),(_vm.multiple || !(_vm.items[0] && (_vm.items[0].error || _vm.inlineRestriction)))?_c('div',{class:_vm.$style['uploader__restrictions']},[_vm._v(" "+_vm._s(_vm.texts.restrictions)+" ")]):_vm._e()]):_c('UiUploaderFileInDropArea',{attrs:{"item":_vm.firstItem,"state":_vm.state,"appearance":_vm.appearance,"multiple":_vm.multiple,"waiting-for-drop":_vm.waitingForDrop,"lang":_vm.lang},on:{"reupload":_vm.reupload,"remove":_vm.remove,"resize":function($event){_vm.isWide = $event >= 410}},scopedSlots:_vm._u([{key:"restrictions",fn:function(){return [_vm._v(" "+_vm._s(_vm.texts.restrictions)+" ")]},proxy:true},(_vm.maxFilesReachedError)?{key:"error",fn:function(){return [_vm._v(" "+_vm._s(_vm.maxFilesReachedError)+" ")]},proxy:true}:null],null,true)})],1)]),(_vm.appearance !== _vm.APPEARANCE.BIG && !_vm.multiple && _vm.firstItem.error)?_c('div',{class:_vm.$style['uploader__errors']},[_vm._v(" "+_vm._s(_vm.firstItem.error)+" ")]):_vm._e(),(_vm.appearance !== _vm.APPEARANCE.BIG && _vm.maxFilesReachedError)?_c('div',{class:_vm.$style['uploader__errors']},[_vm._v(" "+_vm._s(_vm.maxFilesReachedError)+" ")]):_vm._e(),(_vm.multiple)?_c('div',{class:_vm.$style['uploader__files']},_vm._l((_vm.items),function(item){return _c('UiUploaderFile',{key:item.uuid,attrs:{"item":item},on:{"reupload":_vm.reupload,"remove":_vm.remove}})}),1):_vm._e()])}
var UiUploadervue_type_template_id_1e47a2bc_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiUploader/UiUploader.vue?vue&type=template&id=1e47a2bc&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderFile.vue?vue&type=template&id=01384380&
var UiUploaderFilevue_type_template_id_01384380_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style['file'], _vm.$style['file_' + _vm.item.state], ( _obj = {}, _obj[_vm.$style['file_error']] = _vm.item.error, _obj[_vm.$style['file_upload-btn']] = _vm.uploadable, _obj )]},[_c('div',{class:_vm.$style['file__preview']},[(_vm.item.link)?_c('a',{class:_vm.$style['file__preview-link'],attrs:{"href":_vm.item.link}},[_c('UiUploaderPreview',{attrs:{"item":_vm.item}})],1):_c('UiUploaderPreview',{attrs:{"item":_vm.item}})],1),_c('div',{class:_vm.$style['file__name']},[(_vm.item.state === _vm.STATES.LOADING)?_c('UiUploaderProgressBar',{class:_vm.$style['file__progress-bar'],attrs:{"percent":_vm.item.percent}}):_vm._e(),_c('div',{class:_vm.$style['file__name-wrap']},[(_vm.item.error)?[_vm._v(" "+_vm._s(_vm.item.name)+" ")]:[(_vm.item.link)?_c('a',{class:_vm.$style['file__name-link'],attrs:{"href":_vm.item.link,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]):[_vm._v(" "+_vm._s(_vm.item.name)+" ")]]],2)],1),(_vm.item.state === _vm.STATES.LOADING)?_c('div',{class:_vm.$style['file__icon']},[_c('UiIcon',{class:_vm.$style['file__icon-loading'],attrs:{"name":"circleLoading"}})],1):_vm._e(),(_vm.item.state === _vm.STATES.DONE && _vm.showDone)?_c('div',{class:_vm.$style['file__icon']},[_c('UiIcon',{class:_vm.$style['file__icon-done'],attrs:{"name":"done"}})],1):_vm._e(),(_vm.item.error)?_c('div',{class:_vm.$style['file__icon']},[_c('UiTooltip',{attrs:{"placement":"bottom-start","trigger":"hover"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('UiIcon',{class:_vm.$style['file__icon-error'],attrs:{"name":"alertErrorFilled"}})]},proxy:true}],null,false,3482691105)},[_vm._v(" "+_vm._s(_vm.item.error)+" ")])],1):_vm._e(),_c('div',{class:_vm.$style['file__icon']},[_c('UiButton',{attrs:{"variant":"tertiary","shape":"square","modify":"delete","size":"xs"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.item.uuid)}}},[_c('UiIcon',{attrs:{"name":"deleteOutlined"}})],1)],1),(_vm.uploadable && _vm.item.state === _vm.STATES.WAIT)?_c('div',{class:_vm.$style['file__icon']},[_c('UiButton',{attrs:{"variant":"tertiary","shape":"square","modify":"grey","size":"xs"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('reupload', _vm.item.uuid)}}},[_c('UiIcon',{class:_vm.$style['file__icon-upload'],attrs:{"name":"upload"}})],1)],1):_vm._e()])}
var UiUploaderFilevue_type_template_id_01384380_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFile.vue?vue&type=template&id=01384380&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAttachment/UiAttachment.vue?vue&type=template&id=42efdeb8&
var UiAttachmentvue_type_template_id_42efdeb8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.preview, _vm.previewClasses]},[(_vm.thumbSrc)?_c('div',{class:_vm.$style.thumb},[_c('img',{class:_vm.$style.img,attrs:{"src":_vm.thumbSrc,"alt":""}}),_c('UiIcon',{class:_vm.$style.icon,attrs:{"name":_vm.icon}})],1):_c('div',{class:[_vm.$style.ext, _vm.extClasses]},[_vm._v(" "+_vm._s(_vm.placeholder)+" ")])])}
var UiAttachmentvue_type_template_id_42efdeb8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiAttachment/UiAttachment.vue?vue&type=template&id=42efdeb8&

// CONCATENATED MODULE: ./src/components/UiAttachment/enum/sizes.js
/* harmony default export */ var UiAttachment_enum_sizes = ({
  SM: 'sm',
  MD: 'md'
});
// CONCATENATED MODULE: ./src/components/UiAttachment/enum/types.js
/* harmony default export */ var UiAttachment_enum_types = ({
  VIDEO: ['avi', 'mkv', 'mov', 'flv', 'mp4'],
  IMAGE: ['png', 'jpg', 'gif', 'tiff'],
  DOCUMENT: ['pdf', 'doc', 'dot', 'docm', 'docx'],
  SPREADSHEET: ['xls', 'ods', 'xlsx', 'xlsm', 'txt', 'csv']
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiAttachment/UiAttachment.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiAttachmentvue_type_script_lang_js_ = ({
  name: 'UiAttachment',
  components: {
    UiIcon: components_UiIcon
  },
  props: {
    thumbSrc: {
      type: String,
      default: ''
    },
    ext: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: UiAttachment_enum_sizes.SM,
      validator: size => Object.values(UiAttachment_enum_sizes).includes(size)
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    previewClasses() {
      return {
        [this.$style[`preview_size_${this.size}`]]: true,
        [this.$style[`preview_type_${this.type}`]]: this.type,
        [this.$style['preview_state_error']]: this.error,
        [this.$style['preview_overlay']]: !!this.icon
      };
    },

    extClasses() {
      return {
        [this.$style['ext_size_sm']]: this.placeholder.length > 4
      };
    },

    type() {
      for (const type in UiAttachment_enum_types) {
        if (UiAttachment_enum_types[type].includes(this.ext)) {
          return type.toLowerCase();
        }
      }

      return false;
    },

    placeholder() {
      return this.ext && this.ext.length < 6 ? this.ext : 'file';
    },

    icon() {
      let iconName = this.error ? 'errorOutlined' : '';

      if (!this.thumbSrc) {
        return '';
      }

      if (this.type === 'video') {
        iconName = this.error ? 'errorOutlined' : 'playCircleOutlined';
      }

      return iconName;
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiAttachment/UiAttachment.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiAttachment_UiAttachmentvue_type_script_lang_js_ = (UiAttachmentvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiAttachment/UiAttachment.vue?vue&type=style&index=0&lang=less&module=true&
var UiAttachmentvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("3c5c");

// CONCATENATED MODULE: ./src/components/UiAttachment/UiAttachment.vue








function UiAttachment_injectStyles (context) {
  
  this["$style"] = (UiAttachmentvue_type_style_index_0_lang_less_module_true_["default"].locals || UiAttachmentvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiAttachment_component = normalizeComponent(
  UiAttachment_UiAttachmentvue_type_script_lang_js_,
  UiAttachmentvue_type_template_id_42efdeb8_render,
  UiAttachmentvue_type_template_id_42efdeb8_staticRenderFns,
  false,
  UiAttachment_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiAttachment = (UiAttachment_component.exports);
// CONCATENATED MODULE: ./src/components/UiAttachment/index.js

/* harmony default export */ var components_UiAttachment = (UiAttachment);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderPreview.vue?vue&type=script&lang=js&


/* harmony default export */ var UiUploaderPreviewvue_type_script_lang_js_ = ({
  name: 'UiUploaderPreview',
  functional: true,
  props: {
    item: {
      type: Object,
      require: true
    }
  },
  render: (h, {
    props
  }) => h(components_UiAttachment, {
    props: {
      thumbSrc: props.item.thumb,
      ext: props.item.extension,
      size: UiAttachment_enum_sizes.SM
    }
  })
});
// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderPreview.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_UiUploaderPreviewvue_type_script_lang_js_ = (UiUploaderPreviewvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderPreview.vue
var UiUploaderPreview_render, UiUploaderPreview_staticRenderFns




/* normalize component */

var UiUploaderPreview_component = normalizeComponent(
  elements_UiUploaderPreviewvue_type_script_lang_js_,
  UiUploaderPreview_render,
  UiUploaderPreview_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiUploaderPreview = (UiUploaderPreview_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderProgressBar.vue?vue&type=template&id=ab2b9f50&functional=true&
var UiUploaderProgressBarvue_type_template_id_ab2b9f50_functional_true_render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[_vm.$style['progress-bar'], _vm.data.class || '']},[_c('div',{class:_vm.$style['progress-bar__filler'],style:({
            width: ((_vm.props.percent) + "%"),
        })})])}
var UiUploaderProgressBarvue_type_template_id_ab2b9f50_functional_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderProgressBar.vue?vue&type=template&id=ab2b9f50&functional=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderProgressBar.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var UiUploaderProgressBarvue_type_script_lang_js_ = ({
  name: 'UiUploaderProgressBar',
  props: {
    percent: {
      type: [Number, String],
      validator: percentage => !isNaN(Number.parseFloat(percentage)),
      default: 0
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderProgressBar.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_UiUploaderProgressBarvue_type_script_lang_js_ = (UiUploaderProgressBarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiUploader/elements/UiUploaderProgressBar.vue?vue&type=style&index=0&module=true&lang=less&
var UiUploaderProgressBarvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("c6d1");

// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderProgressBar.vue








function UiUploaderProgressBar_injectStyles (context) {
  
  this["$style"] = (UiUploaderProgressBarvue_type_style_index_0_module_true_lang_less_["default"].locals || UiUploaderProgressBarvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiUploaderProgressBar_component = normalizeComponent(
  elements_UiUploaderProgressBarvue_type_script_lang_js_,
  UiUploaderProgressBarvue_type_template_id_ab2b9f50_functional_true_render,
  UiUploaderProgressBarvue_type_template_id_ab2b9f50_functional_true_staticRenderFns,
  true,
  UiUploaderProgressBar_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiUploaderProgressBar = (UiUploaderProgressBar_component.exports);
// CONCATENATED MODULE: ./src/components/UiUploader/enum/states.js
/* harmony default export */ var UiUploader_enum_states = ({
  READY: 'ready',
  LOADING: 'loading',
  WAIT: 'wait',
  DONE: 'done',
  ERROR: 'error'
});
// CONCATENATED MODULE: ./src/components/UiUploader/timings.js
const NOTIFICATIONS_SHOW_TIME = 3000;

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderFile.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var UiUploaderFilevue_type_script_lang_js_ = ({
  name: 'UiUploaderFile',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip,
    UiUploaderPreview: UiUploaderPreview,
    UiUploaderProgressBar: UiUploaderProgressBar
  },
  props: {
    item: {
      type: Object,
      require: true
    },
    uploadable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showDone: false
  }),
  computed: {
    STATES: () => UiUploader_enum_states
  },
  watch: {
    'item.state': function (current, previous) {
      if (current === UiUploader_enum_states.DONE && current !== previous) {
        this.showDone = true;
        setTimeout(() => {
          this.showDone = false;
        }, NOTIFICATIONS_SHOW_TIME);
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFile.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_UiUploaderFilevue_type_script_lang_js_ = (UiUploaderFilevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiUploader/elements/UiUploaderFile.vue?vue&type=style&index=0&module=true&lang=less&
var UiUploaderFilevue_type_style_index_0_module_true_lang_less_ = __webpack_require__("341b");

// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFile.vue








function UiUploaderFile_injectStyles (context) {
  
  this["$style"] = (UiUploaderFilevue_type_style_index_0_module_true_lang_less_["default"].locals || UiUploaderFilevue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiUploaderFile_component = normalizeComponent(
  elements_UiUploaderFilevue_type_script_lang_js_,
  UiUploaderFilevue_type_template_id_01384380_render,
  UiUploaderFilevue_type_template_id_01384380_staticRenderFns,
  false,
  UiUploaderFile_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiUploaderFile = (UiUploaderFile_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue?vue&type=template&id=4e1dd0c0&
var UiUploaderFileInDropAreavue_type_template_id_4e1dd0c0_render = function () {
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"root",class:[
        _vm.$style['drop'],
        _vm.$style['drop_' + _vm.state],
        _vm.$style['drop_' + _vm.appearance],
        ( _obj = {}, _obj[_vm.$style['drop_over']] = _vm.waitingForDrop, _obj ) ]},[(!_vm.multiple && _vm.item && _vm.item.state === _vm.STATES.LOADING)?_c('div',{class:_vm.$style['drop__progress-bar-container']},[_c('UiUploaderProgressBar',{class:_vm.$style['drop__progress-bar'],attrs:{"percent":_vm.item.percent}})],1):_vm._e(),_c('div',{class:[_vm.$style['drop__icon']]},[(_vm.state === _vm.STATES.READY && _vm.appearance === _vm.APPEARANCE.BIG)?_c('div',{class:[
                _vm.$style['drop__file-type'],
                _vm.$style['type'],
                ( _obj$1 = {}, _obj$1[_vm.$style['type_over']] = _vm.waitingForDrop, _obj$1 )
            ]},[_c('div',{class:[_vm.$style['type__item'], _vm.$style['type__item_left']]}),_c('div',{class:[_vm.$style['type__item'], _vm.$style['type__item_right']]}),_c('div',{class:[_vm.$style['type__item'], _vm.$style['type__item_main']]})]):_vm._e(),(_vm.iconName)?_c('UiIcon',{class:_vm.iconClasses,attrs:{"name":_vm.iconName}}):_vm._e(),(_vm.state === _vm.STATES.WAIT)?_c('div',{class:_vm.$style['drop__preview']},[(_vm.item.link)?_c('a',{class:_vm.$style['drop__preview-link'],attrs:{"href":_vm.item.link}},[_c('UiUploaderPreview',{attrs:{"item":_vm.item}})],1):_c('UiUploaderPreview',{attrs:{"item":_vm.item}})],1):_vm._e()],1),_c('div',{class:[_vm.$style['drop__title'], ( _obj$2 = {}, _obj$2[_vm.$style['drop__title_lite']] = _vm.state === _vm.STATES.READY, _obj$2[_vm.$style['drop__title_error']] = _vm.item.state === _vm.STATES.ERROR && !_vm.multiple, _obj$2 )]},[(_vm.state === _vm.STATES.READY && !_vm.waitingForDrop)?[_c('span',{class:_vm.$style['drop__title-accent']},[_vm._v(_vm._s(_vm.I18N.chooseFile))]),(_vm.width >= 410)?[_vm._v("  "+_vm._s(_vm.I18N.orDragHere)+" ")]:_vm._e()]:_vm._e(),(_vm.state === _vm.STATES.READY && _vm.waitingForDrop)?[_vm._v(" "+_vm._s(_vm.I18N.dropForUpload)+" ")]:_vm._e(),(_vm.item.state === _vm.STATES.LOADING)?[_vm._v(" "+_vm._s(_vm.I18N.upload)+" ")]:_vm._e(),(_vm.state === _vm.STATES.ERROR)?[_vm._v(" "+_vm._s(_vm.I18N.uploadingError)+"  ")]:_vm._e(),(_vm.state === _vm.STATES.DONE)?[_vm._v(" "+_vm._s(_vm.I18N.done)+" ")]:_vm._e(),(![_vm.STATES.DONE, _vm.STATES.READY].includes(_vm.state) && [_vm.STATES.WAIT, _vm.STATES.DONE, _vm.STATES.ERROR].includes(_vm.item.state))?[(_vm.item.link)?_c('a',{class:_vm.$style['drop__title-link'],attrs:{"href":_vm.item.link}},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]):(_vm.item.state === _vm.STATES.ERROR)?_c('UiTooltip',{attrs:{"placement":"bottom-start","trigger":"hover","inline":""},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._v(" "+_vm._s(_vm.item.name)+" ")]},proxy:true}],null,false,4235769684)},[_vm._v(" "+_vm._s(_vm.item.error)+" ")]):[_vm._v(" "+_vm._s(_vm.item.name)+" ")]]:_vm._e()],2),_c('div',{class:[_vm.$style['drop__extra'], ( _obj$3 = {}, _obj$3[_vm.$style['drop__extra_error']] = _vm.state === _vm.STATES.ERROR, _obj$3 )]},[(_vm.state === _vm.STATES.READY)?[_vm._t("restrictions")]:_vm._e(),(_vm.state === _vm.STATES.ERROR)?[_vm._t("error",function(){return [_vm._v(" "+_vm._s(_vm.item.error)+" ")]})]:_vm._e(),(_vm.state === _vm.STATES.WAIT)?_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('remove', _vm.item.uuid)}}},[(_vm.appearance === _vm.APPEARANCE.BIG)?[_vm._v(" "+_vm._s(_vm.I18N.deleteFile)+" ")]:_c('UiButton',{attrs:{"variant":"tertiary","shape":"square","modify":"delete","size":"xs"}},[_c('UiIcon',{attrs:{"name":"deleteOutlined"}})],1)],2):_vm._e()],2)])}
var UiUploaderFileInDropAreavue_type_template_id_4e1dd0c0_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue?vue&type=template&id=4e1dd0c0&

// CONCATENATED MODULE: ./src/components/UiUploader/enum/appearance.js
/* harmony default export */ var enum_appearance = ({
  SIMPLE: 'simple',
  BIG: 'big',
  BUTTON: 'button'
});
// CONCATENATED MODULE: ./src/components/UiUploader/i18n/index.js
const UiUploader_i18n_LOCALES = {
  EN: 'en',
  ES: 'es',
  RU: 'ru'
};
/* harmony default export */ var UiUploader_i18n = ({
  [UiUploader_i18n_LOCALES.EN]: {
    invalidFormat: 'Invalid format',
    tooLarge: 'File too\u00a0large',
    deleteFile: 'Delete',
    done: 'Done',
    upload: 'Uploading',
    dropForUpload: 'Drop to\u00a0upload',
    chooseFile: 'Select a\u00a0file',
    orDragHere: 'or\u00a0drag it\u00a0here',
    notMore: 'no\u00a0more than',
    reupload: 'Upload again',
    uploadFile: 'Upload file',
    failedLoadFile: 'Failed to\u00a0upload file',
    mb: 'МB',
    kb: 'КB',
    uploadingError: 'Loading error',
    maxFiles: 'Maximum number of attachments',
    and: 'and',
    file: 'file',
    files: 'files'
  },
  [UiUploader_i18n_LOCALES.ES]: {
    invalidFormat: 'Formato inválido',
    tooLarge: 'Archivo demasiado grande',
    deleteFile: 'Eliminar',
    done: 'Hecho',
    upload: 'Carga',
    dropForUpload: 'Suelta para cargar',
    chooseFile: 'Selecciona un\u00a0archivo',
    orDragHere: 'o\u00a0arrastra aquí',
    notMore: 'no\u00a0más\u00a0de',
    reupload: 'Cargar de\u00a0nuevo',
    uploadFile: 'Cargar archivo',
    failedLoadFile: 'No\u00a0se\u00a0pudo cargar el\u00a0archivo',
    mb: 'МB',
    kb: 'КB',
    uploadingError: 'Error de\u00a0carga',
    maxFiles: 'Máximo permitido de\u00a0archivos adjuntos',
    and: '',
    file: 'archivo',
    files: 'archivos'
  },
  [UiUploader_i18n_LOCALES.RU]: {
    invalidFormat: 'Недопустимый формат',
    tooLarge: 'Слишком большой файл',
    deleteFile: 'Удалить',
    done: 'Готово',
    upload: 'Загрузка',
    dropForUpload: 'Отпустите для\u00a0загрузки',
    chooseFile: 'Выберите файл',
    orDragHere: 'или\u00a0перетащите сюда',
    notMore: 'не\u00a0более',
    reupload: 'Загрузить еще\u00a0раз',
    uploadFile: 'Загрузить файл',
    failedLoadFile: 'Не\u00a0удалось загрузить файл',
    mb: 'МБ',
    kb: 'КБ',
    uploadingError: 'Ошибка загрузки',
    maxFiles: 'Максимальное количество вложений',
    and: 'и',
    file: 'файла',
    files: 'файлов'
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var UiUploaderFileInDropAreavue_type_script_lang_js_ = ({
  name: 'UiUploaderFileInDropArea',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip,
    UiUploaderPreview: UiUploaderPreview,
    UiUploaderProgressBar: UiUploaderProgressBar
  },
  props: {
    item: {
      type: [Object, Boolean],
      require: true
    },
    appearance: {
      type: String
    },
    state: {
      type: String,
      default: () => UiUploader_enum_states.READY
    },
    multiple: {
      type: Boolean,
      default: false
    },
    waitingForDrop: {
      type: Boolean,
      default: false
    },
    lang: {
      type: String
    }
  },
  data: () => ({
    width: null
  }),
  computed: {
    APPEARANCE: () => enum_appearance,

    I18N() {
      return UiUploader_i18n[this.lang];
    },

    STATES: () => UiUploader_enum_states,

    iconName() {
      const state = this.state;
      const error = this.item.error;
      const names = {
        upload: state === UiUploader_enum_states.READY && this.appearance === enum_appearance.SIMPLE,
        circleLoading: state === UiUploader_enum_states.LOADING,
        done: state === UiUploader_enum_states.DONE && !error,
        errorOutlined: state === UiUploader_enum_states.ERROR || state === UiUploader_enum_states.DONE && !!error
      };
      return Object.keys(names).find(iconName => names[iconName]);
    },

    iconClasses() {
      const state = this.state;
      const error = this.item.error;
      return [this.$style['icon'], {
        [this.$style['icon_ready']]: state === UiUploader_enum_states.READY,
        [this.$style['icon_loading']]: state === UiUploader_enum_states.LOADING,
        [this.$style['icon_done']]: state === UiUploader_enum_states.DONE && !error,
        [this.$style['icon_error']]: state === UiUploader_enum_states.ERROR || state === UiUploader_enum_states.DONE && !!error,
        [this.$style['icon_big']]: this.appearance === enum_appearance.BIG
      }];
    }

  },
  watch: {
    width(current, previous) {
      if (current !== previous) {
        this.$emit('resize', current);
      }
    }

  },

  mounted() {
    this.updateWidth();
    window.addEventListener('resize', this.updateWidth);

    if (window.IntersectionObserver) {
      this._observer = new IntersectionObserver(this.updateWidth);

      this._observer.observe(this.$refs.root);
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateWidth);
    this._observer = null;
  },

  methods: {
    updateWidth() {
      if (this.$refs.root) {
        this.width = this.$refs.root.offsetWidth;
      }
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue?vue&type=script&lang=js&
 /* harmony default export */ var elements_UiUploaderFileInDropAreavue_type_script_lang_js_ = (UiUploaderFileInDropAreavue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue?vue&type=style&index=0&module=true&lang=less&
var UiUploaderFileInDropAreavue_type_style_index_0_module_true_lang_less_ = __webpack_require__("cec7");

// CONCATENATED MODULE: ./src/components/UiUploader/elements/UiUploaderFileInDropArea.vue








function UiUploaderFileInDropArea_injectStyles (context) {
  
  this["$style"] = (UiUploaderFileInDropAreavue_type_style_index_0_module_true_lang_less_["default"].locals || UiUploaderFileInDropAreavue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiUploaderFileInDropArea_component = normalizeComponent(
  elements_UiUploaderFileInDropAreavue_type_script_lang_js_,
  UiUploaderFileInDropAreavue_type_template_id_4e1dd0c0_render,
  UiUploaderFileInDropAreavue_type_template_id_4e1dd0c0_staticRenderFns,
  false,
  UiUploaderFileInDropArea_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiUploaderFileInDropArea = (UiUploaderFileInDropArea_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url.js
var web_url = __webpack_require__("2b3d");

// CONCATENATED MODULE: ./src/components/UiUploader/enum/mime.js
const IMAGES = {
  'image/jpg': 'jpg',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/tiff': 'tiff',
  'image/tif': 'tiff',
  'image/bmp': 'bmp',
  'image/x-bmp': 'bmp',
  'image/ms-bmp': 'bmp',
  'image/x-ms-bmp': 'bmp',
  'image/svg+xml': 'svg'
};
const DOCS = {
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-word.document.macroenabled.12': 'docm',
  'application/pdf': 'pdf'
};
const SPREADSHEETS = {
  'application/excel': 'xls',
  'application/vnd.ms-excel': 'xls',
  'application/x-excel': 'xls',
  'application/x-msexcel': 'xls',
  'application/vnd.oasis.opendocument.spreadsheet': 'ods',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-excel.sheet.macroEnabled.12': 'xlsm',
  'text/plain': 'txt',
  'text/csv': 'csv'
};
const VIDEOS = {
  'application/x-troff-msvideo': 'avi',
  'video/x-msvideo': 'avi',
  'video/msvideo': 'avi',
  'video/avi': 'avi',
  'text/csv': 'mkv',
  'video/quicktime': 'mov',
  'video/x-flv': 'flv',
  'video/mp4': 'mp4'
};
const CATEGORIES = {
  DOCS: 'docs',
  FILES: 'files',
  IMAGES: 'images',
  SPREADSHEETS: 'spreadsheets',
  VIDEOS: 'videos'
};
const EXTENSIONS_BY_CATEGORIES = {
  [CATEGORIES.IMAGES]: Object.values(IMAGES),
  [CATEGORIES.DOCS]: Object.values(DOCS),
  [CATEGORIES.SPREADSHEETS]: Object.values(SPREADSHEETS),
  [CATEGORIES.VIDEOS]: Object.values(VIDEOS)
};
const EXTENSIONS_BY_MIME = { ...IMAGES,
  ...DOCS,
  ...SPREADSHEETS,
  ...VIDEOS
};

// CONCATENATED MODULE: ./src/components/UiUploader/utils.js


const id = () => Number.parseInt(String(Date.now() * Math.random()), 10).toString().slice(-6);
/**
 * @param {File} file
 * @return {{extension: string, category: string}}
 */

const fileInfo = file => {
  const extension = EXTENSIONS_BY_MIME[file.type] || file.name.split('.').pop();
  return {
    extension,
    category: fileCategory(extension)
  };
};
const fileCategory = extension => {
  const map = EXTENSIONS_BY_CATEGORIES;
  return Object.keys(map).find(category => map[category].some(e => e === extension)) || CATEGORIES.FILES;
};
/**
 * @param {File} file
 * @return {Promise<string>} Data URL
 */

const resize = file => new Promise(resolve => {
  const _URL = window.URL || window.webkitURL;

  const image = new Image();

  const objectUrl = _URL.createObjectURL(file);

  image.onload = event => {
    /** @type {HTMLImageElement} */
    const source = event.target;
    const size = 40;
    const aspectRatio = source.width / source.height;
    const width = aspectRatio > 1 ? size * aspectRatio : size;
    const height = aspectRatio <= 1 ? size / aspectRatio : size;
    const scale = aspectRatio > 1 ? size / source.height : size / source.width;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').scale(scale, scale);
    canvas.getContext('2d').drawImage(source, 0.5 * (canvas.width - source.width * scale), 0.5 * (canvas.height - source.height * scale));

    _URL.revokeObjectURL(objectUrl);

    resolve(canvas.toDataURL('image/jpg', 60));
  };

  image.src = objectUrl;
});
// CONCATENATED MODULE: ./src/components/UiUploader/upload.js
const HTTP_OK = 200;
const REQUEST_DONE = 4;
const JSON_TYPE = 'json';
/**
 * @param {string} url
 * @param {File} file
 * @param {function} onProgress
 * @return {Promise<unknown>}
 */

/* harmony default export */ var UiUploader_upload = ((url, file, onProgress) => {
  const data = new FormData();
  data.append('file', file);
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open('POST', url, true);
    request.upload.addEventListener('progress', event => {
      onProgress(event.loaded * 100.0 / event.total || 100);
    });
    request.addEventListener('readystatechange', () => {
      if (request.readyState === REQUEST_DONE && request.status === HTTP_OK) {
        const data = request.responseType === JSON_TYPE ? JSON.parse(request.response) : {};
        resolve(data);
      } else if (request.readyState === REQUEST_DONE && request.status !== HTTP_OK) {
        reject(request.responseText);
      }
    });
    request.send(data);
  });
});
// CONCATENATED MODULE: ./src/components/UiUploader/validate.js

const validate_accept = (file, accept) => {
  const {
    extension,
    category
  } = fileInfo(file);
  const a = accept.split(',').map(v => v.trim());
  return a.includes(extension) || a.includes(category);
};
const validate_maxSize = (file, maxInMegabytes) => {
  return file.size < maxInMegabytes * 1024 * 1024;
};
// CONCATENATED MODULE: ./src/components/UiUploader/i18n/computed.js


const capitalize = text => text.length ? text.charAt(0).toUpperCase() + text.slice(1) : '';

const notEmpty = str => str.length > 0;

const ACCEPTED = accept => {
  return accept ? accept.split(',').map(str => str.trim().toUpperCase()).join(', ') : '';
};

const NOT_MORE = (text, locale) => text.length ? `${UiUploader_i18n[locale].notMore} ${text}` : '';

const MAX_COUNT = (maxCount, locale) => {
  const count = parseInt(maxCount, 10);
  return count ? count === 1 ? `${count}\u00a0${UiUploader_i18n[locale].file}` : `${count}\u00a0${UiUploader_i18n[locale].files}` : '';
};
const MAX_SIZE = (maxInMegabytes, locale) => {
  const megabytes = Number.parseFloat(maxInMegabytes);

  if (megabytes > 0) {
    if (megabytes < 1) {
      const kilobytes = (megabytes - Math.trunc(megabytes)) * 1024;
      return `${kilobytes}\u00a0${UiUploader_i18n[locale].kb}`;
    }

    return `${megabytes}\u00a0${UiUploader_i18n[locale].mb}`;
  }

  return '';
};
const RESTRICTIONS = ({
  accept,
  maxCount,
  maxSize
}, locale) => {
  return capitalize([ACCEPTED(accept), NOT_MORE([MAX_SIZE(maxSize, locale), MAX_COUNT(maxCount, locale)].filter(notEmpty).join(` ${UiUploader_i18n[locale].and} `), locale)].filter(notEmpty).join(`, `));
};
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiUploader/UiUploader.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/**
 * @param {File} file
 * @return {UiUploaderItem}
 */

const createItem = file => ({
  uuid: uuid4(),
  name: file.name,
  ...fileInfo(file),
  thumb: null,
  link: null,
  file,
  percent: 0,
  state: UiUploader_enum_states.WAIT,
  error: null
});

const mapItem = ({
  uuid,
  name,
  extension,
  thumb,
  link
}) => ({
  uuid,
  name,
  extension,
  thumb,
  link
});

/* harmony default export */ var UiUploadervue_type_script_lang_js_ = ({
  name: 'UiUploader',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip,
    UiUploaderFile: UiUploaderFile,
    UiUploaderFileInDropArea: UiUploaderFileInDropArea
  },
  props: {
    /**
     * Массив с файлами <pre>
     * [{
     *     uuid: строка, уникальный идентификатор
     *     name: строка, наименование
     *     extension: строка, расширение файла
     *     thumb: строка, изображение-превью, url или data:uri
     *     link: строка, ссылка на файл для просмотра (значение должно приходить в ответе от сервера после загрузки вида {pathToFile: 'somePath'})
     * }]
     * </pre>
     */
    value: {
      type: Array,
      require: true
    },

    /**
     * Типы разрешенных для загрузки файлов
     * 'images','docs','spreadsheets','videos'
     * или расширения файлов
     * 'jpg', 'png, 'doc',...
     * передаются строкой через запятую
     * например, 'docs, jpg, mp4'
     */
    accept: {
      type: String,
      default: null
    },

    /**
     * Возможность множественной загрузки файлов
     */
    multiple: {
      type: Boolean,
      default: false
    },

    /**
     * Ограничение количества загружаемых файлов
     */
    maxFiles: {
      type: [Number, String],
      default: null
    },

    /**
     * Максимальный размер загружаемых файлов в мегабайтах
     */
    maxFileSize: {
      type: [Number, String],
      default: null
    },

    /**
     * Внешний вид загрузчика
     * 'simple' – Маленькое поле загрузки, значение по-умолчанию
     * 'big' – большое поле загрузки
     * 'button' – кнопка, как поле загрузки
     */
    appearance: createEnumProp(enum_appearance, enum_appearance.SIMPLE),

    /**
     * Локализация загрузчика
     * 'ru','en','es'
     */
    lang: createEnumProp(UiUploader_i18n_LOCALES, UiUploader_i18n_LOCALES.RU),

    /**
     * Загрузка стартует сразу же после добавления файла
     * Для работы требуется url
     */
    autoUpload: {
      type: Boolean,
      default: false
    },

    /**
     * Функция загрузки файлов, с сигнатурой (file, onProgress) => Promise<undefined, string>
     *
     * Параметры:
     * file - Объект File
     * onProgress - обработчик, выставляет файлу процент загрузки, его следует вызывать в коде как onProgress(percent)
     *
     * Функция должна возвращать Promise, undefined в случае успеха и сообщение об ошибке в случае неудачи (тут может
     * быть responseText, т.к. сообщение уходит только в консоль)
     */
    uploadFn: {
      type: Function,
      default: null
    },

    /**
     * URL для загрузки файлов. В случае, если **uploadFn** не указан,
     * компонент будет слать на **uploadUrl** запросы
     */
    uploadUrl: {
      type: String,
      default: null
    },

    /**
     * Выодить подпись с ограничениями справа от кнопки
     * Актуально при appearance='button'
     */
    inlineRestriction: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    items: [],
    waitingForDrop: false,
    showError: false,
    showDone: false,
    maxFilesReachedError: null,
    isWide: false
  }),
  computed: {
    APPEARANCE: () => enum_appearance,
    I18N: () => UiUploader_i18n,
    STATES: () => UiUploader_enum_states,

    maxFilesComputed() {
      if (!this.multiple) {
        return 1;
      }

      return this.maxFiles ? parseInt(this.maxFiles, 10) : Infinity;
    },

    maxFilesReached() {
      return this.items.length >= this.maxFilesComputed;
    },

    uploadFnComputed() {
      if (this.uploadFn) {
        return this.uploadFn;
      }

      if (this.uploadUrl) {
        return (file, onProgress) => UiUploader_upload(this.uploadUrl, file, onProgress);
      }

      throw new Error('UiUploader: one of uploadFn / uploadUrl must be set');
    },

    // @TODO: это нужно для отображения файла внутри dropArea, убрать после рефакторинга
    firstItem() {
      return this.items.length ? this.items[0] : false;
    },

    state() {
      if (this.multiple && !!this.maxFilesReachedError) {
        return UiUploader_enum_states.ERROR;
      }

      if (!this.multiple && this.items.length) {
        const state = this.items[0].state;

        if (state === UiUploader_enum_states.ERROR && !this.showError || state === UiUploader_enum_states.DONE && !this.showDone) {
          return UiUploader_enum_states.WAIT;
        }

        return state;
      }

      return UiUploader_enum_states.READY;
    },

    texts() {
      return {
        restrictions: RESTRICTIONS({
          accept: this.accept,
          maxCount: this.maxFiles,
          maxSize: this.maxFileSize
        }, this.lang)
      };
    },

    filesToUpload() {
      const transfer = new DataTransfer();
      const files = this.items.filter(item => item.state === UiUploader_enum_states.WAIT).map(item => item.file);
      files.forEach(file => {
        /**
         * Дополнительная проверка типа, для избежания ошибки
         * при добавлении объекта, который не является файлом.
         */
        if (file.toString().toLowerCase().indexOf('file') > -1) {
          transfer.items.add(file);
        }
      });
      return transfer.files;
    }

  },
  watch: {
    value: {
      immediate: true,

      handler(value) {
        var _this$$refs, _this$$refs$input;

        this.items = value.map(v => {
          const [item] = this.find(v.uuid);

          if (item) {
            return { ...item,
              ...v
            };
          }

          return {
            thumb: null,
            link: null,
            ...v,
            category: fileCategory(v.extension),
            file: null,
            percent: 100,
            state: UiUploader_enum_states.DONE,
            error: null
          };
        });

        if ((_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && (_this$$refs$input = _this$$refs.input) !== null && _this$$refs$input !== void 0 && _this$$refs$input.files) {
          this.$refs.input.files = this.filesToUpload;
        }
      }

    },

    items(current, previous) {
      const currentMapped = current.map(mapItem);
      const previousMapped = previous.map(mapItem);

      if (JSON.stringify(currentMapped) !== JSON.stringify(previousMapped)) {
        this.$emit('input', currentMapped);
        return;
      }

      if (this.autoUpload) {
        current.forEach(({
          file,
          uuid,
          state
        }) => {
          if (state === UiUploader_enum_states.WAIT) {
            this.upload({
              file,
              uuid
            });
          }
        }, this);
      }
    },

    // @TODO: это нужно для отображения файла внутри dropArea, убрать после рефакторинга
    'firstItem.state': function (current, previous) {
      if (current === UiUploader_enum_states.DONE) {
        this.showDone = true;
        setTimeout(() => {
          this.showDone = false;
        }, NOTIFICATIONS_SHOW_TIME);
      }
    },
    // @TODO: это нужно для отображения файла внутри dropArea, убрать после рефакторинга
    'firstItem.error': function (current, previous) {
      if (current !== previous) {
        this.showError = true;
        setTimeout(() => {
          this.showError = false;
        }, NOTIFICATIONS_SHOW_TIME);
      }
    },

    maxFilesReachedError(text) {
      if (text) {
        setTimeout(() => {
          this.maxFilesReachedError = null;
        }, NOTIFICATIONS_SHOW_TIME);
      }
    }

  },

  mounted() {
    // Отключаем обработку drop файла
    ;
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.$refs.dropArea.addEventListener(eventName, event => {
        event.preventDefault();
        event.stopPropagation();
      }, false);
    }) // Активируем/деактивируем анимацию компонента по наведению
    ;
    ['dragenter', 'dragover'].forEach(eventName => {
      this.$refs.dropArea.addEventListener(eventName, () => {
        if (this._dropTimer) {
          clearTimeout(this._dropTimer);
        }

        this.waitingForDrop = true;
      }, false);
    }, this);
    ['dragleave', 'drop'].forEach(eventName => {
      this.$refs.dropArea.addEventListener(eventName, () => {
        this._dropTimer = setTimeout(() => {
          this.waitingForDrop = false;
        }, 100);
      }, false);
    }, this);
    this.$refs.dropArea.addEventListener('drop', event => {
      if (!this.maxFilesReached) {
        this.prepare(event.dataTransfer.files);
      }
    }, false);
  },

  methods: {
    /**
     * @internal Метод загрузки, используемый при autoUpload=true
     * @param {File} file
     * @param {string} uuid
     */
    upload({
      file,
      uuid
    }) {
      this.uploadFnComputed(file, percent => {
        const [item] = this.find(uuid);

        if (item) {
          item.percent = percent;
          item.state = UiUploader_enum_states.LOADING;
        }
      }).then(data => {
        const [item] = this.find(uuid);

        if (item) {
          item.percent = 100;
          item.state = UiUploader_enum_states.DONE;
          item.error = null;

          if (data !== null && data !== void 0 && data.pathToFile) {
            item.link = data.pathToFile;
          }

          this.$emit('uploaded', mapItem(item));
        }
      }).catch(() => {
        const [item] = this.find(uuid);

        if (item) {
          item.percent = 100;
          item.state = UiUploader_enum_states.ERROR;
          item.error = UiUploader_i18n[this.lang].failedLoadFile;
          this.$emit('failed', mapItem(item));
        }
      });
    },

    uploadAll() {
      this.items.filter(item => item.state === UiUploader_enum_states.WAIT).forEach(this.upload);
    },

    reupload(uuid) {
      const [item] = this.find(uuid);

      if (item && item.file && item.state !== UiUploader_enum_states.DONE) {
        item.percent = 0;
        item.state = UiUploader_enum_states.WAIT;
        item.error = null;
        this.upload(item);
      }
    },

    remove(uuid) {
      const [item, index] = this.find(uuid);

      if (item) {
        const items = [...this.items];
        items.splice(index, 1);
        this.items = items;
        this.$refs.input.files = this.filesToUpload;
        this.$emit('removed', mapItem(item));
      }
    },

    /**
     * @param uuid
     * @return {[UiUploaderItem, number]}
     */
    find(uuid) {
      const index = this.items.findIndex(i => i.uuid === uuid);
      const item = index !== -1 ? this.items[index] : null;
      return [item, index];
    },

    /**
     * @param {FileList} files
     */
    prepare(files) {
      let current = [...this.items];
      let added = [...files].filter(file => {
        return !current.find(currentFile => {
          var _currentFile$file, _currentFile$file2, _currentFile$file3;

          /**
           * Не добавляем файлы, у которых имя, размер и дата модификации
           * совпадают с одним из добавленных файлов для исключения дублей
           * и фикса бесконечного добавления в safari
           */
          return (file === null || file === void 0 ? void 0 : file.name) === ((_currentFile$file = currentFile.file) === null || _currentFile$file === void 0 ? void 0 : _currentFile$file.name) && (file === null || file === void 0 ? void 0 : file.lastModified) === ((_currentFile$file2 = currentFile.file) === null || _currentFile$file2 === void 0 ? void 0 : _currentFile$file2.lastModified) && (file === null || file === void 0 ? void 0 : file.size) === ((_currentFile$file3 = currentFile.file) === null || _currentFile$file3 === void 0 ? void 0 : _currentFile$file3.size);
        });
      });

      if (!this.multiple) {
        added = [added.pop()];
        current = [];
      }

      if (this.maxFilesComputed !== Infinity) {
        const exceeds = current.length + added.length - this.maxFilesComputed;

        if (exceeds > 0) {
          this.maxFilesReachedError = `${UiUploader_i18n[this.lang].maxFiles} — ${this.maxFiles}`;
          added.splice(-exceeds);
        }
      }

      Promise.all(added.map(file => this.prepareFile(file), this)).then(items => {
        this.items = [...current, ...items];
      });
    },

    /**
     * @param {File} file
     * @return {Promise<UiUploaderItem>}
     */
    prepareFile(file) {
      const item = createItem(file);
      const [valid, error] = this.validate(file);

      if (!valid) {
        item.state = UiUploader_enum_states.ERROR;
        item.error = error;
        this.$emit('rejected', {
          file,
          error
        });
      }

      if (item.category === CATEGORIES.IMAGES) {
        return resize(file).then(thumb => ({ ...item,
          thumb
        }));
      }

      return Promise.resolve(item);
    },

    /**
     * @param {File} file
     * @return {[boolean, string]}
     */
    validate(file) {
      if (this.accept && !validate_accept(file, this.accept)) {
        return [false, UiUploader_i18n[this.lang].invalidFormat];
      }

      if (this.maxFileSize && !validate_maxSize(file, Number.parseFloat(this.maxFileSize))) {
        return [false, UiUploader_i18n[this.lang].tooLarge];
      }

      return [true, ''];
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiUploader/UiUploader.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiUploader_UiUploadervue_type_script_lang_js_ = (UiUploadervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiUploader/UiUploader.vue?vue&type=style&index=0&module=true&lang=less&
var UiUploadervue_type_style_index_0_module_true_lang_less_ = __webpack_require__("a6dc");

// CONCATENATED MODULE: ./src/components/UiUploader/UiUploader.vue








function UiUploader_injectStyles (context) {
  
  this["$style"] = (UiUploadervue_type_style_index_0_module_true_lang_less_["default"].locals || UiUploadervue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiUploader_component = normalizeComponent(
  UiUploader_UiUploadervue_type_script_lang_js_,
  UiUploadervue_type_template_id_1e47a2bc_render,
  UiUploadervue_type_template_id_1e47a2bc_staticRenderFns,
  false,
  UiUploader_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiUploader = (UiUploader_component.exports);
// CONCATENATED MODULE: ./src/components/UiUploader/index.js

/* harmony default export */ var components_UiUploader = (UiUploader);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPopconfirm/UiPopconfirm.vue?vue&type=template&id=478a71f6&
var UiPopconfirmvue_type_template_id_478a71f6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiTooltip',{attrs:{"placement":_vm.placement,"max-width":_vm.maxWidth,"max-height":_vm.minHeight,"popover-base-class":_vm.popoverBaseClass,"trigger":"click","with-pointer":""},on:{"toggleTooltip":_vm.onToggle},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_vm._t("trigger")]},proxy:true}],null,true)},[(_vm.$slots.title || _vm.title)?_c('div',{class:_vm.$style.title},[(_vm.title)?[_vm._v(" "+_vm._s(_vm.title)+" ")]:_vm._t("title")],2):_vm._e(),_vm._t("default"),_c('div',{class:_vm.$style.footer},[(_vm.$slots.cancelButton || _vm.cancel)?_c('div',{class:_vm.$style.control,attrs:{"data-close-tooltip":""},on:{"click":_vm.onCancel}},[_vm._t("cancelButton",function(){return [_c('UiButton',{attrs:{"variant":"secondary","size":"xs"}},[_vm._v(" "+_vm._s(_vm.cancelText)+" ")])]})],2):_vm._e(),(_vm.$slots.removeButton || _vm.remove)?_c('div',{class:_vm.$style.control,attrs:{"data-close-tooltip":""},on:{"click":_vm.onRemove}},[_vm._t("removeButton",function(){return [_c('UiButton',{attrs:{"state":"error","size":"xs"}},[_c('UiIcon',{attrs:{"name":"deleteOutlined"}}),_vm._v(" "+_vm._s(_vm.removeText)+" ")],1)]})],2):_vm._e(),(_vm.$slots.confirmButton || !_vm.remove)?_c('div',{class:_vm.$style.control,attrs:{"data-close-tooltip":""},on:{"click":_vm.onConfirm}},[_vm._t("confirmButton",function(){return [_c('UiButton',{attrs:{"size":"xs"}},[_vm._v(" "+_vm._s(_vm.confirmText)+" ")])]})],2):_vm._e()])],2)}
var UiPopconfirmvue_type_template_id_478a71f6_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiPopconfirm/UiPopconfirm.vue?vue&type=template&id=478a71f6&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiPopconfirm/UiPopconfirm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




const CONFIRM_EVENT_NAME = 'confirm';
const REMOVE_EVENT_NAME = 'remove';
const CANCEL_EVENT_NAME = 'cancel';
const UiPopconfirmvue_type_script_lang_js_TOGGLE_EVENT_NAME = 'toggle';
/* harmony default export */ var UiPopconfirmvue_type_script_lang_js_ = ({
  name: 'UiPopconfirm',
  components: {
    UiButton: components_UiButton,
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip
  },
  props: {
    /**
     * Определяет позиционирование
     */
    placement: {
      type: String,
      validator: position => Object.values(positions).includes(position),
      default: positions.BOTTOM_START
    },
    popoverBaseClass: {
      type: String,
      default: ''
    },
    maxWidth: {
      type: [Number, String],
      default: null
    },
    minHeight: {
      type: [Number, String],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    cancel: {
      type: Boolean,
      default: true
    },
    remove: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: 'Отмена'
    },
    confirmText: {
      type: String,
      default: 'Подтвердить'
    },
    removeText: {
      type: String,
      default: 'Удалить'
    }
  },
  methods: {
    onToggle(isOpen) {
      this.$emit(UiPopconfirmvue_type_script_lang_js_TOGGLE_EVENT_NAME, isOpen);
    },

    onConfirm() {
      this.$emit(CONFIRM_EVENT_NAME);
    },

    onRemove() {
      this.$emit(REMOVE_EVENT_NAME);
    },

    onCancel() {
      this.$emit(CANCEL_EVENT_NAME);
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiPopconfirm/UiPopconfirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiPopconfirm_UiPopconfirmvue_type_script_lang_js_ = (UiPopconfirmvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiPopconfirm/UiPopconfirm.vue?vue&type=style&index=0&lang=less&module=true&
var UiPopconfirmvue_type_style_index_0_lang_less_module_true_ = __webpack_require__("2dc8");

// CONCATENATED MODULE: ./src/components/UiPopconfirm/UiPopconfirm.vue








function UiPopconfirm_injectStyles (context) {
  
  this["$style"] = (UiPopconfirmvue_type_style_index_0_lang_less_module_true_["default"].locals || UiPopconfirmvue_type_style_index_0_lang_less_module_true_["default"])

}

/* normalize component */

var UiPopconfirm_component = normalizeComponent(
  UiPopconfirm_UiPopconfirmvue_type_script_lang_js_,
  UiPopconfirmvue_type_template_id_478a71f6_render,
  UiPopconfirmvue_type_template_id_478a71f6_staticRenderFns,
  false,
  UiPopconfirm_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiPopconfirm = (UiPopconfirm_component.exports);
// CONCATENATED MODULE: ./src/components/UiPopconfirm/index.js

/* harmony default export */ var components_UiPopconfirm = (UiPopconfirm);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInlineEdit/UiInlineEdit.vue?vue&type=template&id=28b9813e&
var UiInlineEditvue_type_template_id_28b9813e_render = function () {
var _obj, _obj$1, _obj$2, _obj$3;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$style['inline-edit']] = true, _obj[_vm.$style['inline-edit_inversion']] = _vm.inversion, _obj[_vm.$style['inline-edit_focused']] = _vm.isFocused, _obj[_vm.$style['inline-edit_error']] = _vm.error && !_vm.isFocused, _obj[_vm.$style['inline-edit_disabled']] = _vm.disabled, _obj[_vm.$style[("inline-edit_" + _vm.size)]] = true, _obj ),style:(_vm.style)},[(_vm.$slots.iconLeft || _vm.iconLeft)?_c('div',{ref:"iconLeft",class:( _obj$1 = {}, _obj$1[_vm.$style['inline-edit__icon']] = true, _obj$1[_vm.$style['inline-edit__icon-left']] = true, _obj$1[_vm.$style['inline-edit__icon_inversion']] = _vm.inversion, _obj$1 )},[_vm._t("iconLeft",function(){return [_c('UiIcon',{attrs:{"name":_vm.iconLeft}})]})],2):_vm._e(),_c('input',{ref:"input",class:( _obj$2 = {}, _obj$2[_vm.$style['inline-edit__input']] = true, _obj$2[_vm.$style['inline-edit__input_focused']] = _vm.isFocused, _obj$2[_vm.$style['inline-edit__input_error']] = _vm.error && !_vm.isFocused, _obj$2[_vm.$style['inline-edit__input_accent']] = _vm.accent, _obj$2 ),attrs:{"id":_vm.id,"type":_vm.type,"name":_vm.name,"placeholder":_vm.placeholder,"required":_vm.required,"disabled":_vm.disabled,"readonly":_vm.readonly,"pattern":_vm.pattern},domProps:{"value":_vm.value},on:{"input":_vm.onInput,"focus":_vm.onFocus,"blur":_vm.onBlur,"keyup":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.onEscape.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.triggerBlur.apply(null, arguments)}],"keydown":function($event){return _vm.$emit('keydown', $event)},"change":function($event){return _vm.$emit('change', $event)}}}),(_vm.$slots.iconRight || _vm.iconRight)?_c('div',{ref:"iconRight",class:( _obj$3 = {}, _obj$3[_vm.$style['inline-edit__icon']] = true, _obj$3[_vm.$style['inline-edit__icon-right']] = true, _obj$3[_vm.$style['inline-edit__icon_inversion']] = _vm.inversion, _obj$3 )},[_vm._t("iconRight",function(){return [_c('UiIcon',{attrs:{"name":_vm.iconRight}})]})],2):_vm._e(),(_vm.error && _vm.errorMessage && !_vm.isFocused)?_c('UiTooltip',{attrs:{"placement":_vm.errorTooltipPlacement,"dark":!_vm.inversion,"show":_vm.error && _vm.errorMessage.length > 0,"trigger":"manual","size":"sm"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('div',{attrs:{"data-stub":""}})]},proxy:true}],null,false,3010486570)},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()],1)}
var UiInlineEditvue_type_template_id_28b9813e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/UiInlineEdit/UiInlineEdit.vue?vue&type=template&id=28b9813e&

// CONCATENATED MODULE: ./src/components/UiInlineEdit/enums/sizes.js
/* harmony default export */ var enums_sizes = ({
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl'
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/UiInlineEdit/UiInlineEdit.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiInlineEditvue_type_script_lang_js_ = ({
  name: 'UiInlineEdit',
  components: {
    UiIcon: components_UiIcon,
    UiTooltip: components_UiTooltip
  },
  props: {
    /**
     * Значение - строка, отображаемая в инпуте
     */
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    pattern: {
      type: String,
      default: ''
    },

    /**
     * Максимальная ширина инпута
     * Если значение не задано, то инпут будет резиновым
     */
    width: {
      type: [Number, String],
      default: null
    },

    /**
     * Размер
     */
    size: {
      type: String,
      default: enums_sizes.MD
    },
    iconLeft: {
      type: String,
      default: ''
    },
    iconRight: {
      type: String,
      default: ''
    },
    error: {
      type: [Boolean, String],
      default: false
    },
    errorTooltipPlacement: {
      type: String,
      default: 'right'
    },
    inversion: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },

    /**
     * Жирное начертание
     */
    accent: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isFocused: false
    };
  },

  computed: {
    style() {
      if (!this.width) {
        return null;
      }

      const width = `${parseInt(this.width)}px`;
      return `width: ${width}; max-width: ${width};`;
    },

    errorMessage() {
      return typeof this.error === 'string' ? this.error : null;
    }

  },
  watch: {
    value() {
      this.setAreaWidth();
    }

  },

  mounted() {
    this.setAreaWidth();
  },

  methods: {
    onFocus() {
      this.oldValue = this.value;
      this.isFocused = true;
      this.$refs.input.scrollLeft = this.$refs.input.scrollWidth; // timeout for safari

      setTimeout(() => {
        this.$refs.input.select();
      }, 0);
      this.$emit('focus');
    },

    onBlur(e) {
      this.isFocused = false;
      this.$emit('blur');

      if (!this._esc) {
        this.$emit('save', e.target.value);
      }

      this._esc = false;
      this.setAreaWidth();
    },

    onInput(e) {
      this.$emit('input', e.target.value);
      this.setAreaWidth();
    },

    onEscape() {
      this._esc = true;
      this.triggerBlur();
    },

    triggerBlur() {
      if (this.$refs.input) {
        this.$refs.input.blur();
      }
    },

    setAreaWidth() {
      if (this.width || !this.$refs.input) {
        return;
      }

      this.$el.style.width = 0;
      this.$nextTick(() => {
        this.$el.style.width = `${this.$el.clientWidth - this.$refs.input.clientWidth + this.$refs.input.scrollWidth + 1}px`;
      });
    }

  }
});
// CONCATENATED MODULE: ./src/components/UiInlineEdit/UiInlineEdit.vue?vue&type=script&lang=js&
 /* harmony default export */ var UiInlineEdit_UiInlineEditvue_type_script_lang_js_ = (UiInlineEditvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/UiInlineEdit/UiInlineEdit.vue?vue&type=style&index=0&module=true&lang=less&
var UiInlineEditvue_type_style_index_0_module_true_lang_less_ = __webpack_require__("ce5f");

// CONCATENATED MODULE: ./src/components/UiInlineEdit/UiInlineEdit.vue








function UiInlineEdit_injectStyles (context) {
  
  this["$style"] = (UiInlineEditvue_type_style_index_0_module_true_lang_less_["default"].locals || UiInlineEditvue_type_style_index_0_module_true_lang_less_["default"])

}

/* normalize component */

var UiInlineEdit_component = normalizeComponent(
  UiInlineEdit_UiInlineEditvue_type_script_lang_js_,
  UiInlineEditvue_type_template_id_28b9813e_render,
  UiInlineEditvue_type_template_id_28b9813e_staticRenderFns,
  false,
  UiInlineEdit_injectStyles,
  null,
  null
  
)

/* harmony default export */ var UiInlineEdit = (UiInlineEdit_component.exports);
// CONCATENATED MODULE: ./src/components/UiInlineEdit/index.js

/* harmony default export */ var components_UiInlineEdit = (UiInlineEdit);
// CONCATENATED MODULE: ./src/components/index.js
// noinspection JSUnusedGlobalSymbols



























































// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiModalAlert.vue?vue&type=template&id=4fb8a99a&
var UiModalAlertvue_type_template_id_4fb8a99a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiPopup',_vm._b({attrs:{"open":_vm.opened,"type":_vm.type,"role":"dialog"},on:{"togglePopup":function($event){$event ? null : _vm.$emit('close')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('UiVNodeContainer',{attrs:{"node":_vm.title}})]},proxy:true},{key:"footer",fn:function(){return [_c('UiButton',{attrs:{"node":_vm.okTitle,"variant":_vm.okVariant,"size":_vm.buttonSize},on:{"click":function($event){_vm.$emit('close'); _vm.close()}}})]},proxy:true}])},'UiPopup',_vm.attributes,false),[_c('UiVNodeContainer',{attrs:{"node":_vm.content}})],1)}
var UiModalAlertvue_type_template_id_4fb8a99a_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugins/modals/UiModalAlert.vue?vue&type=template&id=4fb8a99a&

// CONCATENATED MODULE: ./src/utils/arraify.js
/* harmony default export */ var arraify = (value => Array.isArray(value) ? [...value] : [value]);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiButtonWithVNodeContent.vue?vue&type=script&lang=js&


/* harmony default export */ var UiButtonWithVNodeContentvue_type_script_lang_js_ = ({
  name: 'UiButtonWithVNodeContent',
  functional: true,
  render: (h, {
    listeners,
    props
  }) => {
    const {
      node,
      ...rest
    } = props;
    return h(components_UiButton, {
      props: rest,
      on: listeners
    }, arraify(typeof node === 'function' ? node(h) : node));
  }
});
// CONCATENATED MODULE: ./src/plugins/modals/UiButtonWithVNodeContent.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_UiButtonWithVNodeContentvue_type_script_lang_js_ = (UiButtonWithVNodeContentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugins/modals/UiButtonWithVNodeContent.vue
var UiButtonWithVNodeContent_render, UiButtonWithVNodeContent_staticRenderFns




/* normalize component */

var UiButtonWithVNodeContent_component = normalizeComponent(
  modals_UiButtonWithVNodeContentvue_type_script_lang_js_,
  UiButtonWithVNodeContent_render,
  UiButtonWithVNodeContent_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiButtonWithVNodeContent = (UiButtonWithVNodeContent_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiVNodeContainer.vue?vue&type=script&lang=js&

/* harmony default export */ var UiVNodeContainervue_type_script_lang_js_ = ({
  name: 'UiVNodeContainer',
  functional: true,
  render: (h, {
    props
  }) => h('div', arraify(typeof props.node === 'function' ? props.node(h) : props.node))
});
// CONCATENATED MODULE: ./src/plugins/modals/UiVNodeContainer.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_UiVNodeContainervue_type_script_lang_js_ = (UiVNodeContainervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugins/modals/UiVNodeContainer.vue
var UiVNodeContainer_render, UiVNodeContainer_staticRenderFns




/* normalize component */

var UiVNodeContainer_component = normalizeComponent(
  modals_UiVNodeContainervue_type_script_lang_js_,
  UiVNodeContainer_render,
  UiVNodeContainer_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiVNodeContainer = (UiVNodeContainer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiModalAlert.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






const VARIANTS = {
  PRIMARY: 'primary',
  DANGER: 'danger'
};
/**
 * Пример контента
 * Контент содержащий html-теги:
 * @example h => h('div', {
 *      domProps: {
 *          innerHTML: 'This is the content <br /> of the popup window',
 *      },
 * })
 *
 * Контент без html-тегов:
 * @example 'Content'
 *
 * Также, у компонентов можно так:
 * @example this.$createElement('span', {
 *      style: {
 *          color: '#0f0',
 *      },
 * }, 'Текст')
 */

/* harmony default export */ var UiModalAlertvue_type_script_lang_js_ = ({
  name: 'UiModalAlert',
  components: {
    UiButton: UiButtonWithVNodeContent,
    UiPopup: components_UiPopup,
    UiVNodeContainer: UiVNodeContainer
  },
  props: {
    title: {
      type: [String, Function, Object],
      default: ''
    },
    content: {
      type: [String, Function, Object],
      default: ''
    },
    variant: {
      type: String,
      validator: variant => Object.values(VARIANTS).includes(variant),
      default: VARIANTS.DANGER
    },
    okTitle: {
      type: [String, Function, Object],
      default: ''
    },
    okVariant: {
      type: String,
      validator: variant => Object.values(variants).includes(variant),
      default: variants.SECONDARY
    },
    buttonSize: {
      type: String,
      validator: size => Object.values(sizes).includes(size),
      default: sizes.SM
    },
    attributes: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    opened: false
  }),
  computed: {
    type() {
      if (this.variant === VARIANTS.DANGER) {
        return UiPopup_enum_types.ALERT;
      }

      return UiPopup_enum_types.DIALOG;
    }

  },
  methods: {
    open() {
      this.opened = true;
    },

    close() {
      this.opened = false;
    }

  }
});
// CONCATENATED MODULE: ./src/plugins/modals/UiModalAlert.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_UiModalAlertvue_type_script_lang_js_ = (UiModalAlertvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugins/modals/UiModalAlert.vue





/* normalize component */

var UiModalAlert_component = normalizeComponent(
  modals_UiModalAlertvue_type_script_lang_js_,
  UiModalAlertvue_type_template_id_4fb8a99a_render,
  UiModalAlertvue_type_template_id_4fb8a99a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiModalAlert = (UiModalAlert_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"0a2faca6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiModalConfirm.vue?vue&type=template&id=351f9461&
var UiModalConfirmvue_type_template_id_351f9461_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiPopup',_vm._b({attrs:{"open":_vm.opened,"type":_vm.type,"role":"dialog"},on:{"togglePopup":function($event){$event ? null : _vm.$emit('cancel')}},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('UiVNodeContainer',{attrs:{"node":_vm.title}})]},proxy:true},{key:"footer",fn:function(){return [_c('UiButton',{attrs:{"node":_vm.cancelTitle,"variant":_vm.cancelVariant,"state":_vm.cancelState,"size":_vm.buttonSize},on:{"click":function($event){_vm.$emit('cancel'); _vm.close()}}}),_c('UiButton',{ref:"okButton",attrs:{"node":_vm.okTitle,"variant":_vm.okVariant,"state":_vm.okStateComputed,"size":_vm.buttonSize},on:{"click":function($event){_vm.$emit('ok'); _vm.close()}}})]},proxy:true}])},'UiPopup',_vm.attributes,false),[_c('UiVNodeContainer',{attrs:{"node":_vm.content}})],1)}
var UiModalConfirmvue_type_template_id_351f9461_staticRenderFns = []


// CONCATENATED MODULE: ./src/plugins/modals/UiModalConfirm.vue?vue&type=template&id=351f9461&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/plugins/modals/UiModalConfirm.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







const UiModalConfirmvue_type_script_lang_js_VARIANTS = {
  PRIMARY: 'primary',
  DANGER: 'danger'
};
/**
 * Пример контента
 * Контент содержащий html-теги:
 * @example h => h('div', {
 *      domProps: {
 *          innerHTML: 'This is the content <br /> of the popup window',
 *      },
 * })
 *
 * Контент без html-тегов:
 * @example 'Content'
 *
 * Также, у компонентов можно так:
 * @example this.$createElement('span', {
 *      style: {
 *          color: '#0f0',
 *      },
 * }, 'Текст')
 */

/* harmony default export */ var UiModalConfirmvue_type_script_lang_js_ = ({
  name: 'UiModalConfirm',
  components: {
    UiButton: UiButtonWithVNodeContent,
    UiPopup: components_UiPopup,
    UiVNodeContainer: UiVNodeContainer
  },
  props: {
    title: {
      type: [String, Function, Object],
      default: ''
    },
    content: {
      type: [String, Function, Object],
      default: ''
    },
    variant: {
      type: String,
      validator: variant => Object.values(UiModalConfirmvue_type_script_lang_js_VARIANTS).includes(variant),
      default: UiModalConfirmvue_type_script_lang_js_VARIANTS.PRIMARY
    },
    okTitle: {
      type: [String, Function, Object],
      default: ''
    },
    okVariant: {
      type: String,
      validator: variant => Object.values(variants).includes(variant),
      default: variants.PRIMARY
    },
    okState: {
      type: String,
      validator: state => [...Object.values(states), ''].includes(state),
      default: ''
    },
    cancelTitle: {
      type: [String, Function, Object],
      default: ''
    },
    cancelVariant: {
      type: String,
      validator: variant => Object.values(variants).includes(variant),
      default: variants.SECONDARY
    },
    cancelState: {
      type: String,
      validator: state => Object.values(states).includes(state),
      default: states.DEFAULT
    },
    buttonSize: {
      type: String,
      validator: size => Object.values(sizes).includes(size),
      default: sizes.SM
    },
    attributes: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    opened: false
  }),
  computed: {
    type() {
      if (this.variant === UiModalConfirmvue_type_script_lang_js_VARIANTS.DANGER) {
        return UiPopup_enum_types.ALERT;
      }

      return UiPopup_enum_types.DIALOG;
    },

    okStateComputed() {
      if (this.okState.length > 0) {
        return this.okState;
      }

      if (this.variant === UiModalConfirmvue_type_script_lang_js_VARIANTS.DANGER) {
        return 'error';
      }

      return 'default';
    }

  },

  mounted() {
    if (this.$refs.okButton) {
      this.$nextTick(() => {
        this.$refs.okButton.$el.focus();
      });
    }
  },

  methods: {
    open() {
      this.opened = true;
    },

    close() {
      this.opened = false;
    }

  }
});
// CONCATENATED MODULE: ./src/plugins/modals/UiModalConfirm.vue?vue&type=script&lang=js&
 /* harmony default export */ var modals_UiModalConfirmvue_type_script_lang_js_ = (UiModalConfirmvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/plugins/modals/UiModalConfirm.vue





/* normalize component */

var UiModalConfirm_component = normalizeComponent(
  modals_UiModalConfirmvue_type_script_lang_js_,
  UiModalConfirmvue_type_template_id_351f9461_render,
  UiModalConfirmvue_type_template_id_351f9461_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var UiModalConfirm = (UiModalConfirm_component.exports);
// CONCATENATED MODULE: ./src/plugins/modals/index.js



const UiModalBoxAlert = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  extends: UiModalAlert,

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }

});
const UiModalBoxConfirm = external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({
  extends: UiModalConfirm,

  destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }

});
class UiModalBuilder {
  constructor($parent, defaults = {
    alert: {},
    confirm: {}
  }) {
    this._parent = $parent;
    this._defaults = {
      alert: defaults.alert || {},
      confirm: defaults.confirm || {}
    };
    this._registry = [];
  }

  msgBoxAlert(content, options = {}) {
    const alertBox = new UiModalBoxAlert({
      parent: this._parent,
      propsData: { ...this._defaults.alert,
        ...options,
        content
      }
    });
    const div = document.createElement('div');
    document.body.appendChild(div);
    alertBox.$mount(div);

    this._registry.push(alertBox);

    return new Promise(resolve => {
      alertBox.open();
      alertBox.$on('close', () => {
        resolve();

        this._release(alertBox);
      });
    });
  }

  msgBoxConfirm(content, options = {}) {
    const confirmBox = new UiModalBoxConfirm({
      parent: this._parent,
      propsData: { ...this._defaults.confirm,
        ...options,
        content
      }
    });
    const div = document.createElement('div');
    document.body.appendChild(div);
    confirmBox.$mount(div);

    this._registry.push(confirmBox);

    return new Promise(resolve => {
      confirmBox.open();
      confirmBox.$on('ok', () => {
        resolve(true);

        this._release(confirmBox);
      });
      confirmBox.$on('cancel', () => {
        resolve(false);

        this._release(confirmBox);
      });
    });
  }

  _release(vm) {
    vm.$destroy();

    if (this._registry.includes(vm)) {
      this._registry.splice(this._registry.indexOf(vm), 1);
    }
  }

  clear() {
    this._registry.forEach(vm => vm.$destroy());

    this._registry = [];
  }

}
/* harmony default export */ var modals = ({
  install(Vue, defaults) {
    Vue.mixin({
      beforeCreate() {
        this.$uiKitModal = new UiModalBuilder(this, defaults);
      },

      beforeDestroy() {
        this.$uiKitModal.clear();
      }

    });
  }

});
// CONCATENATED MODULE: ./src/entry.common.js





function eachComponents(components, addInstall, Vue) {
  for (const componentName in components) {
    const component = components[componentName];

    if (addInstall) {
      component.install = function (Vue) {
        Vue.component(component.name, component);
      };
    } else {
      Vue.component(component.name, component);
    }
  }
}

eachComponents(components_namespaceObject, true);
/**
 * @callback GetLocale
 * @returns {string}
 */

const UiLibrary = {
  /**
   * @param Vue
   * @param {Object} options
   * @param {GetLocale} options.getLocale
   * @param {Object} [options.modals]
   * @param {Object} [options.modals.alert]
   * @param {Object} [options.modals.confirm]
   */
  install(Vue, options = {}) {
    eachComponents(components_namespaceObject, false, Vue);
    Vue.use(v_tooltip_esm["a" /* default */]);
    Vue.use(modals, options.modals || {});
    Vue.mixin({
      methods: {
        $getLocale: options.getLocale ? options.getLocale : () => 'ru_RU'
      }
    });
  },

  ...components_namespaceObject
};
/* harmony default export */ var entry_common = (UiLibrary);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (entry_common);



/***/ }),

/***/ "fb99":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbsMore_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6f86");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbsMore_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbsMore_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "default", function() { return _node_modules_mini_css_extract_plugin_dist_loader_js_ref_10_oneOf_0_0_node_modules_css_loader_dist_cjs_js_ref_10_oneOf_0_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_10_oneOf_0_2_node_modules_less_loader_dist_cjs_js_ref_10_oneOf_0_3_config_webpack_removeGlobalfromLess_js_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UiBreadcrumbsMore_vue_vue_type_style_index_0_lang_less_module_true___WEBPACK_IMPORTED_MODULE_0___default.a; });
 

/***/ }),

/***/ "fba5":
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__("cb5a");

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ })["default"];
//# sourceMappingURL=ui-kit.common.js.map